(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+00f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__("J6GP");
exports.encode = exports.stringify = __webpack_require__("bvhO");

/***/ }),

/***/ "+CEt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try

var $export = __webpack_require__("vSO4");
var newPromiseCapability = __webpack_require__("AIlg");
var perform = __webpack_require__("kX4D");

$export($export.S, 'Promise', { 'try': function _try(callbackfn) {
    var promiseCapability = newPromiseCapability.f(this);
    var result = perform(callbackfn);
    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
    return promiseCapability.promise;
  } });

/***/ }),

/***/ "+hHD":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Jyrs");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "/Muo":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/**
 * Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
 * License: MIT - http://mrgnrdrck.mit-license.org
 *
 * https://github.com/mroderick/PubSubJS
 */

(function (root, factory) {
    'use strict';

    var PubSub = {};

    if (root.PubSub) {
        PubSub = root.PubSub;
        console.warn("PubSub already loaded, using existing version");
    } else {
        root.PubSub = PubSub;
        factory(PubSub);
    }
    // CommonJS and Node.js module support
    if (true) {
        if (module !== undefined && module.exports) {
            exports = module.exports = PubSub; // Node.js specific `module.exports`
        }
        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
        module.exports = exports = PubSub; // CommonJS
    }
    // AMD support
    /* eslint-disable no-undef */
    else if (typeof define === 'function' && define.amd) {
            define(function () {
                return PubSub;
            });
            /* eslint-enable no-undef */
        }
})(typeof window === 'object' && window || this, function (PubSub) {
    'use strict';

    var messages = {},
        lastUid = -1,
        ALL_SUBSCRIBING_MSG = '*';

    function hasKeys(obj) {
        var key;

        for (key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                return true;
            }
        }
        return false;
    }

    /**
     * Returns a function that throws the passed exception, for use as argument for setTimeout
     * @alias throwException
     * @function
     * @param { Object } ex An Error object
     */
    function throwException(ex) {
        return function reThrowException() {
            throw ex;
        };
    }

    function callSubscriberWithDelayedExceptions(subscriber, message, data) {
        try {
            subscriber(message, data);
        } catch (ex) {
            setTimeout(throwException(ex), 0);
        }
    }

    function callSubscriberWithImmediateExceptions(subscriber, message, data) {
        subscriber(message, data);
    }

    function deliverMessage(originalMessage, matchedMessage, data, immediateExceptions) {
        var subscribers = messages[matchedMessage],
            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
            s;

        if (!Object.prototype.hasOwnProperty.call(messages, matchedMessage)) {
            return;
        }

        for (s in subscribers) {
            if (Object.prototype.hasOwnProperty.call(subscribers, s)) {
                callSubscriber(subscribers[s], originalMessage, data);
            }
        }
    }

    function createDeliveryFunction(message, data, immediateExceptions) {
        return function deliverNamespaced() {
            var topic = String(message),
                position = topic.lastIndexOf('.');

            // deliver the message as it is now
            deliverMessage(message, message, data, immediateExceptions);

            // trim the hierarchy and deliver message to each level
            while (position !== -1) {
                topic = topic.substr(0, position);
                position = topic.lastIndexOf('.');
                deliverMessage(message, topic, data, immediateExceptions);
            }

            deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
    }

    function hasDirectSubscribersFor(message) {
        var topic = String(message),
            found = Boolean(Object.prototype.hasOwnProperty.call(messages, topic) && hasKeys(messages[topic]));

        return found;
    }

    function messageHasSubscribers(message) {
        var topic = String(message),
            found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG),
            position = topic.lastIndexOf('.');

        while (!found && position !== -1) {
            topic = topic.substr(0, position);
            position = topic.lastIndexOf('.');
            found = hasDirectSubscribersFor(topic);
        }

        return found;
    }

    function publish(message, data, sync, immediateExceptions) {
        message = typeof message === 'symbol' ? message.toString() : message;

        var deliver = createDeliveryFunction(message, data, immediateExceptions),
            hasSubscribers = messageHasSubscribers(message);

        if (!hasSubscribers) {
            return false;
        }

        if (sync === true) {
            deliver();
        } else {
            setTimeout(deliver, 0);
        }
        return true;
    }

    /**
     * Publishes the message, passing the data to it's subscribers
     * @function
     * @alias publish
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publish = function (message, data) {
        return publish(message, data, false, PubSub.immediateExceptions);
    };

    /**
     * Publishes the message synchronously, passing the data to it's subscribers
     * @function
     * @alias publishSync
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publishSync = function (message, data) {
        return publish(message, data, true, PubSub.immediateExceptions);
    };

    /**
     * Subscribes the passed function to the passed message. Every returned token is unique and should be stored if you need to unsubscribe
     * @function
     * @alias subscribe
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { String }
     */
    PubSub.subscribe = function (message, func) {
        if (typeof func !== 'function') {
            return false;
        }

        message = typeof message === 'symbol' ? message.toString() : message;

        // message is not registered yet
        if (!Object.prototype.hasOwnProperty.call(messages, message)) {
            messages[message] = {};
        }

        // forcing token as String, to allow for future expansions without breaking usage
        // and allow for easy use as key names for the 'messages' object
        var token = 'uid_' + String(++lastUid);
        messages[message][token] = func;

        // return token for unsubscribing
        return token;
    };

    PubSub.subscribeAll = function (func) {
        return PubSub.subscribe(ALL_SUBSCRIBING_MSG, func);
    };

    /**
     * Subscribes the passed function to the passed message once
     * @function
     * @alias subscribeOnce
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { PubSub }
     */
    PubSub.subscribeOnce = function (message, func) {
        var token = PubSub.subscribe(message, function () {
            // before func apply, unsubscribe message
            PubSub.unsubscribe(token);
            func.apply(this, arguments);
        });
        return PubSub;
    };

    /**
     * Clears all subscriptions
     * @function
     * @public
     * @alias clearAllSubscriptions
     */
    PubSub.clearAllSubscriptions = function clearAllSubscriptions() {
        messages = {};
    };

    /**
     * Clear subscriptions by the topic
     * @function
     * @public
     * @alias clearAllSubscriptions
     * @return { int }
     */
    PubSub.clearSubscriptions = function clearSubscriptions(topic) {
        var m;
        for (m in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
                delete messages[m];
            }
        }
    };

    /**
       Count subscriptions by the topic
     * @function
     * @public
     * @alias countSubscriptions
     * @return { Array }
    */
    PubSub.countSubscriptions = function countSubscriptions(topic) {
        var m;
        // eslint-disable-next-line no-unused-vars
        var token;
        var count = 0;
        for (m in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
                for (token in messages[m]) {
                    count++;
                }
                break;
            }
        }
        return count;
    };

    /**
       Gets subscriptions by the topic
     * @function
     * @public
     * @alias getSubscriptions
    */
    PubSub.getSubscriptions = function getSubscriptions(topic) {
        var m;
        var list = [];
        for (m in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
                list.push(m);
            }
        }
        return list;
    };

    /**
     * Removes subscriptions
     *
     * - When passed a token, removes a specific subscription.
     *
    * - When passed a function, removes all subscriptions for that function
     *
    * - When passed a topic, removes all subscriptions for that topic (hierarchy)
     * @function
     * @public
     * @alias subscribeOnce
     * @param { String | Function } value A token, function or topic to unsubscribe from
     * @example // Unsubscribing with a token
     * var token = PubSub.subscribe('mytopic', myFunc);
     * PubSub.unsubscribe(token);
     * @example // Unsubscribing with a function
     * PubSub.unsubscribe(myFunc);
     * @example // Unsubscribing from a topic
     * PubSub.unsubscribe('mytopic');
     */
    PubSub.unsubscribe = function (value) {
        var descendantTopicExists = function descendantTopicExists(topic) {
            var m;
            for (m in messages) {
                if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
                    // a descendant of the topic exists:
                    return true;
                }
            }

            return false;
        },
            isTopic = typeof value === 'string' && (Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value)),
            isToken = !isTopic && typeof value === 'string',
            isFunction = typeof value === 'function',
            result = false,
            m,
            message,
            t;

        if (isTopic) {
            PubSub.clearSubscriptions(value);
            return;
        }

        for (m in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m)) {
                message = messages[m];

                if (isToken && message[value]) {
                    delete message[value];
                    result = value;
                    // tokens are unique, so we can just stop here
                    break;
                }

                if (isFunction) {
                    for (t in message) {
                        if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value) {
                            delete message[t];
                            result = true;
                        }
                    }
                }
            }
        }

        return result;
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("HJJD")(module)))

/***/ }),

/***/ "/cCi":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("i1Q6");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

/***/ }),

/***/ "/wXX":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("q7Kr");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "/wuY":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("NB7d")('keys');
var uid = __webpack_require__("X6va");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),

/***/ "0WCH":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),

/***/ "0p0B":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Q4GW");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "11Ut":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("Gfzd").f;
var has = __webpack_require__("yS17");
var TAG = __webpack_require__("Ug9I")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

/***/ }),

/***/ "1kq3":
/***/ (function(module, exports) {

module.exports = true;

/***/ }),

/***/ "2mwf":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("c2zY")('observable');

/***/ }),

/***/ "2tzx":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".table-fixed__2YZXa tbody{height:calc(100vh - 200px);overflow-y:auto;width:100%}.table-fixed__2YZXa tbody,.table-fixed__2YZXa td,.table-fixed__2YZXa th,.table-fixed__2YZXa thead,.table-fixed__2YZXa tr{display:block}.table-fixed__2YZXa tr:after{content:\"\";display:block;visibility:hidden;clear:both}.table-fixed__2YZXa tbody td,.table-fixed__2YZXa thead>tr>th{float:left}.hoveronly__1iuiF{display:none}.tableline__1T-nu:hover .hoveronly__1iuiF{display:inline}.hoverelementonly__2vBWj,.tableline__1T-nu:hover .hoverhide__13bm5{display:none}.element__3RONb:hover .hoverelementonly__2vBWj{display:inline}.element__3RONb:hover .hoverelementhide__2Okge{display:none}.badge-outline__2eYri{font-weight:400;color:gray;border:1px solid gray;background-color:transparent}.pointerCursor__33vsQ{cursor:pointer;pointer-events:inherit}.code__1vfJP{display:block;white-space:pre-wrap}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/brands/style.css"],"names":[],"mappings":"AAAA,0BACI,2BAA4B,AAC5B,gBAAiB,AACjB,UAAY,CACf,AACD,yHAKI,aAAe,CAClB,AACD,6BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,6DAEI,UAAY,CACf,AAED,kBACI,YAAc,CACjB,AACD,0CACI,cAAiB,CACpB,AAKD,mEACI,YAAc,CACjB,AACD,+CACI,cAAiB,CACpB,AACD,+CACI,YAAe,CAClB,AAED,sBACI,gBAAiB,AACjB,WAAe,AACf,sBAA0B,AAC1B,4BAA8B,CACjC,AAED,sBACI,eAAgB,AAChB,sBAAwB,CAC3B,AAED,aACI,cAAe,AACf,oBAAqB,CACtB","file":"style.css","sourcesContent":[".table-fixed tbody {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    width: 100%;\n}\n.table-fixed thead,\n.table-fixed tbody,\n.table-fixed tr,\n.table-fixed td,\n.table-fixed th {\n    display: block;\n}\n.table-fixed tr:after {\n    content: \"\";\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n.table-fixed tbody td,\n.table-fixed thead > tr > th {\n    float: left;\n}\n\n.hoveronly { \n    display: none;\n}\n.tableline:hover .hoveronly {\n    display : inline;\n}\n.tableline:hover .hoverhide {\n    display : none;\n}\n\n.hoverelementonly {\n    display: none;\n}\n.element:hover .hoverelementonly {\n    display : inline;\n}\n.element:hover .hoverelementhide {\n    display : none;\n}\n\n.badge-outline {\n    font-weight: 400;\n    color: #808080;\n    border: 1px solid #808080;\n    background-color: transparent;\n}\n\n.pointerCursor {\n    cursor: pointer;\n    pointer-events: inherit;\n}\n\n.code {\n    display: block;\n    white-space: pre-wrap   \n  }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table-fixed": "table-fixed__2YZXa",
	"hoveronly": "hoveronly__1iuiF",
	"tableline": "tableline__1T-nu",
	"hoverhide": "hoverhide__13bm5",
	"hoverelementonly": "hoverelementonly__2vBWj",
	"element": "element__3RONb",
	"hoverelementhide": "hoverelementhide__2Okge",
	"badge-outline": "badge-outline__2eYri",
	"pointerCursor": "pointerCursor__33vsQ",
	"code": "code__1vfJP"
};

/***/ }),

/***/ "3F7m":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * marked - a markdown parser
 * Copyright (c) 2011-2018, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

;(function (root) {
  'use strict';

  /**
   * Block-Level Grammar
   */

  var block = {
    newline: /^\n+/,
    code: /^( {4}[^\n]+\n*)+/,
    fences: /^ {0,3}(`{3,}|~{3,})([^`~\n]*)\n(?:|([\s\S]*?)\n)(?: {0,3}\1[~`]* *(?:\n+|$)|$)/,
    hr: /^ {0,3}((?:- *){3,}|(?:_ *){3,}|(?:\* *){3,})(?:\n+|$)/,
    heading: /^ {0,3}(#{1,6}) +([^\n]*?)(?: +#+)? *(?:\n+|$)/,
    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
    list: /^( {0,3})(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
    html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?\\?>\\n*' // (3)
    + '|<![A-Z][\\s\\S]*?>\\n*' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?\\]\\]>\\n*' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:\\n{2,}|$)' // (6)
    + '|<(?!script|pre|style)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:\\n{2,}|$)' // (7) open tag
    + '|</(?!script|pre|style)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:\\n{2,}|$)' // (7) closing tag
    + ')',
    def: /^ {0,3}\[(label)\]: *\n? *<?([^\s>]+)>?(?:(?: +\n? *| *\n *)(title))? *(?:\n+|$)/,
    nptable: noop,
    table: noop,
    lheading: /^([^\n]+)\n {0,3}(=+|-+) *(?:\n+|$)/,
    // regex template, placeholders will be replaced according to different paragraph
    // interruption rules of commonmark and the original markdown spec:
    _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html)[^\n]+)*)/,
    text: /^[^\n]+/
  };

  block._label = /(?!\s*\])(?:\\[\[\]]|[^\[\]])+/;
  block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
  block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();

  block.bullet = /(?:[*+-]|\d{1,9}\.)/;
  block.item = /^( *)(bull) ?[^\n]*(?:\n(?!\1bull ?)[^\n]*)*/;
  block.item = edit(block.item, 'gm').replace(/bull/g, block.bullet).getRegex();

  block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();

  block._tag = 'address|article|aside|base|basefont|blockquote|body|caption' + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption' + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe' + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option' + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr' + '|track|ul';
  block._comment = /<!--(?!-?>)[\s\S]*?-->/;
  block.html = edit(block.html, 'i').replace('comment', block._comment).replace('tag', block._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();

  block.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} +').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}|~{3,})[^`\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();

  block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();

  /**
   * Normal Block Grammar
   */

  block.normal = merge({}, block);

  /**
   * GFM Block Grammar
   */

  block.gfm = merge({}, block.normal, {
    nptable: /^ *([^|\n ].*\|.*)\n *([-:]+ *\|[-| :]*)(?:\n((?:.*[^>\n ].*(?:\n|$))*)\n*|$)/,
    table: /^ *\|(.+)\n *\|?( *[-:]+[-| :]*)(?:\n((?: *[^>\n ].*(?:\n|$))*)\n*|$)/
  });

  /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */

  block.pedantic = merge({}, block.normal, {
    html: edit('^ *(?:comment *(?:\\n|\\s*$)' + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))').replace('comment', block._comment).replace(/tag/g, '(?!(?:' + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub' + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)' + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b').getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^ *(#{1,6}) *([^\n]+?) *(?:#+ *)?(?:\n+|$)/,
    fences: noop, // fences not supported
    paragraph: edit(block.normal._paragraph).replace('hr', block.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
  });

  /**
   * Block Lexer
   */

  function Lexer(options) {
    this.tokens = [];
    this.tokens.links = Object.create(null);
    this.options = options || marked.defaults;
    this.rules = block.normal;

    if (this.options.pedantic) {
      this.rules = block.pedantic;
    } else if (this.options.gfm) {
      this.rules = block.gfm;
    }
  }

  /**
   * Expose Block Rules
   */

  Lexer.rules = block;

  /**
   * Static Lex Method
   */

  Lexer.lex = function (src, options) {
    var lexer = new Lexer(options);
    return lexer.lex(src);
  };

  /**
   * Preprocessing
   */

  Lexer.prototype.lex = function (src) {
    src = src.replace(/\r\n|\r/g, '\n').replace(/\t/g, '    ').replace(/\u00a0/g, ' ').replace(/\u2424/g, '\n');

    return this.token(src, true);
  };

  /**
   * Lexing
   */

  Lexer.prototype.token = function (src, top) {
    src = src.replace(/^ +$/gm, '');
    var next, loose, cap, bull, b, item, listStart, listItems, t, space, i, tag, l, isordered, istask, ischecked;

    while (src) {
      // newline
      if (cap = this.rules.newline.exec(src)) {
        src = src.substring(cap[0].length);
        if (cap[0].length > 1) {
          this.tokens.push({
            type: 'space'
          });
        }
      }

      // code
      if (cap = this.rules.code.exec(src)) {
        var lastToken = this.tokens[this.tokens.length - 1];
        src = src.substring(cap[0].length);
        // An indented code block cannot interrupt a paragraph.
        if (lastToken && lastToken.type === 'paragraph') {
          lastToken.text += '\n' + cap[0].trimRight();
        } else {
          cap = cap[0].replace(/^ {4}/gm, '');
          this.tokens.push({
            type: 'code',
            codeBlockStyle: 'indented',
            text: !this.options.pedantic ? rtrim(cap, '\n') : cap
          });
        }
        continue;
      }

      // fences
      if (cap = this.rules.fences.exec(src)) {
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: 'code',
          lang: cap[2] ? cap[2].trim() : cap[2],
          text: cap[3] || ''
        });
        continue;
      }

      // heading
      if (cap = this.rules.heading.exec(src)) {
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: 'heading',
          depth: cap[1].length,
          text: cap[2]
        });
        continue;
      }

      // table no leading pipe (gfm)
      if (cap = this.rules.nptable.exec(src)) {
        item = {
          type: 'table',
          header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
          cells: cap[3] ? cap[3].replace(/\n$/, '').split('\n') : []
        };

        if (item.header.length === item.align.length) {
          src = src.substring(cap[0].length);

          for (i = 0; i < item.align.length; i++) {
            if (/^ *-+: *$/.test(item.align[i])) {
              item.align[i] = 'right';
            } else if (/^ *:-+: *$/.test(item.align[i])) {
              item.align[i] = 'center';
            } else if (/^ *:-+ *$/.test(item.align[i])) {
              item.align[i] = 'left';
            } else {
              item.align[i] = null;
            }
          }

          for (i = 0; i < item.cells.length; i++) {
            item.cells[i] = splitCells(item.cells[i], item.header.length);
          }

          this.tokens.push(item);

          continue;
        }
      }

      // hr
      if (cap = this.rules.hr.exec(src)) {
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: 'hr'
        });
        continue;
      }

      // blockquote
      if (cap = this.rules.blockquote.exec(src)) {
        src = src.substring(cap[0].length);

        this.tokens.push({
          type: 'blockquote_start'
        });

        cap = cap[0].replace(/^ *> ?/gm, '');

        // Pass `top` to keep the current
        // "toplevel" state. This is exactly
        // how markdown.pl works.
        this.token(cap, top);

        this.tokens.push({
          type: 'blockquote_end'
        });

        continue;
      }

      // list
      if (cap = this.rules.list.exec(src)) {
        src = src.substring(cap[0].length);
        bull = cap[2];
        isordered = bull.length > 1;

        listStart = {
          type: 'list_start',
          ordered: isordered,
          start: isordered ? +bull : '',
          loose: false
        };

        this.tokens.push(listStart);

        // Get each top-level item.
        cap = cap[0].match(this.rules.item);

        listItems = [];
        next = false;
        l = cap.length;
        i = 0;

        for (; i < l; i++) {
          item = cap[i];

          // Remove the list item's bullet
          // so it is seen as the next token.
          space = item.length;
          item = item.replace(/^ *([*+-]|\d+\.) */, '');

          // Outdent whatever the
          // list item contains. Hacky.
          if (~item.indexOf('\n ')) {
            space -= item.length;
            item = !this.options.pedantic ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '') : item.replace(/^ {1,4}/gm, '');
          }

          // Determine whether the next list item belongs here.
          // Backpedal if it does not belong in this list.
          if (i !== l - 1) {
            b = block.bullet.exec(cap[i + 1])[0];
            if (bull.length > 1 ? b.length === 1 : b.length > 1 || this.options.smartLists && b !== bull) {
              src = cap.slice(i + 1).join('\n') + src;
              i = l - 1;
            }
          }

          // Determine whether item is loose or not.
          // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
          // for discount behavior.
          loose = next || /\n\n(?!\s*$)/.test(item);
          if (i !== l - 1) {
            next = item.charAt(item.length - 1) === '\n';
            if (!loose) loose = next;
          }

          if (loose) {
            listStart.loose = true;
          }

          // Check for task list items
          istask = /^\[[ xX]\] /.test(item);
          ischecked = undefined;
          if (istask) {
            ischecked = item[1] !== ' ';
            item = item.replace(/^\[[ xX]\] +/, '');
          }

          t = {
            type: 'list_item_start',
            task: istask,
            checked: ischecked,
            loose: loose
          };

          listItems.push(t);
          this.tokens.push(t);

          // Recurse.
          this.token(item, false);

          this.tokens.push({
            type: 'list_item_end'
          });
        }

        if (listStart.loose) {
          l = listItems.length;
          i = 0;
          for (; i < l; i++) {
            listItems[i].loose = true;
          }
        }

        this.tokens.push({
          type: 'list_end'
        });

        continue;
      }

      // html
      if (cap = this.rules.html.exec(src)) {
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: this.options.sanitize ? 'paragraph' : 'html',
          pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
          text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
        });
        continue;
      }

      // def
      if (top && (cap = this.rules.def.exec(src))) {
        src = src.substring(cap[0].length);
        if (cap[3]) cap[3] = cap[3].substring(1, cap[3].length - 1);
        tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
        if (!this.tokens.links[tag]) {
          this.tokens.links[tag] = {
            href: cap[2],
            title: cap[3]
          };
        }
        continue;
      }

      // table (gfm)
      if (cap = this.rules.table.exec(src)) {
        item = {
          type: 'table',
          header: splitCells(cap[1].replace(/^ *| *\| *$/g, '')),
          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
          cells: cap[3] ? cap[3].replace(/\n$/, '').split('\n') : []
        };

        if (item.header.length === item.align.length) {
          src = src.substring(cap[0].length);

          for (i = 0; i < item.align.length; i++) {
            if (/^ *-+: *$/.test(item.align[i])) {
              item.align[i] = 'right';
            } else if (/^ *:-+: *$/.test(item.align[i])) {
              item.align[i] = 'center';
            } else if (/^ *:-+ *$/.test(item.align[i])) {
              item.align[i] = 'left';
            } else {
              item.align[i] = null;
            }
          }

          for (i = 0; i < item.cells.length; i++) {
            item.cells[i] = splitCells(item.cells[i].replace(/^ *\| *| *\| *$/g, ''), item.header.length);
          }

          this.tokens.push(item);

          continue;
        }
      }

      // lheading
      if (cap = this.rules.lheading.exec(src)) {
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: 'heading',
          depth: cap[2].charAt(0) === '=' ? 1 : 2,
          text: cap[1]
        });
        continue;
      }

      // top-level paragraph
      if (top && (cap = this.rules.paragraph.exec(src))) {
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: 'paragraph',
          text: cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1]
        });
        continue;
      }

      // text
      if (cap = this.rules.text.exec(src)) {
        // Top-level should never reach here.
        src = src.substring(cap[0].length);
        this.tokens.push({
          type: 'text',
          text: cap[0]
        });
        continue;
      }

      if (src) {
        throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
      }
    }

    return this.tokens;
  };

  /**
   * Inline-Level Grammar
   */

  var inline = {
    escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
    url: noop,
    tag: '^comment' + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>', // CDATA section
    link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
    reflink: /^!?\[(label)\]\[(?!\s*\])((?:\\[\[\]]?|[^\[\]\\])+)\]/,
    nolink: /^!?\[(?!\s*\])((?:\[[^\[\]]*\]|\\[\[\]]|[^\[\]])*)\](?:\[\])?/,
    strong: /^__([^\s_])__(?!_)|^\*\*([^\s*])\*\*(?!\*)|^__([^\s][\s\S]*?[^\s])__(?!_)|^\*\*([^\s][\s\S]*?[^\s])\*\*(?!\*)/,
    em: /^_([^\s_])_(?!_)|^\*([^\s*<\[])\*(?!\*)|^_([^\s<][\s\S]*?[^\s_])_(?!_|[^\spunctuation])|^_([^\s_<][\s\S]*?[^\s])_(?!_|[^\spunctuation])|^\*([^\s<"][\s\S]*?[^\s\*])\*(?!\*|[^\spunctuation])|^\*([^\s*"<\[][\s\S]*?[^\s])\*(?!\*)/,
    code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
    br: /^( {2,}|\\)\n(?!\s*$)/,
    del: noop,
    text: /^(`+|[^`])(?:[\s\S]*?(?:(?=[\\<!\[`*]|\b_|$)|[^ ](?= {2,}\n))|(?= {2,}\n))/
  };

  // list of punctuation marks from common mark spec
  // without ` and ] to workaround Rule 17 (inline code blocks/links)
  inline._punctuation = '!"#$%&\'()*+,\\-./:;<=>?@\\[^_{|}~';
  inline.em = edit(inline.em).replace(/punctuation/g, inline._punctuation).getRegex();

  inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;

  inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
  inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
  inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();

  inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;

  inline.tag = edit(inline.tag).replace('comment', block._comment).replace('attribute', inline._attribute).getRegex();

  inline._label = /(?:\[[^\[\]]*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
  inline._href = /<(?:\\[<>]?|[^\s<>\\])*>|[^\s\x00-\x1f]*/;
  inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;

  inline.link = edit(inline.link).replace('label', inline._label).replace('href', inline._href).replace('title', inline._title).getRegex();

  inline.reflink = edit(inline.reflink).replace('label', inline._label).getRegex();

  /**
   * Normal Inline Grammar
   */

  inline.normal = merge({}, inline);

  /**
   * Pedantic Inline Grammar
   */

  inline.pedantic = merge({}, inline.normal, {
    strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
    em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/,
    link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline._label).getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline._label).getRegex()
  });

  /**
   * GFM Inline Grammar
   */

  inline.gfm = merge({}, inline.normal, {
    escape: edit(inline.escape).replace('])', '~|])').getRegex(),
    _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
    url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
    _backpedal: /(?:[^?!.,:;*_~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_~)]+(?!$))+/,
    del: /^~+(?=\S)([\s\S]*?\S)~+/,
    text: /^(`+|[^`])(?:[\s\S]*?(?:(?=[\\<!\[`*~]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))|(?= {2,}\n|[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))/
  });

  inline.gfm.url = edit(inline.gfm.url, 'i').replace('email', inline.gfm._extended_email).getRegex();
  /**
   * GFM + Line Breaks Inline Grammar
   */

  inline.breaks = merge({}, inline.gfm, {
    br: edit(inline.br).replace('{2,}', '*').getRegex(),
    text: edit(inline.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
  });

  /**
   * Inline Lexer & Compiler
   */

  function InlineLexer(links, options) {
    this.options = options || marked.defaults;
    this.links = links;
    this.rules = inline.normal;
    this.renderer = this.options.renderer || new Renderer();
    this.renderer.options = this.options;

    if (!this.links) {
      throw new Error('Tokens array requires a `links` property.');
    }

    if (this.options.pedantic) {
      this.rules = inline.pedantic;
    } else if (this.options.gfm) {
      if (this.options.breaks) {
        this.rules = inline.breaks;
      } else {
        this.rules = inline.gfm;
      }
    }
  }

  /**
   * Expose Inline Rules
   */

  InlineLexer.rules = inline;

  /**
   * Static Lexing/Compiling Method
   */

  InlineLexer.output = function (src, links, options) {
    var inline = new InlineLexer(links, options);
    return inline.output(src);
  };

  /**
   * Lexing/Compiling
   */

  InlineLexer.prototype.output = function (src) {
    var out = '',
        link,
        text,
        href,
        title,
        cap,
        prevCapZero;

    while (src) {
      // escape
      if (cap = this.rules.escape.exec(src)) {
        src = src.substring(cap[0].length);
        out += escape(cap[1]);
        continue;
      }

      // tag
      if (cap = this.rules.tag.exec(src)) {
        if (!this.inLink && /^<a /i.test(cap[0])) {
          this.inLink = true;
        } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
          this.inLink = false;
        }
        if (!this.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.inRawBlock = true;
        } else if (this.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.inRawBlock = false;
        }

        src = src.substring(cap[0].length);
        out += this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
        continue;
      }

      // link
      if (cap = this.rules.link.exec(src)) {
        var lastParenIndex = findClosingBracket(cap[2], '()');
        if (lastParenIndex > -1) {
          var linkLen = 4 + cap[1].length + lastParenIndex;
          cap[2] = cap[2].substring(0, lastParenIndex);
          cap[0] = cap[0].substring(0, linkLen).trim();
          cap[3] = '';
        }
        src = src.substring(cap[0].length);
        this.inLink = true;
        href = cap[2];
        if (this.options.pedantic) {
          link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);

          if (link) {
            href = link[1];
            title = link[3];
          } else {
            title = '';
          }
        } else {
          title = cap[3] ? cap[3].slice(1, -1) : '';
        }
        href = href.trim().replace(/^<([\s\S]*)>$/, '$1');
        out += this.outputLink(cap, {
          href: InlineLexer.escapes(href),
          title: InlineLexer.escapes(title)
        });
        this.inLink = false;
        continue;
      }

      // reflink, nolink
      if ((cap = this.rules.reflink.exec(src)) || (cap = this.rules.nolink.exec(src))) {
        src = src.substring(cap[0].length);
        link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
        link = this.links[link.toLowerCase()];
        if (!link || !link.href) {
          out += cap[0].charAt(0);
          src = cap[0].substring(1) + src;
          continue;
        }
        this.inLink = true;
        out += this.outputLink(cap, link);
        this.inLink = false;
        continue;
      }

      // strong
      if (cap = this.rules.strong.exec(src)) {
        src = src.substring(cap[0].length);
        out += this.renderer.strong(this.output(cap[4] || cap[3] || cap[2] || cap[1]));
        continue;
      }

      // em
      if (cap = this.rules.em.exec(src)) {
        src = src.substring(cap[0].length);
        out += this.renderer.em(this.output(cap[6] || cap[5] || cap[4] || cap[3] || cap[2] || cap[1]));
        continue;
      }

      // code
      if (cap = this.rules.code.exec(src)) {
        src = src.substring(cap[0].length);
        out += this.renderer.codespan(escape(cap[2].trim(), true));
        continue;
      }

      // br
      if (cap = this.rules.br.exec(src)) {
        src = src.substring(cap[0].length);
        out += this.renderer.br();
        continue;
      }

      // del (gfm)
      if (cap = this.rules.del.exec(src)) {
        src = src.substring(cap[0].length);
        out += this.renderer.del(this.output(cap[1]));
        continue;
      }

      // autolink
      if (cap = this.rules.autolink.exec(src)) {
        src = src.substring(cap[0].length);
        if (cap[2] === '@') {
          text = escape(this.mangle(cap[1]));
          href = 'mailto:' + text;
        } else {
          text = escape(cap[1]);
          href = text;
        }
        out += this.renderer.link(href, null, text);
        continue;
      }

      // url (gfm)
      if (!this.inLink && (cap = this.rules.url.exec(src))) {
        if (cap[2] === '@') {
          text = escape(cap[0]);
          href = 'mailto:' + text;
        } else {
          // do extended autolink path validation
          do {
            prevCapZero = cap[0];
            cap[0] = this.rules._backpedal.exec(cap[0])[0];
          } while (prevCapZero !== cap[0]);
          text = escape(cap[0]);
          if (cap[1] === 'www.') {
            href = 'http://' + text;
          } else {
            href = text;
          }
        }
        src = src.substring(cap[0].length);
        out += this.renderer.link(href, null, text);
        continue;
      }

      // text
      if (cap = this.rules.text.exec(src)) {
        src = src.substring(cap[0].length);
        if (this.inRawBlock) {
          out += this.renderer.text(this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]);
        } else {
          out += this.renderer.text(escape(this.smartypants(cap[0])));
        }
        continue;
      }

      if (src) {
        throw new Error('Infinite loop on byte: ' + src.charCodeAt(0));
      }
    }

    return out;
  };

  InlineLexer.escapes = function (text) {
    return text ? text.replace(InlineLexer.rules._escapes, '$1') : text;
  };

  /**
   * Compile Link
   */

  InlineLexer.prototype.outputLink = function (cap, link) {
    var href = link.href,
        title = link.title ? escape(link.title) : null;

    return cap[0].charAt(0) !== '!' ? this.renderer.link(href, title, this.output(cap[1])) : this.renderer.image(href, title, escape(cap[1]));
  };

  /**
   * Smartypants Transformations
   */

  InlineLexer.prototype.smartypants = function (text) {
    if (!this.options.smartypants) return text;
    return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201C')
    // closing doubles
    .replace(/"/g, '\u201D')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
  };

  /**
   * Mangle Links
   */

  InlineLexer.prototype.mangle = function (text) {
    if (!this.options.mangle) return text;
    var out = '',
        l = text.length,
        i = 0,
        ch;

    for (; i < l; i++) {
      ch = text.charCodeAt(i);
      if (Math.random() > 0.5) {
        ch = 'x' + ch.toString(16);
      }
      out += '&#' + ch + ';';
    }

    return out;
  };

  /**
   * Renderer
   */

  function Renderer(options) {
    this.options = options || marked.defaults;
  }

  Renderer.prototype.code = function (code, infostring, escaped) {
    var lang = (infostring || '').match(/\S*/)[0];
    if (this.options.highlight) {
      var out = this.options.highlight(code, lang);
      if (out != null && out !== code) {
        escaped = true;
        code = out;
      }
    }

    if (!lang) {
      return '<pre><code>' + (escaped ? code : escape(code, true)) + '</code></pre>';
    }

    return '<pre><code class="' + this.options.langPrefix + escape(lang, true) + '">' + (escaped ? code : escape(code, true)) + '</code></pre>\n';
  };

  Renderer.prototype.blockquote = function (quote) {
    return '<blockquote>\n' + quote + '</blockquote>\n';
  };

  Renderer.prototype.html = function (html) {
    return html;
  };

  Renderer.prototype.heading = function (text, level, raw, slugger) {
    if (this.options.headerIds) {
      return '<h' + level + ' id="' + this.options.headerPrefix + slugger.slug(raw) + '">' + text + '</h' + level + '>\n';
    }
    // ignore IDs
    return '<h' + level + '>' + text + '</h' + level + '>\n';
  };

  Renderer.prototype.hr = function () {
    return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
  };

  Renderer.prototype.list = function (body, ordered, start) {
    var type = ordered ? 'ol' : 'ul',
        startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
    return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
  };

  Renderer.prototype.listitem = function (text) {
    return '<li>' + text + '</li>\n';
  };

  Renderer.prototype.checkbox = function (checked) {
    return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
  };

  Renderer.prototype.paragraph = function (text) {
    return '<p>' + text + '</p>\n';
  };

  Renderer.prototype.table = function (header, body) {
    if (body) body = '<tbody>' + body + '</tbody>';

    return '<table>\n' + '<thead>\n' + header + '</thead>\n' + body + '</table>\n';
  };

  Renderer.prototype.tablerow = function (content) {
    return '<tr>\n' + content + '</tr>\n';
  };

  Renderer.prototype.tablecell = function (content, flags) {
    var type = flags.header ? 'th' : 'td';
    var tag = flags.align ? '<' + type + ' align="' + flags.align + '">' : '<' + type + '>';
    return tag + content + '</' + type + '>\n';
  };

  // span level renderer
  Renderer.prototype.strong = function (text) {
    return '<strong>' + text + '</strong>';
  };

  Renderer.prototype.em = function (text) {
    return '<em>' + text + '</em>';
  };

  Renderer.prototype.codespan = function (text) {
    return '<code>' + text + '</code>';
  };

  Renderer.prototype.br = function () {
    return this.options.xhtml ? '<br/>' : '<br>';
  };

  Renderer.prototype.del = function (text) {
    return '<del>' + text + '</del>';
  };

  Renderer.prototype.link = function (href, title, text) {
    href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
    if (href === null) {
      return text;
    }
    var out = '<a href="' + escape(href) + '"';
    if (title) {
      out += ' title="' + title + '"';
    }
    out += '>' + text + '</a>';
    return out;
  };

  Renderer.prototype.image = function (href, title, text) {
    href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
    if (href === null) {
      return text;
    }

    var out = '<img src="' + href + '" alt="' + text + '"';
    if (title) {
      out += ' title="' + title + '"';
    }
    out += this.options.xhtml ? '/>' : '>';
    return out;
  };

  Renderer.prototype.text = function (text) {
    return text;
  };

  /**
   * TextRenderer
   * returns only the textual part of the token
   */

  function TextRenderer() {}

  // no need for block level renderers

  TextRenderer.prototype.strong = TextRenderer.prototype.em = TextRenderer.prototype.codespan = TextRenderer.prototype.del = TextRenderer.prototype.text = function (text) {
    return text;
  };

  TextRenderer.prototype.link = TextRenderer.prototype.image = function (href, title, text) {
    return '' + text;
  };

  TextRenderer.prototype.br = function () {
    return '';
  };

  /**
   * Parsing & Compiling
   */

  function Parser(options) {
    this.tokens = [];
    this.token = null;
    this.options = options || marked.defaults;
    this.options.renderer = this.options.renderer || new Renderer();
    this.renderer = this.options.renderer;
    this.renderer.options = this.options;
    this.slugger = new Slugger();
  }

  /**
   * Static Parse Method
   */

  Parser.parse = function (src, options) {
    var parser = new Parser(options);
    return parser.parse(src);
  };

  /**
   * Parse Loop
   */

  Parser.prototype.parse = function (src) {
    this.inline = new InlineLexer(src.links, this.options);
    // use an InlineLexer with a TextRenderer to extract pure text
    this.inlineText = new InlineLexer(src.links, merge({}, this.options, { renderer: new TextRenderer() }));
    this.tokens = src.reverse();

    var out = '';
    while (this.next()) {
      out += this.tok();
    }

    return out;
  };

  /**
   * Next Token
   */

  Parser.prototype.next = function () {
    this.token = this.tokens.pop();
    return this.token;
  };

  /**
   * Preview Next Token
   */

  Parser.prototype.peek = function () {
    return this.tokens[this.tokens.length - 1] || 0;
  };

  /**
   * Parse Text Tokens
   */

  Parser.prototype.parseText = function () {
    var body = this.token.text;

    while (this.peek().type === 'text') {
      body += '\n' + this.next().text;
    }

    return this.inline.output(body);
  };

  /**
   * Parse Current Token
   */

  Parser.prototype.tok = function () {
    switch (this.token.type) {
      case 'space':
        {
          return '';
        }
      case 'hr':
        {
          return this.renderer.hr();
        }
      case 'heading':
        {
          return this.renderer.heading(this.inline.output(this.token.text), this.token.depth, unescape(this.inlineText.output(this.token.text)), this.slugger);
        }
      case 'code':
        {
          return this.renderer.code(this.token.text, this.token.lang, this.token.escaped);
        }
      case 'table':
        {
          var header = '',
              body = '',
              i,
              row,
              cell,
              j;

          // header
          cell = '';
          for (i = 0; i < this.token.header.length; i++) {
            cell += this.renderer.tablecell(this.inline.output(this.token.header[i]), { header: true, align: this.token.align[i] });
          }
          header += this.renderer.tablerow(cell);

          for (i = 0; i < this.token.cells.length; i++) {
            row = this.token.cells[i];

            cell = '';
            for (j = 0; j < row.length; j++) {
              cell += this.renderer.tablecell(this.inline.output(row[j]), { header: false, align: this.token.align[j] });
            }

            body += this.renderer.tablerow(cell);
          }
          return this.renderer.table(header, body);
        }
      case 'blockquote_start':
        {
          body = '';

          while (this.next().type !== 'blockquote_end') {
            body += this.tok();
          }

          return this.renderer.blockquote(body);
        }
      case 'list_start':
        {
          body = '';
          var ordered = this.token.ordered,
              start = this.token.start;

          while (this.next().type !== 'list_end') {
            body += this.tok();
          }

          return this.renderer.list(body, ordered, start);
        }
      case 'list_item_start':
        {
          body = '';
          var loose = this.token.loose;
          var checked = this.token.checked;
          var task = this.token.task;

          if (this.token.task) {
            body += this.renderer.checkbox(checked);
          }

          while (this.next().type !== 'list_item_end') {
            body += !loose && this.token.type === 'text' ? this.parseText() : this.tok();
          }
          return this.renderer.listitem(body, task, checked);
        }
      case 'html':
        {
          // TODO parse inline content if parameter markdown=1
          return this.renderer.html(this.token.text);
        }
      case 'paragraph':
        {
          return this.renderer.paragraph(this.inline.output(this.token.text));
        }
      case 'text':
        {
          return this.renderer.paragraph(this.parseText());
        }
      default:
        {
          var errMsg = 'Token with "' + this.token.type + '" type was not found.';
          if (this.options.silent) {
            console.log(errMsg);
          } else {
            throw new Error(errMsg);
          }
        }
    }
  };

  /**
   * Slugger generates header id
   */

  function Slugger() {
    this.seen = {};
  }

  /**
   * Convert string to unique id
   */

  Slugger.prototype.slug = function (value) {
    var slug = value.toLowerCase().trim().replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');

    if (this.seen.hasOwnProperty(slug)) {
      var originalSlug = slug;
      do {
        this.seen[originalSlug]++;
        slug = originalSlug + '-' + this.seen[originalSlug];
      } while (this.seen.hasOwnProperty(slug));
    }
    this.seen[slug] = 0;

    return slug;
  };

  /**
   * Helpers
   */

  function escape(html, encode) {
    if (encode) {
      if (escape.escapeTest.test(html)) {
        return html.replace(escape.escapeReplace, function (ch) {
          return escape.replacements[ch];
        });
      }
    } else {
      if (escape.escapeTestNoEncode.test(html)) {
        return html.replace(escape.escapeReplaceNoEncode, function (ch) {
          return escape.replacements[ch];
        });
      }
    }

    return html;
  }

  escape.escapeTest = /[&<>"']/;
  escape.escapeReplace = /[&<>"']/g;
  escape.replacements = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  escape.escapeTestNoEncode = /[<>"']|&(?!#?\w+;)/;
  escape.escapeReplaceNoEncode = /[<>"']|&(?!#?\w+;)/g;

  function unescape(html) {
    // explicitly match decimal, hex, and named HTML entities
    return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function (_, n) {
      n = n.toLowerCase();
      if (n === 'colon') return ':';
      if (n.charAt(0) === '#') {
        return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
      }
      return '';
    });
  }

  function edit(regex, opt) {
    regex = regex.source || regex;
    opt = opt || '';
    return {
      replace: function replace(name, val) {
        val = val.source || val;
        val = val.replace(/(^|[^\[])\^/g, '$1');
        regex = regex.replace(name, val);
        return this;
      },
      getRegex: function getRegex() {
        return new RegExp(regex, opt);
      }
    };
  }

  function cleanUrl(sanitize, base, href) {
    if (sanitize) {
      try {
        var prot = decodeURIComponent(unescape(href)).replace(/[^\w:]/g, '').toLowerCase();
      } catch (e) {
        return null;
      }
      if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
        return null;
      }
    }
    if (base && !originIndependentUrl.test(href)) {
      href = resolveUrl(base, href);
    }
    try {
      href = encodeURI(href).replace(/%25/g, '%');
    } catch (e) {
      return null;
    }
    return href;
  }

  function resolveUrl(base, href) {
    if (!baseUrls[' ' + base]) {
      // we can ignore everything in base after the last slash of its path component,
      // but we might need to add _that_
      // https://tools.ietf.org/html/rfc3986#section-3
      if (/^[^:]+:\/*[^/]*$/.test(base)) {
        baseUrls[' ' + base] = base + '/';
      } else {
        baseUrls[' ' + base] = rtrim(base, '/', true);
      }
    }
    base = baseUrls[' ' + base];

    if (href.slice(0, 2) === '//') {
      return base.replace(/:[\s\S]*/, ':') + href;
    } else if (href.charAt(0) === '/') {
      return base.replace(/(:\/*[^/]*)[\s\S]*/, '$1') + href;
    } else {
      return base + href;
    }
  }
  var baseUrls = {};
  var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

  function noop() {}
  noop.exec = noop;

  function merge(obj) {
    var i = 1,
        target,
        key;

    for (; i < arguments.length; i++) {
      target = arguments[i];
      for (key in target) {
        if (Object.prototype.hasOwnProperty.call(target, key)) {
          obj[key] = target[key];
        }
      }
    }

    return obj;
  }

  function splitCells(tableRow, count) {
    // ensure that every cell-delimiting pipe has a space
    // before it to distinguish it from an escaped pipe
    var row = tableRow.replace(/\|/g, function (match, offset, str) {
      var escaped = false,
          curr = offset;
      while (--curr >= 0 && str[curr] === '\\') {
        escaped = !escaped;
      }if (escaped) {
        // odd number of slashes means | is escaped
        // so we leave it alone
        return '|';
      } else {
        // add space before unescaped |
        return ' |';
      }
    }),
        cells = row.split(/ \|/),
        i = 0;

    if (cells.length > count) {
      cells.splice(count);
    } else {
      while (cells.length < count) {
        cells.push('');
      }
    }

    for (; i < cells.length; i++) {
      // leading or trailing whitespace is ignored per the gfm spec
      cells[i] = cells[i].trim().replace(/\\\|/g, '|');
    }
    return cells;
  }

  // Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
  // /c*$/ is vulnerable to REDOS.
  // invert: Remove suffix of non-c chars instead. Default falsey.
  function rtrim(str, c, invert) {
    if (str.length === 0) {
      return '';
    }

    // Length of suffix matching the invert condition.
    var suffLen = 0;

    // Step left until we fail to match the invert condition.
    while (suffLen < str.length) {
      var currChar = str.charAt(str.length - suffLen - 1);
      if (currChar === c && !invert) {
        suffLen++;
      } else if (currChar !== c && invert) {
        suffLen++;
      } else {
        break;
      }
    }

    return str.substr(0, str.length - suffLen);
  }

  function findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) {
      return -1;
    }
    var level = 0;
    for (var i = 0; i < str.length; i++) {
      if (str[i] === '\\') {
        i++;
      } else if (str[i] === b[0]) {
        level++;
      } else if (str[i] === b[1]) {
        level--;
        if (level < 0) {
          return i;
        }
      }
    }
    return -1;
  }

  function checkSanitizeDeprecation(opt) {
    if (opt && opt.sanitize && !opt.silent) {
      console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
    }
  }

  /**
   * Marked
   */

  function marked(src, opt, callback) {
    // throw error in case of non string input
    if (typeof src === 'undefined' || src === null) {
      throw new Error('marked(): input parameter is undefined or null');
    }
    if (typeof src !== 'string') {
      throw new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected');
    }

    if (callback || typeof opt === 'function') {
      if (!callback) {
        callback = opt;
        opt = null;
      }

      opt = merge({}, marked.defaults, opt || {});
      checkSanitizeDeprecation(opt);

      var highlight = opt.highlight,
          tokens,
          pending,
          i = 0;

      try {
        tokens = Lexer.lex(src, opt);
      } catch (e) {
        return callback(e);
      }

      pending = tokens.length;

      var done = function done(err) {
        if (err) {
          opt.highlight = highlight;
          return callback(err);
        }

        var out;

        try {
          out = Parser.parse(tokens, opt);
        } catch (e) {
          err = e;
        }

        opt.highlight = highlight;

        return err ? callback(err) : callback(null, out);
      };

      if (!highlight || highlight.length < 3) {
        return done();
      }

      delete opt.highlight;

      if (!pending) return done();

      for (; i < tokens.length; i++) {
        (function (token) {
          if (token.type !== 'code') {
            return --pending || done();
          }
          return highlight(token.text, token.lang, function (err, code) {
            if (err) return done(err);
            if (code == null || code === token.text) {
              return --pending || done();
            }
            token.text = code;
            token.escaped = true;
            --pending || done();
          });
        })(tokens[i]);
      }

      return;
    }
    try {
      if (opt) opt = merge({}, marked.defaults, opt);
      checkSanitizeDeprecation(opt);
      return Parser.parse(Lexer.lex(src, opt), opt);
    } catch (e) {
      e.message += '\nPlease report this to https://github.com/markedjs/marked.';
      if ((opt || marked.defaults).silent) {
        return '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
      }
      throw e;
    }
  }

  /**
   * Options
   */

  marked.options = marked.setOptions = function (opt) {
    merge(marked.defaults, opt);
    return marked;
  };

  marked.getDefaults = function () {
    return {
      baseUrl: null,
      breaks: false,
      gfm: true,
      headerIds: true,
      headerPrefix: '',
      highlight: null,
      langPrefix: 'language-',
      mangle: true,
      pedantic: false,
      renderer: new Renderer(),
      sanitize: false,
      sanitizer: null,
      silent: false,
      smartLists: false,
      smartypants: false,
      xhtml: false
    };
  };

  marked.defaults = marked.getDefaults();

  /**
   * Expose
   */

  marked.Parser = Parser;
  marked.parser = Parser.parse;

  marked.Renderer = Renderer;
  marked.TextRenderer = TextRenderer;

  marked.Lexer = Lexer;
  marked.lexer = Lexer.lex;

  marked.InlineLexer = InlineLexer;
  marked.inlineLexer = InlineLexer.output;

  marked.Slugger = Slugger;

  marked.parse = marked;

  if (true) {
    module.exports = marked;
  } else if (typeof define === 'function' && define.amd) {
    define(function () {
      return marked;
    });
  } else {
    root.marked = marked;
  }
})(this || (typeof window !== 'undefined' ? window : global));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("b8fj")))

/***/ }),

/***/ "3nwz":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("LRt8");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3v7p":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("htFH");
var $Object = __webpack_require__("zKeE").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

/***/ }),

/***/ "3zRh":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("g31e");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ "5Czc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("zotD");
var isObject = __webpack_require__("BxvP");
var newPromiseCapability = __webpack_require__("AIlg");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

/***/ }),

/***/ "6MLN":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("wLcK")(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "6t7t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("nFDa"), __esModule: true };

/***/ }),

/***/ "6uYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export $mobx */
/* unused harmony export FlowCancellationError */
/* unused harmony export IDerivationState */
/* unused harmony export ObservableMap */
/* unused harmony export ObservableSet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reaction; });
/* unused harmony export _allowStateChanges */
/* unused harmony export _allowStateChangesInsideComputed */
/* unused harmony export _allowStateReadsEnd */
/* unused harmony export _allowStateReadsStart */
/* unused harmony export _endAction */
/* unused harmony export _getAdministration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getGlobalState; });
/* unused harmony export _interceptReads */
/* unused harmony export _isComputingDerivation */
/* unused harmony export _resetGlobalState */
/* unused harmony export _startAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return action; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return autorun; });
/* unused harmony export comparer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return computed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return configure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createAtom; });
/* unused harmony export decorate */
/* unused harmony export entries */
/* unused harmony export extendObservable */
/* unused harmony export flow */
/* unused harmony export get */
/* unused harmony export getAtom */
/* unused harmony export getDebugName */
/* unused harmony export getDependencyTree */
/* unused harmony export getObserverTree */
/* unused harmony export has */
/* unused harmony export intercept */
/* unused harmony export isAction */
/* unused harmony export isArrayLike */
/* unused harmony export isBoxedObservable */
/* unused harmony export isComputed */
/* unused harmony export isComputedProp */
/* unused harmony export isFlowCancellationError */
/* unused harmony export isObservable */
/* unused harmony export isObservableArray */
/* unused harmony export isObservableMap */
/* unused harmony export isObservableObject */
/* unused harmony export isObservableProp */
/* unused harmony export isObservableSet */
/* unused harmony export keys */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return observable; });
/* unused harmony export observe */
/* unused harmony export onBecomeObserved */
/* unused harmony export onBecomeUnobserved */
/* unused harmony export onReactionError */
/* unused harmony export reaction */
/* unused harmony export remove */
/* unused harmony export runInAction */
/* unused harmony export set */
/* unused harmony export spy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toJS; });
/* unused harmony export trace */
/* unused harmony export transaction */
/* unused harmony export untracked */
/* unused harmony export values */
/* unused harmony export when */
/** MobX - (c) Michel Weststrate 2015 - 2020 - MIT Licensed */
var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is a production build.";
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
function getNextId() {
    return ++globalState.mobxGuid;
}
function fail(message) {
    invariant(false, message);
    throw "X"; // unreachable
}
function invariant(check, message) {
    if (!check) throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated(msg, thing) {
    if (true) return false;
    if (thing) {
        return deprecated("'" + msg + "', use '" + thing + "' instead.");
    }
    if (deprecatedMessages.indexOf(msg) !== -1) return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once(func) {
    var invoked = false;
    return function () {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function unique(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1) res.push(item);
    });
    return res;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (value === null || typeof value !== "object") return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) {
        return dataStructure;
    } else if (Array.isArray(dataStructure)) {
        return new Map(dataStructure);
    } else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for (var key in dataStructure) {
            map.set(key, dataStructure[key]);
        }
        return map;
    } else {
        return fail("Cannot convert to map from '" + dataStructure + "'");
    }
}
function addHiddenProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || descriptor.configurable !== false && descriptor.writable !== false;
}
function assertPropertyConfigurable(object, prop) {
    if (false) fail("Cannot make property '" + prop.toString() + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike(x) {
    return Array.isArray(x) || isObservableArray(x);
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
/**
 * Returns the following: own keys, prototype keys & own symbol keys, if they are enumerable.
 */
function getPlainObjectKeys(object) {
    var enumerables = new Set();
    for (var key in object) {
        enumerables.add(key);
    } // *all* enumerables
    Object.getOwnPropertySymbols(object).forEach(function (k) {
        if (Object.getOwnPropertyDescriptor(object, k).enumerable) enumerables.add(k);
    }); // *own* symbols
    // Note: this implementation is missing enumerable, inherited, symbolic property names! That would however pretty expensive to add,
    // as there is no efficient iterator that returns *all* properties
    return Array.from(enumerables);
}
function stringifyKey(key) {
    if (key && key.toString) return key.toString();else return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols ? function (obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */Object.getOwnPropertyNames;

var $mobx = Symbol("mobx administration");
var Atom = /** @class */function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom(name) {
        if (name === void 0) {
            name = "Atom@" + getNextId();
        }
        this.name = name;
        this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.isBeingObserved = false;
        this.observers = new Set();
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    Atom.prototype.onBecomeObserved = function () {
        if (this.onBecomeObservedListeners) {
            this.onBecomeObservedListeners.forEach(function (listener) {
                return listener();
            });
        }
    };
    Atom.prototype.onBecomeUnobserved = function () {
        if (this.onBecomeUnobservedListeners) {
            this.onBecomeUnobservedListeners.forEach(function (listener) {
                return listener();
            });
        }
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     * Returns true if there is currently a reactive context.
     */
    Atom.prototype.reportObserved = function () {
        return reportObserved(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    Atom.prototype.reportChanged = function () {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    Atom.prototype.toString = function () {
        return this.name;
    };
    return Atom;
}();
var isAtom = createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) {
        onBecomeObservedHandler = noop;
    }
    if (onBecomeUnobservedHandler === void 0) {
        onBecomeUnobservedHandler = noop;
    }
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) {
        onBecomeObserved(atom, onBecomeObservedHandler);
    }
    if (onBecomeUnobservedHandler !== noop) {
        onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    }
    return atom;
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    return Object.is(a, b);
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer,
    shallow: shallowComparer
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return _extendStatics(d, b);
};

function __extends(d, b) {
    _extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
    _assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return _assign.apply(this, arguments);
};

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator],
        i = 0;
    if (m) return m.call(o);
    return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o),
        r,
        ar = [],
        e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
            ar.push(r.value);
        }
    } catch (error) {
        e = { error: error };
    } finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
            if (e) throw e.error;
        }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++) {
        ar = ar.concat(__read(arguments[i]));
    }return ar;
}

var mobxDidRunLazyInitializersSymbol = Symbol("mobx did run lazy initializers");
var mobxPendingDecorators = Symbol("mobx pending decorators");
var enumerableDescriptorCache = {};
var nonEnumerableDescriptorCache = {};
function createPropertyInitializerDescriptor(prop, enumerable) {
    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
    return cache[prop] || (cache[prop] = {
        configurable: true,
        enumerable: enumerable,
        get: function get() {
            initializeInstance(this);
            return this[prop];
        },
        set: function set(value) {
            initializeInstance(this);
            this[prop] = value;
        }
    });
}
function initializeInstance(target) {
    var e_1, _a;
    if (target[mobxDidRunLazyInitializersSymbol] === true) return;
    var decorators = target[mobxPendingDecorators];
    if (decorators) {
        addHiddenProp(target, mobxDidRunLazyInitializersSymbol, true);
        // Build property key array from both strings and symbols
        var keys = __spread(Object.getOwnPropertySymbols(decorators), Object.keys(decorators));
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                var d = decorators[key];
                d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
    }
}
function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
    return function decoratorFactory() {
        var decoratorArguments;
        var decorator = function decorate(target, prop, descriptor, applyImmediately
        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
        // as the instance to apply the decorator to equals the target
        ) {
            if (applyImmediately === true) {
                propertyCreator(target, prop, descriptor, target, decoratorArguments);
                return null;
            }
            if (false) fail("This function is a decorator, but it wasn't invoked like a decorator");
            if (!Object.prototype.hasOwnProperty.call(target, mobxPendingDecorators)) {
                var inheritedDecorators = target[mobxPendingDecorators];
                addHiddenProp(target, mobxPendingDecorators, _assign({}, inheritedDecorators));
            }
            target[mobxPendingDecorators][prop] = {
                prop: prop,
                propertyCreator: propertyCreator,
                descriptor: descriptor,
                decoratorTarget: target,
                decoratorArguments: decoratorArguments
            };
            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
        };
        if (quacksLikeADecorator(arguments)) {
            // @decorator
            decoratorArguments = EMPTY_ARRAY;
            return decorator.apply(null, arguments);
        } else {
            // @decorator(args)
            decoratorArguments = Array.prototype.slice.call(arguments);
            return decorator;
        }
    };
}
function quacksLikeADecorator(args) {
    return (args.length === 2 || args.length === 3) && (typeof args[1] === "string" || typeof args[1] === "symbol") || args.length === 4 && args[3] === true;
}

function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, { name: name });
    if (isPlainObject(v)) return observable.object(v, undefined, { name: name });
    if (isES6Map(v)) return observable.map(v, { name: name });
    if (isES6Set(v)) return observable.set(v, { name: name });
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, { name: name, deep: false });
    if (isPlainObject(v)) return observable.object(v, undefined, { name: name, deep: false });
    if (isES6Map(v)) return observable.map(v, { name: name, deep: false });
    if (isES6Set(v)) return observable.set(v, { name: name, deep: false });
    return fail("production" !== "production" && "The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue, name) {
    if (false) throw "observable.struct should not be used with observable values";
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}

function createDecoratorForEnhancer(enhancer) {
    invariant(enhancer);
    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
        if (false) {
            invariant(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + stringifyKey(propertyName) + "\"), use @computed instead.");
        }
        var initialValue = descriptor ? descriptor.initializer ? descriptor.initializer.call(target) : descriptor.value : undefined;
        asObservableObject(target).addObservableProp(propertyName, initialValue, enhancer);
    });
    var res =
    // Extra process checks, as this happens during module initialization
    typeof process !== "undefined" && process.env && "production" !== "production" ? function observableDecorator() {
        // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
        // and simply return the created prop decorator
        if (arguments.length < 2) return fail("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
        return decorator.apply(null, arguments);
    } : decorator;
    res.enhancer = enhancer;
    return res;
}

// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function assertValidOption(key) {
    if (!/^(deep|name|equals|defaultDecorator|proxy)$/.test(key)) fail("invalid option for (extend)observable: " + key);
}
function asCreateObservableOptions(thing) {
    if (thing === null || thing === undefined) return defaultCreateObservableOptions;
    if (typeof thing === "string") return { name: thing, deep: true, proxy: true };
    if (false) {
        if (typeof thing !== "object") return fail("expected options object");
        Object.keys(thing).forEach(assertValidOption);
    }
    return thing;
}
var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
function getEnhancerFromOptions(options) {
    return options.defaultDecorator ? options.defaultDecorator.enhancer : options.deep === false ? referenceEnhancer : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (typeof arguments[1] === "string" || typeof arguments[1] === "symbol") {
        return deepDecorator.apply(null, arguments);
    }
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    var res = isPlainObject(v) ? observable.object(v, arg2, arg3) : Array.isArray(v) ? observable.array(v, arg2) : isES6Map(v) ? observable.map(v, arg2) : isES6Set(v) ? observable.set(v, arg2) : v;
    // this value could be converted to a new observable data structure, return it
    if (res !== v) return res;
    // otherwise, just box it
    fail("production" !== "production" && "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
}
var observableFactories = {
    box: function box(value, options) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("box");
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("array");
        var o = asCreateObservableOptions(options);
        return createObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("map");
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        if (arguments.length > 2) incorrectlyUsedAsDecorator("set");
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        if (typeof arguments[1] === "string") incorrectlyUsedAsDecorator("object");
        var o = asCreateObservableOptions(options);
        if (o.proxy === false) {
            return extendObservable({}, props, decorators, o);
        } else {
            var defaultDecorator = getDefaultDecoratorFromObjectOptions(o);
            var base = extendObservable({}, undefined, undefined, o);
            var proxy = createDynamicObservableObject(base);
            extendObservableObjectWithProperties(proxy, props, decorators, defaultDecorator);
            return proxy;
        }
    },
    ref: refDecorator,
    shallow: shallowDecorator,
    deep: deepDecorator,
    struct: refStructDecorator
};
var observable = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) {
    return observable[name] = observableFactories[name];
});
function incorrectlyUsedAsDecorator(methodName) {
    fail(
    // process.env.NODE_ENV !== "production" &&
    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
    if (false) {
        invariant(descriptor && descriptor.get, "Trying to declare a computed value for unspecified getter '" + stringifyKey(propertyName) + "'");
    }
    var get = descriptor.get,
        set = descriptor.set; // initialValue is the descriptor for get / set props
    // Optimization: faster on decorator target or instance? Assuming target
    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
    // Forcing instance now, fixes hot reloadig issues on React Native:
    var options = decoratorArgs[0] || {};
    asObservableObject(instance).addComputedProp(instance, propertyName, _assign({ get: get,
        set: set, context: instance }, options));
});
var computedStructDecorator = computedDecorator({ equals: comparer.structural });
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed = function computed(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        // @computed
        return computedDecorator.apply(null, arguments);
    }
    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
        // @computed({ options })
        return computedDecorator.apply(null, arguments);
    }
    // computed(expr, options?)
    if (false) {
        invariant(typeof arg1 === "function", "First argument to `computed` should be an expression.");
        invariant(arguments.length < 3, "Computed takes one or two arguments if used as function");
    }
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.get = arg1;
    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
    opts.name = opts.name || arg1.name || ""; /* for generated name */
    return new ComputedValue(opts);
};
computed.struct = computedStructDecorator;

var IDerivationState;
(function (IDerivationState) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode;
(function (TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = /** @class */function () {
    function CaughtException(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException;
}();
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE:
            {
                // state propagation can occur outside of action/reactive context #2195
                var prevAllowStateReads = allowStateReadsStart(true);
                var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
                var obs = derivation.observing,
                    l = obs.length;
                for (var i = 0; i < l; i++) {
                    var obj = obs[i];
                    if (isComputedValue(obj)) {
                        if (globalState.disableErrorBoundaries) {
                            obj.get();
                        } else {
                            try {
                                obj.get();
                            } catch (e) {
                                // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                                untrackedEnd(prevUntracked);
                                allowStateReadsEnd(prevAllowStateReads);
                                return true;
                            }
                        }
                        // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                        // and `derivation` is an observer of `obj`
                        // invariantShouldCompute(derivation)
                        if (derivation.dependenciesState === IDerivationState.STALE) {
                            untrackedEnd(prevUntracked);
                            allowStateReadsEnd(prevAllowStateReads);
                            return true;
                        }
                    }
                }
                changeDependenciesStateTo0(derivation);
                untrackedEnd(prevUntracked);
                allowStateReadsEnd(prevAllowStateReads);
                return false;
            }
    }
}
// function invariantShouldCompute(derivation: IDerivation) {
//     const newDepState = (derivation as any).dependenciesState
//     if (
//         process.env.NODE_ENV === "production" &&
//         (newDepState === IDerivationState.POSSIBLY_STALE ||
//             newDepState === IDerivationState.NOT_TRACKING)
//     )
//         fail("Illegal dependency state")
// }
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers = atom.observers.size > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState.computationDepth > 0 && hasObservers) fail("production" !== "production" && "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "strict")) fail("production" !== "production" && (globalState.enforceActions ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") + atom.name);
}
function checkIfStateReadsAreAllowed(observable) {
    if (false) {
        console.warn("[mobx] Observable " + observable.name + " being read outside a reactive context");
    }
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    var result;
    if (globalState.disableErrorBoundaries === true) {
        result = f.call(context);
    } else {
        try {
            result = f.call(context);
        } catch (e) {
            result = new CaughtException(e);
        }
    }
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    if (true) return;
    if (derivation.observing.length !== 0) return;
    if (globalState.reactionRequiresObservable || derivation.requiresObservable) {
        console.warn("[mobx] Derivation " + derivation.name + " is created/updated without reading any observable value");
    }
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = derivation.observing = derivation.newObserving;
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0,
        l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--) {
        removeObserver(obs[i], derivation);
    }derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally {
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE) return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--) {
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
    }
}

// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var functionNameDescriptor = Object.getOwnPropertyDescriptor(function () {}, "name");
var isFunctionNameConfigurable = functionNameDescriptor && functionNameDescriptor.configurable;
function createAction(actionName, fn, ref) {
    if (false) {
        invariant(typeof fn === "function", "`action` can only be invoked on functions");
        if (typeof actionName !== "string" || !actionName) fail("actions should have valid names, got: '" + actionName + "'");
    }
    var res = function res() {
        return executeAction(actionName, fn, ref || this, arguments);
    };
    res.isMobxAction = true;
    if (false) {
        if (isFunctionNameConfigurable) {
            Object.defineProperty(res, "name", { value: actionName });
        }
    }
    return res;
}
function executeAction(actionName, fn, scope, args) {
    var runInfo = _startAction(actionName, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error = err;
        throw err;
    } finally {
        _endAction(runInfo);
    }
}
function _startAction(actionName, scope, args) {
    var notifySpy = isSpyEnabled() && !!actionName;
    var startTime = 0;
    if (notifySpy && "production" !== "production") {
        startTime = Date.now();
        var l = args && args.length || 0;
        var flattendArgs = new Array(l);
        if (l > 0) for (var i = 0; i < l; i++) {
            flattendArgs[i] = args[i];
        }spyReportStart({
            type: "action",
            name: actionName,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart();
    startBatch();
    var prevAllowStateChanges = allowStateChangesStart(true);
    var prevAllowStateReads = allowStateReadsStart(true);
    var runInfo = {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        prevAllowStateReads: prevAllowStateReads,
        notifySpy: notifySpy,
        startTime: startTime,
        actionId: nextActionId++,
        parentActionId: currentActionId
    };
    currentActionId = runInfo.actionId;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId) {
        fail("invalid action stack. did you forget to finish an action?");
    }
    currentActionId = runInfo.parentActionId;
    if (runInfo.error !== undefined) {
        globalState.suppressReactionErrors = true;
    }
    allowStateChangesEnd(runInfo.prevAllowStateChanges);
    allowStateReadsEnd(runInfo.prevAllowStateReads);
    endBatch();
    untrackedEnd(runInfo.prevDerivation);
    if (runInfo.notifySpy && "production" !== "production") {
        spyReportEnd({ time: Date.now() - runInfo.startTime });
    }
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    var res;
    try {
        res = func();
    } finally {
        allowStateChangesEnd(prev);
    }
    return res;
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
function allowStateChangesInsideComputed(func) {
    var prev = globalState.computationDepth;
    globalState.computationDepth = 0;
    var res;
    try {
        res = func();
    } finally {
        globalState.computationDepth = prev;
    }
    return res;
}

var ObservableValue = /** @class */function (_super) {
    __extends(ObservableValue, _super);
    function ObservableValue(value, enhancer, name, notifySpy, equals) {
        if (name === void 0) {
            name = "ObservableValue@" + getNextId();
        }
        if (notifySpy === void 0) {
            notifySpy = true;
        }
        if (equals === void 0) {
            equals = comparer.default;
        }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.name = name;
        _this.equals = equals;
        _this.hasUnreportedChange = false;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled() && "production" !== "production") {
            // only notify spy if this is a stand-alone observable
            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
        }
        return _this;
    }
    ObservableValue.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    ObservableValue.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            if (notifySpy && "production" !== "production") {
                spyReportStart({
                    type: "update",
                    name: this.name,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy && "production" !== "production") spyReportEnd();
        }
    };
    ObservableValue.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.equals(this.value, newValue) ? globalState.UNCHANGED : newValue;
    };
    ObservableValue.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners(this)) {
            notifyListeners(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableValue.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately) listener({
            object: this,
            type: "update",
            newValue: this.value,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    ObservableValue.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ObservableValue.prototype[Symbol.toPrimitive] = function () {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue = /** @class */function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce a new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue(options) {
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isBeingObserved = false;
        this.isPendingUnobservation = false;
        this.observers = new Set();
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.value = new CaughtException(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode.NONE;
        invariant(options.get, "missing option for computed: get");
        this.derivation = options.get;
        this.name = options.name || "ComputedValue@" + getNextId();
        if (options.set) this.setter = createAction(this.name + "-setter", options.set);
        this.equals = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer.default);
        this.scope = options.context;
        this.requiresReaction = !!options.requiresReaction;
        this.keepAlive = !!options.keepAlive;
    }
    ComputedValue.prototype.onBecomeStale = function () {
        propagateMaybeChanged(this);
    };
    ComputedValue.prototype.onBecomeObserved = function () {
        if (this.onBecomeObservedListeners) {
            this.onBecomeObservedListeners.forEach(function (listener) {
                return listener();
            });
        }
    };
    ComputedValue.prototype.onBecomeUnobserved = function () {
        if (this.onBecomeUnobservedListeners) {
            this.onBecomeUnobservedListeners.forEach(function (listener) {
                return listener();
            });
        }
    };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue.prototype.get = function () {
        if (this.isComputing) fail("Cycle detected in computation " + this.name + ": " + this.derivation);
        if (globalState.inBatch === 0 && this.observers.size === 0 && !this.keepAlive) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead();
                startBatch(); // See perf test 'computed memoization'
                this.value = this.computeValue(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) if (this.trackAndCompute()) propagateChangeConfirmed(this);
        }
        var result = this.value;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    ComputedValue.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException(res)) throw res.cause;
        return res;
    };
    ComputedValue.prototype.set = function (value) {
        if (this.setter) {
            invariant(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            } finally {
                this.isRunningSetter = false;
            }
        } else invariant(false, "production" !== "production" && "[ComputedValue '" + this.name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue.prototype.trackAndCompute = function () {
        if (isSpyEnabled() && "production" !== "production") {
            spyReport({
                object: this.scope,
                type: "compute",
                name: this.name
            });
        }
        var oldValue = this.value;
        var wasSuspended =
        /* see #1208 */this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = this.computeValue(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals(oldValue, newValue);
        if (changed) {
            this.value = newValue;
        }
        return changed;
    };
    ComputedValue.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction(this, this.derivation, this.scope);
        } else {
            if (globalState.disableErrorBoundaries === true) {
                res = this.derivation.call(this.scope);
            } else {
                try {
                    res = this.derivation.call(this.scope);
                } catch (e) {
                    res = new CaughtException(e);
                }
            }
        }
        globalState.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue.prototype.suspend = function () {
        if (!this.keepAlive) {
            clearObserving(this);
            this.value = undefined; // don't hold on to computed value!
        }
    };
    ComputedValue.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue.prototype.warnAboutUntrackedRead = function () {
        if (true) return;
        if (this.requiresReaction === true) {
            fail("[mobx] Computed value " + this.name + " is read outside a reactive context");
        }
        if (this.isTracing !== TraceMode.NONE) {
            console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
        }
        if (globalState.computedRequiresReaction) {
            console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
        }
    };
    ComputedValue.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue.prototype.valueOf = function () {
        return toPrimitive(this.get());
    };
    ComputedValue.prototype[Symbol.toPrimitive] = function () {
        return this.valueOf();
    };
    return ComputedValue;
}();
var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);

/**
 * These values will persist if global state is reset
 */
var persistentKeys = ["mobxGuid", "spyListeners", "enforceActions", "computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "allowStateReads", "disableErrorBoundaries", "runId", "UNCHANGED"];
var MobXGlobals = /** @class */function () {
    function MobXGlobals() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         *
         * N.B: this version is unrelated to the package version of MobX, and is only the version of the
         * internal state storage of MobX, and can be the same across many different package versions
         */
        this.version = 5;
        /**
         * globally unique token to signal unchanged
         */
        this.UNCHANGED = {};
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * Is it allowed to read observables at this point?
         * Used to hold the state needed for `observableRequiresReaction`
         */
        this.allowStateReads = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.enforceActions = false;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
        /**
         * Warn if computed values are accessed outside a reactive context
         */
        this.computedRequiresReaction = false;
        /**
         * (Experimental)
         * Warn if you try to create to derivation / reactive context without accessing any observable.
         */
        this.reactionRequiresObservable = false;
        /**
         * (Experimental)
         * Warn if observables are accessed outside a reactive context
         */
        this.observableRequiresReaction = false;
        /**
         * Allows overwriting of computed properties, useful in tests but not prod as it can cause
         * memory leaks. See https://github.com/mobxjs/mobx/issues/1867
         */
        this.computedConfigurable = false;
        /*
         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
         * the stack when an exception occurs while debugging.
         */
        this.disableErrorBoundaries = false;
        /*
         * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
         * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
         */
        this.suppressReactionErrors = false;
    }
    return MobXGlobals;
}();
var mockGlobal = {};
function getGlobal() {
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    return mockGlobal;
}
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = function () {
    var global = getGlobal();
    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals) canMergeGlobalState = false;
    if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        setTimeout(function () {
            if (!isolateCalled) {
                fail("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
            }
        }, 1);
        return new MobXGlobals();
    } else if (global.__mobxGlobals) {
        global.__mobxInstanceCount += 1;
        if (!global.__mobxGlobals.UNCHANGED) global.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
        return global.__mobxGlobals;
    } else {
        global.__mobxInstanceCount = 1;
        return global.__mobxGlobals = new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) fail("isolateGlobalState should be called before MobX is running any reactions");
    isolateCalled = true;
    if (canMergeGlobalState) {
        if (--getGlobal().__mobxInstanceCount === 0) getGlobal().__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for (var key in defaultGlobals) {
        if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    }globalState.allowStateChanges = !globalState.enforceActions;
}

function hasObservers(observable) {
    return observable.observers && observable.observers.size > 0;
}
function getObservers(observable) {
    return observable.observers;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers.add(node);
    if (observable.lowestObserverState > node.dependenciesState) observable.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers.delete(node);
    if (observable.observers.size === 0) {
        // deleting last observer
        queueForUnobservation(observable);
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBecomeUnobserved();
                }
                if (observable instanceof ComputedValue) {
                    // computed values are automatically teared down when the last observer leaves
                    // this process happens recursively, this computed might be the last observable of another, etc..
                    observable.suspend();
                }
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable.lastAccessedBy) {
            observable.lastAccessedBy = derivation.runId;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving[derivation.unboundDepsCount++] = observable;
            if (!observable.isBeingObserved) {
                observable.isBeingObserved = true;
                observable.onBecomeObserved();
            }
        }
        return true;
    } else if (observable.observers.size === 0 && globalState.inBatch > 0) {
        queueForUnobservation(observable);
    }
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState === IDerivationState.STALE) return;
    observable.lowestObserverState = IDerivationState.STALE;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    });
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState === IDerivationState.STALE) return;
    observable.lowestObserverState = IDerivationState.STALE;
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE) d.dependenciesState = IDerivationState.STALE;else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState = IDerivationState.UP_TO_DATE;
    });
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState !== IDerivationState.UP_TO_DATE) return;
    observable.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    observable.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode.NONE) {
                logTraceInfo(d, observable);
            }
            d.onBecomeStale();
        }
    });
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
    if (derivation.isTracing === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies) tree.dependencies.forEach(function (child) {
        return printDepTree(child, lines, depth + 1);
    });
}

var Reaction = /** @class */function () {
    function Reaction(name, onInvalidate, errorHandler, requiresObservable) {
        if (name === void 0) {
            name = "Reaction@" + getNextId();
        }
        if (requiresObservable === void 0) {
            requiresObservable = false;
        }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.errorHandler = errorHandler;
        this.requiresObservable = requiresObservable;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode.NONE;
    }
    Reaction.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    Reaction.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch();
            this._isScheduled = false;
            if (shouldCompute(this)) {
                this._isTrackPending = true;
                try {
                    this.onInvalidate();
                    if (this._isTrackPending && isSpyEnabled() && "production" !== "production") {
                        // onInvalidate didn't trigger track right away..
                        spyReport({
                            name: this.name,
                            type: "scheduled-reaction"
                        });
                    }
                } catch (e) {
                    this.reportExceptionInDerivation(e);
                }
            }
            endBatch();
        }
    };
    Reaction.prototype.track = function (fn) {
        if (this.isDisposed) {
            return;
            // console.warn("Reaction already disposed") // Note: Not a warning / error in mobx 4 either
        }
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        if (notify && "production" !== "production") {
            startTime = Date.now();
            spyReportStart({
                name: this.name,
                type: "reaction"
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving(this);
        }
        if (isCaughtException(result)) this.reportExceptionInDerivation(result.cause);
        if (notify && "production" !== "production") {
            spyReportEnd({
                time: Date.now() - startTime
            });
        }
        endBatch();
    };
    Reaction.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
        if (globalState.suppressReactionErrors) {
            console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)"); // prettier-ignore
        } else {
            console.error(message, error);
            /** If debugging brought you here, please, read the above message :-). Tnx! */
        }
        if (isSpyEnabled()) {
            spyReport({
                type: "error",
                name: this.name,
                message: message,
                error: "" + error
            });
        }
        globalState.globalReactionErrorHandlers.forEach(function (f) {
            return f(error, _this);
        });
    };
    Reaction.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    Reaction.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r[$mobx] = this;
        return r;
    };
    Reaction.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) {
            enterBreakPoint = false;
        }
        trace(this, enterBreakPoint);
    };
    return Reaction;
}();
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." + (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++) {
            remainingReactions[i].runReaction();
        }
    }
    globalState.isRunningReactions = false;
}
var isReaction = createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function () {
            return baseScheduler(f);
        });
    };
}

function isSpyEnabled() {
    return "production" !== "production" && !!globalState.spyListeners.length;
}
function spyReport(event) {
    if (true) return; // dead code elimination can do the rest
    if (!globalState.spyListeners.length) return;
    var listeners = globalState.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](event);
    }
}
function spyReportStart(event) {
    if (true) return;
    var change = _assign(_assign({}, event), { spyReportStart: true });
    spyReport(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd(change) {
    if (true) return;
    if (change) spyReport(_assign(_assign({}, change), { spyReportEnd: true }));else spyReport(END_EVENT);
}
function spy(listener) {
    if (true) {
        console.warn("[mobx.spy] Is a no-op in production builds");
        return function () {};
    } else {
        globalState.spyListeners.push(listener);
        return once(function () {
            globalState.spyListeners = globalState.spyListeners.filter(function (l) {
                return l !== listener;
            });
        });
    }
}

function dontReassignFields() {
    fail("production" !== "production" && "@action fields are not reassignable");
}
function namedActionDecorator(name) {
    return function (target, prop, descriptor) {
        if (descriptor) {
            if (false) {
                return fail("@action cannot be used with getters");
            }
            // babel / typescript
            // @action method() { }
            if (descriptor.value) {
                // typescript
                return {
                    value: createAction(name, descriptor.value),
                    enumerable: false,
                    configurable: true,
                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
                };
            }
            // babel only: @action method = () => {}
            var initializer_1 = descriptor.initializer;
            return {
                enumerable: false,
                configurable: true,
                writable: true,
                initializer: function initializer() {
                    // N.B: we can't immediately invoke initializer; this would be wrong
                    return createAction(name, initializer_1.call(this));
                }
            };
        }
        // bound instance methods
        return actionFieldDecorator(name).apply(this, arguments);
    };
}
function actionFieldDecorator(name) {
    // Simple property that writes on first invocation to the current instance
    return function (target, prop, descriptor) {
        Object.defineProperty(target, prop, {
            configurable: true,
            enumerable: false,
            get: function get() {
                return undefined;
            },
            set: function set(value) {
                addHiddenProp(this, prop, action(name, value));
            }
        });
    };
}
function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
    if (applyToInstance === true) {
        defineBoundAction(target, propertyName, descriptor.value);
        return null;
    }
    if (descriptor) {
        // if (descriptor.value)
        // Typescript / Babel: @action.bound method() { }
        // also: babel @action.bound method = () => {}
        return {
            configurable: true,
            enumerable: false,
            get: function get() {
                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
                return this[propertyName];
            },
            set: dontReassignFields
        };
    }
    // field decorator Typescript @action.bound method = () => {}
    return {
        enumerable: false,
        configurable: true,
        set: function set(v) {
            defineBoundAction(this, propertyName, v);
        },
        get: function get() {
            return undefined;
        }
    };
}

var action = function action(arg1, arg2, arg3, arg4) {
    // action(fn() {})
    if (arguments.length === 1 && typeof arg1 === "function") return createAction(arg1.name || "<unnamed action>", arg1);
    // action("name", fn() {})
    if (arguments.length === 2 && typeof arg2 === "function") return createAction(arg1, arg2);
    // @action("name") fn() {}
    if (arguments.length === 1 && typeof arg1 === "string") return namedActionDecorator(arg1);
    // @action fn() {}
    if (arg4 === true) {
        // apply to instance immediately
        addHiddenProp(arg1, arg2, createAction(arg1.name || arg2, arg3.value, this));
    } else {
        return namedActionDecorator(arg2).apply(null, arguments);
    }
};
action.bound = boundActionDecorator;
function runInAction(arg1, arg2) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    if (false) {
        invariant(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
        if (typeof actionName !== "string" || !actionName) fail("actions should have valid names, got: '" + actionName + "'");
    }
    return executeAction(actionName, fn, this, undefined);
}
function isAction(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction(target, propertyName, fn) {
    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
}

/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */
function autorun(view, opts) {
    if (opts === void 0) {
        opts = EMPTY_OBJECT;
    }
    if (false) {
        invariant(typeof view === "function", "Autorun expects a function as first argument");
        invariant(isAction(view) === false, "Autorun does not accept actions since actions are untrackable");
    }
    var name = opts && opts.name || view.name || "Autorun@" + getNextId();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) {
        // normal autorun
        reaction = new Reaction(name, function () {
            this.track(reactionRunner);
        }, opts.onError, opts.requiresObservable);
    } else {
        var scheduler_1 = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled_1 = false;
        reaction = new Reaction(name, function () {
            if (!isScheduled_1) {
                isScheduled_1 = true;
                scheduler_1(function () {
                    isScheduled_1 = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    reaction.schedule();
    return reaction.getDisposer();
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function (f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    if (opts === void 0) {
        opts = EMPTY_OBJECT;
    }
    if (false) {
        invariant(typeof expression === "function", "First argument to reaction should be a function");
        invariant(typeof opts === "object", "Third argument of reactions should be an object");
    }
    var name = opts.name || "Reaction@" + getNextId();
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer.default;
    var r = new Reaction(name, function () {
        if (firstTime || runSync) {
            reactionRunner();
        } else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false; // Q: move into reaction runner?
        if (r.isDisposed) return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, r);
        if (!firstTime && changed === true) effectAction(value, r);
        if (firstTime) firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function () {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}

function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook("onBecomeObserved", thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = typeof arg3 === "function" ? arg3 : arg2;
    var listenersKey = hook + "Listeners";
    if (atom[listenersKey]) {
        atom[listenersKey].add(cb);
    } else {
        atom[listenersKey] = new Set([cb]);
    }
    var orig = atom[hook];
    if (typeof orig !== "function") return fail("production" !== "production" && "Not an atom that can be (un)observed");
    return function () {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners.delete(cb);
            if (hookListeners.size === 0) {
                delete atom[listenersKey];
            }
        }
    };
}

function configure(options) {
    var enforceActions = options.enforceActions,
        computedRequiresReaction = options.computedRequiresReaction,
        computedConfigurable = options.computedConfigurable,
        disableErrorBoundaries = options.disableErrorBoundaries,
        reactionScheduler = options.reactionScheduler,
        reactionRequiresObservable = options.reactionRequiresObservable,
        observableRequiresReaction = options.observableRequiresReaction;
    if (options.isolateGlobalState === true) {
        isolateGlobalState();
    }
    if (enforceActions !== undefined) {
        if (typeof enforceActions === "boolean" || enforceActions === "strict") deprecated("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
        var ea = void 0;
        switch (enforceActions) {
            case true:
            case "observed":
                ea = true;
                break;
            case false:
            case "never":
                ea = false;
                break;
            case "strict":
            case "always":
                ea = "strict";
                break;
            default:
                fail("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
        }
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === "strict" ? false : true;
    }
    if (computedRequiresReaction !== undefined) {
        globalState.computedRequiresReaction = !!computedRequiresReaction;
    }
    if (reactionRequiresObservable !== undefined) {
        globalState.reactionRequiresObservable = !!reactionRequiresObservable;
    }
    if (observableRequiresReaction !== undefined) {
        globalState.observableRequiresReaction = !!observableRequiresReaction;
        globalState.allowStateReads = !globalState.observableRequiresReaction;
    }
    if (computedConfigurable !== undefined) {
        globalState.computedConfigurable = !!computedConfigurable;
    }
    if (disableErrorBoundaries !== undefined) {
        if (disableErrorBoundaries === true) console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled.");
        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
    }
    if (reactionScheduler) {
        setReactionScheduler(reactionScheduler);
    }
}

function decorate(thing, decorators) {
    "production" !== "production" && invariant(isPlainObject(decorators), "Decorators should be a key value map");
    var target = typeof thing === "function" ? thing.prototype : thing;
    var _loop_1 = function _loop_1(prop) {
        var propertyDecorators = decorators[prop];
        if (!Array.isArray(propertyDecorators)) {
            propertyDecorators = [propertyDecorators];
        }
        "production" !== "production" && invariant(propertyDecorators.every(function (decorator) {
            return typeof decorator === "function";
        }), "Decorate: expected a decorator function or array of decorator functions for '" + prop + "'");
        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
        var newDescriptor = propertyDecorators.reduce(function (accDescriptor, decorator) {
            return decorator(target, prop, accDescriptor);
        }, descriptor);
        if (newDescriptor) Object.defineProperty(target, prop, newDescriptor);
    };
    for (var prop in decorators) {
        _loop_1(prop);
    }
    return thing;
}

function extendObservable(target, properties, decorators, options) {
    if (false) {
        invariant(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
        invariant(typeof target === "object", "'extendObservable' expects an object as first argument");
        invariant(!isObservableMap(target), "'extendObservable' should not be used on maps, use map.merge instead");
    }
    options = asCreateObservableOptions(options);
    var defaultDecorator = getDefaultDecoratorFromObjectOptions(options);
    initializeInstance(target); // Fixes #1740
    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
    if (properties) extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator);
    return target;
}
function getDefaultDecoratorFromObjectOptions(options) {
    return options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
}
function extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator) {
    var e_1, _a, e_2, _b;
    if (false) {
        invariant(!isObservable(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
        if (decorators) {
            var keys = getPlainObjectKeys(decorators);
            try {
                for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                    var key = keys_1_1.value;
                    if (!(key in properties)) fail("Trying to declare a decorator for unspecified property '" + stringifyKey(key) + "'");
                }
            } catch (e_1_1) {
                e_1 = { error: e_1_1 };
            } finally {
                try {
                    if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
                } finally {
                    if (e_1) throw e_1.error;
                }
            }
        }
    }
    startBatch();
    try {
        var keys = ownKeys(properties);
        try {
            for (var keys_2 = __values(keys), keys_2_1 = keys_2.next(); !keys_2_1.done; keys_2_1 = keys_2.next()) {
                var key = keys_2_1.value;
                var descriptor = Object.getOwnPropertyDescriptor(properties, key);
                if (false) {
                    if (!isPlainObject(properties)) fail("'extendObservable' only accepts plain objects as second argument");
                    if (isComputed(descriptor.value)) fail("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
                }
                var decorator = decorators && key in decorators ? decorators[key] : descriptor.get ? computedDecorator : defaultDecorator;
                if (false) fail("Not a valid decorator for '" + stringifyKey(key) + "', got: " + decorator);
                var resultDescriptor = decorator(target, key, descriptor, true);
                if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
                ) Object.defineProperty(target, key, resultDescriptor);
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (keys_2_1 && !keys_2_1.done && (_b = keys_2.return)) _b.call(keys_2);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
    } finally {
        endBatch();
    }
}

function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0) result.dependencies = unique(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}

var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
function flow(generator) {
    if (arguments.length !== 1) fail(!!"production" && "Flow expects 1 argument and cannot be used as decorator");
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    return function () {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function (resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (ret && typeof ret.then === "function") {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function () {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var res = gen.return(undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
}
function cancelPromise(promise) {
    if (typeof promise.cancel === "function") promise.cancel();
}

function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
        target = getAdministration(thing);
    } else if (isObservableObject(thing)) {
        if (typeof propOrHandler !== "string") return fail("production" !== "production" && "InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration(thing, propOrHandler);
    } else {
        return fail("production" !== "production" && "Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined) return fail("production" !== "production" && "An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

function intercept(thing, propOrHandler, handler) {
    if (typeof handler === "function") return interceptProperty(thing, propOrHandler, handler);else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept(handler);
}

function _isComputed(value, property) {
    if (value === null || value === undefined) return false;
    if (property !== undefined) {
        if (isObservableObject(value) === false) return false;
        if (!value[$mobx].values.has(property)) return false;
        var atom = getAtom(value, property);
        return isComputedValue(atom);
    }
    return isComputedValue(value);
}
function isComputed(value) {
    if (arguments.length > 1) return fail("production" !== "production" && "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    if (typeof propName !== "string") return fail("production" !== "production" && "isComputed expected a property name as second argument");
    return _isComputed(value, propName);
}

function _isObservable(value, property) {
    if (value === null || value === undefined) return false;
    if (property !== undefined) {
        if (false) return fail("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
        if (isObservableObject(value)) {
            return value[$mobx].values.has(property);
        }
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    if (arguments.length !== 1) fail("production" !== "production" && "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    if (typeof propName !== "string") return fail("production" !== "production" && "expected a property name as second argument");
    return _isObservable(value, propName);
}

function keys(obj) {
    if (isObservableObject(obj)) {
        return obj[$mobx].getKeys();
    }
    if (isObservableMap(obj)) {
        return Array.from(obj.keys());
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.keys());
    }
    if (isObservableArray(obj)) {
        return obj.map(function (_, index) {
            return index;
        });
    }
    return fail("production" !== "production" && "'keys()' can only be used on observable objects, arrays, sets and maps");
}
function values(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) {
            return obj[key];
        });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) {
            return obj.get(key);
        });
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.values());
    }
    if (isObservableArray(obj)) {
        return obj.slice();
    }
    return fail("production" !== "production" && "'values()' can only be used on observable objects, arrays, sets and maps");
}
function entries(obj) {
    if (isObservableObject(obj)) {
        return keys(obj).map(function (key) {
            return [key, obj[key]];
        });
    }
    if (isObservableMap(obj)) {
        return keys(obj).map(function (key) {
            return [key, obj.get(key)];
        });
    }
    if (isObservableSet(obj)) {
        return Array.from(obj.entries());
    }
    if (isObservableArray(obj)) {
        return obj.map(function (key, index) {
            return [index, key];
        });
    }
    return fail("production" !== "production" && "'entries()' can only be used on observable objects, arrays and maps");
}
function _set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var values_1 = key;
        try {
            for (var key_1 in values_1) {
                _set(obj, key_1, values_1[key_1]);
            }
        } finally {
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) {
        var adm = obj[$mobx];
        var existingObservable = adm.values.get(key);
        if (existingObservable) {
            adm.write(key, value);
        } else {
            adm.addObservableProp(key, value, adm.defaultEnhancer);
        }
    } else if (isObservableMap(obj)) {
        obj.set(key, value);
    } else if (isObservableSet(obj)) {
        obj.add(key);
    } else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else {
        return fail("production" !== "production" && "'set()' can only be used on observable objects, arrays and maps");
    }
}
function remove(obj, key) {
    if (isObservableObject(obj)) {
        obj[$mobx].remove(key);
    } else if (isObservableMap(obj)) {
        obj.delete(key);
    } else if (isObservableSet(obj)) {
        obj.delete(key);
    } else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        invariant(key >= 0, "Not a valid index: '" + key + "'");
        obj.splice(key, 1);
    } else {
        return fail("production" !== "production" && "'remove()' can only be used on observable objects, arrays and maps");
    }
}
function has(obj, key) {
    if (isObservableObject(obj)) {
        // return keys(obj).indexOf(key) >= 0
        var adm = getAdministration(obj);
        return adm.has(key);
    } else if (isObservableMap(obj)) {
        return obj.has(key);
    } else if (isObservableSet(obj)) {
        return obj.has(key);
    } else if (isObservableArray(obj)) {
        return key >= 0 && key < obj.length;
    } else {
        return fail("production" !== "production" && "'has()' can only be used on observable objects, arrays and maps");
    }
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) {
        return obj[key];
    } else if (isObservableMap(obj)) {
        return obj.get(key);
    } else if (isObservableArray(obj)) {
        return obj[key];
    } else {
        return fail("production" !== "production" && "'get()' can only be used on observable objects, arrays and maps");
    }
}

function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function") return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe(listener, fireImmediately);
}

var defaultOptions = {
    detectCycles: true,
    exportMapsAsObjects: true,
    recurseEverything: false
};
function cache(map, key, value, options) {
    if (options.detectCycles) map.set(key, value);
    return value;
}
function toJSHelper(source, options, __alreadySeen) {
    if (!options.recurseEverything && !isObservable(source)) return source;
    if (typeof source !== "object") return source;
    // Directly return null if source is null
    if (source === null) return null;
    // Directly return the Date object itself if contained in the observable
    if (source instanceof Date) return source;
    if (isObservableValue(source)) return toJSHelper(source.get(), options, __alreadySeen);
    // make sure we track the keys of the object
    if (isObservable(source)) keys(source);
    var detectCycles = options.detectCycles === true;
    if (detectCycles && source !== null && __alreadySeen.has(source)) {
        return __alreadySeen.get(source);
    }
    if (isObservableArray(source) || Array.isArray(source)) {
        var res_1 = cache(__alreadySeen, source, [], options);
        var toAdd = source.map(function (value) {
            return toJSHelper(value, options, __alreadySeen);
        });
        res_1.length = toAdd.length;
        for (var i = 0, l = toAdd.length; i < l; i++) {
            res_1[i] = toAdd[i];
        }return res_1;
    }
    if (isObservableSet(source) || Object.getPrototypeOf(source) === Set.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_2 = cache(__alreadySeen, source, new Set(), options);
            source.forEach(function (value) {
                res_2.add(toJSHelper(value, options, __alreadySeen));
            });
            return res_2;
        } else {
            var res_3 = cache(__alreadySeen, source, [], options);
            source.forEach(function (value) {
                res_3.push(toJSHelper(value, options, __alreadySeen));
            });
            return res_3;
        }
    }
    if (isObservableMap(source) || Object.getPrototypeOf(source) === Map.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_4 = cache(__alreadySeen, source, new Map(), options);
            source.forEach(function (value, key) {
                res_4.set(key, toJSHelper(value, options, __alreadySeen));
            });
            return res_4;
        } else {
            var res_5 = cache(__alreadySeen, source, {}, options);
            source.forEach(function (value, key) {
                res_5[key] = toJSHelper(value, options, __alreadySeen);
            });
            return res_5;
        }
    }
    // Fallback to the situation that source is an ObservableObject or a plain object
    var res = cache(__alreadySeen, source, {}, options);
    getPlainObjectKeys(source).forEach(function (key) {
        res[key] = toJSHelper(source[key], options, __alreadySeen);
    });
    return res;
}
function toJS(source, options) {
    // backward compatibility
    if (typeof options === "boolean") options = { detectCycles: options };
    if (!options) options = defaultOptions;
    options.detectCycles = options.detectCycles === undefined ? options.recurseEverything === true : options.detectCycles === true;
    var __alreadySeen;
    if (options.detectCycles) __alreadySeen = new Map();
    return toJSHelper(source, options, __alreadySeen);
}

function trace() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean") enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail("production" !== "production" && "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction(action, thisArg) {
    if (thisArg === void 0) {
        thisArg = undefined;
    }
    startBatch();
    try {
        return action.apply(thisArg);
    } finally {
        endBatch();
    }
}

function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        timeoutHandle = setTimeout(function () {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                var error = new Error("WHEN_TIMEOUT");
                if (opts.onError) opts.onError(error);else throw error;
            }
        }, opts.timeout);
    }
    opts.name = opts.name || "When@" + getNextId();
    var effectAction = createAction(opts.name + "-effect", effect);
    var disposer = autorun(function (r) {
        if (predicate()) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    if (false) return fail("the options 'onError' and 'promise' cannot be combined");
    var cancel;
    var res = new Promise(function (resolve, reject) {
        var disposer = _when(predicate, resolve, _assign(_assign({}, opts), { onError: reject }));
        cancel = function cancel() {
            disposer();
            reject("WHEN_CANCELLED");
        };
    });
    res.cancel = cancel;
    return res;
}

function getAdm(target) {
    return target[$mobx];
}
function isPropertyKey(val) {
    return typeof val === "string" || typeof val === "number" || typeof val === "symbol";
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol) return true;
        var adm = getAdm(target);
        // MWE: should `in` operator be reactive? If not, below code path will be faster / more memory efficient
        // TODO: check performance stats!
        // if (adm.values.get(name as string)) return true
        if (isPropertyKey(name)) return adm.has(name);
        return name in target;
    },
    get: function get(target, name) {
        if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol) return target[name];
        var adm = getAdm(target);
        var observable = adm.values.get(name);
        if (observable instanceof Atom) {
            var result = observable.get();
            if (result === undefined) {
                // This fixes #1796, because deleting a prop that has an
                // undefined value won't retrigger a observer (no visible effect),
                // the autorun wouldn't subscribe to future key changes (see also next comment)
                adm.has(name);
            }
            return result;
        }
        // make sure we start listening to future keys
        // note that we only do this here for optimization
        if (isPropertyKey(name)) adm.has(name);
        return target[name];
    },
    set: function set(target, name, value) {
        if (!isPropertyKey(name)) return false;
        _set(target, name, value);
        return true;
    },
    deleteProperty: function deleteProperty(target, name) {
        if (!isPropertyKey(name)) return false;
        var adm = getAdm(target);
        adm.remove(name);
        return true;
    },
    ownKeys: function ownKeys(target) {
        var adm = getAdm(target);
        adm.keysAtom.reportObserved();
        return Reflect.ownKeys(target);
    },
    preventExtensions: function preventExtensions(target) {
        fail("Dynamic observable objects cannot be frozen");
        return false;
    }
};
function createDynamicObservableObject(base) {
    var proxy = new Proxy(base, objectProxyTraps);
    base[$mobx].proxy = proxy;
    return proxy;
}

function hasInterceptors(interceptable) {
    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = __spread(interceptable.interceptors || []);
        for (var i = 0, l = interceptors.length; i < l; i++) {
            change = interceptors[i](change);
            invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
            if (!change) break;
        }
        return change;
    } finally {
        untrackedEnd(prevU);
    }
}

function hasListeners(listenable) {
    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners;
    if (!listeners) return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd(prevU);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        if (name === $mobx) return target[$mobx];
        if (name === "length") return target[$mobx].getArrayLength();
        if (typeof name === "number") {
            return arrayExtensions.get.call(target, name);
        }
        if (typeof name === "string" && !isNaN(name)) {
            return arrayExtensions.get.call(target, parseInt(name));
        }
        if (arrayExtensions.hasOwnProperty(name)) {
            return arrayExtensions[name];
        }
        return target[name];
    },
    set: function set(target, name, value) {
        if (name === "length") {
            target[$mobx].setArrayLength(value);
        }
        if (typeof name === "number") {
            arrayExtensions.set.call(target, name, value);
        }
        if (typeof name === "symbol" || isNaN(name)) {
            target[name] = value;
        } else {
            // numeric string
            arrayExtensions.set.call(target, parseInt(name), value);
        }
        return true;
    },
    preventExtensions: function preventExtensions(target) {
        fail("Observable arrays cannot be frozen");
        return false;
    }
};
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) {
        name = "ObservableArray@" + getNextId();
    }
    if (owned === void 0) {
        owned = false;
    }
    var adm = new ObservableArrayAdministration(name, enhancer, owned);
    addHiddenFinalProp(adm.values, $mobx, adm);
    var proxy = new Proxy(adm.values, arrayTraps);
    adm.proxy = proxy;
    if (initialValues && initialValues.length) {
        var prev = allowStateChangesStart(true);
        adm.spliceWithArray(0, 0, initialValues);
        allowStateChangesEnd(prev);
    }
    return proxy;
}
var ObservableArrayAdministration = /** @class */function () {
    function ObservableArrayAdministration(name, enhancer, owned) {
        this.owned = owned;
        this.values = [];
        this.proxy = undefined;
        this.lastKnownLength = 0;
        this.atom = new Atom(name || "ObservableArray@" + getNextId());
        this.enhancer = function (newV, oldV) {
            return enhancer(newV, oldV, name + "[..]");
        };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) {
            fireImmediately = false;
        }
        if (fireImmediately) {
            listener({
                object: this.proxy,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0) throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength) return;else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++) {
                newItems[i] = undefined;
            } // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        } else this.spliceWithArray(newLength, currentLength - newLength);
    };
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength) throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed.");
        this.lastKnownLength += delta;
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom);
        var length = this.values.length;
        if (index === undefined) index = 0;else if (index > length) index = length;else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function (v) {
            return _this.enhancer(v, undefined);
        });
        if (false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        var _a;
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
        } else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values.slice(0, index).concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            object: this.proxy,
            type: "update",
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
        // cause any runtime overhead in development mode without NODE_ENV set, unless spying is enabled
        if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.atom.name }));
        this.atom.reportChanged();
        if (notify) notifyListeners(this, change);
        if (notifySpy && "production" !== "production") spyReportEnd();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            object: this.proxy,
            type: "splice",
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.atom.name }));
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
        if (notifySpy && "production" !== "production") spyReportEnd();
    };
    return ObservableArrayAdministration;
}();
var arrayExtensions = {
    intercept: function intercept(handler) {
        return this[$mobx].intercept(handler);
    },
    observe: function observe(listener, fireImmediately) {
        if (fireImmediately === void 0) {
            fireImmediately = false;
        }
        var adm = this[$mobx];
        return adm.observe(listener, fireImmediately);
    },
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray(0, adm.values.length, newItems);
    },
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    toJS: function toJS() {
        return this.slice();
    },
    toJSON: function toJSON() {
        // Used by JSON.stringify
        return this.toJS();
    },
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    splice: function splice(index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        var adm = this[$mobx];
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray(index);
            case 2:
                return adm.spliceWithArray(index, deleteCount);
        }
        return adm.spliceWithArray(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray(index, deleteCount, newItems);
    },
    push: function push() {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this[$mobx];
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this[$mobx];
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        if (false) {
            console.warn("[mobx] `observableArray.reverse()` will not update the array in place. Use `observableArray.slice().reverse()` to suppress this warning and perform the operation on a copy, or `observableArray.replace(observableArray.slice().reverse())` to reverse & update in place");
        }
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    },
    sort: function sort(compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (false) {
            console.warn("[mobx] `observableArray.sort()` will not update the array in place. Use `observableArray.slice().sort()` to suppress this warning and perform the operation on a copy, or `observableArray.replace(observableArray.slice().sort())` to sort & update in place");
        }
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues(adm.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    },
    get: function get(index) {
        var adm = this[$mobx];
        if (adm) {
            if (index < adm.values.length) {
                adm.atom.reportObserved();
                return adm.dehanceValue(adm.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + adm.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    },
    set: function set(index, newValue) {
        var adm = this[$mobx];
        var values = adm.values;
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(adm.atom);
            var oldValue = values[index];
            if (hasInterceptors(adm)) {
                var change = interceptChange(adm, {
                    type: "update",
                    object: adm.proxy,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        } else if (index === values.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        } else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
        }
    }
};
["concat", "flat", "includes", "indexOf", "join", "lastIndexOf", "slice", "toString", "toLocaleString"].forEach(function (funcName) {
    // Feature detection (eg flat may not be available)
    if (typeof Array.prototype[funcName] !== "function") {
        return;
    }
    arrayExtensions[funcName] = function () {
        var adm = this[$mobx];
        adm.atom.reportObserved();
        var dehancedValues = adm.dehanceValues(adm.values);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
});
["every", "filter", "find", "findIndex", "flatMap", "forEach", "map", "some"].forEach(function (funcName) {
    // Feature detection (eg flatMap may not be available)
    if (typeof Array.prototype[funcName] !== "function") {
        return;
    }
    arrayExtensions[funcName] = function (callback, thisArg) {
        var _this = this;
        var adm = this[$mobx];
        adm.atom.reportObserved();
        var dehancedValues = adm.dehanceValues(adm.values);
        return dehancedValues[funcName](function (element, index) {
            return callback.call(thisArg, element, index, _this);
        }, thisArg);
    };
});
["reduce", "reduceRight"].forEach(function (funcName) {
    arrayExtensions[funcName] = function () {
        var _this = this;
        var adm = this[$mobx];
        adm.atom.reportObserved();
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function (accumulator, currentValue, index) {
            currentValue = adm.dehanceValue(currentValue);
            return callback(accumulator, currentValue, index, _this);
        };
        return adm.values[funcName].apply(adm.values, arguments);
    };
});
var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}

var _a;
var ObservableMapMarker = {};
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /** @class */function () {
    function ObservableMap(initialData, enhancer, name) {
        if (enhancer === void 0) {
            enhancer = deepEnhancer;
        }
        if (name === void 0) {
            name = "ObservableMap@" + getNextId();
        }
        this.enhancer = enhancer;
        this.name = name;
        this[_a] = ObservableMapMarker;
        this._keysAtom = createAtom(this.name + ".keys()");
        this[Symbol.toStringTag] = "Map";
        if (typeof Map !== "function") {
            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
        }
        this._data = new Map();
        this._hasMap = new Map();
        this.merge(initialData);
    }
    ObservableMap.prototype._has = function (key) {
        return this._data.has(key);
    };
    ObservableMap.prototype.has = function (key) {
        var _this = this;
        if (!globalState.trackingDerivation) return this._has(key);
        var entry = this._hasMap.get(key);
        if (!entry) {
            // todo: replace with atom (breaking change)
            var newEntry = entry = new ObservableValue(this._has(key), referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false);
            this._hasMap.set(key, newEntry);
            onBecomeUnobserved(newEntry, function () {
                return _this._hasMap.delete(key);
            });
        }
        return entry.get();
    };
    ObservableMap.prototype.set = function (key, value) {
        var hasKey = this._has(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        } else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap.prototype.delete = function (key) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._keysAtom);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "delete",
                object: this,
                oldValue: this._data.get(key).value,
                name: key
            } : null;
            if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name, key: key }));
            transaction(function () {
                _this._keysAtom.reportChanged();
                _this._updateHasMapEntry(key, false);
                var observable = _this._data.get(key);
                observable.setNewValue(undefined);
                _this._data.delete(key);
            });
            if (notify) notifyListeners(this, change);
            if (notifySpy && "production" !== "production") spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
        var entry = this._hasMap.get(key);
        if (entry) {
            entry.setNewValue(value);
        }
    };
    ObservableMap.prototype._updateValue = function (key, newValue) {
        var observable = this._data.get(key);
        newValue = observable.prepareNewValue(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "update",
                object: this,
                oldValue: observable.value,
                name: key,
                newValue: newValue
            } : null;
            if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify) notifyListeners(this, change);
            if (notifySpy && "production" !== "production") spyReportEnd();
        }
    };
    ObservableMap.prototype._addValue = function (key, newValue) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._keysAtom);
        transaction(function () {
            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + stringifyKey(key), false);
            _this._data.set(key, observable);
            newValue = observable.value; // value might have been changed
            _this._updateHasMapEntry(key, true);
            _this._keysAtom.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            type: "add",
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name, key: key }));
        if (notify) notifyListeners(this, change);
        if (notifySpy && "production" !== "production") spyReportEnd();
    };
    ObservableMap.prototype.get = function (key) {
        if (this.has(key)) return this.dehanceValue(this._data.get(key).get());
        return this.dehanceValue(undefined);
    };
    ObservableMap.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap.prototype.keys = function () {
        this._keysAtom.reportObserved();
        return this._data.keys();
    };
    ObservableMap.prototype.values = function () {
        var self = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _b = keys.next(),
                    done = _b.done,
                    value = _b.value;
                return {
                    done: done,
                    value: done ? undefined : self.get(value)
                };
            }
        });
    };
    ObservableMap.prototype.entries = function () {
        var self = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _b = keys.next(),
                    done = _b.done,
                    value = _b.value;
                return {
                    done: done,
                    value: done ? undefined : [value, self.get(value)]
                };
            }
        });
    };
    ObservableMap.prototype[(_a = $mobx, Symbol.iterator)] = function () {
        return this.entries();
    };
    ObservableMap.prototype.forEach = function (callback, thisArg) {
        var e_1, _b;
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2),
                    key = _e[0],
                    value = _e[1];
                callback.call(thisArg, value, key, this);
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
    };
    /** Merge another object into this object, returns this. */
    ObservableMap.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap(other)) {
            other = other.toJS();
        }
        transaction(function () {
            var prev = allowStateChangesStart(true);
            try {
                if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function (key) {
                    return _this.set(key, other[key]);
                });else if (Array.isArray(other)) other.forEach(function (_b) {
                    var _c = __read(_b, 2),
                        key = _c[0],
                        value = _c[1];
                    return _this.set(key, value);
                });else if (isES6Map(other)) {
                    if (other.constructor !== Map) fail("Cannot initialize from classes that inherit from Map: " + other.constructor.name); // prettier-ignore
                    other.forEach(function (value, key) {
                        return _this.set(key, value);
                    });
                } else if (other !== null && other !== undefined) fail("Cannot initialize map from " + other);
            } finally {
                allowStateChangesEnd(prev);
            }
        });
        return this;
    };
    ObservableMap.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                var e_2, _b;
                try {
                    for (var _c = __values(_this.keys()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var key = _d.value;
                        _this.delete(key);
                    }
                } catch (e_2_1) {
                    e_2 = { error: e_2_1 };
                } finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally {
                        if (e_2) throw e_2.error;
                    }
                }
            });
        });
    };
    ObservableMap.prototype.replace = function (values) {
        var _this = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function () {
            var e_3, _b, e_4, _c;
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            try {
                // Delete keys that don't exist in replacement map
                // if the key deletion is prevented by interceptor
                // add entry at the beginning of the result map
                for (var _d = __values(_this._data.keys()), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var key = _e.value;
                    // Concurrently iterating/deleting keys
                    // iterator should handle this correctly
                    if (!replacementMap.has(key)) {
                        var deleted = _this.delete(key);
                        // Was the key removed?
                        if (deleted) {
                            // _keysAtom.reportChanged() was already called
                            keysReportChangedCalled = true;
                        } else {
                            // Delete prevented by interceptor
                            var value = _this._data.get(key);
                            orderedData.set(key, value);
                        }
                    }
                }
            } catch (e_3_1) {
                e_3 = { error: e_3_1 };
            } finally {
                try {
                    if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                } finally {
                    if (e_3) throw e_3.error;
                }
            }
            try {
                // Merge entries
                for (var _f = __values(replacementMap.entries()), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var _h = __read(_g.value, 2),
                        key = _h[0],
                        value = _h[1];
                    // We will want to know whether a new key is added
                    var keyExisted = _this._data.has(key);
                    // Add or update value
                    _this.set(key, value);
                    // The addition could have been prevent by interceptor
                    if (_this._data.has(key)) {
                        // The update could have been prevented by interceptor
                        // and also we want to preserve existing values
                        // so use value from _data map (instead of replacement map)
                        var value_1 = _this._data.get(key);
                        orderedData.set(key, value_1);
                        // Was a new key added?
                        if (!keyExisted) {
                            // _keysAtom.reportChanged() was already called
                            keysReportChangedCalled = true;
                        }
                    }
                }
            } catch (e_4_1) {
                e_4 = { error: e_4_1 };
            } finally {
                try {
                    if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                } finally {
                    if (e_4) throw e_4.error;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this._data.size !== orderedData.size) {
                    // If size differs, keys are definitely modified
                    _this._keysAtom.reportChanged();
                } else {
                    var iter1 = _this._data.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while (!next1.done) {
                        if (next1.value !== next2.value) {
                            _this._keysAtom.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this._data = orderedData;
        });
        return this;
    };
    Object.defineProperty(ObservableMap.prototype, "size", {
        get: function get() {
            this._keysAtom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a plain object that represents this map.
     * Note that all the keys being stringified.
     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
     */
    ObservableMap.prototype.toPOJO = function () {
        var e_5, _b;
        var res = {};
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read(_d.value, 2),
                    key = _e[0],
                    value = _e[1];
                // We lie about symbol key types due to https://github.com/Microsoft/TypeScript/issues/1863
                res[typeof key === "symbol" ? key : stringifyKey(key)] = value;
            }
        } catch (e_5_1) {
            e_5 = { error: e_5_1 };
        } finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally {
                if (e_5) throw e_5.error;
            }
        }
        return res;
    };
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap.prototype.toJS = function () {
        return new Map(this);
    };
    ObservableMap.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toPOJO();
    };
    ObservableMap.prototype.toString = function () {
        var _this = this;
        return this.name + "[{ " + Array.from(this.keys()).map(function (key) {
            return stringifyKey(key) + ": " + ("" + _this.get(key));
        }).join(", ") + " }]";
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap.prototype.observe = function (listener, fireImmediately) {
        "production" !== "production" && invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
        return registerListener(this, listener);
    };
    ObservableMap.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    return ObservableMap;
}();
/* 'var' fixes small-build issue */
var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);

var _a$1;
var ObservableSetMarker = {};
var ObservableSet = /** @class */function () {
    function ObservableSet(initialData, enhancer, name) {
        if (enhancer === void 0) {
            enhancer = deepEnhancer;
        }
        if (name === void 0) {
            name = "ObservableSet@" + getNextId();
        }
        this.name = name;
        this[_a$1] = ObservableSetMarker;
        this._data = new Set();
        this._atom = createAtom(this.name);
        this[Symbol.toStringTag] = "Set";
        if (typeof Set !== "function") {
            throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
        }
        this.enhancer = function (newV, oldV) {
            return enhancer(newV, oldV, name);
        };
        if (initialData) {
            this.replace(initialData);
        }
    }
    ObservableSet.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableSet.prototype.clear = function () {
        var _this = this;
        transaction(function () {
            untracked(function () {
                var e_1, _b;
                try {
                    for (var _c = __values(_this._data.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var value = _d.value;
                        _this.delete(value);
                    }
                } catch (e_1_1) {
                    e_1 = { error: e_1_1 };
                } finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    } finally {
                        if (e_1) throw e_1.error;
                    }
                }
            });
        });
    };
    ObservableSet.prototype.forEach = function (callbackFn, thisArg) {
        var e_2, _b;
        try {
            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
                var value = _d.value;
                callbackFn.call(thisArg, value, value, this);
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
    };
    Object.defineProperty(ObservableSet.prototype, "size", {
        get: function get() {
            this._atom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    ObservableSet.prototype.add = function (value) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this._atom);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "add",
                object: this,
                newValue: value
            });
            if (!change) return this;
            // TODO: ideally, value = change.value would be done here, so that values can be
            // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function () {
                _this._data.add(_this.enhancer(value, undefined));
                _this._atom.reportChanged();
            });
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "add",
                object: this,
                newValue: value
            } : null;
            if (notifySpy && "production" !== "production") spyReportStart(change);
            if (notify) notifyListeners(this, change);
            if (notifySpy && "production" !== "production") spyReportEnd();
        }
        return this;
    };
    ObservableSet.prototype.delete = function (value) {
        var _this = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "delete",
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                type: "delete",
                object: this,
                oldValue: value
            } : null;
            if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name }));
            transaction(function () {
                _this._atom.reportChanged();
                _this._data.delete(value);
            });
            if (notify) notifyListeners(this, change);
            if (notifySpy && "production" !== "production") spyReportEnd();
            return true;
        }
        return false;
    };
    ObservableSet.prototype.has = function (value) {
        this._atom.reportObserved();
        return this._data.has(this.dehanceValue(value));
    };
    ObservableSet.prototype.entries = function () {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? { value: [keys[index], values[index]], done: false } : { done: true };
            }
        });
    };
    ObservableSet.prototype.keys = function () {
        return this.values();
    };
    ObservableSet.prototype.values = function () {
        this._atom.reportObserved();
        var self = this;
        var nextIndex = 0;
        var observableValues = Array.from(this._data.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? { value: self.dehanceValue(observableValues[nextIndex++]), done: false } : { done: true };
            }
        });
    };
    ObservableSet.prototype.replace = function (other) {
        var _this = this;
        if (isObservableSet(other)) {
            other = other.toJS();
        }
        transaction(function () {
            var prev = allowStateChangesStart(true);
            try {
                if (Array.isArray(other)) {
                    _this.clear();
                    other.forEach(function (value) {
                        return _this.add(value);
                    });
                } else if (isES6Set(other)) {
                    _this.clear();
                    other.forEach(function (value) {
                        return _this.add(value);
                    });
                } else if (other !== null && other !== undefined) {
                    fail("Cannot initialize set from " + other);
                }
            } finally {
                allowStateChangesEnd(prev);
            }
        });
        return this;
    };
    ObservableSet.prototype.observe = function (listener, fireImmediately) {
        // TODO 'fireImmediately' can be true?
        "production" !== "production" && invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with sets.");
        return registerListener(this, listener);
    };
    ObservableSet.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableSet.prototype.toJS = function () {
        return new Set(this);
    };
    ObservableSet.prototype.toString = function () {
        return this.name + "[ " + Array.from(this).join(", ") + " ]";
    };
    ObservableSet.prototype[(_a$1 = $mobx, Symbol.iterator)] = function () {
        return this.values();
    };
    return ObservableSet;
}();
var isObservableSet = createInstanceofPredicate("ObservableSet", ObservableSet);

var ObservableObjectAdministration = /** @class */function () {
    function ObservableObjectAdministration(target, values, name, defaultEnhancer) {
        if (values === void 0) {
            values = new Map();
        }
        this.target = target;
        this.values = values;
        this.name = name;
        this.defaultEnhancer = defaultEnhancer;
        this.keysAtom = new Atom(name + ".keys");
    }
    ObservableObjectAdministration.prototype.read = function (key) {
        return this.values.get(key).get();
    };
    ObservableObjectAdministration.prototype.write = function (key, newValue) {
        var instance = this.target;
        var observable = this.values.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: "update",
                object: this.proxy || instance,
                name: key,
                newValue: newValue
            });
            if (!change) return;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var change = notify || notifySpy ? {
                type: "update",
                object: this.proxy || instance,
                oldValue: observable.value,
                name: key,
                newValue: newValue
            } : null;
            if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name, key: key }));
            observable.setNewValue(newValue);
            if (notify) notifyListeners(this, change);
            if (notifySpy && "production" !== "production") spyReportEnd();
        }
    };
    ObservableObjectAdministration.prototype.has = function (key) {
        var map = this.pendingKeys || (this.pendingKeys = new Map());
        var entry = map.get(key);
        if (entry) return entry.get();else {
            var exists = !!this.values.get(key);
            // Possible optimization: Don't have a separate map for non existing keys,
            // but store them in the values map instead, using a special symbol to denote "not existing"
            entry = new ObservableValue(exists, referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false);
            map.set(key, entry);
            return entry.get(); // read to subscribe
        }
    };
    ObservableObjectAdministration.prototype.addObservableProp = function (propName, newValue, enhancer) {
        if (enhancer === void 0) {
            enhancer = this.defaultEnhancer;
        }
        var target = this.target;
        assertPropertyConfigurable(target, propName);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy || target,
                name: propName,
                type: "add",
                newValue: newValue
            });
            if (!change) return;
            newValue = change.newValue;
        }
        var observable = new ObservableValue(newValue, enhancer, this.name + "." + stringifyKey(propName), false);
        this.values.set(propName, observable);
        newValue = observable.value; // observableValue might have changed it
        Object.defineProperty(target, propName, generateObservablePropConfig(propName));
        this.notifyPropertyAddition(propName, newValue);
    };
    ObservableObjectAdministration.prototype.addComputedProp = function (propertyOwner, // where is the property declared?
    propName, options) {
        var target = this.target;
        options.name = options.name || this.name + "." + stringifyKey(propName);
        this.values.set(propName, new ComputedValue(options));
        if (propertyOwner === target || isPropertyConfigurable(propertyOwner, propName)) Object.defineProperty(propertyOwner, propName, generateComputedPropConfig(propName));
    };
    ObservableObjectAdministration.prototype.remove = function (key) {
        if (!this.values.has(key)) return;
        var target = this.target;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy || target,
                name: key,
                type: "remove"
            });
            if (!change) return;
        }
        try {
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = isSpyEnabled();
            var oldObservable = this.values.get(key);
            var oldValue = oldObservable && oldObservable.get();
            oldObservable && oldObservable.set(undefined);
            // notify key and keyset listeners
            this.keysAtom.reportChanged();
            this.values.delete(key);
            if (this.pendingKeys) {
                var entry = this.pendingKeys.get(key);
                if (entry) entry.set(false);
            }
            // delete the prop
            delete this.target[key];
            var change = notify || notifySpy ? {
                type: "remove",
                object: this.proxy || target,
                oldValue: oldValue,
                name: key
            } : null;
            if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name, key: key }));
            if (notify) notifyListeners(this, change);
            if (notifySpy && "production" !== "production") spyReportEnd();
        } finally {
            endBatch();
        }
    };
    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
        /**
         * This happens if a property is accessed through the prototype chain, but the property was
         * declared directly as own property on the prototype.
         *
         * E.g.:
         * class A {
         * }
         * extendObservable(A.prototype, { x: 1 })
         *
         * classB extens A {
         * }
         * console.log(new B().x)
         *
         * It is unclear whether the property should be considered 'static' or inherited.
         * Either use `console.log(A.x)`
         * or: decorate(A, { x: observable })
         *
         * When using decorate, the property will always be redeclared as own property on the actual instance
         */
        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
        "production" !== "production" && invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener(this, callback);
    };
    ObservableObjectAdministration.prototype.intercept = function (handler) {
        return registerInterceptor(this, handler);
    };
    ObservableObjectAdministration.prototype.notifyPropertyAddition = function (key, newValue) {
        var notify = hasListeners(this);
        var notifySpy = isSpyEnabled();
        var change = notify || notifySpy ? {
            type: "add",
            object: this.proxy || this.target,
            name: key,
            newValue: newValue
        } : null;
        if (notifySpy && "production" !== "production") spyReportStart(_assign(_assign({}, change), { name: this.name, key: key }));
        if (notify) notifyListeners(this, change);
        if (notifySpy && "production" !== "production") spyReportEnd();
        if (this.pendingKeys) {
            var entry = this.pendingKeys.get(key);
            if (entry) entry.set(true);
        }
        this.keysAtom.reportChanged();
    };
    ObservableObjectAdministration.prototype.getKeys = function () {
        var e_1, _a;
        this.keysAtom.reportObserved();
        // return Reflect.ownKeys(this.values) as any
        var res = [];
        try {
            for (var _b = __values(this.values), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2),
                    key = _d[0],
                    value = _d[1];
                if (value instanceof ObservableValue) res.push(key);
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        return res;
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, name, defaultEnhancer) {
    if (name === void 0) {
        name = "";
    }
    if (defaultEnhancer === void 0) {
        defaultEnhancer = deepEnhancer;
    }
    if (Object.prototype.hasOwnProperty.call(target, $mobx)) return target[$mobx];
    "production" !== "production" && invariant(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
    if (!isPlainObject(target)) name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
    if (!name) name = "ObservableObject@" + getNextId();
    var adm = new ObservableObjectAdministration(target, new Map(), stringifyKey(name), defaultEnhancer);
    addHiddenProp(target, $mobx, adm);
    return adm;
}
var observablePropertyConfigs = Object.create(null);
var computedPropertyConfigs = Object.create(null);
function generateObservablePropConfig(propName) {
    return observablePropertyConfigs[propName] || (observablePropertyConfigs[propName] = {
        configurable: true,
        enumerable: true,
        get: function get() {
            return this[$mobx].read(propName);
        },
        set: function set(v) {
            this[$mobx].write(propName, v);
        }
    });
}
function getAdministrationForComputedPropOwner(owner) {
    var adm = owner[$mobx];
    if (!adm) {
        // because computed props are declared on proty,
        // the current instance might not have been initialized yet
        initializeInstance(owner);
        return owner[$mobx];
    }
    return adm;
}
function generateComputedPropConfig(propName) {
    return computedPropertyConfigs[propName] || (computedPropertyConfigs[propName] = {
        configurable: globalState.computedConfigurable,
        enumerable: false,
        get: function get() {
            return getAdministrationForComputedPropOwner(this).read(propName);
        },
        set: function set(v) {
            getAdministrationForComputedPropOwner(this).write(propName, v);
        }
    });
}
var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function isObservableObject(thing) {
    if (isObject(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        return isObservableObjectAdministration(thing[$mobx]);
    }
    return false;
}

function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) fail("production" !== "production" && "It is not possible to get index atoms from arrays");
            return thing[$mobx].atom;
        }
        if (isObservableSet(thing)) {
            return thing[$mobx];
        }
        if (isObservableMap(thing)) {
            var anyThing = thing;
            if (property === undefined) return anyThing._keysAtom;
            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
            if (!observable) fail("production" !== "production" && "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
            return observable;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance(thing);
        if (property && !thing[$mobx]) thing[property]; // See #1072
        if (isObservableObject(thing)) {
            if (!property) return fail("production" !== "production" && "please specify a property");
            var observable = thing[$mobx].values.get(property);
            if (!observable) fail("production" !== "production" && "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
            return observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
            return thing;
        }
    } else if (typeof thing === "function") {
        if (isReaction(thing[$mobx])) {
            // disposer function
            return thing[$mobx];
        }
    }
    return fail("production" !== "production" && "Cannot obtain atom from " + thing);
}
function getAdministration(thing, property) {
    if (!thing) fail("Expecting some object");
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    initializeInstance(thing);
    if (thing[$mobx]) return thing[$mobx];
    fail("production" !== "production" && "Cannot obtain administration from " + thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);else named = getAtom(thing); // valid for arrays as well
    return named.name;
}

var toString = Object.prototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) {
        depth = -1;
    }
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) {
                depth++;
            }
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor,
            bCtor = b.constructor;
        if (aCtor !== bCtor && !(typeof aCtor === "function" && aCtor instanceof aCtor && typeof bCtor === "function" && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) {
            return false;
        }
    }
    if (depth === 0) {
        return false;
    } else if (depth < 0) {
        depth = -1;
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key = void 0;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while (length--) {
            // Deep compare each member
            key = keys[length];
            if (!(has$1(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function has$1(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}

/**
 * (c) Michel Weststrate 2015 - 2018
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
if (typeof Proxy === "undefined" || typeof Symbol === "undefined") {
    throw new Error("[mobx] MobX 5+ requires Proxy and Symbol objects. If your environment doesn't support Symbol or Proxy objects, please downgrade to MobX 4. For React Native Android, consider upgrading JSCore.");
}
try {
    // define process.env if needed
    // if this is not a production build in the first place
    // (in which case the expression below would be substituted with 'production')
    "production";
} catch (e) {
    var g = getGlobal();
    if (typeof process === "undefined") g.process = {};
    g.process.env = {};
}
(function () {
    function testCodeMinification() {}
    if (testCodeMinification.name !== "testCodeMinification" && "production" !== "production" && typeof process !== 'undefined' && process.env.IGNORE_MOBX_MINIFY_WARNING !== "true") {
        // trick so it doesn't get replaced
        var varName = ["process", "env", "NODE_ENV"].join(".");
        console.warn("[mobx] you are running a minified build, but '" + varName + "' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
    }
})();
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    // See: https://github.com/andykog/mobx-devtools/
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
        spy: spy,
        extras: {
            getDebugName: getDebugName
        },
        $mobx: $mobx
    });
}


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("b8fj")))

/***/ }),

/***/ "7AqT":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("ZHvQ");
var ITERATOR = __webpack_require__("Ug9I")('iterator');
var Iterators = __webpack_require__("dhak");
module.exports = __webpack_require__("zKeE").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),

/***/ "9HBQ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("HrPq");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9kJF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__("1kq3");
var global = __webpack_require__("i1Q6");
var ctx = __webpack_require__("3zRh");
var classof = __webpack_require__("ZHvQ");
var $export = __webpack_require__("vSO4");
var isObject = __webpack_require__("BxvP");
var aFunction = __webpack_require__("g31e");
var anInstance = __webpack_require__("KUik");
var forOf = __webpack_require__("ozpD");
var speciesConstructor = __webpack_require__("B1ls");
var task = __webpack_require__("uzcO").set;
var microtask = __webpack_require__("H109")();
var newPromiseCapabilityModule = __webpack_require__("AIlg");
var perform = __webpack_require__("kX4D");
var userAgent = __webpack_require__("/cCi");
var promiseResolve = __webpack_require__("5Czc");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function empty() {/* empty */};
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("Ug9I")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise
    // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // we can't detect it synchronously, so just check versions
    && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) {/* empty */}
}();

// helpers
var isThenable = function isThenable(it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function notify(promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function run(reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) {
      run(chain[i++]);
    } // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function onUnhandled(promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    }promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function isUnhandled(promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function onHandleUnhandled(promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function $reject(value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function $resolve(value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = []; // <- awaiting reactions
    this._a = undefined; // <- checked in isUnhandled reactions
    this._s = 0; // <- state
    this._d = false; // <- done
    this._v = undefined; // <- value
    this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false; // <- notify
  };
  Internal.prototype = __webpack_require__("O6kh")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function OwnPromiseCapability() {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
    return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("11Ut")($Promise, PROMISE);
__webpack_require__("FGzK")(PROMISE);
Wrapper = __webpack_require__("zKeE")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("Lli7")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

/***/ }),

/***/ "9kxq":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("BxvP");
var document = __webpack_require__("i1Q6").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ "9u1Q":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("tuDi");
__webpack_require__("i+u+");
__webpack_require__("COf8");
__webpack_require__("9kJF");
__webpack_require__("zaru");
__webpack_require__("+CEt");
module.exports = __webpack_require__("zKeE").Promise;

/***/ }),

/***/ "AIlg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)

var aFunction = __webpack_require__("g31e");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

/***/ }),

/***/ "Aa2f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim

var global = __webpack_require__("i1Q6");
var has = __webpack_require__("yS17");
var DESCRIPTORS = __webpack_require__("6MLN");
var $export = __webpack_require__("vSO4");
var redefine = __webpack_require__("gojl");
var META = __webpack_require__("e8vu").KEY;
var $fails = __webpack_require__("wLcK");
var shared = __webpack_require__("NB7d");
var setToStringTag = __webpack_require__("11Ut");
var uid = __webpack_require__("X6va");
var wks = __webpack_require__("Ug9I");
var wksExt = __webpack_require__("ZxII");
var wksDefine = __webpack_require__("c2zY");
var enumKeys = __webpack_require__("ycyv");
var isArray = __webpack_require__("ayXv");
var anObject = __webpack_require__("zotD");
var isObject = __webpack_require__("BxvP");
var toObject = __webpack_require__("mbLO");
var toIObject = __webpack_require__("Wyka");
var toPrimitive = __webpack_require__("EKwp");
var createDesc = __webpack_require__("0WCH");
var _create = __webpack_require__("TNJq");
var gOPNExt = __webpack_require__("rMkZ");
var $GOPD = __webpack_require__("sxPs");
var $GOPS = __webpack_require__("Ocr3");
var $DP = __webpack_require__("Gfzd");
var $keys = __webpack_require__("knrM");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function get() {
      return dP(this, 'a', { value: 7 }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    }return setSymbolDesc(it, key, D);
  }return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("Ni5N").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("z7R8").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("1kq3")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols =
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  wks(es6Symbols[j++]);
}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
  wksDefine(wellKnownSymbols[k++]);
}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) {
      if (SymbolRegistry[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () {
  $GOPS.f(1);
});

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }$replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("akPY")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),

/***/ "Aq8W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("dXs8"), __esModule: true };

/***/ }),

/***/ "B1ls":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("zotD");
var aFunction = __webpack_require__("g31e");
var SPECIES = __webpack_require__("Ug9I")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),

/***/ "B9Lq":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("yS17");
var toIObject = __webpack_require__("Wyka");
var arrayIndexOf = __webpack_require__("LNnS")(false);
var IE_PROTO = __webpack_require__("/wuY")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),

/***/ "BMrJ":
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var memoize = function memoize(fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = function (fn) {
	var memo = {};

	return function (selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector];
	};
}(function (target) {
	return document.querySelector(target);
});

var singleton = null;
var singletonCounter = 0;
var stylesInsertedAtTop = [];

var fixUrls = __webpack_require__("DRTY");

module.exports = function (list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if (newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if (domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j]();
				}delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if (domStyle) {
			domStyle.refs++;

			for (var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for (; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for (var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = { css: css, media: media, sourceMap: sourceMap };

		if (!newStyles[id]) styles.push(newStyles[id] = { id: id, parts: [part] });else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement(options, style) {
	var target = getElement(options.insertInto);

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if (idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement(options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs(el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
		result = options.transform(obj.css);

		if (result) {
			// If transform returns a value, use that instead of the original css.
			// This allows running runtime transformations on the css.
			obj.css = result;
		} else {
			// If the transform function returns a falsy value, don't add this css.
			// This allows conditional loading of css
			return function () {
				// noop
			};
		}
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);
	} else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function remove() {
			removeStyleElement(style);

			if (style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function remove() {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if (newObj) {
			if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
}();

function applyToSingletonTag(style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag(style, obj) {
	var css = obj.css;
	var media = obj.media;

	if (media) {
		style.setAttribute("media", media);
	}

	if (style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while (style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink(link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
 	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
 	and there is no publicPath defined then lets turn convertToAbsoluteUrls
 	on by default.  Otherwise default to the convertToAbsoluteUrls option
 	directly
 */
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if (oldSrc) URL.revokeObjectURL(oldSrc);
}

/***/ }),

/***/ "BtxX":
/***/ (function(module, exports) {

(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}

  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function () {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new this.constructor(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    return new Promise(function (resolve, reject) {
      if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
      var args = Array.prototype.slice.call(arr);
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = typeof setImmediate === 'function' && function (fn) {
    setImmediate(fn);
  } || function (fn) {
    setTimeoutFunc(fn, 0);
  };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }
})(this);

/***/ }),

/***/ "BxvP":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ "COf8":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("OYXR");
var global = __webpack_require__("i1Q6");
var hide = __webpack_require__("akPY");
var Iterators = __webpack_require__("dhak");
var TO_STRING_TAG = __webpack_require__("Ug9I")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),

/***/ "DRTY":
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
	// get current location
	var location = typeof window !== "undefined" && window.location;

	if (!location) {
		throw new Error("fixUrls requires window.location");
	}

	// blank or null?
	if (!css || typeof css !== "string") {
		return css;
	}

	var baseUrl = location.protocol + "//" + location.host;
	var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
 This regular expression is just a way to recursively match brackets within
 a string.
 	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
    (  = Start a capturing group
      (?:  = Start a non-capturing group
          [^)(]  = Match anything that isn't a parentheses
          |  = OR
          \(  = Match a start parentheses
              (?:  = Start another non-capturing groups
                  [^)(]+  = Match anything that isn't a parentheses
                  |  = OR
                  \(  = Match a start parentheses
                      [^)(]*  = Match anything that isn't a parentheses
                  \)  = Match a end parentheses
              )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
  \)  = Match a close parens
 	 /gi  = Get all matches, not the first.  Be case insensitive.
  */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
			return $1;
		}).replace(/^'(.*)'$/, function (o, $1) {
			return $1;
		});

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
			//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};

/***/ }),

/***/ "E5Ce":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("ShN9");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),

/***/ "EKwp":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("BxvP");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ "FFZn":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("3v7p"), __esModule: true };

/***/ }),

/***/ "FGzK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__("i1Q6");
var core = __webpack_require__("zKeE");
var dP = __webpack_require__("Gfzd");
var DESCRIPTORS = __webpack_require__("6MLN");
var SPECIES = __webpack_require__("Ug9I")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function get() {
      return this;
    }
  });
};

/***/ }),

/***/ "Gfzd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("zotD");
var IE8_DOM_DEFINE = __webpack_require__("R6c1");
var toPrimitive = __webpack_require__("EKwp");
var dP = Object.defineProperty;

exports.f = __webpack_require__("6MLN") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ "GyB/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("6t7t");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("ibPW");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "H109":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("i1Q6");
var macrotask = __webpack_require__("uzcO").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("ShN9")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function flush() {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();else last = undefined;
        throw e;
      }
    }last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function notify() {
      process.nextTick(flush);
    };
    // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function notify() {
      node.data = toggle = !toggle;
    };
    // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function notify() {
      promise.then(flush);
    };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
  } else {
    notify = function notify() {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    }last = task;
  };
};

/***/ }),

/***/ "HHE0":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("yS17");
var toObject = __webpack_require__("mbLO");
var IE_PROTO = __webpack_require__("/wuY")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }return O instanceof Object ? ObjectProto : null;
};

/***/ }),

/***/ "HJJD":
/***/ (function(module, exports) {

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "HrPq":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".table-fixed__3o0WG tbody{height:calc(100vh - 200px);overflow-y:auto;width:100%}.table-fixed__3o0WG tbody,.table-fixed__3o0WG td,.table-fixed__3o0WG th,.table-fixed__3o0WG thead,.table-fixed__3o0WG tr{display:block}.table-fixed__3o0WG tr:after{content:\"\";display:block;visibility:hidden;clear:both}.table-fixed__3o0WG tbody td,.table-fixed__3o0WG thead>tr>th{float:left}.hoveronly__3e2zK{display:none}.tableline__2DdxV:hover .hoveronly__3e2zK{display:inline}.hoverelementonly__2Fl4q,.tableline__2DdxV:hover .hoverhide__NO_-6{display:none}.element__2HEYz:hover .hoverelementonly__2Fl4q{display:inline}.element__2HEYz:hover .hoverelementhide__3Ias-{display:none}.badge-outline__1On3Z{font-weight:400;color:gray;border:1px solid gray;background-color:transparent}.pointerCursor__3jt8z{cursor:pointer;pointer-events:inherit}.code__8z0Dp{display:block;white-space:pre-wrap}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/maillogs/style.css"],"names":[],"mappings":"AAAA,0BACI,2BAA4B,AAC5B,gBAAiB,AACjB,UAAY,CACf,AACD,yHAKI,aAAe,CAClB,AACD,6BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,6DAEI,UAAY,CACf,AAED,kBACI,YAAc,CACjB,AACD,0CACI,cAAiB,CACpB,AAKD,mEACI,YAAc,CACjB,AACD,+CACI,cAAiB,CACpB,AACD,+CACI,YAAe,CAClB,AAED,sBACI,gBAAiB,AACjB,WAAe,AACf,sBAA0B,AAC1B,4BAA8B,CACjC,AAED,sBACI,eAAgB,AAChB,sBAAwB,CAC3B,AAED,aACI,cAAe,AACf,oBAAqB,CACtB","file":"style.css","sourcesContent":[".table-fixed tbody {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    width: 100%;\n}\n.table-fixed thead,\n.table-fixed tbody,\n.table-fixed tr,\n.table-fixed td,\n.table-fixed th {\n    display: block;\n}\n.table-fixed tr:after {\n    content: \"\";\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n.table-fixed tbody td,\n.table-fixed thead > tr > th {\n    float: left;\n}\n\n.hoveronly { \n    display: none;\n}\n.tableline:hover .hoveronly {\n    display : inline;\n}\n.tableline:hover .hoverhide {\n    display : none;\n}\n\n.hoverelementonly {\n    display: none;\n}\n.element:hover .hoverelementonly {\n    display : inline;\n}\n.element:hover .hoverelementhide {\n    display : none;\n}\n\n.badge-outline {\n    font-weight: 400;\n    color: #808080;\n    border: 1px solid #808080;\n    background-color: transparent;\n}\n\n.pointerCursor {\n    cursor: pointer;\n    pointer-events: inherit;\n}\n\n.code {\n    display: block;\n    white-space: pre-wrap   \n  }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table-fixed": "table-fixed__3o0WG",
	"hoveronly": "hoveronly__3e2zK",
	"tableline": "tableline__2DdxV",
	"hoverhide": "hoverhide__NO_-6",
	"hoverelementonly": "hoverelementonly__2Fl4q",
	"element": "element__2HEYz",
	"hoverelementhide": "hoverelementhide__3Ias-",
	"badge-outline": "badge-outline__1On3Z",
	"pointerCursor": "pointerCursor__3jt8z",
	"code": "code__8z0Dp"
};

/***/ }),

/***/ "Hzzu":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("WHk1");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ID6i":
/***/ (function(module, exports) {

module.exports = function () {/* empty */};

/***/ }),

/***/ "J6GP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function (qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr,
        vstr,
        k,
        v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("T4f3");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// CONCATENATED MODULE: ../node_modules/preact-habitat/dist/preact-habitat.es.js



/**
 * Removes `-` fron a string and capetalize the letter after
 * example: data-props-hello-world =>  dataPropsHelloWorld
 * Used for props passed from host DOM element
 * @param  {String} str string
 * @return {String} Capetalized string
 */
var camelcasize = function camelcasize(str) {
  return str.replace(/-([a-z])/gi, function (all, letter) {
    return letter.toUpperCase();
  });
};

/**
 * [getExecutedScript internal widget to provide the currently executed script]
 * @param  {document} document [Browser document object]
 * @return {HTMLElement}     [script Element]
 */
var getExecutedScript = function getExecutedScript() {
  return document.currentScript || function () {
    var scripts = document.getElementsByTagName("script");
    return scripts[scripts.length - 1];
  }();
};

/**
 * Get the props from a host element's data attributes
 * @param  {Element} tag The host element
 * @return {Object}  props object to be passed to the component
 */
var preact_habitat_es_collectPropsFromElement = function collectPropsFromElement(element, defaultProps) {
  if (defaultProps === void 0) defaultProps = {};

  var attrs = element.attributes;

  var props = extends_default()({}, defaultProps);

  // collect from element
  Object.keys(attrs).forEach(function (key) {
    if (attrs.hasOwnProperty(key)) {
      var dataAttrName = attrs[key].name;
      if (!dataAttrName || typeof dataAttrName !== "string") {
        return false;
      }
      var propName = dataAttrName.split(/(data-props?-)/).pop() || '';
      propName = camelcasize(propName);
      if (dataAttrName !== propName) {
        var propValue = attrs[key].nodeValue;
        props[propName] = propValue;
      }
    }
  });

  // check for child script text/props or application/json
  [].forEach.call(element.getElementsByTagName('script'), function (scrp) {
    var propsObj = {};
    if (scrp.hasAttribute('type')) {
      if (scrp.getAttribute("type") !== "text/props" && scrp.getAttribute("type") !== "application/json") {
        return;
      }
      try {
        propsObj = JSON.parse(scrp.innerHTML);
      } catch (e) {
        throw new Error(e);
      }
      extends_default()(props, propsObj);
    }
  });

  return props;
};

var getHabitatSelectorFromClient = function getHabitatSelectorFromClient(currentScript) {
  var scriptTagAttrs = currentScript.attributes;
  var selector = null;
  // check for another props attached to the tag
  Object.keys(scriptTagAttrs).forEach(function (key) {
    if (scriptTagAttrs.hasOwnProperty(key)) {
      var dataAttrName = scriptTagAttrs[key].name;
      if (dataAttrName === 'data-mount-in') {
        selector = scriptTagAttrs[key].nodeValue;
      }
    }
  });
  return selector;
};

/**
 * Return array of 0 or more elements that will host our widget
 * @param  {id} attrId the data widget id attribute the host should have
 * @param  {document} scope  Docuemnt object or DOM Element as a scope
 * @return {Array}        Array of matching habitats
 */
var widgetDOMHostElements = function widgetDOMHostElements(ref) {
  var selector = ref.selector;
  var inline = ref.inline;
  var clientSpecified = ref.clientSpecified;

  var hostNodes = [];
  var currentScript = getExecutedScript();

  if (inline === true) {
    var parentNode = currentScript.parentNode;
    hostNodes.push(parentNode);
  }
  if (clientSpecified === true && !selector) {
    // user did not specify where to mount - get it from script tag attributes
    selector = getHabitatSelectorFromClient(currentScript);
  }
  if (selector) {
    [].forEach.call(document.querySelectorAll(selector), function (queriedTag) {
      hostNodes.push(queriedTag);
    });
  }
  return hostNodes;
};

/**
 * preact render function that will be queued if the DOM is not ready
 * and executed immeidatly if DOM is ready
 */
var preact_habitat_es_preactRender = function preactRender(widget, hostElements, root, cleanRoot, defaultProps) {
  hostElements.forEach(function (elm) {
    var hostNode = elm;
    if (hostNode._habitat) {
      return;
    }
    hostNode._habitat = true;
    var props = preact_habitat_es_collectPropsFromElement(elm, defaultProps) || defaultProps;
    if (cleanRoot) {
      hostNode.innerHTML = "";
    }
    return Object(preact_min["render"])(Object(preact_min["h"])(widget, props), hostNode, root);
  });
};

var habitat = function habitat(Widget) {
  // Widget represents the Preact component we need to mount
  var widget = Widget;
  // preact root render helper
  var root = null;

  var render$$1 = function render$$1(ref) {
    if (ref === void 0) ref = {};
    var selector = ref.selector;if (selector === void 0) selector = null;
    var inline = ref.inline;if (inline === void 0) inline = false;
    var clean = ref.clean;if (clean === void 0) clean = false;
    var clientSpecified = ref.clientSpecified;if (clientSpecified === void 0) clientSpecified = false;
    var defaultProps = ref.defaultProps;if (defaultProps === void 0) defaultProps = {};

    var elements = widgetDOMHostElements({
      selector: selector,
      inline: inline,
      clientSpecified: clientSpecified
    });
    var loaded = function loaded() {
      if (elements.length > 0) {
        var elements$1 = widgetDOMHostElements({
          selector: selector,
          inline: inline,
          clientSpecified: clientSpecified
        });

        return preact_habitat_es_preactRender(widget, elements$1, root, clean, defaultProps);
      }
    };
    loaded();
    document.addEventListener("DOMContentLoaded", loaded);
    document.addEventListener("load", loaded);
  };

  return { render: render$$1 };
};

/* harmony default export */ var preact_habitat_es = (habitat);
//# sourceMappingURL=preact-habitat.es.js.map
// EXTERNAL MODULE: ../node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("aIIw");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("kcQR");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("dACh");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("VOrx");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("ZKjc");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ../node_modules/pubsub-js/src/pubsub.js
var pubsub = __webpack_require__("/Muo");
var pubsub_default = /*#__PURE__*/__webpack_require__.n(pubsub);

// CONCATENATED MODULE: ./lib/pubsub.js


var topics = {
    LOG_OUT: 'logOut',

    // to show progress when running long-living tasks. Should be [0-100]
    LOADING_PROGRESS: 'loadingProgress',

    // when user has authenticated, this is used to update to the new token
    JWT_TOKEN_CHANGED: 'jwtTokenChanged',

    ERROR_MESSAGE: 'errorMessage',

    STATUS_MESSAGE: 'statusMessage',

    INDICATE_FETCH_CONTENT_START: 'indicateFetchContentStart',
    INDICATE_FETCH_CONTENT_STOP: 'indicateFetchContentStop'
};

var ps = {
    publish: function publish(topic, message) {
        pubsub_default.a.publish(topic, message);
    },

    subscribe: function subscribe(topic, callback) {
        pubsub_default.a.subscribe(topic, function (_, message) {
            callback(message);
        });
    }
};

/* harmony default export */ var lib_pubsub = (ps);

// EXTERNAL MODULE: ../node_modules/querystring-es3/index.js
var querystring_es3 = __webpack_require__("+00f");
var querystring_es3_default = /*#__PURE__*/__webpack_require__.n(querystring_es3);

// CONCATENATED MODULE: ./lib/util.js









var API_SERVER_KEY = 'apiServer';
var PREVIEW_SERVER_KEY = 'previewServer';
var IMAGE_SERVER_KEY = 'imageServer';
var JWT_TOKEN_KEY = 'jwtToken';
var USER_EMAIL = 'userEmail';
var IS_MAC = /Mac/.test(navigator.platform);

var util__ref2 = Object(preact_min["h"])('i', { 'class': 'fas fa-sort-amount-up ml-2' });

var util__ref3 = Object(preact_min["h"])('i', { 'class': 'fas fa-sort-amount-down ml-2' });

var util_Utilities = function () {
    function Utilities() {
        classCallCheck_default()(this, Utilities);
    }

    /**
     *
     * @param object
     * @param name Name of key on level 1
     * @param name Name of key on level 2
     * ...
     * @param name Name of key on level N
     * @returns {true|false}
     * @example
     *    Let's say you have object:
     *      obj = {
     *            foo: {
     *                bar: 1
     *            }
     *        };
     *    1. You want to check if obj.foo.bar exists:
     *      checkNested(obj, 'foo', 'bar');
     *          returns true
     *    2. You want to check if obj.foo.bar.gomle exists:
     *      checkNested(obj, 'foo', 'bar', 'gomle');
     *          returns false
     */
    Utilities.checkNested = function checkNested($obj) {
        var obj = $obj;

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        for (var i = 0; i < args.length; i += 1) {
            if (!obj || !obj.hasOwnProperty(args[i])) {
                return false;
            }
            obj = obj[args[i]];
        }
        return true;
    };

    Utilities.asString = function asString($obj) {
        for (var _len2 = arguments.length, $args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            $args[_key2 - 1] = arguments[_key2];
        }

        var args = $args;
        if (Array.isArray(args[0])) {
            args = args[0];
        }
        // let args = Array.prototype.slice.call(arguments, 1);
        var obj = $obj;
        for (var i = 0; i < args.length; i += 1) {
            if (!obj || !obj.hasOwnProperty(args[i])) {
                return false;
            }
            obj = obj[args[i]];
        }
        return obj;
    };

    Utilities.asBoolean = function asBoolean($obj) {
        for (var _len3 = arguments.length, $args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            $args[_key3 - 1] = arguments[_key3];
        }

        var args = $args;
        if (Array.isArray(args[0])) {
            args = args[0];
        }
        // let args = Array.prototype.slice.call(arguments, 1);
        var obj = $obj;
        for (var i = 0; i < args.length; i += 1) {
            if (!obj || !obj.hasOwnProperty(args[i])) {
                return false;
            }
            obj = obj[args[i]];
        }
        return obj;
    };

    Utilities.asObject = function asObject($obj) {
        for (var _len4 = arguments.length, $args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
            $args[_key4 - 1] = arguments[_key4];
        }

        var args = $args;
        if (Array.isArray(args[0])) {
            args = args[0];
        }
        // let args = Array.prototype.slice.call(arguments, 1);
        var obj = $obj;
        for (var i = 0; i < args.length; i += 1) {
            if (!obj || !obj.hasOwnProperty(args[i])) {
                return {};
            }
            obj = obj[args[i]];
        }
        if (typeof obj === 'object') {
            return obj;
        }
        return {};
    };

    Utilities.asNumber = function asNumber($obj) {
        for (var _len5 = arguments.length, $args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
            $args[_key5 - 1] = arguments[_key5];
        }

        var args = $args;
        if (Array.isArray(args[0])) {
            args = args[0];
        }
        // let args = Array.prototype.slice.call(arguments, 1);
        var obj = $obj;
        for (var i = 0; i < args.length; i += 1) {
            if (!obj || !obj.hasOwnProperty(args[i])) {
                return 0;
            }
            obj = obj[args[i]];
        }
        return parseFloat(obj);
    };

    Utilities.getNestedValue = function getNestedValue(obj, path) {
        var el = obj;
        if (typeof el !== 'object' || el === null) {
            return null;
        }
        path.split('.').forEach(function (part) {
            if (typeof el[part] === 'undefined') {
                el = null;
            }

            if (el) {
                el = el[part];
            }
        });
        return el;
    };

    Utilities.setNestedValue = function setNestedValue(obj, is, value) {
        if (typeof obj === 'undefined') {
            return null;
        }
        if (typeof is === 'string') {
            return Utilities.setNestedValue(obj, is.split('.'), value);
        }
        if (is.length === 1 && value !== undefined) {
            // eslint-disable-next-line
            return obj[is[0]] = value;
        }
        if (is.length === 0) {
            return obj;
        }
        return Utilities.setNestedValue(obj[is[0]], is.slice(1), value);
    };

    Utilities.cleanObject = function cleanObject($obj) {
        var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var obj = extends_default()({}, $obj);
        var keys = Object.keys(obj);
        for (var i = 0; i < keys.length; i += 1) {
            var idx = keys[i];
            if (obj.hasOwnProperty(idx)) {
                if (typeof obj[idx] === 'undefined' || obj[idx] === false) {
                    delete obj[idx];
                }
                if (opt.emptyIsUndefined && obj[idx] === '') {
                    delete obj[idx];
                }
                if (opt.zeroIsUndefined && obj[idx] === 0) {
                    delete obj[idx];
                }
                if (opt.zeroStringIsUndefined && obj[idx] === '0') {
                    delete obj[idx];
                }
                if (opt.nullIsUndefined && obj[idx] === null) {
                    delete obj[idx];
                }
            }
        }
        return obj;
    };

    Utilities.padDate = function padDate(number) {
        var r = String(number);
        if (r.length === 1) {
            r = '0' + r;
        }
        return r;
    };

    Utilities.parseInputDate = function parseInputDate(inputDate) {
        var parsedDate = void 0;
        if (typeof inputDate === 'string' || typeof inputDate === 'number') {
            if (inputDate > 1000000000 && inputDate < 9999999999) {
                parsedDate = new Date(0); // The 0 there is the key, which sets the date to the epoch
                parsedDate.setUTCSeconds(inputDate);
            } else if (inputDate > 1000000000000 && inputDate < 9999999999999) {
                parsedDate = new Date(0); // The 0 there is the key, which sets the date to the epoch
                parsedDate.setUTCSeconds(parseInt(inputDate / 1000, 10));
            } else if (typeof inputDate === 'string' && inputDate.match(/\d{4}-\d{2}-\d{2}/)) {
                // "d.m.y"
                parsedDate = new Date(inputDate);
            }
        } else {
            parsedDate = new Date();
        }
        return parsedDate;
    };

    Utilities.isoDate = function isoDate(inputDate) {
        var showSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var showTimezone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var availDate = Utilities.parseInputDate(inputDate);
        // "d.m.y"
        if (availDate) {
            var mm = availDate.getMonth() + 1;
            var dd = availDate.getDate();
            var yy = availDate.getFullYear();
            var hh = availDate.getHours();
            var mi = availDate.getMinutes();
            var ss = availDate.getSeconds();
            var tzo = -availDate.getTimezoneOffset();
            var dif = tzo >= 0 ? '+' : '-';

            var ret = Utilities.padDate(yy) + '-' + Utilities.padDate(mm) + '-' + Utilities.padDate(dd);
            ret += ' ' + Utilities.padDate(hh) + ':' + Utilities.padDate(mi);
            if (showSeconds) {
                ret += ':' + Utilities.padDate(ss);
            }
            if (showTimezone) {
                ret += '' + dif + tzo;
            }
            return ret;
        }
        return 'n/a';
    };

    Utilities.ffeDateTime = function ffeDateTime(inputDate) {
        var showSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var showTimezone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var availDate = Utilities.parseInputDate(inputDate);
        // "d.m.y"
        if (availDate) {
            var mm = availDate.getMonth() + 1;
            var dd = availDate.getDate();
            var yy = availDate.getFullYear();
            var hh = availDate.getHours();
            var mi = availDate.getMinutes();
            var ss = availDate.getSeconds();
            var tzo = -availDate.getTimezoneOffset();
            var dif = tzo >= 0 ? '+' : '-';

            var date = Utilities.padDate(dd) + '.' + Utilities.padDate(mm) + '.' + Utilities.padDate(yy);
            var time = Utilities.padDate(hh) + ':' + Utilities.padDate(mi);
            if (showSeconds) {
                time += ':' + Utilities.padDate(ss);
            }
            if (showTimezone) {
                time += '' + dif + tzo;
            }
            return date + ' ' + time;
        }
        return 'n/a';
    };

    Utilities.getApiServer = function getApiServer() {
        return localStorage.getItem(API_SERVER_KEY);
    };

    Utilities.setApiServer = function setApiServer(apiServer) {
        return localStorage.setItem(API_SERVER_KEY, apiServer);
    };

    Utilities.getPreviewServer = function getPreviewServer() {
        return localStorage.getItem(PREVIEW_SERVER_KEY);
    };

    Utilities.setPreviewServer = function setPreviewServer(previewServer) {
        return localStorage.setItem(PREVIEW_SERVER_KEY, previewServer);
    };

    Utilities.getImageServer = function getImageServer() {
        return localStorage.getItem(IMAGE_SERVER_KEY);
    };

    Utilities.setImageServer = function setImageServer(imageServer) {
        return localStorage.setItem(IMAGE_SERVER_KEY, imageServer);
    };

    Utilities.getJwtToken = function getJwtToken() {
        return localStorage.getItem(JWT_TOKEN_KEY);
    };

    Utilities.setJwtToken = function setJwtToken(token) {
        return localStorage.setItem(JWT_TOKEN_KEY, token);
    };

    Utilities.removeJwtToken = function removeJwtToken() {
        return localStorage.removeItem(JWT_TOKEN_KEY);
    };

    Utilities.setUserEmail = function setUserEmail(email) {
        return localStorage.setItem(USER_EMAIL, email);
    };

    Utilities.getUserEmail = function getUserEmail() {
        return localStorage.getItem(USER_EMAIL);
    };

    Utilities.removeUserEmail = function removeUserEmail() {
        return localStorage.removeItem(USER_EMAIL);
    };

    Utilities.setObject = function setObject(objKey, key, val) {
        var value = localStorage.getItem(objKey);
        var obj = {};
        if (typeof key === 'object') {
            obj = extends_default()({}, key);
        } else {
            if (typeof value === 'string') {
                obj = JSON.parse(value);
            }
            obj[key] = val;
        }
        return localStorage.setItem(objKey, JSON.stringify(obj));
    };

    Utilities.unsetObj = function unsetObj(objKey, key) {
        if (typeof key === 'string') {
            return Utilities.setObject(objKey, key, null);
        }
        return localStorage.setItem(objKey, null);
    };

    Utilities.getObject = function getObject(objKey) {
        var data = JSON.parse(localStorage.getItem(objKey));
        // if (data === null) {
        //     data = {};
        // }
        return data;
    };

    Utilities.set = function set(key, val) {
        return localStorage.setItem(key, JSON.stringify(val));
    };

    Utilities.unset = function unset(key) {
        return localStorage.setItem(key, null);
    };

    Utilities.get = function get(key) {
        return JSON.parse(localStorage.getItem(key));
    };

    /**
     *
     * @param endpoint
     * @param opts
     *  - method: PUT, GET, POST, etc.. Defaults to GET
     *  - publish: if true, use PubSub for various feedbacks (including error handling). Defaults to true
     * @param body
     * @returns {Promise<Promise<any>|Array>}
     */


    Utilities.fetchApi = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(endpoint) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var apiServer, shouldPublish, jwtToken, fetchOpt, qs, response;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            apiServer = Utilities.getApiServer();
                            shouldPublish = opts.hasOwnProperty('publish') ? opts.publish : true;


                            if (shouldPublish) {
                                lib_pubsub.publish(topics.LOADING_PROGRESS, 0);
                            }

                            jwtToken = Utilities.getJwtToken();
                            fetchOpt = extends_default()({
                                credentials: 'omit',
                                method: 'GET',
                                mode: 'cors',
                                cache: 'default',
                                headers: {},
                                publish: true
                            }, opts);


                            if (jwtToken) {
                                fetchOpt.headers = {
                                    Authorization: 'Bearer ' + jwtToken
                                };
                            }

                            qs = '';

                            if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(opts.method)) {
                                fetchOpt.credentials = 'include';
                                fetchOpt.body = JSON.stringify(body);
                                fetchOpt.headers['Content-Type'] = 'application/json';
                            } else {
                                qs = querystring_es3_default.a.stringify(body);
                            }

                            if (shouldPublish) {
                                lib_pubsub.publish(topics.LOADING_PROGRESS, 25);
                            }

                            _context.prev = 9;
                            _context.next = 12;
                            return fetch('' + apiServer + endpoint + (qs ? '?' + qs : ''), fetchOpt);

                        case 12:
                            response = _context.sent;

                            if (shouldPublish) {
                                lib_pubsub.publish(topics.LOADING_PROGRESS, 100);
                            }

                            if (!(response.status >= 500)) {
                                _context.next = 16;
                                break;
                            }

                            throw new Error(response.status + ' ' + response.statusText);

                        case 16:
                            return _context.abrupt('return', response.json());

                        case 19:
                            _context.prev = 19;
                            _context.t0 = _context['catch'](9);

                            if (!shouldPublish) {
                                _context.next = 24;
                                break;
                            }

                            lib_pubsub.publish(topics.ERROR_MESSAGE, 'An error occurred');
                            return _context.abrupt('return', []);

                        case 24:
                            throw _context.t0;

                        case 25:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[9, 19]]);
        }));

        function fetchApi(_x6) {
            return _ref.apply(this, arguments);
        }

        return fetchApi;
    }();

    Utilities.format = function format($number, $decimals, $decPoint, $thousandsSep) {
        var $compact = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

        var decimals = Number.isNaN($decimals) ? 2 : Math.abs($decimals);
        var decPoint = $decPoint === undefined ? ',' : $decPoint;
        var thousandsSep = $thousandsSep === undefined ? ' ' : $thousandsSep;

        var number = Math.abs($number || 0);
        var sign = Math.sign($number) >= 0 ? '' : '-';

        if ($compact) {
            if (number > 999999) {
                var compact = Utilities.format(number / 1000000, 1, $decPoint, $thousandsSep);
                return '' + sign + compact + 'M';
            }if (number > 999) {
                var _compact = Utilities.format(number / 1000, 1, $decPoint, $thousandsSep);
                return '' + sign + _compact + 'K';
            }
        }

        if (Utilities.isNumber(number)) {
            var intPart = String(parseInt(number.toFixed(decimals), 10));
            var j = intPart.length > 3 ? intPart.length % 3 : 0;

            var firstPart = j ? intPart.substr(0, j) + thousandsSep : '';
            var secondPart = intPart.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousandsSep);
            var decimalPart = decimals ? decPoint + Math.abs(number - intPart).toFixed(decimals).slice(2) : '';
            return '' + sign + firstPart + secondPart + decimalPart;
        }
        return '';
    };

    Utilities.formatCompact = function formatCompact(number) {
        return Utilities.format(number, 0, ',', ' ', true);
    };

    Utilities.formatBytes = function formatBytes($bytes, decimals) {
        var bytes = parseInt($bytes, 10);
        if (Utilities.isNumber(bytes)) {
            if (bytes === 0) {
                return '0 Bytes';
            }
            var k = 1024;
            var dm = decimals || 2;
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            var i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }
        return '';
    };

    Utilities.getDomain = function getDomain() {
        if (Utilities.checkNested(window, 'location')) {
            return window.location.hostname;
        }
        return undefined;
    };

    Utilities.getImageHostname = function getImageHostname() {
        var imageServer = Utilities.getImageServer();
        return imageServer;
    };

    Utilities.getImageSrc = function getImageSrc(image) {
        var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '220x';
        var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var defaultPrefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'product';

        if (typeof image === 'object') {
            if (image.newFilename) {
                return size + '/' + image.newFilename;
            }
            return size + '/' + (image.prefix || defaultPrefix) + '_' + index + '_' + image.filename + '.' + image.ext;
        }
        return '';
    };

    Utilities.isCapsLock = function isCapsLock(event) {
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

        var capsLock = false;
        var charCode = event.charCode;
        var shiftKey = event.shiftKey;

        if (charCode >= 97 && charCode <= 122) {
            capsLock = shiftKey;
        } else if (charCode >= 65 && charCode <= 90 && !(shiftKey && IS_MAC)) {
            capsLock = !shiftKey;
        }
        callback(capsLock);
    };

    Utilities.validateEmail = function validateEmail(email) {
        // eslint-disable-next-line
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    Utilities.ucfirst = function ucfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    Utilities.randomPassword = function randomPassword() {
        var randomstring = Math.random().toString(36).slice(-8);
        return randomstring;
    };

    Utilities.toggleDarkModeClasses = function toggleDarkModeClasses(isEnabled) {
        if (isEnabled) {
            document.body.classList.remove('bootstrap');
            document.body.classList.add('bootstrap-dark');
        } else {
            document.body.classList.remove('bootstrap-dark');
            document.body.classList.add('bootstrap');
        }
    };

    Utilities.cyclevalues = function cyclevalues() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var idx = values.findIndex(function (e) {
            return e === val;
        }) + 1;
        if (idx > values.length - 1) {
            idx = 0;
        }
        return values[idx];
    };

    Utilities.buttonClass = function buttonClass(val, type) {
        return 'btn-' + Utilities.colorClass(val, type, 'outline-');
    };

    Utilities.colorClass = function colorClass(val, type) {
        var prefixDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

        if (type === 'article') {
            switch (val) {
                case 1:
                    return 'warning';
                    break;
                case 2:
                    return 'success';
                    break;
                case 3:
                    return 'danger';
                    break;
                default:
                    return prefixDefault + 'secondary';
                    break;
            }
        } else if (type === 'yesno') {
            switch (val) {
                case 1:
                    return 'success';
                    break;
                default:
                    return prefixDefault + 'danger';
                    break;
            }
        } else {
            switch (val) {
                case 0:
                    return 'danger';
                    break;
                case 1:
                    return 'success';
                    break;
                default:
                    if (val < 0) {
                        return 'danger';
                    }
                    return prefixDefault + 'secondary';
                    break;
            }
        }
    };

    Utilities.statusText = function statusText(val, type) {
        if (type === 'article') {
            switch (val) {
                case 1:
                    return 'wip';
                    break;
                case 2:
                    return 'Live';
                    break;
                case 3:
                    return 'Dead';
                    break;
                default:
                    return 'Unknown';
                    break;
            }
        } else if (type === 'yesno') {
            switch (val) {
                case 1:
                    return 'yes';
                    break;
                default:
                    return 'no';
                    break;
            }
        } else {
            switch (val) {
                case 0:
                    return 'wip';
                    break;
                case 1:
                    return 'Live';
                    break;
                default:
                    return 'Unknown';
                    break;
            }
        }
    };

    Utilities.removeHtml = function removeHtml(content) {
        if (typeof content === 'string') {
            var newContent = content.replace(/<br>/g, '\n');
            newContent = newContent.replace(/<br \/>/g, '\n');
            newContent = newContent.replace(/^\s+/gm, '');
            return newContent;
        }
        return content;
    };

    Utilities.getType = function getType(element) {
        return Object.prototype.toString.call(element);
    };

    Utilities.isArray = function isArray(element) {
        if (Utilities.getType(element) === '[object Array]') {
            return true;
        }
        return false;
    };

    Utilities.isObject = function isObject(element) {
        if (Utilities.getType(element) === '[object Object]') {
            return true;
        }
        return false;
    };

    Utilities.isString = function isString(element) {
        if (Utilities.getType(element) === '[object String]') {
            return true;
        }
        return false;
    };

    Utilities.isDate = function isDate(element) {
        if (Utilities.getType(element) === '[object Date]') {
            return true;
        }
        return false;
    };

    Utilities.isNumber = function isNumber(element) {
        if (Utilities.getType(element) === '[object Number]' && !Number.isNaN(element)) {
            return true;
        }
        return false;
    };

    Utilities.makeArrayOfObject = function makeArrayOfObject(object) {
        var keys = Utilities.isObject(object) ? Object.keys(object) : [];
        var array = keys.map(function (e, idx) {
            return extends_default()({}, object[e], { idx: idx });
        });
        return array;
    };

    Utilities.makeObjectOfArray = function makeObjectOfArray(array) {
        var object = {};
        if (Utilities.isArray(array)) {
            array.forEach(function (e, idx) {
                object[idx + 1] = e;
            });
        }
        return object;
    };

    Utilities.makeField = function makeField(f, fields) {
        return {
            name: f,
            label: Utilities.asString(fields, f, 'label'),
            type: Utilities.asString(fields, f, 'type'),
            readonly: Utilities.asString(fields, f, 'readonly'),
            rows: Utilities.asString(fields, f, 'rows'),
            aliasFor: Utilities.asString(fields, f, 'aliasFor'),
            help: Utilities.asString(fields, f, 'help'),
            imagePrefix: Utilities.asString(fields, f, 'imagePrefix'),
            values: Utilities.asString(fields, f, 'values')
        };
    };

    Utilities.getSortIcon = function getSortIcon(name, sort) {
        if (name === sort) {
            return util__ref2;
        }
        if ('-' + name === sort) {
            return util__ref3;
        }
        return '';
    };

    return Utilities;
}();

/* harmony default export */ var util = (util_Utilities);
// CONCATENATED MODULE: ./components/error/index.js







var STATE = {
    ERROR_MESSAGE: 'errorMessage',
    TIMER: 'timer'
};

var ERROR_DISPLAY_MS = 10000;

var error__ref = Object(preact_min["h"])('i', { className: 'fas fa-times' });

var error_ErrorMessage = function (_Component) {
    inherits_default()(ErrorMessage, _Component);

    function ErrorMessage(props) {
        var _this$setState2;

        classCallCheck_default()(this, ErrorMessage);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.hideErrorBar = function (e) {
            var _this$setState;

            if (e) {
                e.preventDefault();
            }
            _this.setState((_this$setState = {}, _this$setState[STATE.ERROR_MESSAGE] = '', _this$setState[STATE.TIMER] = undefined, _this$setState));
        };

        _this.setState((_this$setState2 = {}, _this$setState2[STATE.ERROR_MESSAGE] = props.message, _this$setState2));

        lib_pubsub.subscribe(topics.ERROR_MESSAGE, function (msg) {
            var _this$setState3;

            _this.setState((_this$setState3 = {}, _this$setState3[STATE.ERROR_MESSAGE] = msg, _this$setState3));

            lib_pubsub.publish(topics.INDICATE_FETCH_CONTENT_STOP);
        });
        return _this;
    }

    ErrorMessage.prototype.componentDidUpdate = function componentDidUpdate(_, previousState) {
        var prevMsg = previousState[STATE.ERROR_MESSAGE] || '';
        var currMsg = this.state[STATE.ERROR_MESSAGE] || '';

        var displayMessage = prevMsg.length === 0 && currMsg.length > 0;
        var hideMessage = prevMsg.length > 0 && currMsg.length === 0;

        if (displayMessage) {
            var _setState;

            this.setState((_setState = {}, _setState[STATE.TIMER] = setTimeout(this.hideErrorBar, ERROR_DISPLAY_MS), _setState));
        } else if (hideMessage) {
            clearTimeout(this.state[STATE.TIMER]);
        }
    };

    ErrorMessage.prototype.render = function render() {
        if (!this.state[STATE.ERROR_MESSAGE]) {
            return '';
        }

        return Object(preact_min["h"])(
            'div',
            { 'class': 'container' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'alert alert-danger row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-11' },
                    this.state[STATE.ERROR_MESSAGE]
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-1' },
                    Object(preact_min["h"])(
                        'a',
                        { href: '#', onclick: this.hideErrorBar },
                        error__ref
                    )
                )
            )
        );
    };

    return ErrorMessage;
}(preact_min["Component"]);

/* harmony default export */ var error = (error_ErrorMessage);
// CONCATENATED MODULE: ./components/login/index.js











var login__ref2 = Object(preact_min["h"])(
    'h2',
    { 'class': 'mt-5 mb-5' },
    'Login'
);

var login__ref3 = Object(preact_min["h"])(error, null);

var login__ref4 = Object(preact_min["h"])(
    'label',
    { 'for': 'emailInput' },
    'Email address'
);

var login__ref5 = Object(preact_min["h"])(
    'label',
    { 'for': 'passwordInput' },
    'Password'
);

var login__ref6 = Object(preact_min["h"])(
    'div',
    { 'class': 'alert alert-danger', role: 'alert' },
    'CAPS LOCK is on!'
);

var login__ref7 = Object(preact_min["h"])(
    'label',
    { 'for': 'tokenInput' },
    '2FA Token'
);

var login__ref8 = Object(preact_min["h"])('input', { type: 'submit', value: 'Log in' });

var login_Login = function (_Component) {
    inherits_default()(Login, _Component);

    function Login(props) {
        var _this2 = this;

        classCallCheck_default()(this, Login);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.onAuthenticate = function () {
            var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(e) {
                var opts, body, loginResponse;
                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                e.preventDefault();
                                _context.prev = 1;
                                opts = {
                                    method: 'POST',
                                    publish: false
                                };
                                body = {
                                    email: _this.emailRef.value,
                                    pass: _this.passRef.value,
                                    token: _this.tokenRef.value
                                };
                                _context.next = 6;
                                return util.fetchApi('/api/login', opts, body);

                            case 6:
                                loginResponse = _context.sent;

                                if (!(loginResponse.status === 202 && loginResponse.needsTwoFactor)) {
                                    _context.next = 10;
                                    break;
                                }

                                lib_pubsub.publish(topics.ERROR_MESSAGE, loginResponse.message);
                                return _context.abrupt('return', _this.setState({
                                    showToken: true
                                }));

                            case 10:
                                if (!(![200, 202].includes(loginResponse.status) || !loginResponse.apiToken)) {
                                    _context.next = 12;
                                    break;
                                }

                                return _context.abrupt('return', Promise.reject(new error('Authentication failed')));

                            case 12:

                                util.setUserEmail(_this.emailRef.value);
                                lib_pubsub.publish(topics.JWT_TOKEN_CHANGED, loginResponse.apiToken);
                                _context.next = 20;
                                break;

                            case 16:
                                _context.prev = 16;
                                _context.t0 = _context['catch'](1);

                                lib_pubsub.publish(topics.ERROR_MESSAGE, 'Login failed');
                                console.log('onAuthenticate error', _context.t0);

                            case 20:
                                return _context.abrupt('return', true);

                            case 21:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2, [[1, 16]]);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.updateCapsLockStatus = function (isCapsLock) {
            _this.setState({
                isCapsLock: isCapsLock
            });
        };

        _this.state = {
            showToken: false,
            isCapsLock: false
        };
        _this.emailRef = {};
        _this.passRef = {};
        _this.tokenRef = {};
        return _this;
    }

    Login.prototype.render = function render() {
        var _this3 = this;

        var isCapsLock = this.state.isCapsLock;

        return Object(preact_min["h"])(
            'div',
            { 'class': 'container' },
            login__ref2,
            login__ref3,
            Object(preact_min["h"])(
                'form',
                { onsubmit: this.onAuthenticate },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'form-group' },
                    login__ref4,
                    Object(preact_min["h"])('input', { type: 'email',
                        'class': 'form-control',
                        name: 'email',
                        ref: function ref(r) {
                            _this3.emailRef = r;
                        },
                        id: 'emailInput',
                        onKeypress: function onKeypress(e) {
                            util.isCapsLock(e, _this3.updateCapsLockStatus);
                        }
                    })
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'form-group' },
                    login__ref5,
                    Object(preact_min["h"])('input', { type: 'password',
                        'class': 'form-control',
                        name: 'pass',
                        ref: function ref(r) {
                            _this3.passRef = r;
                        },
                        id: 'passwordInput',
                        onKeypress: function onKeypress(e) {
                            util.isCapsLock(e, _this3.updateCapsLockStatus);
                        }
                    })
                ),
                isCapsLock && login__ref6,
                this.state.showToken && Object(preact_min["h"])(
                    'div',
                    { 'class': 'form-group' },
                    login__ref7,
                    Object(preact_min["h"])('input', { type: 'number',
                        'class': 'form-control',
                        name: 'token',
                        ref: function ref(r) {
                            _this3.tokenRef = r;
                        },
                        id: 'tokenInput'
                    })
                ),
                login__ref8
            )
        );
    };

    return Login;
}(preact_min["Component"]);

/* harmony default export */ var login = (login_Login);
// CONCATENATED MODULE: ../node_modules/preact-router/dist/preact-router.es.js


var EMPTY$1 = {};

function preact_router_es_assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var preact_router_es_Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					preact_router_es_assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(preact_min["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(preact_min["Component"]);

var preact_router_es_Link = function Link(props) {
	return Object(preact_min["h"])('a', preact_router_es_assign({ onClick: handleLinkClick }, props));
};

var preact_router_es_Route = function Route(props) {
	return Object(preact_min["h"])(props.component, props);
};

preact_router_es_Router.subscribers = subscribers;
preact_router_es_Router.getCurrentUrl = getCurrentUrl;
preact_router_es_Router.route = route;
preact_router_es_Router.Router = preact_router_es_Router;
preact_router_es_Router.Route = preact_router_es_Route;
preact_router_es_Router.Link = preact_router_es_Link;

/* harmony default export */ var preact_router_es = (preact_router_es_Router);
//# sourceMappingURL=preact-router.es.js.map
// EXTERNAL MODULE: ../node_modules/mobx-preact/lib/index.module.js
var index_module = __webpack_require__("mKeQ");

// CONCATENATED MODULE: ../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
// CONCATENATED MODULE: ../node_modules/resolve-pathname/esm/resolve-pathname.js
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ var resolve_pathname = (resolvePathname);
// CONCATENATED MODULE: ../node_modules/value-equal/esm/value-equal.js

function value_equal_valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = value_equal_valueOf(a);
    var bValue = value_equal_valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(extends_default()({}, a, b)).every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ var value_equal = (valueEqual);
// CONCATENATED MODULE: ../node_modules/tiny-warning/dist/tiny-warning.esm.js
var isProduction = "production" === 'production';
function tiny_warning_esm_warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ var tiny_warning_esm = (tiny_warning_esm_warning);
// CONCATENATED MODULE: ../node_modules/tiny-invariant/dist/tiny-invariant.esm.js
var tiny_invariant_esm_isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function tiny_invariant_esm_invariant(condition, message) {
    if (condition) {
        return;
    }
    if (tiny_invariant_esm_isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}


// CONCATENATED MODULE: ../node_modules/history/esm/history.js






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = resolve_pathname(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && value_equal(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */

function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : tiny_invariant_esm_invariant(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : tiny_invariant_esm_invariant(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */

function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}


// CONCATENATED MODULE: ./components/progress/index.js







var progress_Progress = function (_Component) {
    inherits_default()(Progress, _Component);

    function Progress(props) {
        classCallCheck_default()(this, Progress);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = {
            progress: 0,
            display: 'block'
        };
        _this.subscriptions();
        return _this;
    }

    Progress.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LOADING_PROGRESS, function (progress) {
            if (progress === 100) {
                // Hide bar white we go back to 0;
                clearTimeout(_this2.timerAnimateId);
                _this2.timerAnimateId = setTimeout(function () {
                    _this2.setState({ display: 'none' });
                }, 700);
                // Set bar to go to 0:
                clearTimeout(_this2.timerResetId);
                _this2.timerResetId = setTimeout(function () {
                    _this2.setState({
                        progress: 0,
                        display: 'block'
                    });
                }, 1000);
            }
            if (progress === 0) {
                _this2.setState({ display: 'block' });
            }
            _this2.setState({
                progress: progress
            });
        });
    };

    Progress.prototype.render = function render() {
        var _state = this.state,
            progress = _state.progress,
            display = _state.display;

        return Object(preact_min["h"])(
            'div',
            { 'class': 'progress', style: 'height: 2px;' },
            Object(preact_min["h"])('div', { 'class': 'progress-bar progress-bar-striped progress-bar-animated',
                role: 'progressbar',
                'aria-valuenow': progress,
                'aria-valuemin': '0',
                'aria-valuemax': '100',
                style: 'width: ' + progress + '%; display: ' + display + ';'
            })
        );
    };

    return Progress;
}(preact_min["Component"]);

/* harmony default export */ var components_progress = (progress_Progress);
// CONCATENATED MODULE: ./components/status/index.js







var status_STATE = {
    STATUS_MESSAGE: 'statusMessage',
    TIMER: 'statusMessageTimer'
};

var STATUS_DISPLAY_MS = 5000;

var status__ref = Object(preact_min["h"])('i', { className: 'fas fa-times' });

var status_Status = function (_Component) {
    inherits_default()(Status, _Component);

    function Status(props) {
        var _this$setState2;

        classCallCheck_default()(this, Status);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.hideStatusBar = function (e) {
            var _this$setState;

            if (e) {
                e.preventDefault();
            }

            _this.setState((_this$setState = {}, _this$setState[status_STATE.STATUS_MESSAGE] = '', _this$setState[status_STATE.TIMER] = undefined, _this$setState));
        };

        _this.setState((_this$setState2 = {}, _this$setState2[status_STATE.STATUS_MESSAGE] = props.message, _this$setState2));

        _this.subscriptions();
        return _this;
    }

    Status.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.STATUS_MESSAGE, function (msg) {
            var _this2$setState;

            _this2.setState((_this2$setState = {}, _this2$setState[status_STATE.STATUS_MESSAGE] = msg, _this2$setState));
        });
    };

    Status.prototype.componentDidUpdate = function componentDidUpdate(_, previousState) {
        var prevMsg = previousState[status_STATE.STATUS_MESSAGE] || '';
        var currMsg = this.state[status_STATE.STATUS_MESSAGE] || '';

        var displayMessage = prevMsg.length === 0 && currMsg.length > 0;
        var hideMessage = prevMsg.length > 0 && currMsg.length === 0;

        if (displayMessage) {
            var _setState;

            this.setState((_setState = {}, _setState[status_STATE.TIMER] = setTimeout(this.hideStatusBar, STATUS_DISPLAY_MS), _setState));
        } else if (hideMessage) {
            clearTimeout(this.state[status_STATE.TIMER]);
        }
    };

    Status.prototype.render = function render() {
        if (!this.state[status_STATE.STATUS_MESSAGE]) {
            return '';
        }

        return Object(preact_min["h"])(
            'div',
            { 'class': 'container' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'alert alert-success row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-11' },
                    this.state[status_STATE.STATUS_MESSAGE]
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-1' },
                    Object(preact_min["h"])(
                        'a',
                        { href: '#', onclick: this.hideStatusBar },
                        status__ref
                    )
                )
            )
        );
    };

    return Status;
}(preact_min["Component"]);

/* harmony default export */ var components_status = (status_Status);
// CONCATENATED MODULE: ./components/navigation/index.js





var _class;





var initialState = {
    dealer: {}
};

var navigation__ref = Object(preact_min["h"])(
    'button',
    { 'class': 'navbar-toggler', type: 'button',
        'data-toggle': 'collapse',
        'data-target': '#navbarSupportedContent',
        'aria-controls': 'navbarSupportedContent',
        'aria-expanded': 'false',
        'aria-label': 'Toggle navigation'
    },
    Object(preact_min["h"])('span', { 'class': 'navbar-toggler-icon' })
);

var navigation__ref2 = Object(preact_min["h"])('ul', { 'class': 'navbar-nav mr-auto' });

var navigation__ref3 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/dealers' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-store-alt' }),
        ' Dealers'
    )
);

var navigation__ref4 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/brands' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-copyright' }),
        ' Brands'
    )
);

var navigation__ref5 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/categories' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-folder-open' }),
        ' Categories'
    )
);

var navigation__ref6 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/products' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-box' }),
        ' Products'
    )
);

var navigation__ref7 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/productcombos' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-boxes' }),
        ' Product combos'
    )
);

var navigation__ref8 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/tags' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-tag' }),
        ' Tags'
    )
);

var navigation__ref9 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/articles' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-file-alt' }),
        ' Articles'
    )
);

var navigation__ref10 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/consumers' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-user' }),
        ' Consumers'
    )
);

var navigation__ref11 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/rodregs' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-signature' }),
        ' Rodregs'
    )
);

var navigation__ref12 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/shipments' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-shipping-fast' }),
        ' Shipments'
    )
);

var navigation__ref13 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/maillogs' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-envelope' }),
        ' Mail logs'
    )
);

var _ref14 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/mailaddresses' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-at' }),
        ' Mail addresses'
    )
);

var _ref15 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/urls' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-link' }),
        ' Short urls'
    )
);

var _ref16 = Object(preact_min["h"])(
    'a',
    { 'class': 'nav-link', href: '/logout' },
    Object(preact_min["h"])(
        'nobr',
        null,
        Object(preact_min["h"])('i', { 'class': 'fas fa-sign-out-alt' }),
        ' Logout'
    )
);

var navigation_Navigation = Object(index_module["a" /* observer */])(_class = function (_Component) {
    inherits_default()(Navigation, _Component);

    function Navigation(props) {
        classCallCheck_default()(this, Navigation);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = extends_default()({}, initialState);
        return _this;
    }

    Navigation.prototype.render = function render(props) {
        var appState = this.props.stores.appState;
        var darkmode = appState.darkmode;
        var _props$path = props.path,
            path = _props$path === undefined ? '' : _props$path;

        return Object(preact_min["h"])(
            'nav',
            { 'class': 'navbar navbar-expand-lg navbar-themed' },
            Object(preact_min["h"])(
                'a',
                { 'class': 'navbar-brand', href: '/' },
                Object(preact_min["h"])('img', { src: '/img/logo' + (darkmode ? '-white' : '-black') + '.png', style: 'height: 40px;' })
            ),
            navigation__ref,
            Object(preact_min["h"])(
                'div',
                { 'class': 'collapse navbar-collapse', id: 'navbarSupportedContent' },
                navigation__ref2,
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'my-0 my-lg-0' },
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'navbar-nav mr-auto' },
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/dealers/) ? 'active' : '') },
                            navigation__ref3
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/brands/) ? 'active' : '') },
                            navigation__ref4
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/categories/) ? 'active' : '') },
                            navigation__ref5
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/products/) ? 'active' : '') },
                            navigation__ref6
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/productcombos/) ? 'active' : '') },
                            navigation__ref7
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/tags/) ? 'active' : '') },
                            navigation__ref8
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/articles/) ? 'active' : '') },
                            navigation__ref9
                        )
                    ),
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'navbar-nav mr-auto' },
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/consumers/) ? 'active' : '') },
                            navigation__ref10
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/rodregs/) ? 'active' : '') },
                            navigation__ref11
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/shipments/) ? 'active' : '') },
                            navigation__ref12
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/maillogs/) ? 'active' : '') },
                            navigation__ref13
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/mailaddresses/) ? 'active' : '') },
                            _ref14
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/urls/) ? 'active' : '') },
                            _ref15
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'nav-item ' + (path.match(/^\/logout/) ? 'active' : '') },
                            _ref16
                        ),
                        Object(preact_min["h"])(
                            'li',
                            { 'class': 'm' },
                            Object(preact_min["h"])(
                                'button',
                                { 'class': 'btn btn-link',
                                    onClick: function onClick() {
                                        return appState.toggleDarkmode();
                                    }
                                },
                                Object(preact_min["h"])('i', { 'class': (darkmode ? 'fas text-warning' : 'far') + ' fa-moon' })
                            )
                        )
                    )
                )
            )
        );
    };

    return Navigation;
}(preact_min["Component"])) || _class;

/* harmony default export */ var navigation = (navigation_Navigation);
// CONCATENATED MODULE: ./components/navigation/breadcrumb.js





var breadcrumb__class;





var breadcrumb_initialState = {};

var breadcrumb__ref = Object(preact_min["h"])(
    'li',
    { 'class': 'breadcrumb-item' },
    Object(preact_min["h"])(
        'a',
        { href: '/' },
        'FFE CMS'
    )
);

var breadcrumb_Breadcrumb = Object(index_module["a" /* observer */])(breadcrumb__class = function (_Component) {
    inherits_default()(Breadcrumb, _Component);

    function Breadcrumb(props) {
        classCallCheck_default()(this, Breadcrumb);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = extends_default()({}, breadcrumb_initialState);
        return _this;
    }

    Breadcrumb.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var dealerStore = this.props.stores.dealerStore;
        var realDealer = dealerStore.realDealer;


        var url = props.url.replace(/^\//, '');
        url = url.split('/');
        if (url[1]) {
            url[1] = url[1].toUpperCase();
        }
        return Object(preact_min["h"])(
            'nav',
            { 'aria-label': 'breadcrumb' },
            Object(preact_min["h"])(
                'ol',
                { 'class': 'breadcrumb py-1 font-weight-lighter mb-0' },
                breadcrumb__ref,
                url.map(function (u, idx) {
                    return Object(preact_min["h"])(
                        'li',
                        { 'class': 'breadcrumb-item' },
                        Object(preact_min["h"])(
                            'a',
                            { href: '/' + url.slice(0, idx + 1).join('/') },
                            decodeURIComponent(u)
                        )
                    );
                }),
                Object(preact_min["h"])(
                    'li',
                    { 'class': 'ml-auto' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'text-muted' },
                        'Logged in as: ',
                        realDealer.name,
                        ' (',
                        realDealer.email,
                        ')'
                    )
                )
            )
        );
    };

    return Breadcrumb;
}(preact_min["Component"])) || breadcrumb__class;

/* harmony default export */ var breadcrumb = (breadcrumb_Breadcrumb);
// CONCATENATED MODULE: ./components/navigation/top.js





var top__class;













var top_initialState = {
    height: 100
};

var top__ref = Object(preact_min["h"])(components_progress, null);

var top__ref2 = Object(preact_min["h"])(error, null);

var top__ref3 = Object(preact_min["h"])(components_status, null);

var top_Top = Object(index_module["a" /* observer */])(top__class = function (_Component) {
    inherits_default()(Top, _Component);

    function Top(props) {
        classCallCheck_default()(this, Top);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = extends_default()({}, top_initialState);
        return _this;
    }

    Top.prototype.toggleLanguageSelection = function toggleLanguageSelection() {
        var showLanguageSelection = this.state.showLanguageSelection;

        this.setState({ showLanguageSelection: !showLanguageSelection });
    };

    Top.prototype.componentDidUpdate = function componentDidUpdate() {
        var height = this.state.height;

        height = document.getElementById('topNavigationBar').offsetHeight;
        lib_pubsub.publish(topics.LEFT_MENU_HEIGHT_UPDATED, height);
    };

    Top.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            { 'class': 'sticky-top mb-1', id: 'topNavigationBar' },
            top__ref,
            top__ref2,
            top__ref3,
            Object(preact_min["h"])(navigation, props),
            Object(preact_min["h"])(breadcrumb, props)
        );
    };

    return Top;
}(preact_min["Component"])) || top__class;

/* harmony default export */ var navigation_top = (top_Top);
// CONCATENATED MODULE: ./components/frontpage/index.js




var frontpage__class;









var frontpage_initialState = {};

var frontpage_Frontpage = Object(index_module["a" /* observer */])(frontpage__class = function (_Component) {
    inherits_default()(Frontpage, _Component);

    function Frontpage(props) {
        classCallCheck_default()(this, Frontpage);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = frontpage_initialState;
        return _this;
    }

    // eslint-disable-next-line


    Frontpage.prototype.render = function render(props) {
        var appState = this.props.stores.appState;


        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'button',
                        { type: 'button', onClick: function onClick() {
                                return appState.toggleDarkmode();
                            } },
                        'Toggle darkmode'
                    )
                )
            )
        );
    };

    return Frontpage;
}(preact_min["Component"])) || frontpage__class;

/* harmony default export */ var frontpage = (frontpage_Frontpage);
// EXTERNAL MODULE: ./components/dealers/style.css
var style = __webpack_require__("TFt2");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./components/dealers/list.js







var list__class, _class2, list__temp, list__initialiseProps;







var list_initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false
    }
};

var list__ref = Object(preact_min["h"])('br', null);

var list__ref2 = Object(preact_min["h"])(
    'h1',
    null,
    Object(preact_min["h"])('i', { 'class': 'fas fa-search' }),
    ' Search results'
);

var list__ref3 = Object(preact_min["h"])('br', null);

var list__ref4 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var list__ref5 = Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle' });

var list__ref6 = Object(preact_min["h"])(
    'th',
    { style: 'width: 10%', 'class': 'text-right' },
    'Basket'
);

var list__ref7 = Object(preact_min["h"])('i', { 'class': 'fas fa-user-secret' });

var list__ref8 = Object(preact_min["h"])('i', { 'class': 'fas fa-moon' });

var list__ref9 = Object(preact_min["h"])('i', { 'class': 'fas fa-flag' });

var list__ref10 = Object(preact_min["h"])('i', { 'class': 'fas fa-file-csv' });

var list__ref11 = Object(preact_min["h"])('i', { 'class': 'fas fa-map-marker-alt' });

var list__ref12 = Object(preact_min["h"])('i', { 'class': 'fas fa-check' });

var list__ref13 = Object(preact_min["h"])('i', { 'class': 'fas fa-thumbs-up' });

var list__ref14 = Object(preact_min["h"])('br', null);

var list__ref15 = Object(preact_min["h"])('i', { 'class': 'fas fa-shopping-cart' });

var list__ref16 = Object(preact_min["h"])('i', { 'class': 'fas fa-box-open' });

var list__ref17 = Object(preact_min["h"])('br', null);

var _ref18 = Object(preact_min["h"])('i', { 'class': 'fas fa-signature' });

var list__ref19 = Object(preact_min["h"])('i', { 'class': 'text-muted fas fa-sign-in-alt mr-1' });

var _ref20 = Object(preact_min["h"])('br', null);

var list__ref21 = Object(preact_min["h"])('i', { 'class': 'text-muted fas fa-running mr-1' });

var _ref22 = Object(preact_min["h"])('br', null);

var _ref23 = Object(preact_min["h"])('i', { 'class': 'text-success fas fa-skiing-nordic mr-1' });

var _ref24 = Object(preact_min["h"])('br', null);

var _ref25 = Object(preact_min["h"])('i', { 'class': 'fas fa-exclamation-triangle mr-1' });

var _ref26 = Object(preact_min["h"])('i', { 'class': 'text-muted fas fa-sign-in-alt ml-1' });

var _ref27 = Object(preact_min["h"])('br', null);

var _ref28 = Object(preact_min["h"])('i', { 'class': 'text-muted fas fa-running ml-1' });

var _ref29 = Object(preact_min["h"])('br', null);

var _ref30 = Object(preact_min["h"])('i', { 'class': 'text-success fas fa-skiing-nordic ml-1' });

var _ref31 = Object(preact_min["h"])('br', null);

var _ref32 = Object(preact_min["h"])('br', null);

var _ref33 = Object(preact_min["h"])('br', null);

var _ref34 = Object(preact_min["h"])('br', null);

var _ref35 = Object(preact_min["h"])('br', null);

var _ref36 = Object(preact_min["h"])('br', null);

var _ref37 = Object(preact_min["h"])(
    'div',
    { 'class': 'row' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'col-12 text-center' },
        Object(preact_min["h"])(
            'div',
            { 'class': 'spinner-border text-success', role: 'status' },
            Object(preact_min["h"])(
                'span',
                { 'class': 'sr-only' },
                'Loading...'
            )
        )
    )
);

var _ref38 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var list_DealerList = Object(index_module["a" /* observer */])(list__class = (list__temp = _class2 = function (_Component) {
    inherits_default()(DealerList, _Component);

    function DealerList(props) {
        classCallCheck_default()(this, DealerList);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        list__initialiseProps.call(_this);

        _this.state = extends_default()({}, list_initialState);

        var _this$props$stores = _this.props.stores,
            dealerStore = _this$props$stores.dealerStore,
            brandStore = _this$props$stores.brandStore;

        dealerStore.updateSort('-last_activity');
        dealerStore.list(false, { addData: ['countries'] });

        brandStore.load();
        return _this;
    }

    // toggleQueryfilter(filter, value = 1, opt = {}) {
    //     const { dealerStore } = this.props.stores;
    //     const { queryFilter } = dealerStore;
    //     const finalFilter = { ...queryFilter };
    //     if (opt.setValue) {
    //         finalFilter[filter] = value;
    //     } else {
    //         finalFilter[filter] = finalFilter[filter] ? null : value;
    //     }
    //     if (!finalFilter[filter]) {
    //         delete finalFilter[filter];
    //     }
    //     dealerStore.updateQueryFilter(finalFilter);
    //     if (!opt.skipUpdate) {
    //         dealerStore.list();
    //     }
    //     if (opt.viewElement) {
    //         this.toggleView(opt.viewElement);
    //     }
    //     if (opt.setTimer) {
    //         clearTimeout(this.searchTimer);
    //         this.searchTimer = setTimeout(async () => {
    //             dealerStore.list();
    //         }, 750);
    //     }
    // }

    DealerList.prototype.toggleView = function toggleView(element) {
        var view = this.state.view;

        view[element] = !view[element];
        this.setState({ view: view });
    };

    DealerList.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    DealerList.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    DealerList.prototype.render = function render() {
        var _this2 = this;

        var _state = this.state,
            loading = _state.loading,
            view = _state.view;
        var _props$stores = this.props.stores,
            dealerStore = _props$stores.dealerStore,
            brandStore = _props$stores.brandStore;
        var dealers = dealerStore.dealers,
            countries = dealerStore.countries,
            queryFilter = dealerStore.queryFilter,
            languages = dealerStore.languages;
        var brands = brandStore.brands;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'text-muted font-weight-lighter float-right mr-2' },
                        'Total: ',
                        dealerStore.total,
                        list__ref
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'btn-group mr-2', role: 'group' },
                        Object(preact_min["h"])(
                            'button',
                            { id: 'btnGroupCountries', type: 'button', 'class': 'btn btn-sm btn-secondary dropdown-toggle',
                                'data-toggle': 'dropdown', 'aria-haspopup': 'true', 'aria-expanded': 'false',
                                onClick: function onClick() {
                                    return _this2.toggleView('countries');
                                }
                            },
                            queryFilter.country ? queryFilter.country : 'Countries'
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'dropdown-menu ' + (view.countries ? 'show' : 'hide'), 'aria-labelledby': 'btnGroupCountries' },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': 'dropdown-item ' + style_default.a.pointerCursor, onClick: function onClick() {
                                        return dealerStore.toggleQueryfilter('country', null, { setValue: true, viewElement: 'countries' });
                                    } },
                                'All countries'
                            ),
                            countries.map(function (country) {
                                return Object(preact_min["h"])(
                                    'div',
                                    { 'class': 'dropdown-item ' + style_default.a.pointerCursor, onClick: function onClick() {
                                            return dealerStore.toggleQueryfilter('country', country, { setValue: true, viewElement: 'countries' });
                                        } },
                                    country
                                );
                            })
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'btn-group mr-2', role: 'group' },
                        Object(preact_min["h"])(
                            'button',
                            { id: 'btnGroupLanguages', type: 'button', 'class': 'btn btn-sm btn-secondary dropdown-toggle',
                                'data-toggle': 'dropdown', 'aria-haspopup': 'true', 'aria-expanded': 'false',
                                onClick: function onClick() {
                                    return _this2.toggleView('languages');
                                }
                            },
                            queryFilter.language ? queryFilter.language : 'Languages'
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'dropdown-menu ' + (view.languages ? 'show' : 'hide'), 'aria-labelledby': 'btnGroupLanguages' },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': 'dropdown-item ' + style_default.a.pointerCursor, onClick: function onClick() {
                                        return dealerStore.toggleQueryfilter('language', null, { setValue: true, viewElement: 'languages' });
                                    } },
                                'All languages'
                            ),
                            Object.keys(languages).map(function (language) {
                                var lang = languages[language];
                                return Object(preact_min["h"])(
                                    'div',
                                    { 'class': 'dropdown-item ' + style_default.a.pointerCursor, onClick: function onClick() {
                                            return dealerStore.toggleQueryfilter('language', lang, { setValue: true, viewElement: 'languages' });
                                        } },
                                    language
                                );
                            })
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'btn-group mr-2', role: 'group' },
                        Object(preact_min["h"])(
                            'button',
                            { id: 'btnGroupBrand', type: 'button', 'class': 'btn btn-sm btn-secondary dropdown-toggle',
                                'data-toggle': 'dropdown', 'aria-haspopup': 'true', 'aria-expanded': 'false',
                                onClick: function onClick() {
                                    return _this2.toggleView('brands');
                                }
                            },
                            queryFilter.brand ? queryFilter.brand : 'Brands'
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'dropdown-menu ' + (view.brands ? 'show' : 'hide'), 'aria-labelledby': 'btnGroupBrand' },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': 'dropdown-item ' + style_default.a.pointerCursor, onClick: function onClick() {
                                        return dealerStore.toggleQueryfilter('brand', null, { setValue: true, viewElement: 'brands' });
                                    } },
                                'All brands'
                            ),
                            brands.map(function (brand) {
                                return Object(preact_min["h"])(
                                    'div',
                                    { 'class': 'dropdown-item ' + style_default.a.pointerCursor, onClick: function onClick() {
                                            return dealerStore.toggleQueryfilter('brand', brand.brandno, { setValue: true, viewElement: 'brands' });
                                        } },
                                    brand.name
                                );
                            })
                        )
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.terms),
                            onClick: function onClick() {
                                return dealerStore.toggleQueryfilter('terms', util.cyclevalues(queryFilter.terms, [null, 1, -1]), { setValue: 1 });
                            }
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.terms ? 'on' : 'off') + ' mr-1' }),
                        'Terms'
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.is_agent),
                            onClick: function onClick() {
                                return dealerStore.toggleQueryfilter('is_agent', util.cyclevalues(queryFilter.is_agent, [null, 1, 0]), { setValue: 1 });
                            }
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.is_agent ? 'on' : 'off') + ' mr-1' }),
                        'Agent'
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.locator),
                            onClick: function onClick() {
                                return dealerStore.toggleQueryfilter('locator', util.cyclevalues(queryFilter.locator, [null, 1, 0]), { setValue: 1 });
                            }
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.locator ? 'on' : 'off') + ' mr-1' }),
                        'Locator'
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.approved),
                            onClick: function onClick() {
                                return dealerStore.toggleQueryfilter('approved', util.cyclevalues(queryFilter.approved, [null, 1, 0]), { setValue: 1 });
                            }
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.approved ? 'on' : 'off') + ' mr-1' }),
                        'Approved'
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.confirmed),
                            onClick: function onClick() {
                                return dealerStore.toggleQueryfilter('confirmed', util.cyclevalues(queryFilter.confirmed, [null, 1, 0]), { setValue: 1 });
                            }
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.confirmed ? 'on' : 'off') + ' mr-1' }),
                        'Confirmed'
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.darkmode),
                            onClick: function onClick() {
                                return dealerStore.toggleQueryfilter('darkmode', util.cyclevalues(queryFilter.darkmode, [null, 1, 0]), { setValue: 1 });
                            }
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.darkmode ? 'on' : 'off') + ' mr-1' }),
                        'Darkmode'
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.hasAccessToCombos),
                            onClick: function onClick() {
                                return dealerStore.toggleQueryfilter('hasAccessToCombos', util.cyclevalues(queryFilter.hasAccessToCombos, [null, 1, 0]), { setValue: 1 });
                            }
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.hasAccessToCombos ? 'on' : 'off') + ' mr-1' }),
                        'Combos'
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.acceptCustomerOrders),
                            onClick: function onClick() {
                                return dealerStore.toggleQueryfilter('acceptCustomerOrders', util.cyclevalues(queryFilter.acceptCustomerOrders, [null, 1, 0]), { setValue: 1 });
                            }
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.acceptCustomerOrders ? 'on' : 'off') + ' mr-1' }),
                        'Customer orders'
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.shipping),
                            onClick: function onClick() {
                                return dealerStore.toggleQueryfilter('shipping', util.cyclevalues(queryFilter.shipping, [null, 1, 0]), { setValue: 1 });
                            }
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.shipping ? 'on' : 'off') + ' mr-1' }),
                        'Shipping'
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.store),
                            onClick: function onClick() {
                                return dealerStore.toggleQueryfilter('store', util.cyclevalues(queryFilter.store, [null, 1, 0]), { setValue: 1 });
                            }
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.store ? 'on' : 'off') + ' mr-1' }),
                        'Store'
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.backorders),
                            onClick: function onClick() {
                                return dealerStore.toggleQueryfilter('backorders', util.cyclevalues(queryFilter.backorders, [null, 1, 0]), { setValue: 1 });
                            }
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.backorders ? 'on' : 'off') + ' mr-1' }),
                        'Backorders'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': 'float-left form-row align-items-center mr-5' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])('input', { type: 'text', 'class': 'form-control form-control-sm', id: 'inlineFormInputName', placeholder: 'Search for dealers...',
                                onInput: function onInput(e) {
                                    return dealerStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true });
                                },
                                value: queryFilter.search
                            })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])(
                                'button',
                                { type: 'button', 'class': 'btn btn-sm btn-primary', onClick: function onClick() {
                                        return dealerStore.list();
                                    } },
                                'Search'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    queryFilter.search && Object(preact_min["h"])(
                        'div',
                        { 'class': 'w-100 text-left mt-2 mb-5' },
                        list__ref2,
                        'Found ',
                        dealerStore.total || 0,
                        ' results in your search for "',
                        queryFilter.search,
                        '".',
                        list__ref3,
                        Object(preact_min["h"])(
                            'button',
                            { 'class': 'btn btn-sm btn-warning mt-2',
                                onClick: function onClick() {
                                    return dealerStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true });
                                }
                            },
                            list__ref4,
                            ' Reset search'
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'table-responsive' },
                        Object(preact_min["h"])(
                            'table',
                            { 'class': style_default.a.table + ' table table-striped table-sm table-borderless' },
                            Object(preact_min["h"])(
                                'thead',
                                null,
                                dealerStore.sort !== dealerStore.defaultSort && Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { colspan: '8' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': style_default.a.pointerCursor + ' mr-2 badge badge-pill badge-secondary', onClick: function onClick() {
                                                    return dealerStore.resetSort();
                                                } },
                                            list__ref5,
                                            ' Reset sort'
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 65%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': style_default.a.pointerCursor, onClick: function onClick() {
                                                    return dealerStore.toggleSort('name', '-');
                                                } },
                                            'Name ',
                                            util.getSortIcon('name', dealerStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-center' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': style_default.a.pointerCursor, onClick: function onClick() {
                                                    return dealerStore.toggleSort('locator', '-');
                                                } },
                                            'Locator ',
                                            util.getSortIcon('locator', dealerStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': '' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': style_default.a.pointerCursor, onClick: function onClick() {
                                                    return dealerStore.toggleSort('status', '-');
                                                } },
                                            'Status ',
                                            util.getSortIcon('status', dealerStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%', 'class': '' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': style_default.a.pointerCursor, onClick: function onClick() {
                                                    return dealerStore.toggleSort('last_activity', '-');
                                                } },
                                            'Last login / Last activity ',
                                            util.getSortIcon('last_activity', dealerStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': style_default.a.pointerCursor, onClick: function onClick() {
                                                    return dealerStore.toggleSort('api_activity', '-');
                                                } },
                                            'Logins / Activities ',
                                            util.getSortIcon('api_activity', dealerStore.sort)
                                        )
                                    ),
                                    list__ref6
                                )
                            ),
                            Object(preact_min["h"])(
                                'tbody',
                                null,
                                dealers && dealers.map(function (dealer) {
                                    return Object(preact_min["h"])(
                                        'tr',
                                        { 'class': '' + style_default.a.tableline },
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': '' },
                                            Object(preact_min["h"])(
                                                'span',
                                                { 'class': 'float-right text-muted' },
                                                Object(preact_min["h"])(
                                                    'small',
                                                    null,
                                                    dealer.country,
                                                    ' ',
                                                    dealer.pricelistno
                                                )
                                            ),
                                            dealer.is_agent && dealer.agent_dealers && Object(preact_min["h"])(
                                                'span',
                                                { 'class': 'mr-2 text-muted' },
                                                list__ref7,
                                                ' (',
                                                dealer.agent_dealers.length,
                                                ')'
                                            ),
                                            Object(preact_min["h"])(
                                                'a',
                                                { href: '/dealers/' + dealer.customerno + '/Basics' },
                                                dealer.customerno,
                                                ': ',
                                                dealer.name,
                                                Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': 'text-muted ml-2' },
                                                    Object(preact_min["h"])(
                                                        'small',
                                                        null,
                                                        '(',
                                                        dealer.email,
                                                        ')'
                                                    )
                                                )
                                            ),
                                            Object(preact_min["h"])(
                                                'small',
                                                { 'class': 'float-right' },
                                                dealer.isOnline && Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': 'mr-2 badge badge-pill badge-info' },
                                                    'Online'
                                                ),
                                                dealer.isOnlineApi && Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': 'mr-2 badge badge-pill badge-success text-white' },
                                                    'Online API'
                                                ),
                                                dealer.settings && dealer.settings.darkmode === 1 && Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': 'mr-2 badge badge-pill badge-secondary text-warning' },
                                                    list__ref8,
                                                    ' Darkmode'
                                                ),
                                                dealer.settings && dealer.settings.language && Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': 'mr-2 badge badge-pill text-muted' },
                                                    list__ref9,
                                                    ' ',
                                                    dealer.settings.language
                                                )
                                            ),
                                            Object(preact_min["h"])(
                                                'div',
                                                null,
                                                Object(preact_min["h"])(
                                                    'small',
                                                    null,
                                                    brands && brands.map(function (brand) {
                                                        var nested = util.checkNested(dealer, 'brands', brand.brandno, 'allowed');
                                                        var allowed = nested && dealer.brands[brand.brandno].allowed;
                                                        var badgeStyle = nested && allowed ? 'badge-success' : 'btn-outline-success';
                                                        var brandAllowed = nested && util.asBoolean(dealer, 'brands', brand.brandno, 'allowed');
                                                        return Object(preact_min["h"])(
                                                            'span',
                                                            {
                                                                'class': 'mr-1 badge ' + badgeStyle + ' ' + style_default.a.pointerCursor,
                                                                'data-brandno': brand.brandno,
                                                                'data-customerno': dealer.customerno,
                                                                onClick: function onClick() {
                                                                    return dealerStore.saveField(dealer.customerno, 'brands.' + brand.brandno + '.allowed', !brandAllowed, true);
                                                                }
                                                            },
                                                            brand.name
                                                        );
                                                    })
                                                )
                                            ),
                                            Object(preact_min["h"])(
                                                'div',
                                                null,
                                                Object(preact_min["h"])(
                                                    'small',
                                                    null,
                                                    brands && brands.map(function (brand) {
                                                        var nested = util.checkNested(dealer, 'brandCombos', brand.brandno, 'allowed');
                                                        var allowed = nested && dealer.brandCombos[brand.brandno].allowed;
                                                        var badgeStyle = nested && allowed ? 'badge-primary' : 'btn-outline-primary';
                                                        var brandAllowed = nested && util.asBoolean(dealer, 'brandCombos', brand.brandno, 'allowed');
                                                        return Object(preact_min["h"])(
                                                            'span',
                                                            {
                                                                'class': 'mr-1 badge ' + badgeStyle + ' ' + style_default.a.pointerCursor,
                                                                'data-brandno': brand.brandno,
                                                                'data-customerno': dealer.customerno,
                                                                onClick: function onClick() {
                                                                    return dealerStore.saveField(dealer.customerno, 'brandCombos.' + brand.brandno + '.allowed', !brandAllowed, true);
                                                                }
                                                            },
                                                            brand.name
                                                        );
                                                    })
                                                )
                                            ),
                                            Object(preact_min["h"])(
                                                'small',
                                                { 'class': 'mr-2 text-muted font-weight-lighter' },
                                                'Downloads:'
                                            ),
                                            Object.keys(dealer.csvDownloads || {}).map(function (brand) {
                                                return Object(preact_min["h"])(
                                                    'small',
                                                    { 'class': 'mr-2 text-muted font-weight-lighter' },
                                                    list__ref10,
                                                    ' ',
                                                    brand,
                                                    ': ',
                                                    dealer.csvDownloads[brand]
                                                );
                                            })
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-center' },
                                            Object(preact_min["h"])(
                                                'small',
                                                null,
                                                Object(preact_min["h"])(
                                                    'span',
                                                    {
                                                        'class': 'mr-1 badge ' + style_default.a.pointerCursor + ' ' + (dealer.locator ? 'badge-success' : 'btn-outline-secondary'),
                                                        onClick: function onClick() {
                                                            return dealerStore.saveField(dealer.customerno, 'locator', dealer.locator ? 0 : 1, true);
                                                        }
                                                    },
                                                    Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (dealer.locator ? 'on' : 'off') }),
                                                    '\xA0',
                                                    list__ref11,
                                                    ' ',
                                                    dealer.locator ? 'Yes' : 'No'
                                                )
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': '' },
                                            Object(preact_min["h"])(
                                                'small',
                                                null,
                                                Object(preact_min["h"])(
                                                    'nobr',
                                                    null,
                                                    Object(preact_min["h"])(
                                                        'span',
                                                        {
                                                            'class': 'mr-1 badge ' + style_default.a.pointerCursor + ' badge-' + (dealer.confirmed ? 'success' : 'danger'),
                                                            onClick: function onClick() {
                                                                return dealerStore.saveField(dealer.customerno, 'confirmed', dealer.confirmed ? 0 : 1, true);
                                                            }
                                                        },
                                                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (dealer.confirmed === 1 ? 'on' : 'off') }),
                                                        '\xA0',
                                                        list__ref12,
                                                        ' Confirmed'
                                                    ),
                                                    Object(preact_min["h"])(
                                                        'span',
                                                        {
                                                            'class': 'mr-1 badge ' + style_default.a.pointerCursor + ' badge-' + (dealer.approved ? 'success' : 'danger'),
                                                            onClick: function onClick() {
                                                                return dealerStore.saveField(dealer.customerno, 'approved', dealer.approved ? 0 : 1, true);
                                                            }
                                                        },
                                                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (dealer.approved === 1 ? 'on' : 'off') }),
                                                        '\xA0',
                                                        list__ref13,
                                                        ' Approved'
                                                    )
                                                ),
                                                list__ref14,
                                                Object(preact_min["h"])(
                                                    'nobr',
                                                    null,
                                                    Object(preact_min["h"])(
                                                        'span',
                                                        {
                                                            'class': 'mr-1 badge ' + style_default.a.pointerCursor + ' ' + (dealer.settings.acceptCustomerOrders ? 'badge-success' : 'btn-outline-secondary'),
                                                            onClick: function onClick() {
                                                                return dealerStore.saveField(dealer.customerno, 'settings.acceptCustomerOrders', dealer.settings.acceptCustomerOrders ? 0 : 1, true);
                                                            }
                                                        },
                                                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (dealer.settings.acceptCustomerOrders === 1 ? 'on' : 'off') }),
                                                        '\xA0',
                                                        list__ref15,
                                                        ' CustOrders'
                                                    ),
                                                    Object(preact_min["h"])(
                                                        'span',
                                                        {
                                                            'class': 'mr-1 badge ' + style_default.a.pointerCursor + ' ' + (dealer.hasAccessToCombos ? 'badge-success' : 'btn-outline-secondary'),
                                                            onClick: function onClick() {
                                                                return dealerStore.saveField(dealer.customerno, 'hasAccessToCombos', dealer.hasAccessToCombos ? 0 : 1, true);
                                                            }
                                                        },
                                                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (dealer.hasAccessToCombos === 1 ? 'on' : 'off') }),
                                                        '\xA0',
                                                        list__ref16,
                                                        ' Combos'
                                                    )
                                                ),
                                                list__ref17,
                                                Object(preact_min["h"])(
                                                    'nobr',
                                                    null,
                                                    Object.keys(dealer.termsAndConditions || {}).map(function (ver) {
                                                        return Object(preact_min["h"])(
                                                            'span',
                                                            {
                                                                'class': 'mr-1 badge ' + style_default.a.pointerCursor + ' ' + (dealer.termsAndConditions[ver].acceptedDate ? 'badge-success' : 'btn-outline-secondary'),
                                                                onClick: function onClick() {
                                                                    return dealerStore.saveField(dealer.customerno, 'termsAndConditions.' + ver + '.acceptedDate', dealer.termsAndConditions[ver].acceptedDate ? 0 : new Date(), true);
                                                                }
                                                            },
                                                            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (dealer.termsAndConditions[ver].acceptedDate ? 'on' : 'off') }),
                                                            '\xA0',
                                                            _ref18,
                                                            ' ',
                                                            ver
                                                        );
                                                    })
                                                )
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(
                                                'small',
                                                null,
                                                Object(preact_min["h"])(
                                                    'nobr',
                                                    null,
                                                    list__ref19,
                                                    util.ffeDateTime(dealer.last_login)
                                                ),
                                                _ref20,
                                                Object(preact_min["h"])(
                                                    'nobr',
                                                    null,
                                                    list__ref21,
                                                    util.ffeDateTime(dealer.last_activity)
                                                ),
                                                _ref22,
                                                Object(preact_min["h"])(
                                                    'nobr',
                                                    null,
                                                    _ref23,
                                                    dealer.last_api_activity ? util.ffeDateTime(dealer.last_api_activity) : 'n/a'
                                                ),
                                                _ref24,
                                                dealer.emails && Object.keys(dealer.emails).map(function (email) {
                                                    var user = dealer.emails[email];
                                                    if (user.current_login_failed > 0) {
                                                        return Object(preact_min["h"])(
                                                            'div',
                                                            { 'class': 'text-' + (user.current_login_failed < 5 ? 'warning' : 'danger') },
                                                            Object(preact_min["h"])(
                                                                'small',
                                                                { 'class': style_default.a.pointerCursor,
                                                                    onClick: function onClick() {
                                                                        return dealerStore.saveField(dealer.customerno, 'emails.' + email + '.current_login_failed', 0, true);
                                                                    }
                                                                },
                                                                _ref25,
                                                                'Failed logins: ',
                                                                user.email || dealer.email,
                                                                ': ',
                                                                user.current_login_failed
                                                            )
                                                        );
                                                    }
                                                })
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            Object(preact_min["h"])(
                                                'small',
                                                null,
                                                util.formatCompact(dealer.visits),
                                                _ref26,
                                                _ref27,
                                                util.formatCompact(dealer.activity),
                                                _ref28,
                                                _ref29,
                                                util.formatCompact(dealer.api_activity || 0),
                                                _ref30
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            Object(preact_min["h"])(
                                                'small',
                                                null,
                                                dealer.basketQty > 0 && Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': 'text-success' },
                                                    Object(preact_min["h"])(
                                                        'nobr',
                                                        null,
                                                        dealer.basketQty,
                                                        ' basket items'
                                                    ),
                                                    _ref31,
                                                    Object(preact_min["h"])(
                                                        'nobr',
                                                        null,
                                                        Object(preact_min["h"])(
                                                            'small',
                                                            { 'class': 'mr-1' },
                                                            dealer.basketCurrency
                                                        ),
                                                        util.format(dealer.basketTotal, 2)
                                                    ),
                                                    _ref32
                                                ),
                                                dealer.psBasketQty > 0 && Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': 'text-warning' },
                                                    Object(preact_min["h"])(
                                                        'nobr',
                                                        null,
                                                        dealer.psBasketQty,
                                                        ' ps basket items'
                                                    ),
                                                    _ref33,
                                                    Object(preact_min["h"])(
                                                        'nobr',
                                                        null,
                                                        Object(preact_min["h"])(
                                                            'small',
                                                            { 'class': 'mr-1' },
                                                            dealer.psBasketCurrency
                                                        ),
                                                        util.format(dealer.psBasketTotal, 2)
                                                    ),
                                                    _ref34
                                                ),
                                                dealer.backorderCount > 0 && Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': 'text-info' },
                                                    Object(preact_min["h"])(
                                                        'nobr',
                                                        null,
                                                        dealer.backorderCount,
                                                        ' backorders ',
                                                        dealer.backorderProductCount,
                                                        ' items'
                                                    ),
                                                    _ref35,
                                                    Object(preact_min["h"])(
                                                        'nobr',
                                                        null,
                                                        Object(preact_min["h"])(
                                                            'small',
                                                            { 'class': 'ml-2 mr-1' },
                                                            dealer.currency
                                                        ),
                                                        ' ',
                                                        util.format(dealer.backorderProductTotal, 2)
                                                    ),
                                                    _ref36
                                                )
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    )
                )
            ),
            loading && _ref37,
            _ref38
        );
    };

    return DealerList;
}(preact_min["Component"]), list__initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleScroll = function () {
        var loading = _this3.state.loading;
        var dealerStore = _this3.props.stores.dealerStore;
        var totalAppend = dealerStore.totalAppend,
            limit = dealerStore.limit;

        if (window.innerHeight + document.documentElement.scrollTop + 500 < document.documentElement.offsetHeight) return;
        if (loading) return;

        var offset = dealerStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(_this3.scrollLoader);
            _this3.scrollLoader = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this3.setState({ loading: true });
                                dealerStore.updateOffset(offset);
                                _context.next = 4;
                                return dealerStore.list(true);

                            case 4:
                                _this3.setState({ loading: false });

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            })), 500);
        }
    };
}, list__temp)) || list__class;

/* harmony default export */ var dealers_list = (list_DealerList);
// CONCATENATED MODULE: ./components/dealers/index.js




var dealers__class;









var dealers_initialState = {
    height: 100
};

var dealers_Frontpage = Object(index_module["a" /* observer */])(dealers__class = function (_Component) {
    inherits_default()(Frontpage, _Component);

    function Frontpage(props) {
        classCallCheck_default()(this, Frontpage);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = dealers_initialState;
        _this.subscriptions();
        return _this;
    }

    Frontpage.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    Frontpage.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(dealers_list, props)
                )
            )
        );
    };

    return Frontpage;
}(preact_min["Component"])) || dealers__class;

/* harmony default export */ var components_dealers = (dealers_Frontpage);
// CONCATENATED MODULE: ./components/form/autocomplete.js




var autocomplete__class;





var autocomplete_Autocomplete = Object(index_module["a" /* observer */])(autocomplete__class = function (_Component) {
    inherits_default()(Autocomplete, _Component);

    function Autocomplete() {
        var _temp, _this, _ret;

        classCallCheck_default()(this, Autocomplete);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleOnInput = function (e) {
            var oninput = _this.props.oninput;

            _this.setState({
                searchText: e.target.value
            });
            oninput(e);
        }, _this.keyDown = function (e) {
            var _this$props$handleKey = _this.props.handleKeydown,
                handleKeydown = _this$props$handleKey === undefined ? function () {} : _this$props$handleKey;

            handleKeydown(e);
        }, _this.onFocus = function () {
            _this.setState({ isActive: true });
        }, _this.onBlur = function () {
            _this.setState({ isActive: false });
        }, _temp), possibleConstructorReturn_default()(_this, _ret);
    }

    Autocomplete.prototype.render = function render() {
        var _props = this.props,
            name = _props.name,
            type = _props.type,
            _props$disabled = _props.disabled,
            disabled = _props$disabled === undefined ? false : _props$disabled,
            _props$placeholder = _props.placeholder,
            placeholder = _props$placeholder === undefined ? '' : _props$placeholder,
            _props$removeElement = _props.removeElement,
            removeElement = _props$removeElement === undefined ? function () {} : _props$removeElement,
            _props$addElement = _props.addElement,
            addElement = _props$addElement === undefined ? function () {} : _props$addElement,
            _props$autocompleteLi = _props.autocompleteList,
            myAutocompleteList = _props$autocompleteLi === undefined ? [] : _props$autocompleteLi,
            _props$value = _props.value,
            value = _props$value === undefined ? [] : _props$value,
            _props$currentIdx = _props.currentIdx,
            currentIdx = _props$currentIdx === undefined ? 0 : _props$currentIdx,
            _props$currentId = _props.currentId,
            currentId = _props$currentId === undefined ? 0 : _props$currentId,
            _props$valueDisplayMa = _props.valueDisplayMap,
            valueDisplayMap = _props$valueDisplayMa === undefined ? function (v) {
            return v;
        } : _props$valueDisplayMa,
            total = _props.total;
        var isActive = this.state.isActive;


        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])('input', {
                'class': 'form-control',
                type: type,
                name: name + 'Search',
                disabled: !!disabled,
                'aria-describedby': name + 'Help',
                placeholder: placeholder,
                onInput: this.handleOnInput,
                onKeyDown: this.keyDown,
                onFocus: this.onFocus,
                onBlur: this.onBlur
            }),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                isActive && Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-sm-12' },
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'list-group' },
                        myAutocompleteList && myAutocompleteList.map(function (el, idx) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'list-group-item ' + (currentIdx === idx ? 'bg-primary text-white' : ''),
                                    onClick: function onClick() {
                                        return addElement(idx);
                                    }
                                },
                                valueDisplayMap(el)
                            );
                        })
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-sm-12' },
                    value && value.map(function (val) {
                        return Object(preact_min["h"])(
                            'span',
                            { 'class': 'badge badge-' + (val.id == currentId ? 'success p-3' : 'primary') + ' mr-2' },
                            valueDisplayMap(val),
                            Object(preact_min["h"])('i', { 'class': 'ml-2 fas fa-times-circle',
                                onClick: function onClick() {
                                    return removeElement(val.id);
                                }
                            })
                        );
                    })
                )
            )
        );
    };

    return Autocomplete;
}(preact_min["Component"])) || autocomplete__class;

/* harmony default export */ var autocomplete = (autocomplete_Autocomplete);
// CONCATENATED MODULE: ./lib/markdown.js
/*
 * https://github.com/5orenso
 *
 * Copyright (c) 2018 Øistein Sørensen
 * Licensed under the MIT license.
 */



// import 'highlight.js/styles/atom-one-dark.css';


var marked = __webpack_require__("3F7m");
// const hljs = require('highlight.js');

var renderer = new marked.Renderer();

// hljs.configure({
//     tabReplace: '    ', // 4 spaces
//     classPrefix: 'hljs-', // don't append class prefix
// });

// Markdown setup.
marked.setOptions({
    renderer: renderer,
    // highlight: (code, language) => {
    //     // console.log(code, language);
    //     // if (language) {
    //     //     return hljs.highlight(language, code).value;
    //     // }
    //     return hljs.highlightAuto(code).value;
    // },
    pedantic: false,
    gfm: true,
    tables: true,
    breaks: true,
    sanitize: false,
    smartLists: true,
    smartypants: true,
    xhtml: false
});

renderer.heading = function heading(text, level) {
    var escapedText = text.toLowerCase().replace(/[^\w]+/g, '-');
    return '<h' + level + ' class=\'toc-' + level + '\'><a name=\'' + escapedText + '\' class=\'anchor\' href=\'#' + escapedText + '\'><span class=\'header-link\'></span></a>' + text + '</h' + level + '>';
};

renderer.table = function table(header, body) {
    return '<table class=\'table table-striped table-hover\'>\n        <thead class=\'thead-dark\'>' + header + '</thead>\n        <tbody>' + body + '</tbody>\n    </table>';
};

renderer.blockquote = function blockquote(quote) {
    return '<blockquote class=\'blockquote text-muted ml-5\'>\n        <span class=\'display-4 float-left mr-4\'>\n            <i class="fas fa-quote-right"></i>\n        </span>\n        <p class=\'mb-0\'>' + quote + '</p>\n    </blockquote>';
};

// renderer.code = function code(code, infostring, escaped) {
//     return `<pre>
//         <code class="language-${infostring} hljs rounded-lg">${
//             infostring ? hljs.highlight(infostring, code).value : hljs.highlightAuto(code).value
//         }</code>
//     </pre>`;
// };

renderer.image = function image($href, title, text) {
    if ($href.match(/youtube.com/)) {
        var regexp = /(^|[\s\t\n]+)https*:\/\/(www\.)*youtube\.com\/(.*?v=([^&\s]+)(&[^\s]+)*)/gi;
        var youtubeVideo = $href.replace(regexp, function (match, p0, p1, p2, p3) {
            return p3;
        });
        // <iframe class='embed-responsive-item' src='https://www.youtube.com/embed/${youtubeVideo}?rel=0' allowfullscreen  width='1900' height='1200'></iframe>
        return '\n            <div class=\'youtube\' data-embed=\'' + youtubeVideo + '\'>\n                <div class=\'play-button\'></div>\n                <img src=\'https://img.youtube.com/vi/' + youtubeVideo + '/sddefault.jpg\'>\n            </div>\n            <div class=\'image_inline_text\'><strong>' + (text || '') + '</strong> ' + (title || '') + '</div>\n        ';
    }
    var serverName = '';
    if (document.domain === 'localhost' && !$href.match(/^http/)) {
        serverName = 'http://localhost:8080';
    }
    var src = '' + serverName + $href;
    var href = $href.replace(/(w=[0-9]+)/, 'w=1800');
    var mediaClass = [];
    var result = src.match(/#([a-z0-9,]+)$/);
    if (result) {
        var allClasses = result[1].split(',');
        if (allClasses[0] === 'card') {
            return '\n                <div class=\'card float-right col-lg-4 col-md-6 col-sm-12 p-0 ml-2 mb-2 mt-2\'>\n                    <img class=\'card-img-top\' src=\'' + src + '\' alt=\'' + (title || text) + '\'>\n                    <div class=\'card-body\'>\n                        <h5 class=\'card-title\'>' + (text || '') + '</h5>\n                        <p class=\'card-text\'>' + (title || '') + '</p>\n                    </div>\n                </div>';
        }
        if (allClasses[0] === 'card2') {
            return '\n                <div class=\'float-right card col-lg-7 col-md-7 col-sm-12 p-0 ml-2 mb-2 mt-2\'>\n                    <div class=\'row no-gutters\'>\n                        <div class=\'col-md-4\'>\n                            <img class=\'card-img img-fluid\' src=\'' + src + '\' alt=\'' + (title || text) + '\'>\n                        </div>\n                        <div class=\'col-md-8\'>\n                            <div class=\'card-body\'>\n                                <h5 class=\'card-title\'>' + (text || '') + '</h5>\n                                <p class=\'card-text\'>' + (title || '') + '</p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            ';
        }
        for (var i = 0, l = allClasses.length; i < l; i += 1) {
            mediaClass.push(allClasses[i]);
        }
    }
    return '\n        <p class=\'image_inline ' + mediaClass.join(' ') + '\'>\n            <a href=\'' + href + '\' data-smoothzoom=\'group1\' title=\'' + (title || text) + '\'>\n                <img src=\'' + src + '\' alt=\'' + (title || text) + '\' title=\'' + (title || text) + '\' class=\'img-fluid\'>\n            </a>\n            <div class=\'font-weight-lighter\'>\n                <small>\n                    <strong>' + (text || '') + '</strong> ' + (title || '') + '\n                </small>\n            </div>\n        </p>';
};

var markdown_Markdown = function () {
    function Markdown() {
        classCallCheck_default()(this, Markdown);
    }

    Markdown.render = function render() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        if (data) {
            var markdownData = marked(data.toString(), { renderer: renderer });
            return markdownData;
        }
        return '';
    };

    return Markdown;
}();

/* harmony default export */ var markdown = (markdown_Markdown);
// CONCATENATED MODULE: ./components/form/textarea.js




var textarea__class;




// import Markdown from 'preact-markdown';




var textarea__ref = Object(preact_min["h"])(
    'div',
    { 'class': 'valid-feedback', style: 'display: block;' },
    'Looks good. Saving...'
);

var textarea_Textarea = Object(index_module["a" /* observer */])(textarea__class = function (_Component) {
    inherits_default()(Textarea, _Component);

    function Textarea() {
        classCallCheck_default()(this, Textarea);

        return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }

    Textarea.prototype.render = function render() {
        var _props = this.props,
            _props$handleKeydown = _props.handleKeydown,
            handleKeydown = _props$handleKeydown === undefined ? function () {} : _props$handleKeydown,
            _props$onInput = _props.onInput,
            onInput = _props$onInput === undefined ? function () {} : _props$onInput,
            id = _props.id,
            isValid = _props.isValid,
            name = _props.name,
            _props$placeholder = _props.placeholder,
            placeholder = _props$placeholder === undefined ? '' : _props$placeholder,
            readonly = _props.readonly,
            required = _props.required,
            value = _props.value,
            rows = _props.rows,
            help = _props.help,
            removeHtml = _props.removeHtml;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'row' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'col-6' },
                Object(preact_min["h"])('textarea', { 'class': 'form-control ' + (isValid ? 'is-valid' : ''),
                    id: 'input' + name + '-' + id,
                    name: name,
                    rows: rows,
                    placeholder: placeholder,
                    readonly: readonly,
                    required: required,
                    value: removeHtml ? util.removeHtml(value) : value,
                    onInput: onInput,
                    onKeyDown: handleKeydown
                }),
                isValid ? textarea__ref : Object(preact_min["h"])(
                    'small',
                    { id: name + 'Help', 'class': 'form-text text-muted' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'float-right text-info ml-2' },
                        '"',
                        util.getType(value),
                        '"'
                    ),
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'float-right' },
                        '"',
                        name,
                        '"'
                    ),
                    help
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'col-6' },
                Object(preact_min["h"])('div', { 'class': 'lead', id: 'ingressDisplay', dangerouslySetInnerHTML: {
                        __html: markdown.render(value)
                    } })
            )
        );
    };

    return Textarea;
}(preact_min["Component"])) || textarea__class;

/* harmony default export */ var form_textarea = (textarea_Textarea);
// CONCATENATED MODULE: ./components/form/input.js




var input__class;







var input_Input = Object(index_module["a" /* observer */])(input__class = function (_Component) {
    inherits_default()(Input, _Component);

    function Input() {
        classCallCheck_default()(this, Input);

        return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }

    Input.prototype.render = function render() {
        var _props = this.props,
            _props$handleKeydown = _props.handleKeydown,
            handleKeydown = _props$handleKeydown === undefined ? function () {} : _props$handleKeydown,
            _props$onInput = _props.onInput,
            onInput = _props$onInput === undefined ? function () {} : _props$onInput,
            isValid = _props.isValid,
            isCheckbox = _props.isCheckbox,
            id = _props.id,
            name = _props.name,
            type = _props.type,
            _props$placeholder = _props.placeholder,
            placeholder = _props$placeholder === undefined ? '' : _props$placeholder,
            readonly = _props.readonly,
            required = _props.required,
            value = _props.value,
            values = _props.values,
            checked = _props.checked,
            help = _props.help,
            _props$className = _props.className,
            className = _props$className === undefined ? '' : _props$className,
            _props$hideHelp = _props.hideHelp,
            hideHelp = _props$hideHelp === undefined ? false : _props$hideHelp,
            dataParams = _props.dataParams,
            object = _props.object;


        if (type === 'radio' && Array.isArray(values)) {
            return Object(preact_min["h"])(
                'div',
                null,
                values.map(function (obj) {
                    return Object(preact_min["h"])(
                        'div',
                        { 'class': 'form-check ' + (isValid ? 'is-valid' : '') },
                        Object(preact_min["h"])('input', { 'class': 'form-check-input ' + (isValid ? 'is-valid' : '') + ' ' + className,
                            id: 'input' + name + '-' + id,
                            name: name,
                            type: type,
                            placeholder: placeholder,
                            readonly: readonly,
                            required: required,
                            value: obj.val,
                            onInput: readonly ? function () {} : onInput,
                            checked: obj.val == value ? 'checked' : '',
                            'data-params': dataParams
                        }),
                        Object(preact_min["h"])(
                            'label',
                            { 'class': 'form-check-label', 'for': 'input' + name + '-' + obj.val },
                            obj.key
                        )
                    );
                }),
                isValid ? Object(preact_min["h"])(
                    'div',
                    { 'class': 'valid-feedback', style: 'display: block;' },
                    'Looks good. Saving...'
                ) : !hideHelp && Object(preact_min["h"])(
                    'small',
                    { id: name + '-' + id + 'Help', 'class': 'form-text text-muted' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'float-right text-info ml-2' },
                        '"',
                        util.getType(value),
                        '"'
                    ),
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'float-right' },
                        '"',
                        name,
                        '"'
                    ),
                    help
                )
            );
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])('input', { 'class': (isCheckbox ? 'form-check-input mx-1' : 'form-control') + ' ' + (isValid ? 'is-valid' : '') + ' ' + className,
                id: 'input' + name + '-' + id,
                name: name,
                type: type,
                placeholder: placeholder,
                readonly: readonly,
                required: required,
                value: value,
                onInput: readonly ? function () {} : onInput,
                onKeyDown: handleKeydown,
                checked: checked,
                'data-params': dataParams
            }),
            isValid ? Object(preact_min["h"])(
                'div',
                { 'class': (isCheckbox ? 'ml-4' : '') + ' valid-feedback', style: 'display: block;' },
                'Looks good. Saving...'
            ) : !hideHelp && Object(preact_min["h"])(
                'small',
                { id: name + '-' + id + 'Help', 'class': (isCheckbox ? 'ml-4' : '') + ' form-text text-muted' },
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right text-info ml-2' },
                    '"',
                    util.getType(value),
                    '"'
                ),
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right' },
                    '"',
                    name,
                    '"'
                ),
                util.asString(object, 'updatedFields', name) && Object(preact_min["h"])(
                    'div',
                    null,
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'text-primary mr-2' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': '' },
                            'Last updated: ',
                            util.isoDate(util.asString(object, 'updatedFields', name))
                        ),
                        util.asString(object, 'updatedLastValue', name) && Object(preact_min["h"])(
                            'span',
                            { 'class': 'ml-2' },
                            'Last value: ',
                            util.asString(object, 'updatedLastValue', name)
                        )
                    )
                ),
                help
            )
        );
    };

    return Input;
}(preact_min["Component"])) || input__class;

/* harmony default export */ var input = (input_Input);
// EXTERNAL MODULE: ./components/form/style.css
var form_style = __webpack_require__("0p0B");
var form_style_default = /*#__PURE__*/__webpack_require__.n(form_style);

// CONCATENATED MODULE: ./components/form/json.js




var json__class;








var json_Json = Object(index_module["a" /* observer */])(json__class = function (_Component) {
    inherits_default()(Json, _Component);

    function Json() {
        classCallCheck_default()(this, Json);

        return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }

    Json.prototype.render = function render() {
        var _props = this.props,
            name = _props.name,
            value = _props.value,
            help = _props.help;


        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(
                'code',
                { 'class': form_style_default.a.code },
                JSON.stringify(value, null, 4)
            ),
            Object(preact_min["h"])(
                'small',
                { id: name + 'Help', 'class': 'form-text text-muted' },
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right text-info ml-2' },
                    '"',
                    util.getType(value),
                    '"'
                ),
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right' },
                    '"',
                    name,
                    '"'
                ),
                help
            )
        );
    };

    return Json;
}(preact_min["Component"])) || json__class;

/* harmony default export */ var json = (json_Json);
// CONCATENATED MODULE: ./components/form/view.js




var view__class;







var view_View = Object(index_module["a" /* observer */])(view__class = function (_Component) {
    inherits_default()(View, _Component);

    function View() {
        classCallCheck_default()(this, View);

        return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }

    View.prototype.render = function render() {
        var _props = this.props,
            _props$view = _props.view,
            view = _props$view === undefined ? function () {} : _props$view,
            id = _props.id,
            name = _props.name,
            value = _props.value,
            help = _props.help,
            updateField = _props.updateField,
            object = _props.object;


        return Object(preact_min["h"])(
            'div',
            null,
            view(value, { id: id, name: name, updateField: updateField, object: object }),
            Object(preact_min["h"])(
                'small',
                { id: name + 'Help', 'class': 'form-text text-muted' },
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right text-info ml-2' },
                    '"',
                    util.getType(value),
                    '"'
                ),
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right' },
                    '"',
                    name,
                    '"'
                ),
                help
            )
        );
    };

    return View;
}(preact_min["Component"])) || view__class;

/* harmony default export */ var form_view = (view_View);
// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("zCAL");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// CONCATENATED MODULE: ../node_modules/linkstate/dist/linkstate.es.js
function dlv(obj, key, def, p) {
	p = 0;
	key = key.split ? key.split('.') : key;
	while (obj && p < key.length) {
		obj = obj[key[p++]];
	}
	return obj === undefined ? def : obj;
}

/** Create an Event handler function that sets a given state property.
 *	@param {Component} component	The component whose state should be updated
 *	@param {string} key				A dot-notated key path to update in the component's state
 *	@param {string} eventPath		A dot-notated key path to the value that should be retrieved from the Event or component
 *	@returns {function} linkedStateHandler
 */
function linkState(component, key, eventPath) {
	var path = key.split('.'),
	    cache = component.__lsc || (component.__lsc = {});

	return cache[key + eventPath] || (cache[key + eventPath] = function (e) {
		var t = e && e.target || this,
		    state = {},
		    obj = state,
		    v = typeof eventPath === 'string' ? dlv(e, eventPath) : t.nodeName ? t.type.match(/^che|rad/) ? t.checked : t.value : e,
		    i = 0;
		for (; i < path.length - 1; i++) {
			obj = obj[path[i]] || (obj[path[i]] = !i && component.state[path[i]] || {});
		}
		obj[path[i]] = v;
		component.setState(state);
	});
}

/* harmony default export */ var linkstate_es = (linkState);
//# sourceMappingURL=linkstate.es.js.map
// CONCATENATED MODULE: ./components/form/dragNdrop.js






var dragNdrop__class;








var dragNdrop_DragNDrop = Object(index_module["a" /* observer */])(dragNdrop__class = function (_Component) {
    inherits_default()(DragNDrop, _Component);

    function DragNDrop(props) {
        classCallCheck_default()(this, DragNDrop);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.onMouseDown = function (idx) {
            _this.setState({
                draggable: idx
            });
        };

        _this.onMouseUp = function () {
            _this.setState({
                draggable: -1
            });
        };

        _this.dragStart = function (idx, e) {
            // const { items = [] } = this.props;
            if (e.target.getAttribute('draggable') === 'false') return;
            // e.dataTransfer.setData('application/json', JSON.stringify(items[idx]));
            e.dataTransfer.effectAllowed = 'move';

            _this.setState({
                dragging: true,
                dragged: idx,
                over: idx
            });
        };

        _this.dragEnd = function () {
            _this.setState({
                dragging: false,
                draggable: -1,
                dragged: -1,
                over: -1
            });
        };

        _this.dragOver = function (idx, e) {
            _this.setState({
                over: idx
            });

            if (idx === _this.state.dragged) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();
        };

        _this.drop = function (target) {
            var dragged = _this.state.dragged;

            if (dragged === target) return;
            var newItems = _this.props.items.slice();
            newItems.splice(target, 0, newItems.splice(dragged, 1)[0]);
            _this.props.onSort(newItems);
        };

        _this.state = {
            dragging: false,
            draggable: -1,
            dragged: -1,
            over: -1
        };
        return _this;
    }

    DragNDrop.prototype.render = function render(_ref, _ref2) {
        var _this2 = this;

        var Container = _ref.container,
            Item = _ref.item,
            _ref$items = _ref.items,
            items = _ref$items === undefined ? [] : _ref$items,
            Handle = _ref.handle,
            prop = _ref.prop,
            imagePrefix = _ref.imagePrefix,
            handleDelImage = _ref.handleDelImage,
            articleId = _ref.articleId;
        var dragged = _ref2.dragged,
            dragging = _ref2.dragging,
            over = _ref2.over,
            draggable = _ref2.draggable;

        var newItems = dragging && over !== dragged ? items.slice() : items;

        if (dragging && over !== dragged) {
            newItems.splice(over, 0, newItems.splice(dragged, 1)[0]);
        }

        return Object(preact_min["h"])(
            Container,
            { 'aria-dropeffect': 'move' },
            newItems.map(function (data, idx) {
                return Object(preact_min["h"])(Item, {
                    key: data[prop],
                    data: data,
                    handle: Object(preact_min["h"])(Handle, {
                        onMouseDown: function onMouseDown() {
                            return _this2.onMouseDown(idx);
                        },
                        onMouseUp: function onMouseUp() {
                            return _this2.onMouseUp();
                        },
                        data: data
                    }),
                    draggable: !Handle || draggable === idx,
                    beeingDragged: !Handle || draggable === idx,
                    over: dragging && idx === over,
                    onDragStart: function onDragStart(e) {
                        return _this2.dragStart(idx, e);
                    },
                    onDragEnd: function onDragEnd() {
                        return _this2.dragEnd(idx);
                    },
                    onDragOver: function onDragOver(e) {
                        return _this2.dragOver(idx, e);
                    },
                    onDrop: function onDrop() {
                        return _this2.drop(idx);
                    },
                    role: 'option',
                    'aria-grabbed': dragging && idx === over,
                    grabbed: dragging && idx === over,
                    imagePrefix: imagePrefix,
                    articleId: articleId,
                    idx: idx,
                    handleDelImage: handleDelImage
                });
            })
        );
    };

    return DragNDrop;
}(preact_min["Component"])) || dragNdrop__class;

var dragNdrop_Item = function Item(_ref3) {
    var data = _ref3.data,
        handle = _ref3.handle,
        beeingDragged = _ref3.beeingDragged,
        over = _ref3.over,
        props = objectWithoutProperties_default()(_ref3, ['data', 'handle', 'beeingDragged', 'over']);

    return Object(preact_min["h"])(
        'li',
        extends_default()({ 'class': 'item ' + (beeingDragged ? form_style_default.a.dragged : '') + ' ' + (over ? form_style_default.a.over : '') }, props),
        handle,
        Object(preact_min["h"])(
            'section',
            { 'class': 'content' },
            Object(preact_min["h"])(
                'p',
                null,
                'Item #',
                data.id
            ),
            JSON.stringify(props)
        )
    );
};

var dragNdrop__ref6 = Object(preact_min["h"])('i', { 'class': 'fas fa-bars' });

dragNdrop_DragNDrop.defaultProps = {
    container: function container(_ref4) {
        var children = _ref4.children,
            props = objectWithoutProperties_default()(_ref4, ['children']);

        return Object(preact_min["h"])(
            'ul',
            props,
            children
        );
    },
    item: dragNdrop_Item,
    handle: function handle(_ref5) {
        var props = objectWithoutProperties_default()(_ref5, []);

        return Object(preact_min["h"])(
            'button',
            extends_default()({ 'class': 'btn btn-link' }, props),
            dragNdrop__ref6
        );
    },
    onSort: function onSort() {},
    onSwap: function onSwap(from, to) {},
    prop: 'id'
};

/* harmony default export */ var dragNdrop = (dragNdrop_DragNDrop);
// CONCATENATED MODULE: ./components/form/dragNdropFileupload.js




var dragNdropFileupload__class;







var debug = false;
var debugName = 'Images';

var dragNdropFileupload__ref = Object(preact_min["h"])(
    'div',
    null,
    'drop your files here :)'
);

var dragNdropFileupload__ref2 = Object(preact_min["h"])(
    'h3',
    null,
    'Uploaded images'
);

var dragNdropFileupload_DragNDropFileupload = Object(index_module["a" /* observer */])(dragNdropFileupload__class = function (_Component) {
    inherits_default()(DragNDropFileupload, _Component);

    function DragNDropFileupload(props) {
        classCallCheck_default()(this, DragNDropFileupload);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.dropRef = Object(preact_min["createRef"])();

        _this.handleDrag = function (e) {
            e.preventDefault();
            e.stopPropagation();
        };

        _this.handleDragIn = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.dragCounter++;
            if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
                _this.setState({ drag: true });
            }
        };

        _this.handleDragOut = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.dragCounter--;
            if (_this.dragCounter === 0) {
                _this.setState({ drag: false });
            }
        };

        _this.handleDrop = function (e) {
            if (debug) {
                console.log(debugName + '.handleDrop: event', e);
            }
            e.preventDefault();
            e.stopPropagation();
            _this.setState({ drag: false });
            if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                // this.props.handleDrop(e.dataTransfer.files);
                // e.dataTransfer.clearData();
                for (var i = 0, l = e.dataTransfer.files.length; i < l; i += 1) {
                    var photo = e.dataTransfer.files[i];
                    // if (photo.type.match('image.*')) {
                    _this.readLocalFile(photo);
                    // }
                }
                _this.dragCounter = 0;
            }
        };

        _this.handleAddFiles = function (event) {
            event.preventDefault();
            var el = event.target;
            if (debug) {
                console.log(debugName + '.handleAddFiles: event, el', event, el);
            }
            for (var i = 0, l = el.files.length; i < l; i += 1) {
                var photo = el.files[i];
                // if (photo.type.match('image.*')) {
                _this.readLocalFile(photo);
                // }
            }
        };

        _this.handleEvent = function (e, fileObject) {
            if (debug) {
                console.log(debugName + '.handleEvent[' + fileObject.name + ']: ' + e.type + ': ' + (e.loaded + ' bytes transferred of ' + e.total + '. Is lengthComputable: ' + e.lengthComputable + ': ') + ('' + JSON.stringify(e)));
            }
        };

        _this.handleUpload = function (fileObject) {
            if (debug) {
                console.log(debugName + '.handleUpload[' + fileObject.name + ']');
            }
            var formData = new FormData();
            formData.append('files[]', fileObject);
            var uploadMeta = {
                progress: 1
            };

            uploadMeta.xhr = new XMLHttpRequest();

            uploadMeta.xhr.upload.addEventListener('progress', function (event) {
                var fileObj = fileObject;
                _this.updateProgress(event, fileObj);
            });
            uploadMeta.xhr.addEventListener('loadstart', function (event) {
                var fileObj = fileObject;
                _this.handleEvent(event, fileObj);
            });
            uploadMeta.xhr.addEventListener('load', function (event) {
                var fileObj = fileObject;
                _this.handleEvent(event, fileObj);
            });
            uploadMeta.xhr.addEventListener('loadend', function (event) {
                var fileObj = fileObject;
                _this.handleEvent(event, fileObj);
            });
            uploadMeta.xhr.addEventListener('progress', function (event) {
                var fileObj = fileObject;
                _this.handleEvent(event, fileObj);
            });
            uploadMeta.xhr.addEventListener('error', function (event) {
                var fileObj = fileObject;
                _this.handleEvent(event, fileObj);
            });
            uploadMeta.xhr.addEventListener('abort', function (event) {
                var fileObj = fileObject;
                _this.handleEvent(event, fileObj);
            });
            uploadMeta.xhr.addEventListener('readystatechange', function (event) {
                var fileObj = fileObject;
                _this.uploadDone(event, fileObj);
            });

            uploadMeta.xhr.open('POST', '' + util.getApiServer() + _this.props.apiUrl);
            uploadMeta.xhr.setRequestHeader('Authorization', 'Bearer ' + util.getJwtToken());
            uploadMeta.xhr.send(formData);

            var filename = fileObject.name;
            var uploadedFilesData = _this.state.uploadedFilesData;
            if (!uploadedFilesData[filename]) {
                uploadedFilesData[filename] = {};
            }
            uploadedFilesData[filename].uploadMeta = uploadMeta;
            uploadedFilesData[filename].imageNum = _this.state.imageNum;
            _this.setState({ uploadedFilesData: uploadedFilesData });
        };

        _this.readLocalFile = function (fileObject) {
            return new Promise(function (resolve, reject) {
                var reader = new FileReader();

                reader.addEventListener('error', function (error) {
                    if (debug) {
                        console.log(debugName + '.FileReader: Error occurred reading file: ' + fileObject.name + ': ' + error);
                    }
                    reject(error);
                });

                reader.addEventListener('load', function (event) {
                    if (debug) {
                        console.log(debugName + '.FileReader: File: ' + fileObject.name + ' read successfully: ' + ('' + JSON.stringify(event)));
                    }
                    var photo = fileObject;
                    var filename = photo.name;
                    var uploadedFilesData = _this.state.uploadedFilesData;
                    if (!uploadedFilesData[filename]) {
                        uploadedFilesData[filename] = {};
                    }
                    uploadedFilesData[filename].event = event;
                    _this.setState({ uploadedFilesData: uploadedFilesData });
                    _this.handleUpload(photo);
                    resolve(event);
                });

                reader.readAsDataURL(fileObject);
            });
        };

        _this.updateProgress = function (event, fileObject) {
            if (event.lengthComputable) {
                var filename = fileObject.name;
                var uploadedFilesData = _this.state.uploadedFilesData;
                var percentComplete = event.loaded / event.total * 100;
                if (debug) {
                    console.log(debugName + '.updateProgress[' + filename + '].progress', percentComplete);
                }
                uploadedFilesData[filename].uploadMeta.progress = percentComplete;
                _this.setState({ uploadedFilesData: uploadedFilesData });
            }
        };

        _this.uploadDone = function (event, fileObject) {
            var filename = fileObject.name;
            var uploadedFilesData = _this.state.uploadedFilesData;
            var uploadMeta = uploadedFilesData[filename].uploadMeta;
            if (debug) {
                console.log(debugName + '.uploadDone[' + filename + '].uploadedFilesData', uploadedFilesData);
                console.log(debugName + '.uploadDone[' + filename + '].uploadMeta', uploadMeta);
                console.log(debugName + '.uploadDone.event', event);
            }

            if (uploadMeta && uploadMeta.xhr.readyState === 4 && uploadMeta.xhr.status === 201) {
                var response = JSON.parse(uploadMeta.xhr.responseText);
                var files = response.data.files;
                for (var i = 0; i < files.length; i += 1) {
                    var file = files[i];
                    _this.addFileToUpload(file);
                    _this.fileInput.value = '';
                }
            }
        };

        _this.state = {
            drag: false,
            loadingProgress: 0,
            uploadedFiles: [],
            uploadedFilesData: {}
        };
        return _this;
    }

    // Upload


    // eslint-disable-next-line


    DragNDropFileupload.prototype.addFileToUpload = function addFileToUpload(file) {
        if (debug) {
            console.log(debugName + '.addFileToUpload[' + file.name + ']');
        }
        var uploadedFilesData = this.state.uploadedFilesData;
        var handleAddImage = this.props.handleAddImage;


        delete uploadedFilesData[file.name];
        this.setState({ uploadedFilesData: uploadedFilesData });
        handleAddImage(file);
    };
    // /Upload

    DragNDropFileupload.prototype.componentDidMount = function componentDidMount() {
        var div = this.dropRef.current;
        div.addEventListener('dragenter', this.handleDragIn);
        div.addEventListener('dragleave', this.handleDragOut);
        div.addEventListener('dragover', this.handleDrag);
        div.addEventListener('drop', this.handleDrop);
    };

    DragNDropFileupload.prototype.componentWillUnmount = function componentWillUnmount() {
        var div = this.dropRef.current;
        div.removeEventListener('dragenter', this.handleDragIn);
        div.removeEventListener('dragleave', this.handleDragOut);
        div.removeEventListener('dragover', this.handleDrag);
        div.removeEventListener('drop', this.handleDrop);
    };

    DragNDropFileupload.prototype.render = function render() {
        var _this2 = this;

        var uploadedFilesData = this.state.uploadedFilesData;


        return Object(preact_min["h"])(
            'div',
            { style: { position: 'relative' }, ref: this.dropRef },
            this.state.drag && Object(preact_min["h"])(
                'div',
                { style: {
                        border: 'dashed grey 4px',
                        backgroundColor: 'rgba(255,255,255,.8)',
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 9999
                    } },
                Object(preact_min["h"])(
                    'div',
                    {
                        style: {
                            position: 'absolute',
                            top: '50%',
                            right: 0,
                            left: 0,
                            textAlign: 'center',
                            color: 'grey',
                            fontSize: 36
                        }
                    },
                    dragNdropFileupload__ref
                )
            ),
            Object(preact_min["h"])(
                'div',
                null,
                Object(preact_min["h"])('input', { 'class': 'btn btn-info col-sm-12', multiple: true,
                    type: 'file',
                    id: 'image-file',
                    onchange: this.handleAddFiles,
                    ref: function ref(c) {
                        _this2.fileInput = c;
                    }
                })
            ),
            Object(preact_min["h"])(
                'div',
                null,
                Object.keys(uploadedFilesData).length > 0 ? dragNdropFileupload__ref2 : '',
                Object(preact_min["h"])(
                    'ul',
                    { 'class': 'list-group' },
                    Object.keys(uploadedFilesData).map(function (key) {
                        var _uploadedFilesData$ke = uploadedFilesData[key].uploadMeta,
                            uploadMeta = _uploadedFilesData$ke === undefined ? {} : _uploadedFilesData$ke;

                        var isImage = key.match(/(jpg|jpeg|png|gif)/i);
                        return Object(preact_min["h"])(
                            'li',
                            { 'class': 'list-group-item list-group-item-action flex-column align-items-start' },
                            Object(preact_min["h"])(
                                'div',
                                { 'class': 'd-flex w-100 justify-content-between' },
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': 'mb-1' },
                                    key
                                ),
                                Object(preact_min["h"])(
                                    'small',
                                    null,
                                    util.formatBytes(uploadedFilesData[key].event.total, 2)
                                )
                            ),
                            Object(preact_min["h"])(
                                'div',
                                { 'class': 'd-flex w-100 justify-content-between' },
                                isImage && Object(preact_min["h"])('img', { 'class': 'img-fluid mr-3',
                                    src: uploadedFilesData[key].event.target.result,
                                    style: 'max-height: 150px;'
                                }),
                                Object(preact_min["h"])(
                                    'small',
                                    null,
                                    uploadedFilesData[key].event.uploadDone
                                ),
                                'Uploading, please wait...'
                            ),
                            Object(preact_min["h"])(
                                'div',
                                { 'class': 'progress', style: 'height: 2px;' },
                                Object(preact_min["h"])('div', {
                                    'class': 'progress-bar progress-bar-striped progress-bar-animated bg-success',
                                    role: 'progressbar',
                                    style: 'width: ' + uploadMeta.progress + '%; height: 2px;',
                                    'aria-valuenow': uploadMeta.progress,
                                    'aria-valuemin': '0',
                                    'aria-valuemax': '100'
                                })
                            )
                        );
                    })
                )
            ),
            this.props.children
        );
    };

    return DragNDropFileupload;
}(preact_min["Component"])) || dragNdropFileupload__class;

/* harmony default export */ var dragNdropFileupload = (dragNdropFileupload_DragNDropFileupload);
// CONCATENATED MODULE: ./components/form/images.js






var images__class, images__class2, _class4;












var images__ref = Object(preact_min["h"])('i', { 'class': 'fas fa-bars' });

var images_Handle = Object(index_module["a" /* observer */])(images__class = function (_Component) {
    inherits_default()(Handle, _Component);

    function Handle() {
        classCallCheck_default()(this, Handle);

        return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }

    Handle.prototype.render = function render() {
        return Object(preact_min["h"])(
            'button',
            extends_default()({ 'class': 'btn btn-link' }, this.props),
            images__ref
        );
    };

    return Handle;
}(preact_min["Component"])) || images__class;

var images__ref2 = Object(preact_min["h"])('br', null);

var images__ref3 = Object(preact_min["h"])(
    'small',
    null,
    'Dominant'
);

var images__ref4 = Object(preact_min["h"])('br', null);

var images__ref5 = Object(preact_min["h"])(
    'small',
    null,
    'Palette'
);

var images__ref6 = Object(preact_min["h"])('br', null);

var images__ref7 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var images__ref8 = Object(preact_min["h"])('br', null);

var images_Item = Object(index_module["a" /* observer */])(images__class2 = function (_Component2) {
    inherits_default()(Item, _Component2);

    function Item() {
        var _temp, _this2, _ret;

        classCallCheck_default()(this, Item);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = possibleConstructorReturn_default()(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.imageServer = util.getImageServer(), _this2.uniqId = util.randomPassword(), _this2.selectAndCopy = function (event) {
            event.target.select();
            document.execCommand('copy');
            _this2.setState({ selected: true });
            _this2.removeSelectText();
        }, _this2.handleImageErrored = function (e) {
            var image = e.target;
            image.onerror = null;
            setTimeout(function () {
                image.src += '?' + new Date();
            }, 1000);
        }, _temp), possibleConstructorReturn_default()(_this2, _ret);
    }

    Item.prototype.removeSelectText = function removeSelectText() {
        var _this3 = this;

        this.selectTimer = setTimeout(function () {
            _this3.setState({ selected: false });
        }, 2000);
    };

    Item.prototype.render = function render() {
        var _this4 = this;

        var _props = this.props,
            data = _props.data,
            handle = _props.handle,
            beeingDragged = _props.beeingDragged,
            over = _props.over,
            imagePrefix = _props.imagePrefix,
            handleDelImage = _props.handleDelImage,
            articleId = _props.articleId,
            idx = _props.idx,
            props = objectWithoutProperties_default()(_props, ['data', 'handle', 'beeingDragged', 'over', 'imagePrefix', 'handleDelImage', 'articleId', 'idx']);

        var _state = this.state,
            selected = _state.selected,
            _state$title = _state.title,
            title = _state$title === undefined ? '' : _state$title,
            _state$text = _state.text,
            text = _state$text === undefined ? '' : _state$text,
            _state$size = _state.size,
            size = _state$size === undefined ? '800x' : _state$size;

        // name: Screenshot 2019-02-20 at 14.50.55.jpg
        // encoding: 7bit
        // mimetype: image/jpeg
        // ext: .jpg
        // newFilename: dealerweb-cms-e583e492-8ab0-48c8-9033-2c5083bcfbed.jpg
        // s3Link: http://ffe-web-images-original.s3-website-eu-west-1.amazonaws.comdealerweb-cms-e583e492-8ab0-48c8-9033-2c5083bcfbed.jpg
        // s3ThumbLink: //ffe-web-images-resized.s3-website-eu-west-1.amazonaws.com/80x80/dealerweb-cms-e583e492-8ab0-48c8-9033-2c5083bcfbed.jpg
        // sort: 10
        // idx: 9

        var isImage = void 0;
        if (data.mimetype) {
            isImage = data.mimetype.match(/^image/);
        } else {
            isImage = data.ext.match(/(jpg|jpeg|gif|png)/i);
        }

        var imageName = (imagePrefix || 'product') + '_' + data.sort + '_' + data.filename + '.' + data.ext;
        if (data.newFilename) {
            imageName = data.newFilename;
        }

        return Object(preact_min["h"])(
            'li',
            extends_default()({ 'class': 'item ' + (beeingDragged ? form_style_default.a.dragged : '') + ' ' + (over ? form_style_default.a.over : '') + ' mb-2' }, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-1 text-right' },
                    handle
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-4' },
                    isImage && Object(preact_min["h"])('img', { 'class': 'img-fluid',
                        src: this.imageServer + '/220x/' + imageName,
                        ondragstart: function ondragstart(e) {
                            return e.preventDefault();
                        },
                        onError: this.handleImageErrored
                    }),
                    images__ref2,
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'row' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-3' },
                            images__ref3,
                            images__ref4,
                            data.color && Object(preact_min["h"])(
                                'div',
                                {
                                    'class': 'rounded-circle border float-left mr-2 mt-2',
                                    style: 'background-color: rgb(' + data.color[0] + ', ' + data.color[1] + ', ' + data.color[2] + '); width: 50px; height: 50px;'
                                },
                                '\xA0'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-7' },
                            images__ref5,
                            images__ref6,
                            data.palette && data.palette.map(function (col) {
                                return Object(preact_min["h"])(
                                    'div',
                                    {
                                        'class': 'rounded-circle border float-left mt-2',
                                        style: 'background-color: rgb(' + col[0] + ', ' + col[1] + ', ' + col[2] + '); width: 20px; height: 20px;'
                                    },
                                    '\xA0'
                                );
                            })
                        )
                    ),
                    Object(preact_min["h"])(
                        'small',
                        null,
                        Object(preact_min["h"])(
                            'strong',
                            null,
                            title
                        ),
                        ' ',
                        text
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-7' },
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'btn btn-sm btn-danger float-right',
                            onClick: function onClick() {
                                return handleDelImage(idx + 1);
                            }
                        },
                        images__ref7
                    ),
                    imageName,
                    images__ref8,
                    data && ['name', 'mimetype'].map(function (key) {
                        return Object(preact_min["h"])(
                            'li',
                            { style: 'line-height: .9em;' },
                            data[key] && Object(preact_min["h"])(
                                'small',
                                { 'class': 'font-weight-lighter' },
                                key,
                                ': ',
                                data[key]
                            )
                        );
                    }),
                    isImage && Object(preact_min["h"])(
                        'div',
                        { 'class': 'row mb-1' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-3' },
                            Object(preact_min["h"])('input', { 'class': 'form-control form-control-sm', oninput: linkstate_es(this, 'title'), value: title, placeholder: 'Enter image title' })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-9' },
                            Object(preact_min["h"])('input', { 'class': 'form-control form-control-sm', oninput: linkstate_es(this, 'text'), value: text, placeholder: 'Enter image text' })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-12' },
                            ['80x80', '150x', '220x', '400x', '800x', '1024x', '1280x'].map(function (toggleSize) {
                                return Object(preact_min["h"])(
                                    'div',
                                    { 'class': 'form-check form-control-sm form-check-inline' },
                                    Object(preact_min["h"])('input', { 'class': 'form-check-input', type: 'radio', name: 'size', id: 'size' + toggleSize + _this4.uniqId, value: '' + toggleSize, onchange: linkstate_es(_this4, 'size', 'target.value') }),
                                    Object(preact_min["h"])(
                                        'label',
                                        { 'class': 'form-check-label', 'for': 'size' + toggleSize + _this4.uniqId },
                                        toggleSize
                                    )
                                );
                            })
                        )
                    ),
                    isImage && Object(preact_min["h"])('input', { 'class': 'form-control form-control-sm', value: '![' + title + '](' + this.imageServer + '/' + size + '/' + imageName + ' "' + text + '")',
                        onClick: this.selectAndCopy
                    }),
                    !isImage && Object(preact_min["h"])('input', { 'class': 'form-control form-control-sm', value: '[' + data.name + '](' + data.s3Link + ')',
                        onClick: this.selectAndCopy
                    }),
                    selected && Object(preact_min["h"])(
                        'div',
                        { 'class': 'valid-feedback', style: 'display: block;' },
                        'Text copied to clipboard...'
                    )
                )
            )
        );
    };

    return Item;
}(preact_min["Component"])) || images__class2;

var images__ref10 = Object(preact_min["h"])('br', null);

var images_Images = Object(index_module["a" /* observer */])(_class4 = function (_Component3) {
    inherits_default()(Images, _Component3);

    function Images(props) {
        classCallCheck_default()(this, Images);

        var _this5 = possibleConstructorReturn_default()(this, _Component3.call(this, props));

        _this5.state = {
            files: []
        };
        return _this5;
    }

    Images.prototype.render = function render() {
        var _props2 = this.props,
            id = _props2.id,
            updateField = _props2.updateField,
            handleAddImage = _props2.handleAddImage,
            handleDelImage = _props2.handleDelImage,
            name = _props2.name,
            value = _props2.value,
            imagePrefix = _props2.imagePrefix,
            help = _props2.help,
            object = _props2.object;
        var files = this.state.files;

        var items = util.makeArrayOfObject(value);

        return Object(preact_min["h"])(
            'div',
            { 'class': 'row' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'col-7' },
                Object(preact_min["h"])(dragNdrop, {
                    container: function container(_ref9) {
                        var children = _ref9.children;
                        return Object(preact_min["h"])(
                            'ul',
                            { 'class': form_style_default.a.list },
                            children
                        );
                    },
                    items: items,
                    item: images_Item,
                    handle: images_Handle,
                    imagePrefix: imagePrefix,
                    onSort: function onSort(newItems) {
                        var obj = object;
                        updateField(id, name, util.makeObjectOfArray(newItems), obj);
                    },
                    articleId: id,
                    handleDelImage: handleDelImage
                })
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'col-5' },
                'Upload files or drop them here:',
                images__ref10,
                Object(preact_min["h"])(
                    dragNdropFileupload,
                    {
                        handleAddImage: handleAddImage,
                        apiUrl: '/api/fileupload'
                    },
                    Object(preact_min["h"])('div', { style: { height: 300, width: 250 } })
                )
            ),
            Object(preact_min["h"])(
                'small',
                { id: name + 'Help', 'class': 'form-text text-muted' },
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right text-info ml-2' },
                    '"',
                    util.getType(value),
                    '"'
                ),
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right' },
                    '"',
                    name,
                    '"'
                ),
                help
            )
        );
    };

    return Images;
}(preact_min["Component"])) || _class4;

/* harmony default export */ var form_images = (images_Images);
// CONCATENATED MODULE: ./components/form/imagelist.js






var imagelist__class, _class3;









var imagelist__ref = Object(preact_min["h"])('br', null);

var imagelist_Item = Object(index_module["a" /* observer */])(imagelist__class = function (_Component) {
    inherits_default()(Item, _Component);

    function Item() {
        var _temp, _this, _ret;

        classCallCheck_default()(this, Item);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.imageServer = util.getImageServer(), _this.uniqId = util.randomPassword(), _this.selectAndCopy = function (event) {
            event.target.select();
            document.execCommand('copy');
            _this.setState({ selected: true });
            _this.removeSelectText();
        }, _temp), possibleConstructorReturn_default()(_this, _ret);
    }

    Item.prototype.removeSelectText = function removeSelectText() {
        var _this2 = this;

        this.selectTimer = setTimeout(function () {
            _this2.setState({ selected: false });
        }, 2000);
    };

    Item.prototype.render = function render() {
        var _this3 = this;

        var _props = this.props,
            data = _props.data,
            _props$imagePrefix = _props.imagePrefix,
            imagePrefix = _props$imagePrefix === undefined ? 'product' : _props$imagePrefix,
            props = objectWithoutProperties_default()(_props, ['data', 'imagePrefix']);

        var _state = this.state,
            selected = _state.selected,
            _state$title = _state.title,
            title = _state$title === undefined ? '' : _state$title,
            _state$text = _state.text,
            text = _state$text === undefined ? '' : _state$text,
            _state$size = _state.size,
            size = _state$size === undefined ? '800x' : _state$size;


        var imageName = imagePrefix + '_' + data.sort + '_' + data.filename + '.' + data.ext;
        if (data.newFilename) {
            imageName = data.newFilename;
        }

        return Object(preact_min["h"])(
            'li',
            extends_default()({ 'class': 'item mb-2' }, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-2' },
                    Object(preact_min["h"])('img', { 'class': 'img-fluid', src: this.imageServer + '/220x/' + imageName, ondragstart: function ondragstart(e) {
                            return e.preventDefault();
                        } })
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-10' },
                    imageName,
                    imagelist__ref,
                    data && ['name', 'mimetype'].map(function (key) {
                        return Object(preact_min["h"])(
                            'li',
                            { style: 'line-height: .9em;' },
                            data[key] && Object(preact_min["h"])(
                                'small',
                                { 'class': 'font-weight-lighter' },
                                key,
                                ': ',
                                data[key]
                            )
                        );
                    }),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'row mb-1' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-3' },
                            Object(preact_min["h"])('input', { 'class': 'form-control form-control-sm', oninput: linkstate_es(this, 'title'), placeholder: 'Enter image title' })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-9' },
                            Object(preact_min["h"])('input', { 'class': 'form-control form-control-sm', oninput: linkstate_es(this, 'text'), placeholder: 'Enter image text' })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-12' },
                            ['80x80', '150x', '220x', '400x', '800x', '1024x', '1280x'].map(function (toggleSize) {
                                return Object(preact_min["h"])(
                                    'div',
                                    { 'class': 'form-check form-control-sm form-check-inline' },
                                    Object(preact_min["h"])('input', { 'class': 'form-check-input', type: 'radio', name: 'size', id: 'size' + toggleSize + _this3.uniqId, value: '' + toggleSize, onchange: linkstate_es(_this3, 'size', 'target.value') }),
                                    Object(preact_min["h"])(
                                        'label',
                                        { 'class': 'form-check-label', 'for': 'size' + toggleSize + _this3.uniqId },
                                        toggleSize
                                    )
                                );
                            })
                        )
                    ),
                    Object(preact_min["h"])('input', { 'class': 'form-control form-control-sm', value: '![' + title + '](' + this.imageServer + '/' + size + '/' + imageName + ' "' + text + '")',
                        onClick: this.selectAndCopy
                    }),
                    selected && Object(preact_min["h"])(
                        'div',
                        { 'class': 'valid-feedback', style: 'display: block;' },
                        'Text copied to clipboard...'
                    )
                )
            )
        );
    };

    return Item;
}(preact_min["Component"])) || imagelist__class;

var imagelist_ImageList = Object(index_module["a" /* observer */])(_class3 = function (_Component2) {
    inherits_default()(ImageList, _Component2);

    function ImageList() {
        classCallCheck_default()(this, ImageList);

        return possibleConstructorReturn_default()(this, _Component2.apply(this, arguments));
    }

    ImageList.prototype.render = function render() {
        var _this5 = this;

        var _props2 = this.props,
            name = _props2.name,
            value = _props2.value,
            help = _props2.help;

        var items = util.makeArrayOfObject(value);

        return Object(preact_min["h"])(
            'div',
            { 'class': 'row' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'col-12' },
                Object(preact_min["h"])(
                    'ul',
                    { 'class': form_style_default.a.list + ' px-0' },
                    items.map(function (item) {
                        return Object(preact_min["h"])(imagelist_Item, extends_default()({
                            data: item
                        }, _this5.props));
                    })
                )
            ),
            Object(preact_min["h"])(
                'small',
                { id: name + 'Help', 'class': 'form-text text-muted' },
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right text-info ml-2' },
                    '"',
                    util.getType(value),
                    '"'
                ),
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right' },
                    '"',
                    name,
                    '"'
                ),
                help
            )
        );
    };

    return ImageList;
}(preact_min["Component"])) || _class3;

/* harmony default export */ var imagelist = (imagelist_ImageList);
// CONCATENATED MODULE: ./components/form/array.js




var array__class, array__class2, array__class3;







var array_TableCol = Object(index_module["a" /* observer */])(array__class = function (_Component) {
    inherits_default()(TableCol, _Component);

    function TableCol() {
        classCallCheck_default()(this, TableCol);

        return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }

    TableCol.prototype.render = function render() {
        var col = this.props.col;

        var isNumber = util.isNumber(col);
        var isString = util.isString(col);
        var isComplex = !isNumber && !isString;
        return Object(preact_min["h"])(
            'td',
            { 'class': '' + (isNumber ? 'text-right' : '') },
            isComplex ? Object(preact_min["h"])(
                'code',
                null,
                JSON.stringify(col)
            ) : col
        );
    };

    return TableCol;
}(preact_min["Component"])) || array__class;

var array_TableRow = Object(index_module["a" /* observer */])(array__class2 = function (_Component2) {
    inherits_default()(TableRow, _Component2);

    function TableRow() {
        classCallCheck_default()(this, TableRow);

        return possibleConstructorReturn_default()(this, _Component2.apply(this, arguments));
    }

    TableRow.prototype.render = function render() {
        var row = this.props.row;


        if (util.isArray(row)) {
            return Object(preact_min["h"])(
                'tr',
                null,
                row.map(function (col) {
                    return Object(preact_min["h"])(array_TableCol, { col: col });
                })
            );
        }

        return Object(preact_min["h"])(
            'tr',
            null,
            Object(preact_min["h"])(array_TableCol, { col: row })
        );
    };

    return TableRow;
}(preact_min["Component"])) || array__class2;

var array__ref = Object(preact_min["h"])(
    'small',
    { 'class': 'text-muted' },
    'Copy-paste from Excel should work fine. Copy only the column with the articlenos.'
);

var array_Array = Object(index_module["a" /* observer */])(array__class3 = function (_Component3) {
    inherits_default()(Array, _Component3);

    function Array() {
        classCallCheck_default()(this, Array);

        return possibleConstructorReturn_default()(this, _Component3.apply(this, arguments));
    }

    Array.prototype.render = function render() {
        var _props = this.props,
            id = _props.id,
            name = _props.name,
            value = _props.value,
            help = _props.help,
            readonly = _props.readonly,
            required = _props.required,
            rows = _props.rows,
            placeholder = _props.placeholder,
            onInput = _props.onInput,
            removeHtml = _props.removeHtml,
            handleKeydown = _props.handleKeydown,
            isValid = _props.isValid;

        var isArray = util.isArray(value);

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])('textarea', { 'class': 'form-control ' + (isValid ? 'is-valid' : ''),
                id: 'input' + name + '-' + id,
                name: name,
                rows: rows,
                placeholder: placeholder,
                readonly: readonly,
                required: required,
                value: removeHtml ? util.removeHtml(value) : value,
                onInput: onInput,
                onKeyDown: handleKeydown
            }),
            array__ref,
            Object(preact_min["h"])(
                'table',
                { 'class': 'table table-striped table-sm table-borderless' },
                Object(preact_min["h"])(
                    'tbody',
                    null,
                    isArray && value.map(function (row) {
                        return Object(preact_min["h"])(array_TableRow, { row: row });
                    })
                )
            ),
            Object(preact_min["h"])(
                'small',
                { id: name + 'Help', 'class': 'form-text text-muted' },
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right text-info ml-2' },
                    '"',
                    util.getType(value),
                    '"'
                ),
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right' },
                    '"',
                    name,
                    '"'
                ),
                help
            )
        );
    };

    return Array;
}(preact_min["Component"])) || array__class3;

/* harmony default export */ var form_array = (array_Array);
// CONCATENATED MODULE: ./components/form/formField.js





var formField__class, formField__class2, formField__class3;
















var formField_FormRow = Object(index_module["a" /* observer */])(formField__class = function (_Component) {
    inherits_default()(FormRow, _Component);

    function FormRow() {
        classCallCheck_default()(this, FormRow);

        return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }

    FormRow.prototype.render = function render() {
        var _props = this.props,
            field = _props.field,
            object = _props.object,
            saved = _props.saved,
            updateField = _props.updateField,
            updateFieldId = _props.updateFieldId,
            _props$level = _props.level,
            level = _props$level === undefined ? 0 : _props$level;

        var name = '' + (field.namePrefix || '') + field.name + (field.nameSuffix || '');
        var value = util.getNestedValue(object, name);

        if (!field.view && typeof value === 'object' && value !== null && field.type === 'object') {
            var keys = field.keys || Object.keys(value);
            return Object(preact_min["h"])(
                'div',
                null,
                keys.map(function (key) {
                    return Object(preact_min["h"])(formField_FormField, {
                        level: level,
                        field: {
                            labelPrefix: name,
                            name: key,
                            namePrefix: name + '.',
                            readonly: field.readonly,
                            readonlyRef: field.readonlyRef,
                            type: field.type,
                            help: field.help,
                            imagePrefix: field.imagePrefix
                        },
                        object: object,
                        saved: saved,
                        updateField: updateField,
                        updateFieldId: updateFieldId
                    });
                })
            );
        }
        return Object(preact_min["h"])(formField_FormField, {
            level: level,
            field: extends_default()({}, field, {
                updateField: updateField
            }),
            object: object,
            saved: saved,
            updateField: updateField,
            updateFieldId: updateFieldId,
            imagePrefix: field.imagePrefix
        });
    };

    return FormRow;
}(preact_min["Component"])) || formField__class;

var formField_ChooseField = Object(index_module["a" /* observer */])(formField__class2 = function (_Component2) {
    inherits_default()(ChooseField, _Component2);

    function ChooseField() {
        classCallCheck_default()(this, ChooseField);

        return possibleConstructorReturn_default()(this, _Component2.apply(this, arguments));
    }

    ChooseField.prototype.render = function render() {
        var _props2 = this.props,
            field = _props2.field,
            object = _props2.object,
            saved = _props2.saved,
            updateField = _props2.updateField,
            updateFieldId = _props2.updateFieldId,
            level = _props2.level,
            isCheckbox = _props2.isCheckbox,
            imagePrefix = _props2.imagePrefix;

        var name = '' + (field.namePrefix || '') + field.name + (field.nameSuffix || '');
        var value = isCheckbox ? field.value || 'true' : util.getNestedValue(object, name);
        var isObject = typeof value === 'object' && value !== null;
        var isArray = typeof value === 'object' && util.isArray([]);
        var isString = typeof value === 'string';
        var isNumber = typeof value === 'number';
        var isBoolean = typeof value === 'boolean';

        var newValue = isCheckbox ? !util.getNestedValue(object, name) : null;
        if (isCheckbox && field.value === 1) {
            newValue = util.getNestedValue(object, name) ? 0 : 1;
        }
        var isMultiline = isString && (value.match(/\n/) || value.length > 100);
        var objectIdField = updateFieldId || 'id';
        var objectId = object[objectIdField];
        var readonlyRefIsDefined = field.readonlyRef && field.readonlyRef.hasOwnProperty(field.name);
        var readonly = readonlyRefIsDefined ? field.readonlyRef[field.name] : field.readonly;

        if (field.view) {
            return Object(preact_min["h"])(form_view, extends_default()({}, field, {
                id: objectId,
                name: name,
                value: value,
                updateField: updateField,
                object: object
            }));
        }

        if (field.type === 'images') {
            return Object(preact_min["h"])(form_images, extends_default()({}, field, {
                isValid: saved[name + '.' + objectId],
                id: objectId,
                name: name,
                value: value,
                updateField: updateField,
                imagePrefix: imagePrefix,
                object: object
            }));
        }

        if (field.type === 'imageList') {
            return Object(preact_min["h"])(imagelist, extends_default()({}, field, {
                isValid: saved[name + '.' + objectId],
                id: objectId,
                name: name,
                value: value,
                updateField: updateField,
                imagePrefix: imagePrefix,
                object: object
            }));
        }

        if (field.type === 'array' || !field.type && isArray) {
            return Object(preact_min["h"])(form_array, extends_default()({}, field, {
                id: objectId,
                name: name,
                value: value

            }, field, {
                rows: 7,
                readonly: readonly,
                isValid: saved[name + '.' + objectId],
                onInput: function onInput(e) {
                    return updateField(objectId, name, e.target.value, field.type);
                },
                object: object
            }));
        }

        if (field.type === 'json') {
            return Object(preact_min["h"])(json, extends_default()({}, field, {
                id: objectId,
                name: name,
                value: value
            }));
        }

        if (isObject && field.type === 'object') {
            return Object(preact_min["h"])(formField_FormRow, {
                level: level + 1,
                field: extends_default()({}, field),
                saved: saved,
                updateField: updateField,
                updateFieldId: updateFieldId,
                object: object
            });
        }

        if (field.type === 'textarea' || isMultiline) {
            return Object(preact_min["h"])(form_textarea, extends_default()({}, field, {
                rows: 7,
                readonly: readonly,
                id: objectId,
                isValid: saved[name + '.' + objectId],
                name: name,
                value: value,
                onInput: function onInput(e) {
                    return updateField(objectId, name, e.target.value, object);
                },
                object: object
            }));
        }

        if (['checkbox'].indexOf(field.type) >= 0 || isBoolean || isCheckbox) {
            return Object(preact_min["h"])(input, extends_default()({}, field, {
                readonly: readonly,
                type: 'checkbox',
                id: objectId,
                isValid: saved[name + '.' + objectId],
                isCheckbox: isCheckbox,
                name: name,
                value: value,
                onInput: function onInput(e) {
                    return updateField(objectId, name, newValue, object);
                },
                checked: isCheckbox && util.getNestedValue(object, name) ? 'checked' : false,
                object: object
            }));
        }

        if (['radio'].indexOf(field.type) >= 0) {
            return Object(preact_min["h"])(input, extends_default()({}, field, {
                readonly: readonly,
                type: 'radio',
                id: objectId,
                isValid: saved[name + '.' + objectId],
                isCheckbox: isCheckbox,
                name: name,
                value: value,
                onInput: function onInput(e) {
                    return updateField(objectId, name, e.target.value, object);
                },
                checked: isCheckbox && util.getNestedValue(object, name) ? 'checked' : false,
                object: object
            }));
        }

        if (['text', 'number'].indexOf(field.type) >= 0 || isNumber || isString) {
            return Object(preact_min["h"])(input, extends_default()({}, field, {
                readonly: readonly,
                id: objectId,
                isValid: saved[name + '.' + objectId],
                name: name,
                value: value,
                onInput: function onInput(e) {
                    return updateField(objectId, name, e.target.value, object);
                },
                object: object
            }));
        }

        return Object(preact_min["h"])(json, extends_default()({}, field, {
            id: objectId,
            name: name,
            value: value
        }));
    };

    return ChooseField;
}(preact_min["Component"])) || formField__class2;

var formField__ref = Object(preact_min["h"])(
    'span',
    { 'class': 'font-weight-lighter text-muted' },
    '(no label)'
);

var formField__ref2 = Object(preact_min["h"])('br', null);

var formField_FormField = Object(index_module["a" /* observer */])(formField__class3 = function (_Component3) {
    inherits_default()(FormField, _Component3);

    function FormField() {
        classCallCheck_default()(this, FormField);

        return possibleConstructorReturn_default()(this, _Component3.apply(this, arguments));
    }

    FormField.prototype.render = function render() {
        var _props3 = this.props,
            _props3$field = _props3.field,
            field = _props3$field === undefined ? {} : _props3$field,
            _props3$object = _props3.object,
            object = _props3$object === undefined ? {} : _props3$object,
            _props3$saved = _props3.saved,
            saved = _props3$saved === undefined ? {} : _props3$saved,
            _props3$updateField = _props3.updateField,
            updateField = _props3$updateField === undefined ? function () {} : _props3$updateField,
            updateFieldId = _props3.updateFieldId,
            level = _props3.level,
            imagePrefix = _props3.imagePrefix;

        var name = '' + (field.namePrefix || '') + field.name + (field.nameSuffix || '');
        var value = util.getNestedValue(object, name);
        var isCheckbox = false;
        if (field.type === 'object' && typeof value === 'boolean') {
            isCheckbox = true;
        } else if (field.type === 'checkbox') {
            isCheckbox = true;
        } else if (typeof value === 'boolean') {
            isCheckbox = true;
        }
        var objectIdField = updateFieldId || 'id';
        var objectId = object[objectIdField];
        // console.log('isCheckbox', name, field.type, typeof value, value, isCheckbox);

        return Object(preact_min["h"])(
            'div',
            { 'class': (isCheckbox ? 'form-group' : 'form-group') + ' row' },
            Object(preact_min["h"])(
                'label',
                { 'for': 'input' + name + '-' + objectId, 'class': 'col-sm-2 col-form-label' },
                level === 0 && field.labelPrefix ? field.labelPrefix + '.' : '',
                field.label || Object(preact_min["h"])(
                    'span',
                    null,
                    field.name,
                    ' ',
                    formField__ref
                ),
                formField__ref2,
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'text-muted font-weight-lighter' },
                    field.aliasFor ? field.aliasFor + ' -> ' : '',
                    ' ',
                    field.name
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'col-sm-10' },
                Object(preact_min["h"])(formField_ChooseField, {
                    field: field,
                    object: object,
                    saved: saved,
                    imagePrefix: imagePrefix,
                    updateField: updateField,
                    updateFieldId: updateFieldId,
                    level: level,
                    isCheckbox: isCheckbox
                })
            )
        );
    };

    return FormField;
}(preact_min["Component"])) || formField__class3;

/* harmony default export */ var formField = (formField_FormField);

// CONCATENATED MODULE: ./components/dealers/edit.js







var edit__class, edit__class2, edit__temp, edit__initialiseProps;












var edit_initialState = {};

var edit_DealerEdit = Object(index_module["a" /* observer */])(edit__class = (edit__temp = edit__class2 = function (_Component) {
    inherits_default()(DealerEdit, _Component);

    function DealerEdit(props) {
        var _this2 = this;

        classCallCheck_default()(this, DealerEdit);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        edit__initialiseProps.call(_this);

        _this.state = extends_default()({}, edit_initialState);
        _this.updateTimer = {};
        var _this$props$stores = _this.props.stores,
            dealerStore = _this$props$stores.dealerStore,
            brandStore = _this$props$stores.brandStore;

        dealerStore.load('', false, { query: { customerno: props.customerno } });
        brandStore.load();
        var brands = brandStore.brands;

        _this.fields = [{
            tabname: 'Basics',
            icon: 'fas fa-user-edit',
            fields: [{
                name: 'customerno',
                label: 'Customer #',
                type: 'number',
                readonly: true,
                help: 'Field is imported from Visma: "CustomerNo" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".'
            }, {
                name: 'name',
                label: 'Customer name',
                type: 'text',
                readonly: true,
                help: 'Field is imported from Visma: "Name" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".'
            }, {
                name: 'emailaddress',
                label: 'Invoice email',
                type: 'text',
                readonly: true,
                help: 'Field is imported from Visma: "EmailAddress" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".'
            }, {
                name: 'email',
                label: 'Login email',
                type: 'text',
                readonly: true,
                help: 'Field is imported from Visma: "ZUsrRating" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".'
            }, {
                name: 'repairEmail',
                label: 'Repair notification email',
                type: 'text',
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'dealerLevel',
                label: 'Dealer level',
                type: 'text',
                readonly: true,
                help: 'Field is imported from Visma: "DealerLevel" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".'
            }, {
                name: 'brands',
                label: 'Brands',
                type: 'object',
                readonly: false
                // keys: brands.map(b => b.brandno),
                // fields: [
                //     {
                //         namePrefix: 'brands.',
                //         nameSuffix: '.allowed',
                //         type: 'checkbox',
                //         readonly: false,
                //         help: 'Field is DealerWeb only.',
                //     },
                // ],
            }, {
                name: 'brandCombos',
                label: 'Brand combos',
                type: 'object',
                readonly: false
                // keys: brands.map(b => b.brandno),
                // fields: [
                //     {
                //         namePrefix: 'brands.',
                //         nameSuffix: '.allowed',
                //         type: 'checkbox',
                //         readonly: false,
                //         help: 'Field is DealerWeb only.',
                //     },
                // ],
            }, {
                name: 'hasAccessToCombos',
                label: 'Has access to combos',
                type: 'checkbox',
                value: 1,
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'termsAndConditions',
                label: 'Terms and conditions',
                type: 'object',
                readonly: true,
                fields: [{
                    namePrefix: 'termsAndConditions.',
                    nameSuffix: '.acceptedDate',
                    type: 'text',
                    readonly: true,
                    help: 'Field is DealerWeb only.'
                }, {
                    namePrefix: 'termsAndConditions.',
                    nameSuffix: '.acceptedTerms',
                    type: 'text',
                    readonly: true,
                    help: 'Field is DealerWeb only.'
                }]
            }, {
                name: 'currency',
                label: 'Currency',
                type: 'text',
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'pricelistno',
                label: 'Pricelist #',
                type: 'text',
                readonly: false,
                help: 'Field is imported from Visma: "PricelistNo" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".'
            }, {
                name: 'inboxSignature',
                label: 'Inbox signature',
                type: 'textarea',
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'settings',
                label: 'Settings',
                type: 'object',
                keys: ['language', 'darkmode', 'inboxEmailNotifications'],
                fields: [{
                    namePrefix: 'settings.',
                    // nameSuffix: '.allowed',
                    type: 'text',
                    readonly: false,
                    help: 'Field is DealerWeb only.'
                }]
            }]
        }, {
            tabname: 'Login',
            icon: 'fas fa-sign-in-alt',
            fields: [{
                name: 'confirmed',
                label: 'Confirmed',
                type: 'checkbox',
                value: 1,
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'approved',
                label: 'Approved',
                type: 'checkbox',
                value: 1,
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'last_login',
                label: 'Last login',
                type: 'text',
                value: 1,
                readonly: true,
                help: 'Field is accumulated from all emails and is DealerWeb only.'
            }, {
                name: 'current_login_failed',
                label: 'Current logins failed',
                type: 'text',
                value: 1,
                readonly: true,
                help: 'Field is accumulated from all emails and is DealerWeb only.'
            }, {
                name: 'visits',
                label: 'Visits',
                type: 'number',
                value: 1,
                readonly: true,
                help: 'Field is accumulated from all emails and is DealerWeb only.'
            }, {
                name: 'activity',
                label: 'Activity',
                type: 'number',
                value: 1,
                readonly: true,
                help: 'Field is accumulated from all emails and is DealerWeb only.'
            }, {
                name: 'last_activity',
                label: 'Last activity',
                type: 'text',
                value: 1,
                readonly: true,
                help: 'Field is accumulated from all emails and is DealerWeb only.'
            }, {
                name: 'isOnline',
                label: 'Is online',
                type: 'text',
                value: 1,
                readonly: true,
                help: 'Field is accumulated from all emails and is DealerWeb only.'
            }, {
                name: 'emails',
                label: 'Login emails',
                type: 'object',
                help: 'Field is DealerWeb only.',
                readonly: true,
                readonlyRef: {
                    current_login_failed: false
                }
            }]
        }, {
            tabname: 'Delivery',
            icon: 'fas fa-truck',
            fields: [{
                name: 'deliveryname',
                label: 'Delivery name',
                type: 'text',
                value: 1,
                readonly: true,
                help: 'Field is imported from Visma: "DeliveryName" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".'
            }, {
                name: 'deliveryaddress1',
                label: 'Delivery address',
                type: 'text',
                value: 1,
                readonly: true,
                help: 'Field is imported from Visma: "DeliveryName" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".'
            }, {
                name: 'deliverypostcode',
                label: 'Delivery post code',
                type: 'text',
                value: 1,
                readonly: true,
                help: 'Field is imported from Visma: "DeliveryName" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".'
            }, {
                name: 'deliverypostoffice',
                label: 'Delivery post office',
                type: 'text',
                value: 1,
                readonly: true,
                help: 'Field is imported from Visma: "DeliveryName" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".'
            }, {
                name: 'country',
                label: 'Country',
                type: 'text',
                value: 1,
                readonly: true,
                help: 'Field is imported from Visma: "DeliveryName" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv".'
            }]
        }, {
            tabname: 'ConsumerWeb',
            icon: 'fas fa-store',
            fields: [{
                name: 'locator',
                label: 'Dealer locator',
                type: 'checkbox',
                value: 1,
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'acceptConsumerOrders',
                label: 'Accept consumer orders',
                type: 'checkbox',
                value: 1,
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'store',
                label: 'Store',
                type: 'object',
                keys: ['name', 'address1', 'address2', 'zip', 'city', 'country', 'phone', 'fax', 'email', 'url', 'opening_hours_mon', 'opening_hours_tue', 'opening_hours_wed', 'opening_hours_thu', 'opening_hours_fri', 'opening_hours_sat', 'opening_hours_sub'],
                fields: [{
                    namePrefix: 'store.',
                    type: 'text',
                    readonly: false,
                    help: 'Field is DealerWeb only.'
                }]
            }, {
                name: 'geo',
                label: 'Geo',
                type: 'object',
                keys: ['lat', 'lon', 'updated'],
                fields: [{
                    namePrefix: 'geo.',
                    type: 'text',
                    readonly: false,
                    help: 'Field is DealerWeb only.'
                }]
            }, {
                name: 'google_maps_lookup',
                label: 'Google maps lookup',
                type: 'object',
                fields: [{
                    namePrefix: 'google_maps_lookup.',
                    type: 'text',
                    readonly: true,
                    help: 'Field is DealerWeb only.'
                }]
            }]
        }, {
            tabname: 'Repair',
            icon: 'fas fa-tools',
            fields: [{
                name: 'shipping',
                label: 'Shipping',
                type: 'object',
                keys: ['addresses', 'contacts'],
                fields: [{
                    namePrefix: 'shipping.',
                    type: 'text',
                    readonly: false,
                    help: 'Field is DealerWeb only.'
                }]
            }]
        }, {
            tabname: 'Basket',
            icon: 'fas fa-shopping-cart',
            fields: [{
                name: 'basketQty',
                label: 'Basket qty',
                type: 'number',
                value: 1,
                readonly: true,
                help: 'Field is accumulated from Basket and is DealerWeb only.'
            }, {
                name: 'basketTotal',
                label: 'Basket total',
                type: 'number',
                value: 1,
                readonly: true,
                help: 'Field is accumulated from Basket and is DealerWeb only.'
            }, {
                name: 'basketCurrency',
                label: 'Basket currency',
                type: 'number',
                value: 1,
                readonly: true,
                help: 'Field is accumulated from Basket and is DealerWeb only.'
            }, {
                name: 'psBasketQty',
                label: 'PS Basket qty',
                type: 'number',
                value: 1,
                readonly: true,
                help: 'Field is accumulated from Basket and is DealerWeb only.'
            }, {
                name: 'psBasketTotal',
                label: 'PS Basket total',
                type: 'number',
                value: 1,
                readonly: true,
                help: 'Field is accumulated from Basket and is DealerWeb only.'
            }, {
                name: 'psBasketCurrency',
                label: 'PS Basket currency',
                type: 'number',
                value: 1,
                readonly: true,
                help: 'Field is accumulated from Basket and is DealerWeb only.'
            }, {
                name: 'basket',
                label: 'Basket content',
                type: 'object',
                help: 'Field is DealerWeb only.',
                fields: [{
                    namePrefix: 'basket.',
                    nameSuffix: '.content',
                    type: 'object',
                    readonly: false,
                    help: 'Field is DealerWeb only.',
                    view: function view(val) {
                        var keys = Object.keys(val);
                        return keys.map(function (key) {
                            var line = val[key];
                            return Object(preact_min["h"])(
                                'li',
                                null,
                                line.qty,
                                ' x ',
                                line.name,
                                ' ',
                                line.currency,
                                ' ',
                                util.format(line.qty * line.price, 2),
                                Object(preact_min["h"])(
                                    'small',
                                    { 'class': 'ml-2 text-muted' },
                                    line.date,
                                    ' ',
                                    line.addedFrom
                                )
                            );
                        });
                    }
                }, {
                    namePrefix: 'basket.',
                    nameSuffix: '.content-preSale',
                    type: 'object',
                    readonly: false,
                    help: 'Field is DealerWeb only.',
                    view: function view(val) {
                        var keys = Object.keys(val);
                        return keys.map(function (key) {
                            var line = val[key];
                            return Object(preact_min["h"])(
                                'li',
                                null,
                                line.qty,
                                ' x ',
                                line.name,
                                ' ',
                                line.currency,
                                ' ',
                                util.format(line.qty * line.price, 2),
                                Object(preact_min["h"])(
                                    'small',
                                    { 'class': 'ml-2 text-muted' },
                                    line.date,
                                    ' ',
                                    line.addedFrom
                                )
                            );
                        });
                    }
                }]
            }, {
                name: 'backorders',
                label: 'Backorders',
                type: 'object',
                fields: [{
                    namePrefix: 'backorders.',
                    type: 'text',
                    readonly: false,
                    help: 'Field is DealerWeb only.',
                    view: function view(val) {
                        return val.map(function (line) {
                            return Object(preact_min["h"])(
                                'li',
                                null,
                                line.qty,
                                ' x ',
                                line.name,
                                ' ',
                                line.currency,
                                ' ',
                                util.format(line.qty * line.price, 2),
                                Object(preact_min["h"])(
                                    'small',
                                    { 'class': 'ml-2 text-muted' },
                                    line.orderdate,
                                    ' ',
                                    line.yourref
                                )
                            );
                        });
                    }
                }],
                readonly: true,
                help: 'Field is imported from Visma... TODO!'
            }, {
                name: 'backorderDeleteReq',
                label: 'Backorder delete requests',
                type: 'object',
                fields: [{
                    namePrefix: 'backorderDeleteReq.',
                    type: 'text',
                    readonly: false,
                    help: 'Field is DealerWeb only.'
                }],
                help: 'Field is DealerWeb only.'
            }]
        }, {
            tabname: 'Agent',
            icon: 'fas fa-skull-crossbones',
            fields: [{
                name: 'is_agent',
                label: 'Is agent',
                type: 'checkbox',
                value: 1,
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'agent_dealers',
                label: 'Agent dealers',
                type: 'object',
                view: function view(val) {
                    var opts = {
                        placeholder: 'Search for dealers...',
                        value: val,
                        valueDisplayMap: function valueDisplayMap(v) {
                            return Object(preact_min["h"])(
                                'span',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': 'font-weight-light' },
                                    v.customerno,
                                    ':'
                                ),
                                ' ',
                                v.name
                            );
                        },
                        autocompleteList: dealerStore.searchResults,
                        oninput: function oninput(e) {
                            clearTimeout(_this.searchTimer);
                            _this.searchTimer = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                return regenerator_default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                dealerStore.search(e.target.value);

                                            case 1:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this2);
                            })), 500);
                        },
                        addElement: function addElement(idx) {
                            dealerStore.addElement(idx, 'dealer', 'agent_dealers');
                            dealerStore.resetSearch();
                        },
                        removeElement: function removeElement(id) {
                            dealerStore.removeElement(id, 'dealer', 'agent_dealers');
                            dealerStore.resetSearch();
                        },
                        handleKeydown: function handleKeydown(e) {
                            if (e.key === 'ArrowDown') {
                                if (dealerStore.totalSearch === 0) {
                                    dealerStore.search(e.target.value);
                                }
                                dealerStore.incSearchSelectIdx();
                            } else if (e.key === 'ArrowUp') {
                                dealerStore.decSearchSelectIdx();
                            } else if (e.key === 'Enter') {
                                dealerStore.addElement(0, 'dealer', 'agent_dealers');
                                dealerStore.resetSearch();
                            } else if (e.key === 'Escape') {
                                dealerStore.resetSearch();
                            }
                        },
                        currentIdx: dealerStore.searchSelectIdx,
                        currentId: dealerStore.searchSelectId,
                        total: dealerStore.totalSearch
                    };
                    return Object(preact_min["h"])(autocomplete, opts);
                },
                readonly: false,
                help: 'Field is DealerWeb only.'
            }]
        }, {
            tabname: 'Advanced',
            icon: 'fas fa-cogs',
            fields: [{
                name: 'offline',
                label: 'Offline / Deleted',
                type: 'checkbox',
                value: 1,
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'inactiveyesno',
                label: 'Inactive',
                type: 'checkbox',
                value: 1,
                readonly: true,
                help: 'Field is imported from Visma: "InActiveYesNo" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv"'
            }, {
                name: 'customergrpno',
                label: 'Customer grp',
                type: 'number',
                value: 1,
                readonly: true,
                help: 'Field is imported from Visma: "CustomerGrpNo" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv"'
            }, {
                name: 'customertype',
                label: 'Customer type',
                type: 'number',
                value: 1,
                readonly: true,
                help: 'Field is imported from Visma: "CustomerTypeNo" via new Visma SQL -> S3 -> Lambda -> API  file "kunde.csv"'
            }, {
                name: 'favorite',
                label: 'Favorite',
                type: 'object',
                value: 1,
                fields: [{
                    namePrefix: 'favorite.',
                    type: 'text',
                    readonly: false,
                    help: 'Field is DealerWeb only.'
                }],
                help: 'Field is DealerWeb only.'
            }, {
                name: 'pushNotifications',
                label: 'pushNotifications',
                type: 'object',
                value: 1,
                fields: [{
                    namePrefix: 'pushNotifications.',
                    type: 'text',
                    readonly: false,
                    help: 'Field is DealerWeb only.'
                }],
                help: 'Field is DealerWeb only.'
            }, {
                name: 'videos',
                label: 'videos',
                type: 'object',
                value: 1,
                fields: [{
                    namePrefix: 'videos.',
                    type: 'text',
                    readonly: false,
                    help: 'Field is DealerWeb only.'
                }],
                help: 'Field is DealerWeb only.'
            }]
        }];
        return _this;
    }

    DealerEdit.prototype.doUpdateField = function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(customerno, field, value) {
            var dealerStore;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            dealerStore = this.props.stores.dealerStore;
                            _context2.next = 3;
                            return dealerStore.saveField(customerno, field, value);

                        case 3:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref2.apply(this, arguments);
        }

        return doUpdateField;
    }();

    // formRow(field) {
    //     const { dealerStore } = this.props.stores;
    //     const { dealer, saved } = dealerStore;

    //     if (!field.view && field.type === 'object' && typeof dealer[field.name] === 'object') {
    //         const keys = field.keys || Object.keys(dealer[field.name]);

    //         return (
    //             <div class='form-group row'>
    //                 <label for={`input${field.name}`} class='col-sm-2 col-form-label'>{field.label || field.name}</label>
    //                 <div class='col-sm-10'>
    //                     {keys.map((key) => {
    //                         if (field.fields) {
    //                             return field.fields.map((f, idx) => <FormField
    //                                 field={{
    //                                     name: key,
    //                                     idx,
    //                                     ...f,
    //                                     updateField: this.updateField,
    //                                     updateFieldId: 'customerno',
    //                                 }}
    //                                 object={dealer}
    //                                 saved={saved}
    //                             />);
    //                         }
    //                         return <FormField
    //                             field={{
    //                                 name: key,
    //                                 ...field,
    //                                 updateField: this.updateField,
    //                                 updateFieldId: 'customerno',
    //                             }}
    //                             object={dealer}
    //                             saved={saved}
    //                         />;
    //                     })}
    //                 </div>
    //             </div>
    //         );
    //     }
    //     return <FormField
    //         field={{
    //             ...field,
    //             updateField: this.updateField,
    //             updateFieldId: 'customerno',
    //         }}
    //         object={dealer}
    //         saved={saved}
    //     />;
    // }

    DealerEdit.prototype.render = function render(props) {
        var _this3 = this;

        var dealerStore = this.props.stores.dealerStore;
        var dealer = dealerStore.dealer,
            saved = dealerStore.saved;


        var tabIdx = this.fields.findIndex(function (e) {
            return e.tabname === props.tabname;
        });
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-flex flex-row bd-highlight mb-3' },
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: '/dealers', 'class': 'mr-2 btn btn-sm btn-warning' },
                                Object(preact_min["h"])('i', { 'class': 'fas fa-arrow-left mr-1' }),
                                'Back'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'h4',
                                null,
                                'Edit: ',
                                dealer.customerno,
                                ': ',
                                dealer.name
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'nav nav-tabs mb-2' },
                        this.fields.map(function (tab) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'nav-item' },
                                Object(preact_min["h"])(
                                    'a',
                                    { 'class': 'nav-link ' + (props.tabname === tab.tabname ? 'active' : ''),
                                        href: '/dealers/' + props.customerno + '/' + tab.tabname
                                    },
                                    Object(preact_min["h"])('i', { 'class': tab.icon + ' mr-2' }),
                                    tab.tabname
                                )
                            );
                        })
                    ),
                    this.fields[tabIdx].fields.map(function (field) {
                        return Object(preact_min["h"])(formField_FormRow, {
                            field: field,
                            object: dealer,
                            saved: saved,
                            updateField: _this3.updateField,
                            updateFieldId: 'customerno'
                        });
                    })
                )
            )
        );
    };

    return DealerEdit;
}(preact_min["Component"]), edit__initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.updateField = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(customerno, field, value) {
            var dealerStore;
            return regenerator_default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            dealerStore = _this4.props.stores.dealerStore;

                            dealerStore.updateField(customerno, field, value);

                            clearTimeout(_this4.updateTimer[field]);
                            _this4.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                                return regenerator_default.a.wrap(function _callee3$(_context3) {
                                    while (1) {
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                _this4.doUpdateField(customerno, field, value);

                                            case 1:
                                            case 'end':
                                                return _context3.stop();
                                        }
                                    }
                                }, _callee3, _this4);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }));

        return function (_x4, _x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}, edit__temp)) || edit__class;

/* harmony default export */ var edit = (edit_DealerEdit);
// EXTERNAL MODULE: ./components/brands/style.css
var brands_style = __webpack_require__("Rg5Y");
var brands_style_default = /*#__PURE__*/__webpack_require__.n(brands_style);

// CONCATENATED MODULE: ./components/brands/list.js







var brands_list__class, list__class2, brands_list__temp, brands_list__initialiseProps;










var brands_list_initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false
    }
};

var brands_list__ref4 = Object(preact_min["h"])('br', null);

var brands_list__ref5 = Object(preact_min["h"])(
    'h1',
    null,
    Object(preact_min["h"])('i', { 'class': 'fas fa-search' }),
    ' Search results'
);

var brands_list__ref6 = Object(preact_min["h"])('br', null);

var brands_list__ref7 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var brands_list__ref8 = Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle' });

var brands_list__ref9 = Object(preact_min["h"])(
    'div',
    { 'class': 'row' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'col-12 text-center' },
        Object(preact_min["h"])(
            'div',
            { 'class': 'spinner-border text-success', role: 'status' },
            Object(preact_min["h"])(
                'span',
                { 'class': 'sr-only' },
                'Loading...'
            )
        )
    )
);

var brands_list__ref10 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var list_BrandList = Object(index_module["a" /* observer */])(brands_list__class = (brands_list__temp = list__class2 = function (_Component) {
    inherits_default()(BrandList, _Component);

    function BrandList(props) {
        classCallCheck_default()(this, BrandList);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        brands_list__initialiseProps.call(_this);

        _this.state = extends_default()({}, brands_list_initialState);
        _this.updateTimer = {};

        var brandStore = _this.props.stores.brandStore;

        brandStore.list();
        return _this;
    }

    BrandList.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    BrandList.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    BrandList.prototype.updateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(id, field, value) {
            var _this2 = this;

            var brandStore;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            brandStore = this.props.stores.brandStore;

                            brandStore.updateField(id, field, value);

                            clearTimeout(this.updateTimer[field]);
                            this.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                return regenerator_default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _this2.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this2);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function updateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return updateField;
    }();

    BrandList.prototype.doUpdateField = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var brandStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            brandStore = this.props.stores.brandStore;
                            _context3.next = 3;
                            return brandStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function doUpdateField(_x4, _x5, _x6) {
            return _ref3.apply(this, arguments);
        }

        return doUpdateField;
    }();

    BrandList.prototype.render = function render() {
        var _this3 = this;

        var loading = this.state.loading;
        var brandStore = this.props.stores.brandStore;
        var brands = brandStore.brands,
            queryFilter = brandStore.queryFilter,
            saved = brandStore.saved;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'text-muted font-weight-lighter float-right mr-2' },
                        'Total: ',
                        brandStore.total,
                        brands_list__ref4
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': 'float-left form-row align-items-center mr-5' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])('input', { type: 'text', 'class': 'form-control form-control-sm', id: 'inlineFormInputName', placeholder: 'Search for brands...',
                                onInput: function onInput(e) {
                                    return brandStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true });
                                },
                                value: queryFilter.search
                            })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])(
                                'button',
                                { type: 'button', 'class': 'btn btn-sm btn-primary', onClick: function onClick() {
                                        return brandStore.list();
                                    } },
                                'Search'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    queryFilter.search && Object(preact_min["h"])(
                        'div',
                        { 'class': 'w-100 text-left mt-2 mb-5' },
                        brands_list__ref5,
                        'Found ',
                        brandStore.total,
                        ' results in your search for "',
                        queryFilter.search,
                        '".',
                        brands_list__ref6,
                        Object(preact_min["h"])(
                            'button',
                            { 'class': 'btn btn-sm btn-warning mt-2',
                                onClick: function onClick() {
                                    return brandStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true });
                                }
                            },
                            brands_list__ref7,
                            ' Reset search'
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'table-responsive' },
                        Object(preact_min["h"])(
                            'table',
                            { 'class': brands_style_default.a.table + ' table table-striped table-sm table-borderless' },
                            Object(preact_min["h"])(
                                'thead',
                                null,
                                brandStore.sort !== brandStore.defaultSort && Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { colspan: '8' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': brands_style_default.a.pointerCursor + ' mr-2 badge badge-pill badge-secondary', onClick: function onClick() {
                                                    return brandStore.resetSort();
                                                } },
                                            brands_list__ref8,
                                            ' Reset sort'
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 15%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': brands_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return brandStore.toggleSort('name', '');
                                                } },
                                            'Name ',
                                            util.getSortIcon('name', brandStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 15%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': brands_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return brandStore.toggleSort('brandno', '');
                                                } },
                                            'Brandno ',
                                            util.getSortIcon('brandno', brandStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 45%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': brands_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return brandStore.toggleSort('fullName', '');
                                                } },
                                            'Fullname ',
                                            util.getSortIcon('fullName', brandStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': brands_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return brandStore.toggleSort('showOnConsumerWeb', '');
                                                } },
                                            'showOnConsumerWeb ',
                                            util.getSortIcon('showOnConsumerWeb', brandStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': brands_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return brandStore.toggleSort('showOnDealerWeb', '');
                                                } },
                                            'showOnDealerWeb ',
                                            util.getSortIcon('showOnDealerWeb', brandStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': brands_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return brandStore.toggleSort('sort', '');
                                                } },
                                            'Sort ',
                                            util.getSortIcon('sort', brandStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': brands_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return brandStore.toggleSort('count', '-');
                                                } },
                                            'Count ',
                                            util.getSortIcon('count', brandStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': brands_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return brandStore.toggleSort('countPresale', '-');
                                                } },
                                            'Count presale ',
                                            util.getSortIcon('countPresale', brandStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': brands_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return brandStore.toggleSort('updatedDate', '-');
                                                } },
                                            'Updated ',
                                            util.getSortIcon('updatedDate', brandStore.sort)
                                        )
                                    )
                                )
                            ),
                            Object(preact_min["h"])(
                                'tbody',
                                null,
                                brands && brands.map(function (brand) {
                                    return Object(preact_min["h"])(
                                        'tr',
                                        { 'class': '' + brands_style_default.a.tableline },
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(
                                                'a',
                                                { href: '/brands/' + brand.id + '/Basics' },
                                                brand.name
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            brand.brandno
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            brand.fullName
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            brand.showOnConsumerWeb
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            brand.showOnDealerWeb
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            Object(preact_min["h"])(input, {
                                                id: brand.id,
                                                className: 'text-right form-control-sm',
                                                isValid: saved['sort.' + brand.id],
                                                name: 'sort',
                                                value: brand.sort,
                                                onInput: function onInput(e) {
                                                    return _this3.updateField(brand.id, 'sort', e.target.value);
                                                },
                                                hideHelp: 1
                                            })
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            brand.count
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            brand.countPresale
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            util.ffeDateTime(brand.updatedDate)
                                        )
                                    );
                                })
                            )
                        )
                    )
                )
            ),
            loading && brands_list__ref9,
            brands_list__ref10
        );
    };

    return BrandList;
}(preact_min["Component"]), brands_list__initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.handleScroll = function () {
        var loading = _this4.state.loading;
        var brandStore = _this4.props.stores.brandStore;
        var totalAppend = brandStore.totalAppend,
            limit = brandStore.limit;

        if (window.innerHeight + document.documentElement.scrollTop + 500 < document.documentElement.offsetHeight) return;
        if (loading) return;

        var offset = brandStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(_this4.scrollLoader);
            _this4.scrollLoader = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this4.setState({ loading: true });
                                brandStore.updateOffset(offset);
                                _context4.next = 4;
                                return brandStore.list(true);

                            case 4:
                                _this4.setState({ loading: false });

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            })), 500);
        }
    };
}, brands_list__temp)) || brands_list__class;

/* harmony default export */ var brands_list = (list_BrandList);
// CONCATENATED MODULE: ./components/brands/index.js




var brands__class;









var brands_initialState = {
    height: 100
};

var brands_Brand = Object(index_module["a" /* observer */])(brands__class = function (_Component) {
    inherits_default()(Brand, _Component);

    function Brand(props) {
        classCallCheck_default()(this, Brand);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = brands_initialState;
        _this.subscriptions();
        return _this;
    }

    Brand.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    Brand.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(brands_list, props)
                )
            )
        );
    };

    return Brand;
}(preact_min["Component"])) || brands__class;

/* harmony default export */ var components_brands = (brands_Brand);
// CONCATENATED MODULE: ./components/brands/edit.js







var brands_edit__class, brands_edit__class2, brands_edit__temp, brands_edit__initialiseProps;










var brands_edit_initialState = {};

var FIELDS = {
    brandno: { label: 'brand #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    name: { label: 'brand name', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    fullName: { label: 'brand fullName', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    showOnConsumerWeb: { label: 'Show on ConsumerWeb', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },
    showOnDealerWeb: { label: 'Show on DealerWeb', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },

    sort: { label: 'sort', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    count: { label: 'count', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    countPresale: { label: 'countPresale', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'updatedDate', type: 'text', readonly: true, help: 'Field is DealerWeb only.' }
};

var edit_BrandEdit = Object(index_module["a" /* observer */])(brands_edit__class = (brands_edit__temp = brands_edit__class2 = function (_Component) {
    inherits_default()(BrandEdit, _Component);

    function BrandEdit(props) {
        classCallCheck_default()(this, BrandEdit);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        brands_edit__initialiseProps.call(_this);

        _this.state = extends_default()({}, brands_edit_initialState);
        _this.updateTimer = {};
        var brandStore = _this.props.stores.brandStore;

        brandStore.load(props.brandid);

        _this.fields = [{
            tabname: 'Basics',
            icon: 'fas fa-user-edit',
            fields: ['brandno', 'name', 'fullName', 'showOnConsumerWeb', 'showOnDealerWeb', 'sort', 'count', 'countPresale', 'updatedDate'].map(function (f) {
                return util.makeField(f, FIELDS);
            })
        }];
        return _this;
    }

    BrandEdit.prototype.doUpdateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(id, field, value) {
            var brandStore;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            brandStore = this.props.stores.brandStore;
                            _context.next = 3;
                            return brandStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return doUpdateField;
    }();

    BrandEdit.prototype.render = function render(props) {
        var _this2 = this;

        var brandStore = this.props.stores.brandStore;
        var brand = brandStore.brand,
            saved = brandStore.saved;


        var tabIdx = this.fields.findIndex(function (e) {
            return e.tabname === props.tabname;
        });
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-flex flex-row bd-highlight mb-3' },
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: '/brands', 'class': 'mr-2 btn btn-sm btn-warning' },
                                Object(preact_min["h"])('i', { 'class': 'fas fa-arrow-left mr-1' }),
                                'Back'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'h4',
                                null,
                                'Edit: ',
                                brand.id,
                                ': ',
                                brand.name
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'nav nav-tabs mb-2' },
                        this.fields.map(function (tab) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'nav-item' },
                                Object(preact_min["h"])(
                                    'a',
                                    { 'class': 'nav-link ' + (props.tabname === tab.tabname ? 'active' : ''),
                                        href: '/brands/' + props.brandid + '/' + tab.tabname
                                    },
                                    Object(preact_min["h"])('i', { 'class': tab.icon + ' mr-2' }),
                                    tab.tabname
                                )
                            );
                        })
                    ),
                    this.fields[tabIdx].fields.map(function (field) {
                        return Object(preact_min["h"])(formField_FormRow, {
                            field: field,
                            object: brand,
                            saved: saved,
                            updateField: _this2.updateField
                        });
                    })
                )
            )
        );
    };

    return BrandEdit;
}(preact_min["Component"]), brands_edit__initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.updateField = function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var brandStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            brandStore = _this3.props.stores.brandStore;

                            brandStore.updateField(id, field, value);

                            clearTimeout(_this3.updateTimer[field]);
                            _this3.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                    while (1) {
                                        switch (_context2.prev = _context2.next) {
                                            case 0:
                                                _this3.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context2.stop();
                                        }
                                    }
                                }, _callee2, _this3);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x4, _x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();
}, brands_edit__temp)) || brands_edit__class;

/* harmony default export */ var brands_edit = (edit_BrandEdit);
// EXTERNAL MODULE: ./components/categories/style.css
var categories_style = __webpack_require__("VUtF");
var categories_style_default = /*#__PURE__*/__webpack_require__.n(categories_style);

// CONCATENATED MODULE: ./components/categories/treeBranch.js





var treeBranch__class;








var treeBranch__ref = Object(preact_min["h"])(
    'small',
    null,
    Object(preact_min["h"])(
        'span',
        { 'class': 'badge' },
        'cw'
    )
);

function isConsumerWeb(cat) {
    if (cat.showOnConsumerWeb) {
        return treeBranch__ref;
    }
    return '';
}

var treeBranch__ref2 = Object(preact_min["h"])(
    'small',
    null,
    Object(preact_min["h"])(
        'span',
        { 'class': 'badge' },
        'dw'
    )
);

function isDealerWeb(cat) {
    if (cat.status === 2) {
        return treeBranch__ref2;
    }
    return '';
}

var treeBranch_initialState = {};

var treeBranch_CategoryBranch = Object(index_module["a" /* observer */])(treeBranch__class = function (_Component) {
    inherits_default()(CategoryBranch, _Component);

    function CategoryBranch(props) {
        classCallCheck_default()(this, CategoryBranch);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = extends_default()({}, treeBranch_initialState);
        return _this;
    }

    CategoryBranch.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var categoryStore = props.stores.categoryStore;
        var categoryTree = categoryStore.categoryTree,
            categoryView = categoryStore.categoryView,
            queryFilter = categoryStore.queryFilter,
            toggleQueryfilter = categoryStore.toggleQueryfilter;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'ml-4' },
            categoryTree.map(function (cat) {
                var isSelectedMain = cat.groupno == queryFilter.parent;
                var onClickMain = cat.children ? function () {
                    toggleQueryfilter('parent', cat.groupno, {
                        setValue: 1,
                        toggle: function toggle(groupno) {
                            return categoryStore.updateCategoryView(cat.groupno, groupno == cat.groupno ? 1 : null);
                        }
                    });
                    route('/categories/', true);
                } : function () {
                    return route('/categories/' + cat.groupno + '/Basics', true);
                };
                var editMain = function editMain(e) {
                    e.stopPropagation();
                    route('/categories/' + cat.groupno + '/Basics', true);
                };
                var onClickRemoveMain = function onClickRemoveMain(e) {
                    e.stopPropagation();
                    toggleQueryfilter('parent', '', { setValue: 1 });
                    categoryStore.updateCategoryView(cat.groupno, null);
                    route('/categories/', true);
                };
                var toggleMain = function toggleMain(e) {
                    e.stopPropagation();
                    categoryStore.updateCategoryView(cat.groupno);
                };
                var hasChildrenMain = cat.children && cat.children.length > 0;
                return Object(preact_min["h"])(
                    'div',
                    { 'class': 'nav-item' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': categories_style_default.a.pointerCursor + ' nav-link py-0 ' + (isSelectedMain ? 'active' : '') },
                        Object(preact_min["h"])(
                            'span',
                            { onClick: onClickMain },
                            Object(preact_min["h"])(
                                'nobr',
                                null,
                                Object(preact_min["h"])(
                                    'small',
                                    null,
                                    Object(preact_min["h"])('i', { 'class': 'fas fa-edit mr-1 text-' + (isSelectedMain ? 'light' : 'primary') + ' primary font-weight-lighter', onClick: editMain })
                                ),
                                Object(preact_min["h"])('i', { 'class': (hasChildrenMain ? 'fas' : 'far') + ' fa-folder' + (categoryView[cat.groupno] ? '-open' : '') + ' mr-1', onClick: toggleMain }),
                                cat.name,
                                ' ',
                                cat.discount && Object(preact_min["h"])(
                                    'small',
                                    { 'class': 'font-weight-lighter' },
                                    cat.discount,
                                    '%'
                                ),
                                ' ',
                                isConsumerWeb(cat),
                                ' ',
                                isDealerWeb(cat)
                            ),
                            hasChildrenMain && Object(preact_min["h"])(
                                'span',
                                { 'class': 'font-weight-lighter float-right' },
                                '(',
                                cat.children.length,
                                ')'
                            )
                        ),
                        isSelectedMain && Object(preact_min["h"])(
                            'span',
                            { 'class': categories_style_default.a.pointerCursor + ' float-right' },
                            Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle float-right mt-1', onClick: onClickRemoveMain })
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-' + (categoryView[cat.groupno] ? 'block' : 'none') + ' nav flex-column mt-1' },
                        hasChildrenMain && cat.children.map(function (intcat) {
                            var isSelectedInt = intcat.groupno == queryFilter.parent;
                            var onClickInt = intcat.children ? function () {
                                toggleQueryfilter('parent', intcat.groupno, {
                                    setValue: 1,
                                    toggle: function toggle(groupno) {
                                        return categoryStore.updateCategoryView(intcat.groupno, groupno == intcat.groupno ? 1 : null);
                                    }
                                });
                                route('/categories/', true);
                            } : function () {
                                return route('/categories/' + intcat.groupno + '/Basics', true);
                            };
                            var editInt = function editInt(e) {
                                e.stopPropagation();
                                route('/categories/' + intcat.groupno + '/Basics', true);
                            };
                            var onClickRemoveInt = function onClickRemoveInt(e) {
                                e.stopPropagation();
                                toggleQueryfilter('parent', '', { setValue: 1 });
                                categoryStore.updateCategoryView(intcat.groupno, null);
                                route('/categories/', true);
                            };
                            var toggleInt = function toggleInt(e) {
                                e.stopPropagation();
                                categoryStore.updateCategoryView(intcat.groupno);
                            };
                            var hasChildrenInt = intcat.children && intcat.children.length > 0;
                            return Object(preact_min["h"])(
                                'div',
                                { 'class': 'ml-4' },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': categories_style_default.a.pointerCursor + ' nav-link py-0 ' + (isSelectedInt ? 'active' : '') },
                                    isSelectedInt && Object(preact_min["h"])(
                                        'span',
                                        { 'class': categories_style_default.a.pointerCursor },
                                        Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle float-right mt-1', onClick: onClickRemoveInt })
                                    ),
                                    Object(preact_min["h"])(
                                        'span',
                                        { onClick: onClickInt },
                                        Object(preact_min["h"])(
                                            'nobr',
                                            null,
                                            Object(preact_min["h"])(
                                                'small',
                                                null,
                                                Object(preact_min["h"])('i', { 'class': 'fas fa-edit mr-1 text-' + (isSelectedInt ? 'light' : 'primary') + ' font-weight-lighter', onClick: editInt })
                                            ),
                                            Object(preact_min["h"])('i', { 'class': (hasChildrenInt ? 'fas' : 'far') + ' fa-folder' + (categoryView[intcat.groupno] ? '-open' : '') + ' mr-1', onClick: toggleInt }),
                                            intcat.name,
                                            ' ',
                                            intcat.discount && Object(preact_min["h"])(
                                                'small',
                                                { 'class': 'font-weight-lighter' },
                                                intcat.discount,
                                                '%'
                                            ),
                                            ' ',
                                            isConsumerWeb(intcat),
                                            ' ',
                                            isDealerWeb(intcat)
                                        ),
                                        hasChildrenInt && Object(preact_min["h"])(
                                            'span',
                                            { 'class': 'font-weight-lighter float-right' },
                                            '(',
                                            intcat.children.length,
                                            ')'
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': 'd-' + (categoryView[intcat.groupno] ? 'block' : 'none') + ' nav flex-column mt-1' },
                                    hasChildrenInt && intcat.children.map(function (subcat) {
                                        var isSelectedSub = subcat.groupno == queryFilter.parent;
                                        var onClickSub = subcat.children ? function () {
                                            toggleQueryfilter('parent', subcat.groupno, {
                                                setValue: 1,
                                                toggle: function toggle() {
                                                    return categoryStore.updateCategoryView(subcat.groupno, !isSelectedInt && categoryView[subcat.groupno] ? 1 : null);
                                                }
                                            });
                                            route('/categories/', true);
                                        } : function () {
                                            return route('/categories/' + subcat.groupno + '/Basics', true);
                                        };
                                        var editSub = function editSub(e) {
                                            e.stopPropagation();
                                            route('/categories/' + subcat.groupno + '/Basics', true);
                                        };
                                        return Object(preact_min["h"])(
                                            'div',
                                            { 'class': 'ml-4' },
                                            Object(preact_min["h"])(
                                                'div',
                                                { 'class': categories_style_default.a.pointerCursor + ' nav-link py-0 ' + (isSelectedSub ? 'active' : '') },
                                                Object(preact_min["h"])(
                                                    'span',
                                                    { onClick: onClickSub },
                                                    Object(preact_min["h"])(
                                                        'nobr',
                                                        null,
                                                        Object(preact_min["h"])(
                                                            'small',
                                                            null,
                                                            Object(preact_min["h"])('i', { 'class': 'fas fa-edit mr-1 text-primary font-weight-lighter', onClick: editSub })
                                                        ),
                                                        Object(preact_min["h"])('i', { 'class': 'far fa-folder' + (categoryView[subcat.groupno] ? '-open' : '') + ' mr-1' }),
                                                        subcat.name,
                                                        ' ',
                                                        subcat.discount && Object(preact_min["h"])(
                                                            'small',
                                                            { 'class': 'font-weight-lighter' },
                                                            subcat.discount,
                                                            '%'
                                                        ),
                                                        ' ',
                                                        isConsumerWeb(subcat),
                                                        ' ',
                                                        isDealerWeb(subcat)
                                                    )
                                                )
                                            )
                                        );
                                    })
                                )
                            );
                        })
                    )
                );
            })
        );
    };

    return CategoryBranch;
}(preact_min["Component"])) || treeBranch__class;

/* harmony default export */ var treeBranch = (treeBranch_CategoryBranch);
// CONCATENATED MODULE: ./components/categories/tree.js





var tree__class, tree__class2, tree__class3, tree__class4, tree__temp, tree__initialiseProps;









var tree_initialState = {};

var tree_BrandLine = Object(index_module["a" /* observer */])(tree__class = function (_Component) {
    inherits_default()(BrandLine, _Component);

    function BrandLine() {
        classCallCheck_default()(this, BrandLine);

        return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }

    BrandLine.prototype.render = function render() {
        var _props = this.props,
            stores = _props.stores,
            brand = _props.brand,
            queryFilter = _props.queryFilter,
            onClickBrand = _props.onClickBrand;

        var isSelectedBrand = queryFilter.brand === brand.brandno;
        return Object(preact_min["h"])(
            'div',
            { 'class': 'nav-item' },
            Object(preact_min["h"])(
                'div',
                { 'class': categories_style_default.a.pointerCursor + ' nav-link py-0 ' + (isSelectedBrand ? 'active' : '') },
                Object(preact_min["h"])(
                    'span',
                    { onClick: function onClick() {
                            return onClickBrand(brand.brandno);
                        } },
                    brand.name,
                    brand.count && Object(preact_min["h"])(
                        'span',
                        { 'class': 'font-weight-lighter float-right' },
                        '(',
                        brand.count,
                        ')'
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'd-' + (isSelectedBrand ? 'block' : 'none') + ' nav flex-column mt-1' },
                Object(preact_min["h"])(treeBranch, { stores: stores, brand: brand.brandno })
            )
        );
    };

    return BrandLine;
}(preact_min["Component"])) || tree__class;

var tree_BrandList = Object(index_module["a" /* observer */])(tree__class2 = function (_Component2) {
    inherits_default()(BrandList, _Component2);

    function BrandList() {
        classCallCheck_default()(this, BrandList);

        return possibleConstructorReturn_default()(this, _Component2.apply(this, arguments));
    }

    BrandList.prototype.render = function render() {
        var _props2 = this.props,
            stores = _props2.stores,
            brands = _props2.brands,
            queryFilter = _props2.queryFilter,
            onClickBrand = _props2.onClickBrand;

        return Object(preact_min["h"])(
            'div',
            null,
            brands.map(function (brand) {
                return Object(preact_min["h"])(tree_BrandLine, { stores: stores, brand: brand, queryFilter: queryFilter, onClickBrand: onClickBrand });
            })
        );
    };

    return BrandList;
}(preact_min["Component"])) || tree__class2;

var tree_CategoryTree = Object(index_module["a" /* observer */])(tree__class3 = (tree__temp = tree__class4 = function (_Component3) {
    inherits_default()(CategoryTree, _Component3);

    function CategoryTree(props) {
        classCallCheck_default()(this, CategoryTree);

        var _this3 = possibleConstructorReturn_default()(this, _Component3.call(this, props));

        tree__initialiseProps.call(_this3);

        _this3.state = extends_default()({}, tree_initialState);

        var _this3$props$stores = _this3.props.stores,
            categoryStore = _this3$props$stores.categoryStore,
            brandStore = _this3$props$stores.brandStore;
        var queryFilter = categoryStore.queryFilter;

        categoryStore.updateQueryFilter({
            level: queryFilter.level || 'all',
            brand: queryFilter.brand || 'all',
            status: queryFilter.status || 'all',
            parent: queryFilter.parent
        });
        categoryStore.tree();

        brandStore.resetQueryFilter();
        brandStore.load();
        return _this3;
    }

    CategoryTree.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var _props$stores = props.stores,
            brandStore = _props$stores.brandStore,
            categoryStore = _props$stores.categoryStore;
        var brands = brandStore.brands;
        var queryFilter = categoryStore.queryFilter;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'nav flex-column nav-pills' },
            Object(preact_min["h"])(tree_BrandList, { stores: this.props.stores,
                brands: brands,
                queryFilter: queryFilter,
                onClickBrand: this.onClickBrand
            })
        );
    };

    return CategoryTree;
}(preact_min["Component"]), tree__initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.onClickBrand = function (brandno) {
        var categoryStore = _this4.props.stores.categoryStore;

        categoryStore.toggleQueryfilter('parent', '', { setValue: 1, skipUpdate: 1 });
        categoryStore.toggleQueryfilter('level', '', { setValue: 1, skipUpdate: 1 });
        categoryStore.toggleQueryfilter('brand', brandno, { setValue: true });
    };
}, tree__temp)) || tree__class3;

/* harmony default export */ var categories_tree = (tree_CategoryTree);
// CONCATENATED MODULE: ./components/categories/nav.js





var nav__ref = Object(preact_min["h"])('br', null);

function CategoryNav(props) {
    var _props$stores = props.stores,
        categoryStore = _props$stores.categoryStore,
        brandStore = _props$stores.brandStore;
    var queryFilter = categoryStore.queryFilter,
        total = categoryStore.total,
        view = categoryStore.view;
    var brands = brandStore.brands;


    return Object(preact_min["h"])(
        'div',
        null,
        Object(preact_min["h"])(
            'small',
            { 'class': 'text-muted font-weight-lighter float-right mr-2' },
            'Total: ',
            total,
            nav__ref
        ),
        Object(preact_min["h"])(
            'div',
            { 'class': 'btn-group mr-2', role: 'group' },
            Object(preact_min["h"])(
                'button',
                { id: 'btnGroupBrand', type: 'button', 'class': 'btn btn-sm btn-' + (queryFilter.brand !== 'all' ? 'success' : 'outline-secondary') + ' dropdown-toggle',
                    'data-toggle': 'dropdown', 'aria-haspopup': 'true', 'aria-expanded': 'false',
                    onClick: function onClick() {
                        return categoryStore.toggleView('brands');
                    }
                },
                'Brands: ',
                queryFilter.brand ? queryFilter.brand : 'All'
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'dropdown-menu ' + (view.brands ? 'show' : 'hide'), 'aria-labelledby': 'btnGroupBrand' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'dropdown-item ' + categories_style_default.a.pointerCursor,
                        onClick: function onClick() {
                            return categoryStore.toggleQueryfilter('brand', 'all', { setValue: true, toggle: function toggle() {
                                    return categoryStore.toggleView('brands');
                                } });
                        }
                    },
                    'All brands'
                ),
                brands.map(function (brand) {
                    return Object(preact_min["h"])(
                        'div',
                        { 'class': 'dropdown-item ' + categories_style_default.a.pointerCursor,
                            onClick: function onClick() {
                                return categoryStore.toggleQueryfilter('brand', brand.brandno, { setValue: true, toggle: function toggle() {
                                        return categoryStore.toggleView('brands');
                                    } });
                            }
                        },
                        brand.name
                    );
                })
            )
        ),
        Object(preact_min["h"])(
            'div',
            { 'class': 'btn-group mr-2', role: 'group' },
            Object(preact_min["h"])(
                'button',
                { id: 'btnGroupLevel', type: 'button', 'class': 'btn btn-sm btn-' + (queryFilter.level !== 'all' ? 'success' : 'outline-secondary') + ' dropdown-toggle',
                    'data-toggle': 'dropdown', 'aria-haspopup': 'true', 'aria-expanded': 'false',
                    onClick: function onClick() {
                        return categoryStore.toggleView('level');
                    }
                },
                'Level: ',
                queryFilter.level ? queryFilter.level : 'All'
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'dropdown-menu ' + (view.level ? 'show' : 'hide'), 'aria-labelledby': 'btnGroupLevel' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'dropdown-item ' + categories_style_default.a.pointerCursor, onClick: function onClick() {
                            return categoryStore.toggleQueryfilter('level', 'all', { setValue: true, toggle: function toggle() {
                                    return categoryStore.toggleView('level');
                                } });
                        } },
                    'All levels'
                ),
                ['main', 'intermediate', 'sub'].map(function (lvl) {
                    return Object(preact_min["h"])(
                        'div',
                        { 'class': 'dropdown-item ' + categories_style_default.a.pointerCursor, onClick: function onClick() {
                                return categoryStore.toggleQueryfilter('level', lvl, { setValue: true, toggle: function toggle() {
                                        return categoryStore.toggleView('level');
                                    } });
                            } },
                        lvl
                    );
                })
            )
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + (queryFilter.showOnConsumerWeb ? 'btn-success' : 'btn-outline-secondary'),
                onClick: function onClick() {
                    return categoryStore.toggleQueryfilter('showOnConsumerWeb');
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.showOnConsumerWeb ? 'on' : 'off') + ' mr-1' }),
            'ConsumerWeb'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + (queryFilter.preSale ? 'btn-success' : 'btn-outline-secondary'),
                onClick: function onClick() {
                    return categoryStore.toggleQueryfilter('preSale');
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.preSale ? 'on' : 'off') + ' mr-1' }),
            'PS'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + (queryFilter.hasNewProducts ? 'btn-success' : 'btn-outline-secondary'),
                onClick: function onClick() {
                    return categoryStore.toggleQueryfilter('hasNewProducts');
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.hasNewProducts ? 'on' : 'off') + ' mr-1' }),
            'Has new products'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + (queryFilter.hasPresaleProducts ? 'btn-success' : 'btn-outline-secondary'),
                onClick: function onClick() {
                    return categoryStore.toggleQueryfilter('hasPresaleProducts');
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.hasPresaleProducts ? 'on' : 'off') + ' mr-1' }),
            'Has PS products'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + (queryFilter.showall ? 'btn-success' : 'btn-outline-secondary'),
                onClick: function onClick() {
                    return categoryStore.toggleQueryfilter('showall');
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.showall ? 'on' : 'off') + ' mr-1' }),
            'Show all'
        ),
        Object(preact_min["h"])(
            'span',
            { 'class': 'float-left form-row align-items-center mr-5' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'col-auto' },
                Object(preact_min["h"])('input', { type: 'text', 'class': 'form-control form-control-sm', id: 'inlineFormInputName', placeholder: 'Search for categories...',
                    onInput: function onInput(e) {
                        return categoryStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true });
                    },
                    value: queryFilter.search
                })
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'col-auto' },
                Object(preact_min["h"])(
                    'button',
                    { type: 'button', 'class': 'btn btn-sm btn-primary', onClick: function onClick() {
                            return categoryStore.list();
                        } },
                    'Search'
                )
            )
        )
    );
}

/* harmony default export */ var nav = (CategoryNav);
// CONCATENATED MODULE: ./components/categories/list.js







var categories_list__class, list__class3, list__class4, _class5, _temp2, categories_list__initialiseProps;













var categories_list__ref = Object(preact_min["h"])('i', { 'class': 'fas fa-star-of-life' });

var categories_list__ref2 = Object(preact_min["h"])('i', { 'class': 'fas fa-redo' });

var categories_list__ref3 = Object(preact_min["h"])('i', { 'class': 'fas fa-newspaper' });

var categories_list__ref4 = Object(preact_min["h"])('i', { 'class': 'fas fa-folder-open' });

var categories_list__ref5 = Object(preact_min["h"])('i', { 'class': 'fas fa-tshirt' });

var categories_list__ref6 = Object(preact_min["h"])('i', { 'class': 'fas fa-check' });

var categories_list__ref7 = Object(preact_min["h"])('i', { 'class': 'fas fa-check' });

var categories_list__ref8 = Object(preact_min["h"])('i', { 'class': 'fas fa-check' });

var list_CategoryTableLine = Object(index_module["a" /* observer */])(categories_list__class = function (_Component) {
    inherits_default()(CategoryTableLine, _Component);

    function CategoryTableLine() {
        var _temp, _this, _ret;

        classCallCheck_default()(this, CategoryTableLine);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.updateLineField = function (e) {
            // console.log('updateLineField:', e);
            var updateField = _this.props.updateField;
            var params = e.target.dataset.params;

            var inputParams = JSON.parse(params || {});
            var id = inputParams.id,
                field = inputParams.field;
            var value = e.target.value;

            updateField(id, field, value);
        }, _this.saveLineField = function (e) {
            // console.log('saveField:', e);
            var saveField = _this.props.saveField;
            var params = e.target.dataset.params;

            var inputParams = JSON.parse(params || {});
            var id = inputParams.id,
                field = inputParams.field,
                updatememory = inputParams.updatememory,
                value = inputParams.value;

            saveField(id, field, value, updatememory);
        }, _temp), possibleConstructorReturn_default()(_this, _ret);
    }

    CategoryTableLine.prototype.render = function render() {
        var _props = this.props,
            category = _props.category,
            saved = _props.saved;

        return Object(preact_min["h"])(
            'tr',
            { 'class': '' + categories_style_default.a.tableline },
            Object(preact_min["h"])(
                'td',
                null,
                category.groupno
            ),
            Object(preact_min["h"])(
                'td',
                null,
                Object(preact_min["h"])(
                    'a',
                    { href: '/categories/' + category.groupno + '/Basics' },
                    category.name
                ),
                category.discount && Object(preact_min["h"])(
                    'span',
                    { 'class': 'ml-2 font-weight-lighter' },
                    '(-',
                    category.discount,
                    '%)'
                ),
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right' },
                    category.hasNewProducts && Object(preact_min["h"])(
                        'span',
                        { 'class': 'ml-2 badge badge-pill badge-info' },
                        categories_list__ref,
                        ' Has new products'
                    ),
                    category.hasPresaleProducts && Object(preact_min["h"])(
                        'span',
                        { 'class': 'ml-2 badge badge-pill badge-warning' },
                        categories_list__ref2,
                        ' Has PS products'
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'small' },
                    Object(preact_min["h"])(
                        'div',
                        null,
                        category.articles && category.articles.map(function (art) {
                            return Object(preact_min["h"])(
                                'span',
                                { 'class': 'mr-2 badge badge-primary' },
                                categories_list__ref3,
                                ' ',
                                art.id,
                                ': ',
                                art.title
                            );
                        })
                    ),
                    Object(preact_min["h"])(
                        'div',
                        null,
                        category.categories && category.categories.map(function (cat) {
                            return Object(preact_min["h"])(
                                'span',
                                { 'class': 'mr-2 badge badge-info' },
                                categories_list__ref4,
                                ' ',
                                cat.text
                            );
                        })
                    ),
                    Object(preact_min["h"])(
                        'div',
                        null,
                        category.products && category.products.map(function (prod) {
                            return Object(preact_min["h"])(
                                'span',
                                { 'class': 'mr-2 badge badge-secondary' },
                                categories_list__ref5,
                                ' ',
                                prod.name
                            );
                        })
                    ),
                    JSON.stringify(category.imgs),
                    JSON.stringify(category.images)
                )
            ),
            Object(preact_min["h"])(
                'td',
                null,
                category.level
            ),
            Object(preact_min["h"])(
                'td',
                null,
                category.parent
            ),
            Object(preact_min["h"])(
                'td',
                null,
                Object(preact_min["h"])(
                    'small',
                    null,
                    Object(preact_min["h"])(
                        'span',
                        {
                            'class': 'mr-1 badge ' + categories_style_default.a.pointerCursor + ' badge-' + (category.status === 2 ? 'success' : 'danger')
                            // onClick={() => categoryStore.saveField(category.id, `status`, category.status === 1 ? 2 : 1, true)}
                            , 'data-params': JSON.stringify({
                                id: category.id,
                                field: 'status',
                                value: category.status === 1 ? 2 : 1,
                                updatememory: 1
                            }),
                            onClick: this.saveLineField
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (category.status === 2 ? 'on' : 'off') }),
                        '\xA0',
                        categories_list__ref6,
                        ' DealerWeb'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        {
                            'class': 'mr-1 badge ' + categories_style_default.a.pointerCursor + ' badge-' + (category.showOnConsumerWeb === 1 ? 'success' : 'danger')
                            // onClick={() => categoryStore.saveField(category.id, `showOnConsumerWeb`, category.showOnConsumerWeb === 1 ? 0 : 1, true)}
                            , 'data-params': JSON.stringify({
                                id: category.id,
                                field: 'showOnConsumerWeb',
                                value: category.showOnConsumerWeb === 1 ? 0 : 1,
                                updatememory: 1
                            }),
                            onClick: this.saveLineField
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (category.showOnConsumerWeb === 1 ? 'on' : 'off') }),
                        '\xA0',
                        categories_list__ref7,
                        ' ConsumerWeb'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        {
                            'class': 'mr-1 badge ' + categories_style_default.a.pointerCursor + ' badge-' + (category.preSale === 1 ? 'success' : 'danger')
                            // onClick={() => categoryStore.saveField(category.id, `preSale`, category.preSale === 1 ? 0 : 1, true)}
                            , 'data-params': JSON.stringify({
                                id: category.id,
                                field: 'preSale',
                                value: category.preSale === 1 ? 0 : 1,
                                updatememory: 1
                            }),
                            onClick: this.saveLineField
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (category.preSale === 1 ? 'on' : 'off') }),
                        '\xA0',
                        categories_list__ref8,
                        ' PS'
                    )
                )
            ),
            Object(preact_min["h"])(
                'td',
                { 'class': 'text-right' },
                Object(preact_min["h"])(input, {
                    id: category.id,
                    className: 'text-right form-control-sm',
                    isValid: saved['sort.' + category.id],
                    name: 'sort',
                    value: category.sort,
                    dataParams: JSON.stringify({
                        id: category.id,
                        field: 'sort'
                    }),
                    onInput: this.updateLineField,
                    hideHelp: 1
                })
            ),
            Object(preact_min["h"])(
                'td',
                { 'class': 'text-right' },
                Object(preact_min["h"])(input, {
                    id: category.id,
                    className: 'text-right form-control-sm',
                    isValid: saved['discount.' + category.id],
                    name: 'discount',
                    value: category.discount,
                    dataParams: JSON.stringify({
                        id: category.id,
                        field: 'discount'
                    }),
                    onInput: this.updateLineField,
                    hideHelp: 1
                })
            ),
            Object(preact_min["h"])(
                'td',
                { 'class': 'text-right' },
                category.count
            ),
            Object(preact_min["h"])(
                'td',
                { 'class': 'text-right' },
                category.countPresale
            ),
            Object(preact_min["h"])(
                'td',
                { 'class': 'text-right' },
                Object(preact_min["h"])(
                    'span',
                    {
                        'class': 'mr-1 badge ' + categories_style_default.a.pointerCursor + ' badge-' + (category.offline === 1 ? 'success' : 'danger'),
                        'data-params': JSON.stringify({
                            id: category.id,
                            field: 'offline',
                            value: category.offline === 1 ? 0 : 1,
                            updatememory: 1
                        }),
                        onClick: this.saveLineField
                    },
                    '\xA0',
                    Object(preact_min["h"])('i', { 'class': 'fas fa-trash' + (category.offline === 1 ? '-restore' : '') }),
                    ' ',
                    category.offline === 1 ? 'Restore' : 'Delete'
                )
            )
        );
    };

    return CategoryTableLine;
}(preact_min["Component"])) || categories_list__class;

var categories_list__ref9 = Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle' });

var categories_list__ref10 = Object(preact_min["h"])(
    'td',
    { 'class': 'text-center', colspan: '9' },
    Object(preact_min["h"])(
        'h5',
        null,
        'No categories found'
    ),
    'Try using the "Show all" button if you are missing some categories.'
);

var list_CategoryTable = Object(index_module["a" /* observer */])(list__class3 = function (_Component2) {
    inherits_default()(CategoryTable, _Component2);

    function CategoryTable() {
        classCallCheck_default()(this, CategoryTable);

        return possibleConstructorReturn_default()(this, _Component2.apply(this, arguments));
    }

    CategoryTable.prototype.render = function render() {
        var _props2 = this.props,
            categories = _props2.categories,
            saved = _props2.saved,
            saveField = _props2.saveField,
            updateField = _props2.updateField,
            categoryStore = _props2.categoryStore;

        return Object(preact_min["h"])(
            'table',
            { 'class': categories_style_default.a.table + ' table table-striped table-sm table-borderless' },
            Object(preact_min["h"])(
                'thead',
                null,
                categoryStore.sort !== categoryStore.defaultSort && Object(preact_min["h"])(
                    'tr',
                    null,
                    Object(preact_min["h"])(
                        'th',
                        { colspan: '8' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': categories_style_default.a.pointerCursor + ' mr-2 badge badge-pill badge-secondary', onClick: function onClick() {
                                    return categoryStore.resetSort();
                                } },
                            categories_list__ref9,
                            ' Reset sort'
                        )
                    )
                ),
                Object(preact_min["h"])(
                    'tr',
                    null,
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 5%' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': categories_style_default.a.pointerCursor, onClick: function onClick() {
                                    return categoryStore.toggleSort('groupno', '');
                                } },
                            'Groupno ',
                            util.getSortIcon('groupno', categoryStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 50%' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': categories_style_default.a.pointerCursor, onClick: function onClick() {
                                    return categoryStore.toggleSort('name', '');
                                } },
                            'Name ',
                            util.getSortIcon('name', categoryStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 5%' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': categories_style_default.a.pointerCursor, onClick: function onClick() {
                                    return categoryStore.toggleSort('level', '-');
                                } },
                            'Level ',
                            util.getSortIcon('level', categoryStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 5%' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': categories_style_default.a.pointerCursor, onClick: function onClick() {
                                    return categoryStore.toggleSort('parent', '-');
                                } },
                            'Parent ',
                            util.getSortIcon('parent', categoryStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 5%' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': categories_style_default.a.pointerCursor, onClick: function onClick() {
                                    return categoryStore.toggleSort('status', '');
                                } },
                            'Status ',
                            util.getSortIcon('status', categoryStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 10%', 'class': 'text-right' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': categories_style_default.a.pointerCursor, onClick: function onClick() {
                                    return categoryStore.toggleSort('sort', '');
                                } },
                            'Sort ',
                            util.getSortIcon('sort', categoryStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 10%', 'class': 'text-right' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': categories_style_default.a.pointerCursor, onClick: function onClick() {
                                    return categoryStore.toggleSort('discount', '-');
                                } },
                            'Discount ',
                            util.getSortIcon('discount', categoryStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 5%', 'class': 'text-right' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': categories_style_default.a.pointerCursor, onClick: function onClick() {
                                    return categoryStore.toggleSort('count', '-');
                                } },
                            'Count ',
                            util.getSortIcon('count', categoryStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 5%', 'class': 'text-right' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': categories_style_default.a.pointerCursor, onClick: function onClick() {
                                    return categoryStore.toggleSort('countPresale', '-');
                                } },
                            'Count presale ',
                            util.getSortIcon('countPresale', categoryStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 5%', 'class': 'text-center' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': categories_style_default.a.pointerCursor, onClick: function onClick() {
                                    return categoryStore.toggleSort('offline', '-');
                                } },
                            'Offline ',
                            util.getSortIcon('offline', categoryStore.sort)
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'tbody',
                null,
                !categories.length && Object(preact_min["h"])(
                    'tr',
                    { 'class': '' + categories_style_default.a.tableline },
                    categories_list__ref10
                ),
                categories && categories.map(function (category) {
                    return Object(preact_min["h"])(list_CategoryTableLine, {
                        category: category,
                        saved: saved,
                        saveField: saveField,
                        updateField: updateField
                    });
                })
            )
        );
    };

    return CategoryTable;
}(preact_min["Component"])) || list__class3;

var categories_list_initialState = {
    height: 100,
    loading: false,
    view: {
        brands: false,
        languages: false,
        categories: false
    }
};

var categories_list__ref12 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var categories_list__ref13 = Object(preact_min["h"])(
    'h1',
    null,
    Object(preact_min["h"])('i', { 'class': 'fas fa-search' }),
    ' Search results'
);

var categories_list__ref14 = Object(preact_min["h"])('br', null);

var categories_list__ref15 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var categories_list__ref16 = Object(preact_min["h"])(
    'div',
    { 'class': 'row' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'col-12 text-center' },
        Object(preact_min["h"])(
            'div',
            { 'class': 'spinner-border text-success', role: 'status' },
            Object(preact_min["h"])(
                'span',
                { 'class': 'sr-only' },
                'Loading...'
            )
        )
    )
);

var categories_list__ref17 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var list_CategoryList = Object(index_module["a" /* observer */])(list__class4 = (_temp2 = _class5 = function (_Component3) {
    inherits_default()(CategoryList, _Component3);

    function CategoryList(props) {
        classCallCheck_default()(this, CategoryList);

        var _this3 = possibleConstructorReturn_default()(this, _Component3.call(this, props));

        categories_list__initialiseProps.call(_this3);

        _this3.state = extends_default()({}, categories_list_initialState);
        _this3.updateTimer = {};

        var categoryStore = _this3.props.stores.categoryStore;

        categoryStore.list();
        _this3.subscriptions();
        return _this3;
    }

    CategoryList.prototype.subscriptions = function subscriptions() {
        var _this4 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this4.setState({ height: height });
        });
    };

    CategoryList.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    CategoryList.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    CategoryList.prototype.doUpdateField = function () {
        var _ref11 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(id, field, value) {
            var categoryStore;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            categoryStore = this.props.stores.categoryStore;
                            _context.next = 3;
                            return categoryStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref11.apply(this, arguments);
        }

        return doUpdateField;
    }();

    CategoryList.prototype.render = function render() {
        var _state = this.state,
            loading = _state.loading,
            height = _state.height;
        var categoryStore = this.props.stores.categoryStore;
        var categories = categoryStore.categories,
            queryFilter = categoryStore.queryFilter,
            saved = categoryStore.saved;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(nav, this.props)
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-2 fixed-top overflow-auto',
                        style: 'margin-top: ' + (height + 60) + 'px; height: calc(100% - ' + (height + 60) + 'px);'
                    },
                    Object(preact_min["h"])(
                        'small',
                        null,
                        Object(preact_min["h"])(categories_tree, this.props)
                    ),
                    categories_list__ref12
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-10 offset-2' },
                    queryFilter.search && Object(preact_min["h"])(
                        'div',
                        { 'class': 'w-100 text-left mt-2 mb-5' },
                        categories_list__ref13,
                        'Found ',
                        categoryStore.total,
                        ' results in your search for "',
                        queryFilter.search,
                        '".',
                        categories_list__ref14,
                        Object(preact_min["h"])(
                            'button',
                            { 'class': 'btn btn-sm btn-warning mt-2',
                                onClick: function onClick() {
                                    return categoryStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true });
                                }
                            },
                            categories_list__ref15,
                            ' Reset search'
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'table-responsive' },
                        Object(preact_min["h"])(list_CategoryTable, {
                            categories: categories,
                            saved: saved,
                            saveField: this.saveField,
                            updateField: this.updateField,
                            categoryStore: categoryStore
                        })
                    )
                )
            ),
            loading && categories_list__ref16,
            categories_list__ref17
        );
    };

    return CategoryList;
}(preact_min["Component"]), categories_list__initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.handleScroll = function () {
        var loading = _this5.state.loading;
        var categoryStore = _this5.props.stores.categoryStore;
        var totalAppend = categoryStore.totalAppend,
            limit = categoryStore.limit;

        if (window.innerHeight + document.documentElement.scrollTop + 500 < document.documentElement.offsetHeight) return;
        if (loading) return;

        var offset = categoryStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(_this5.scrollLoader);
            _this5.scrollLoader = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this5.setState({ loading: true });
                                categoryStore.updateOffset(offset);
                                _context2.next = 4;
                                return categoryStore.list(true);

                            case 4:
                                _this5.setState({ loading: false });

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this5);
            })), 500);
        }
    };

    this.updateField = function () {
        var _ref19 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(id, field, value) {
            var categoryStore;
            return regenerator_default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            categoryStore = _this5.props.stores.categoryStore;

                            categoryStore.updateField(id, field, value);

                            clearTimeout(_this5.updateTimer[field]);
                            _this5.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                                return regenerator_default.a.wrap(function _callee3$(_context3) {
                                    while (1) {
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                _this5.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context3.stop();
                                        }
                                    }
                                }, _callee3, _this5);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this5);
        }));

        return function (_x4, _x5, _x6) {
            return _ref19.apply(this, arguments);
        };
    }();

    this.saveField = function () {
        var _ref21 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(id, field, value, updatememory) {
            var categoryStore;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            categoryStore = _this5.props.stores.categoryStore;

                            categoryStore.saveField(id, field, value, updatememory);

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }));

        return function (_x7, _x8, _x9, _x10) {
            return _ref21.apply(this, arguments);
        };
    }();
}, _temp2)) || list__class4;

/* harmony default export */ var categories_list = (list_CategoryList);
// CONCATENATED MODULE: ./components/categories/index.js




var categories__class;









var categories_initialState = {
    height: 100
};

var categories_Frontpage = Object(index_module["a" /* observer */])(categories__class = function (_Component) {
    inherits_default()(Frontpage, _Component);

    function Frontpage(props) {
        classCallCheck_default()(this, Frontpage);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = categories_initialState;
        _this.subscriptions();
        return _this;
    }

    Frontpage.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    Frontpage.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(categories_list, props)
                )
            )
        );
    };

    return Frontpage;
}(preact_min["Component"])) || categories__class;

/* harmony default export */ var components_categories = (categories_Frontpage);
// CONCATENATED MODULE: ./components/categories/edit.js







var categories_edit__class, categories_edit__class2, categories_edit__temp, categories_edit__initialiseProps;















var categories_edit_initialState = {
    height: 100
};

var edit_FIELDS = {
    groupno: { label: 'group #', type: 'text', readonly: true, help: 'Field is imported from Visma: "MainGroupNo", "IntermediateGroupNo", "SubGroupNo" via new Visma SQL -> S3 -> Lambda -> API  files "hovedgruppe.csv", "mellomgruppe.csv", "undergruppe.csv"' },
    name: { label: 'Category name', type: 'text', readonly: true, help: 'Field is imported from Visma: "Name" via new Visma SQL -> S3 -> Lambda -> API  files "hovedgruppe.csv", "mellomgruppe.csv", "undergruppe.csv"' },
    level: { label: 'level', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    sort: { label: 'sort', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    status: { label: 'Show on DealerWeb', values: [{ key: 'Yes', val: 2 }, { key: 'No', val: 1 }], type: 'radio', readonly: false, help: 'Field is DealerWeb only.' },
    discount: { label: 'Disount in %', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    preSale: { label: 'PS', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },
    hasNewProducts: { label: 'Has new products', type: 'checkbox', value: 1, readonly: true, help: 'Field is DealerWeb only and updated automatically every day.' },
    showOnConsumerWeb: { label: 'Show on ConsumerWeb', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },
    hasPresaleProducts: { label: 'Has PS products', type: 'checkbox', value: 1, readonly: true, help: 'Field is DealerWeb only and updated automatically every day.' },

    count: { label: 'Total products', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    countPresale: { label: 'Total PS products', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    depth: { label: 'Depth', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'updatedDate', type: 'text', readonly: true, help: 'Field is DealerWeb only.' }

};

var edit__ref6 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var edit_CategoryEdit = Object(index_module["a" /* observer */])(categories_edit__class = (categories_edit__temp = categories_edit__class2 = function (_Component) {
    inherits_default()(CategoryEdit, _Component);

    function CategoryEdit(props) {
        var _this2 = this;

        classCallCheck_default()(this, CategoryEdit);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        categories_edit__initialiseProps.call(_this);

        _this.state = extends_default()({}, categories_edit_initialState);
        _this.updateTimer = {};
        var _this$props$stores = _this.props.stores,
            articleStore = _this$props$stores.articleStore,
            categoryStore = _this$props$stores.categoryStore,
            brandStore = _this$props$stores.brandStore,
            productStore = _this$props$stores.productStore;

        categoryStore.load(props.categoryid);
        categoryStore.tree();
        brandStore.load();
        _this.subscriptions();

        _this.fields = [{
            tabname: 'Basics',
            icon: 'fas fa-user-edit',
            fields: ['groupno', 'name', 'level', 'sort', 'status', 'preSale', 'showOnConsumerWeb', 'discount', 'hasNewProducts', 'hasPresaleProducts', 'count', 'countPresale', 'depth', 'updatedDate'].map(function (f) {
                return util.makeField(f, edit_FIELDS);
            })
        }, {
            tabname: 'Related',
            icon: 'fas fa-user-edit',
            fields: [{
                name: 'categories',
                label: 'Related categories',
                type: 'object',
                view: function view(val) {
                    var opts = {
                        placeholder: 'Search for category...',
                        value: val,
                        valueDisplayMap: function valueDisplayMap(v) {
                            return Object(preact_min["h"])(
                                'span',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': 'font-weight-light' },
                                    v.groupno,
                                    ':'
                                ),
                                ' ',
                                v.name
                            );
                        },
                        autocompleteList: categoryStore.searchResults,
                        oninput: function oninput(e) {
                            clearTimeout(_this.searchTimer);
                            _this.searchTimer = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                return regenerator_default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                categoryStore.search(e.target.value);

                                            case 1:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this2);
                            })), 500);
                        },
                        addElement: function addElement(idx) {
                            categoryStore.addElement(idx, 'category', 'categories');
                            categoryStore.resetSearch();
                        },
                        removeElement: function removeElement(id) {
                            categoryStore.removeElement(id, 'category', 'categories');
                            categoryStore.resetSearch();
                        },
                        handleKeydown: function handleKeydown(e) {
                            if (e.key === 'ArrowDown') {
                                if (categoryStore.totalSearch === 0) {
                                    categoryStore.search(e.target.value);
                                }
                                categoryStore.incSearchSelectIdx();
                            } else if (e.key === 'ArrowUp') {
                                categoryStore.decSearchSelectIdx();
                            } else if (e.key === 'Enter') {
                                categoryStore.addElement(0, 'category', 'categories');
                                categoryStore.resetSearch();
                            } else if (e.key === 'Escape') {
                                categoryStore.resetSearch();
                            }
                        },
                        currentIdx: categoryStore.searchSelectIdx,
                        currentId: categoryStore.searchSelectId,
                        total: categoryStore.totalSearch
                    };
                    return Object(preact_min["h"])(autocomplete, opts);
                },
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'articles',
                label: 'Related articles',
                type: 'object',
                view: function view(val) {
                    var opts = {
                        placeholder: 'Search for article...',
                        value: val,
                        valueDisplayMap: function valueDisplayMap(v) {
                            return Object(preact_min["h"])(
                                'span',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': 'font-weight-light' },
                                    v.id,
                                    ':'
                                ),
                                ' ',
                                v.title
                            );
                        },
                        autocompleteList: articleStore.searchResults,
                        oninput: function oninput(e) {
                            clearTimeout(_this.searchTimer);
                            _this.searchTimer = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                    while (1) {
                                        switch (_context2.prev = _context2.next) {
                                            case 0:
                                                articleStore.search(e.target.value);

                                            case 1:
                                            case 'end':
                                                return _context2.stop();
                                        }
                                    }
                                }, _callee2, _this2);
                            })), 500);
                        },
                        addElement: function addElement(idx) {
                            categoryStore.addElement(articleStore.getElement(idx), 'category', 'articles');
                            articleStore.resetSearch();
                        },
                        removeElement: function removeElement(id) {
                            categoryStore.removeElement(id, 'category', 'articles');
                            articleStore.resetSearch();
                        },
                        handleKeydown: function handleKeydown(e) {
                            if (e.key === 'ArrowDown') {
                                if (articleStore.totalSearch === 0) {
                                    articleStore.search(e.target.value);
                                }
                                articleStore.incSearchSelectIdx();
                            } else if (e.key === 'ArrowUp') {
                                articleStore.decSearchSelectIdx();
                            } else if (e.key === 'Enter') {
                                categoryStore.addElement(articleStore.getElement(), 'category', 'articles');
                                articleStore.resetSearch();
                            } else if (e.key === 'Escape') {
                                articleStore.resetSearch();
                            }
                        },
                        currentIdx: articleStore.searchSelectIdx,
                        currentId: articleStore.searchSelectId,
                        total: articleStore.totalSearch
                    };
                    return Object(preact_min["h"])(autocomplete, opts);
                },
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'articlesTech',
                label: 'Related tech articles',
                type: 'object',
                view: function view(val) {
                    var opts = {
                        placeholder: 'Search for tech article...',
                        value: val,
                        valueDisplayMap: function valueDisplayMap(v) {
                            return Object(preact_min["h"])(
                                'span',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': 'font-weight-light' },
                                    v.id,
                                    ':'
                                ),
                                ' ',
                                v.title
                            );
                        },
                        autocompleteList: articleStore.searchResults,
                        oninput: function oninput(e) {
                            clearTimeout(_this.searchTimer);
                            _this.searchTimer = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                                return regenerator_default.a.wrap(function _callee3$(_context3) {
                                    while (1) {
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                articleStore.search(e.target.value);

                                            case 1:
                                            case 'end':
                                                return _context3.stop();
                                        }
                                    }
                                }, _callee3, _this2);
                            })), 500);
                        },
                        addElement: function addElement(idx) {
                            categoryStore.addElement(articleStore.getElement(idx), 'category', 'articlesTech');
                            articleStore.resetSearch();
                        },
                        removeElement: function removeElement(id) {
                            categoryStore.removeElement(id, 'category', 'articlesTech');
                            articleStore.resetSearch();
                        },
                        handleKeydown: function handleKeydown(e) {
                            if (e.key === 'ArrowDown') {
                                if (articleStore.totalSearch === 0) {
                                    articleStore.search(e.target.value);
                                }
                                articleStore.incSearchSelectIdx();
                            } else if (e.key === 'ArrowUp') {
                                articleStore.decSearchSelectIdx();
                            } else if (e.key === 'Enter') {
                                categoryStore.addElement(articleStore.getElement(), 'category', 'articlesTech');
                                articleStore.resetSearch();
                            } else if (e.key === 'Escape') {
                                articleStore.resetSearch();
                            }
                        },
                        currentIdx: articleStore.searchSelectIdx,
                        currentId: articleStore.searchSelectId,
                        total: articleStore.totalSearch
                    };
                    return Object(preact_min["h"])(autocomplete, opts);
                },
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'products',
                label: 'Related products',
                type: 'object',
                view: function view(val) {
                    var opts = {
                        placeholder: 'Search for product...',
                        value: val,
                        valueDisplayMap: function valueDisplayMap(v) {
                            return Object(preact_min["h"])(
                                'span',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': 'font-weight-light' },
                                    v.articleno,
                                    ':'
                                ),
                                ' ',
                                v.name
                            );
                        },
                        autocompleteList: productStore.searchResults,
                        oninput: function oninput(e) {
                            clearTimeout(_this.searchTimer);
                            _this.searchTimer = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                                return regenerator_default.a.wrap(function _callee4$(_context4) {
                                    while (1) {
                                        switch (_context4.prev = _context4.next) {
                                            case 0:
                                                productStore.search(e.target.value);

                                            case 1:
                                            case 'end':
                                                return _context4.stop();
                                        }
                                    }
                                }, _callee4, _this2);
                            })), 500);
                        },
                        addElement: function addElement(idx) {
                            categoryStore.addElement(productStore.getElement(idx), 'category', 'products');
                            productStore.resetSearch();
                        },
                        removeElement: function removeElement(id) {
                            categoryStore.removeElement(id, 'category', 'products');
                            productStore.resetSearch();
                        },
                        handleKeydown: function handleKeydown(e) {
                            if (e.key === 'ArrowDown') {
                                if (productStore.totalSearch === 0) {
                                    productStore.search(e.target.value);
                                }
                                productStore.incSearchSelectIdx();
                            } else if (e.key === 'ArrowUp') {
                                productStore.decSearchSelectIdx();
                            } else if (e.key === 'Enter') {
                                categoryStore.addElement(productStore.getElement(), 'category', 'products');
                                productStore.resetSearch();
                            } else if (e.key === 'Escape') {
                                productStore.resetSearch();
                            }
                        },
                        currentIdx: productStore.searchSelectIdx,
                        currentId: productStore.searchSelectId,
                        total: articleStore.totalSearch
                    };
                    return Object(preact_min["h"])(autocomplete, opts);
                },
                readonly: false,
                help: 'Field is DealerWeb only.'
            }]
        }];
        return _this;
    }

    CategoryEdit.prototype.subscriptions = function subscriptions() {
        var _this3 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this3.setState({ height: height });
        });
    };

    CategoryEdit.prototype.doUpdateField = function () {
        var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(id, field, value) {
            var categoryStore;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            categoryStore = this.props.stores.categoryStore;
                            _context5.next = 3;
                            return categoryStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref5.apply(this, arguments);
        }

        return doUpdateField;
    }();

    CategoryEdit.prototype.render = function render(props) {
        var _this4 = this;

        var height = this.state.height;
        var categoryStore = this.props.stores.categoryStore;
        var category = categoryStore.category,
            saved = categoryStore.saved;


        var tabIdx = this.fields.findIndex(function (e) {
            return e.tabname === props.tabname;
        });
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(nav, this.props)
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-2 fixed-top overflow-auto',
                        style: 'margin-top: ' + (height + 60) + 'px; height: calc(100% - ' + (height + 60) + 'px);'
                    },
                    Object(preact_min["h"])(
                        'small',
                        null,
                        Object(preact_min["h"])(categories_tree, this.props)
                    ),
                    edit__ref6
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-10 offset-2' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-flex flex-row bd-highlight mb-3 mt-4' },
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: '/categories', 'class': 'mr-2 btn btn-sm btn-warning' },
                                Object(preact_min["h"])('i', { 'class': 'fas fa-arrow-left mr-1' }),
                                'Back'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'h4',
                                null,
                                'Edit: ',
                                category.id,
                                ': ',
                                category.name
                            )
                        )
                    ),
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'nav nav-tabs mb-2' },
                        this.fields.map(function (tab) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'nav-item' },
                                Object(preact_min["h"])(
                                    'a',
                                    { 'class': 'nav-link ' + (props.tabname === tab.tabname ? 'active' : ''),
                                        href: '/categories/' + props.categoryid + '/' + tab.tabname
                                    },
                                    Object(preact_min["h"])('i', { 'class': tab.icon + ' mr-2' }),
                                    tab.tabname
                                )
                            );
                        })
                    ),
                    this.fields[tabIdx].fields.map(function (field) {
                        return Object(preact_min["h"])(formField_FormRow, {
                            field: field,
                            object: category,
                            saved: saved,
                            updateField: _this4.updateField
                        });
                    })
                )
            )
        );
    };

    return CategoryEdit;
}(preact_min["Component"]), categories_edit__initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.updateField = function () {
        var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7(id, field, value) {
            var categoryStore;
            return regenerator_default.a.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            categoryStore = _this5.props.stores.categoryStore;

                            categoryStore.updateField(id, field, value);

                            clearTimeout(_this5.updateTimer[field]);
                            _this5.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6() {
                                return regenerator_default.a.wrap(function _callee6$(_context6) {
                                    while (1) {
                                        switch (_context6.prev = _context6.next) {
                                            case 0:
                                                _this5.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context6.stop();
                                        }
                                    }
                                }, _callee6, _this5);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this5);
        }));

        return function (_x4, _x5, _x6) {
            return _ref7.apply(this, arguments);
        };
    }();
}, categories_edit__temp)) || categories_edit__class;

/* harmony default export */ var categories_edit = (edit_CategoryEdit);
// EXTERNAL MODULE: ./components/products/style.css
var products_style = __webpack_require__("PZ+8");
var products_style_default = /*#__PURE__*/__webpack_require__.n(products_style);

// CONCATENATED MODULE: ./components/products/treeBranch.js





var products_treeBranch__class;








var products_treeBranch__ref = Object(preact_min["h"])(
    'small',
    null,
    Object(preact_min["h"])(
        'span',
        { 'class': 'badge' },
        'cw'
    )
);

function treeBranch_isConsumerWeb(cat) {
    if (cat.showOnConsumerWeb) {
        return products_treeBranch__ref;
    }
    return '';
}

var products_treeBranch__ref2 = Object(preact_min["h"])(
    'small',
    null,
    Object(preact_min["h"])(
        'span',
        { 'class': 'badge' },
        'dw'
    )
);

function treeBranch_isDealerWeb(cat) {
    if (cat.status === 2) {
        return products_treeBranch__ref2;
    }
    return '';
}

var products_treeBranch_initialState = {};

var products_treeBranch_CategoryBranch = Object(index_module["a" /* observer */])(products_treeBranch__class = function (_Component) {
    inherits_default()(CategoryBranch, _Component);

    function CategoryBranch(props) {
        classCallCheck_default()(this, CategoryBranch);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = extends_default()({}, products_treeBranch_initialState);
        return _this;
    }

    CategoryBranch.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var _props$stores = props.stores,
            categoryStore = _props$stores.categoryStore,
            productStore = _props$stores.productStore;
        var categoryTree = categoryStore.categoryTree,
            categoryView = categoryStore.categoryView;
        var queryFilter = productStore.queryFilter,
            toggleQueryfilter = productStore.toggleQueryfilter;


        var filterRegexp = new RegExp('^' + props.brand, 'i');
        return Object(preact_min["h"])(
            'div',
            { 'class': 'ml-4' },
            categoryTree.filter(function (e) {
                return e.name.match(filterRegexp);
            }).map(function (cat) {
                var isSelectedMain = cat.groupno == queryFilter.mainCat;
                var onClickMain = function onClickMain() {
                    toggleQueryfilter('intCat', '', { setValue: 1, skipUpdate: 1 });
                    toggleQueryfilter('subCat', '', { setValue: 1, skipUpdate: 1 });
                    toggleQueryfilter('mainCat', cat.groupno, {
                        setValue: 1
                        // toggle: groupno => categoryStore.updateCategoryView(cat.groupno, groupno == cat.groupno ? 1 : null),
                    });
                    route('/products/', true);
                };
                var onClickRemoveMain = function onClickRemoveMain(e) {
                    e.stopPropagation();
                    toggleQueryfilter('mainCat', '', { setValue: 1 });
                    categoryStore.updateCategoryView(cat.groupno, null);
                    route('/products/', true);
                };
                var toggleMain = function toggleMain(e) {
                    e.stopPropagation();
                    categoryStore.updateCategoryView(cat.groupno);
                };
                var hasChildrenMain = cat.children && cat.children.length > 0;
                return Object(preact_min["h"])(
                    'div',
                    { 'class': 'nav-item' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': products_style_default.a.pointerCursor + ' nav-link py-0 ' + (isSelectedMain ? 'active' : '') },
                        Object(preact_min["h"])(
                            'span',
                            { onClick: onClickMain },
                            Object(preact_min["h"])('i', { 'class': (hasChildrenMain ? 'fas' : 'far') + ' fa-folder' + (categoryView[cat.groupno] ? '-open' : '') + ' mr-1', onClick: toggleMain }),
                            cat.name,
                            ' ',
                            treeBranch_isConsumerWeb(cat),
                            ' ',
                            treeBranch_isDealerWeb(cat),
                            cat.count && Object(preact_min["h"])(
                                'span',
                                { 'class': 'font-weight-lighter float-right' },
                                '(',
                                cat.count,
                                ')'
                            )
                        ),
                        isSelectedMain && Object(preact_min["h"])(
                            'span',
                            { 'class': products_style_default.a.pointerCursor + ' float-right' },
                            Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle float-right mt-1', onClick: onClickRemoveMain })
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-' + (categoryView[cat.groupno] ? 'block' : 'none') + ' nav flex-column mt-1' },
                        hasChildrenMain && cat.children.map(function (intcat) {
                            var isSelectedInt = intcat.groupno == queryFilter.intCat;
                            var onClickInt = function onClickInt() {
                                toggleQueryfilter('mainCat', '', { setValue: 1, skipUpdate: 1 });
                                toggleQueryfilter('subCat', '', { setValue: 1, skipUpdate: 1 });
                                toggleQueryfilter('intCat', intcat.groupno, {
                                    setValue: 1
                                    // toggle: groupno => categoryStore.updateCategoryView(intcat.groupno, groupno == intcat.groupno ? 1 : null),
                                });
                                route('/products/', true);
                            };
                            var onClickRemoveInt = function onClickRemoveInt(e) {
                                e.stopPropagation();
                                toggleQueryfilter('intCat', '', { setValue: 1 });
                                categoryStore.updateCategoryView(intcat.groupno, null);
                                route('/products/', true);
                            };
                            var toggleInt = function toggleInt(e) {
                                e.stopPropagation();
                                categoryStore.updateCategoryView(intcat.groupno);
                            };
                            var hasChildrenInt = intcat.children && intcat.children.length > 0;
                            return Object(preact_min["h"])(
                                'div',
                                { 'class': 'ml-4 font-weight-lighter' },
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': products_style_default.a.pointerCursor + ' nav-link py-0 ' + (isSelectedInt ? 'active' : '') },
                                    isSelectedInt && Object(preact_min["h"])(
                                        'span',
                                        { 'class': products_style_default.a.pointerCursor },
                                        Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle float-right mt-1', onClick: onClickRemoveInt })
                                    ),
                                    Object(preact_min["h"])(
                                        'span',
                                        { onClick: onClickInt },
                                        Object(preact_min["h"])('i', { 'class': (hasChildrenInt ? 'fas' : 'far') + ' fa-folder' + (categoryView[intcat.groupno] ? '-open' : '') + ' mr-1', onClick: toggleInt }),
                                        intcat.name,
                                        ' ',
                                        treeBranch_isConsumerWeb(intcat),
                                        ' ',
                                        treeBranch_isDealerWeb(intcat),
                                        intcat.count && Object(preact_min["h"])(
                                            'span',
                                            { 'class': 'font-weight-lighter float-right' },
                                            '(',
                                            intcat.count,
                                            ')'
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'div',
                                    { 'class': 'd-' + (categoryView[intcat.groupno] ? 'block' : 'none') + ' nav flex-column mt-1' },
                                    hasChildrenInt && intcat.children.map(function (subcat) {
                                        var isSelectedSub = subcat.groupno == queryFilter.subCat;
                                        var onClickSub = function onClickSub() {
                                            toggleQueryfilter('mainCat', '', { setValue: 1, skipUpdate: 1 });
                                            toggleQueryfilter('intCat', '', { setValue: 1, skipUpdate: 1 });
                                            toggleQueryfilter('subCat', subcat.groupno, {
                                                setValue: 1
                                                // toggle: () => categoryStore.updateCategoryView(subcat.groupno, (!isSelectedInt && categoryView[subcat.groupno] ? 1 : null)),
                                            });
                                            route('/products/', true);
                                        };
                                        var onClickRemoveSub = function onClickRemoveSub(e) {
                                            e.stopPropagation();
                                            toggleQueryfilter('subCat', '', { setValue: 1 });
                                            categoryStore.updateCategoryView(subcat.groupno, null);
                                            route('/products/', true);
                                        };
                                        return Object(preact_min["h"])(
                                            'div',
                                            { 'class': 'ml-4 font-weight-lighter' },
                                            Object(preact_min["h"])(
                                                'div',
                                                { 'class': products_style_default.a.pointerCursor + ' nav-link py-0 ' + (isSelectedSub ? 'active' : '') },
                                                isSelectedSub && Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': products_style_default.a.pointerCursor },
                                                    Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle float-right mt-1', onClick: onClickRemoveSub })
                                                ),
                                                Object(preact_min["h"])(
                                                    'span',
                                                    { onClick: onClickSub },
                                                    Object(preact_min["h"])('i', { 'class': 'far fa-folder' + (categoryView[subcat.groupno] ? '-open' : '') + ' mr-1' }),
                                                    subcat.name,
                                                    ' ',
                                                    treeBranch_isConsumerWeb(subcat),
                                                    ' ',
                                                    treeBranch_isDealerWeb(subcat),
                                                    subcat.count && Object(preact_min["h"])(
                                                        'span',
                                                        { 'class': 'font-weight-lighter float-right' },
                                                        '(',
                                                        subcat.count,
                                                        ')'
                                                    )
                                                )
                                            )
                                        );
                                    })
                                )
                            );
                        })
                    )
                );
            })
        );
    };

    return CategoryBranch;
}(preact_min["Component"])) || products_treeBranch__class;

/* harmony default export */ var products_treeBranch = (products_treeBranch_CategoryBranch);
// CONCATENATED MODULE: ./components/products/tree.js





var products_tree__class, products_tree__class2, products_tree__class3, products_tree__class4, products_tree__temp, products_tree__initialiseProps;









var products_tree_initialState = {};

var products_tree_BrandLine = Object(index_module["a" /* observer */])(products_tree__class = function (_Component) {
    inherits_default()(BrandLine, _Component);

    function BrandLine() {
        classCallCheck_default()(this, BrandLine);

        return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }

    BrandLine.prototype.render = function render() {
        var _props = this.props,
            stores = _props.stores,
            brand = _props.brand,
            queryFilter = _props.queryFilter,
            onClickBrand = _props.onClickBrand;

        var isSelectedBrand = queryFilter.brand === brand.brandno;
        return Object(preact_min["h"])(
            'div',
            { 'class': 'nav-item' },
            Object(preact_min["h"])(
                'div',
                { 'class': products_style_default.a.pointerCursor + ' nav-link py-0 ' + (isSelectedBrand ? 'active' : '') },
                Object(preact_min["h"])(
                    'span',
                    { onClick: function onClick() {
                            return onClickBrand(brand.brandno);
                        } },
                    brand.name,
                    brand.count && Object(preact_min["h"])(
                        'span',
                        { 'class': 'font-weight-lighter float-right' },
                        '(',
                        brand.count,
                        ')'
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'd-' + (isSelectedBrand ? 'block' : 'none') + ' nav flex-column mt-1' },
                Object(preact_min["h"])(products_treeBranch, { stores: stores, brand: brand.brandno })
            )
        );
    };

    return BrandLine;
}(preact_min["Component"])) || products_tree__class;

var products_tree_BrandList = Object(index_module["a" /* observer */])(products_tree__class2 = function (_Component2) {
    inherits_default()(BrandList, _Component2);

    function BrandList() {
        classCallCheck_default()(this, BrandList);

        return possibleConstructorReturn_default()(this, _Component2.apply(this, arguments));
    }

    BrandList.prototype.render = function render() {
        var _props2 = this.props,
            stores = _props2.stores,
            brands = _props2.brands,
            queryFilter = _props2.queryFilter,
            onClickBrand = _props2.onClickBrand;

        return Object(preact_min["h"])(
            'div',
            null,
            brands.map(function (brand) {
                return Object(preact_min["h"])(products_tree_BrandLine, { stores: stores, brand: brand, queryFilter: queryFilter, onClickBrand: onClickBrand });
            })
        );
    };

    return BrandList;
}(preact_min["Component"])) || products_tree__class2;

var products_tree_CategoryTree = Object(index_module["a" /* observer */])(products_tree__class3 = (products_tree__temp = products_tree__class4 = function (_Component3) {
    inherits_default()(CategoryTree, _Component3);

    function CategoryTree(props) {
        classCallCheck_default()(this, CategoryTree);

        var _this3 = possibleConstructorReturn_default()(this, _Component3.call(this, props));

        products_tree__initialiseProps.call(_this3);

        _this3.state = extends_default()({}, products_tree_initialState);

        var _this3$props$stores = _this3.props.stores,
            categoryStore = _this3$props$stores.categoryStore,
            brandStore = _this3$props$stores.brandStore,
            productStore = _this3$props$stores.productStore;

        categoryStore.tree();

        brandStore.resetQueryFilter();
        brandStore.load();

        categoryStore.toggleQueryfilter('brand', productStore.queryFilter.brand, { setValue: true, skipUpdate: true });
        categoryStore.tree();

        brandStore.resetQueryFilter();
        brandStore.load();
        return _this3;
    }

    CategoryTree.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var _props$stores = props.stores,
            brandStore = _props$stores.brandStore,
            productStore = _props$stores.productStore;
        var brands = brandStore.brands;
        var queryFilter = productStore.queryFilter;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'nav flex-column nav-pills' },
            Object(preact_min["h"])(products_tree_BrandList, { stores: this.props.stores, brands: brands, queryFilter: queryFilter, onClickBrand: this.onClickBrand })
        );
    };

    return CategoryTree;
}(preact_min["Component"]), products_tree__initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.onClickBrand = function (brandno) {
        var _props$stores2 = _this4.props.stores,
            categoryStore = _props$stores2.categoryStore,
            productStore = _props$stores2.productStore;

        productStore.toggleQueryfilter('mainCat', '', { setValue: 1, skipUpdate: 1 });
        productStore.toggleQueryfilter('intCat', '', { setValue: 1, skipUpdate: 1 });
        productStore.toggleQueryfilter('subCat', '', { setValue: 1, skipUpdate: 1 });
        categoryStore.toggleQueryfilter('brand', brandno, { setValue: true });
        productStore.toggleQueryfilter('brand', brandno, { setValue: true });
    };
}, products_tree__temp)) || products_tree__class3;

/* harmony default export */ var products_tree = (products_tree_CategoryTree);
// CONCATENATED MODULE: ./components/products/nav.js






var products_nav__ref = Object(preact_min["h"])('br', null);

function nav_CategoryNav(props) {
    var _props$stores = props.stores,
        productStore = _props$stores.productStore,
        categoryStore = _props$stores.categoryStore,
        brandStore = _props$stores.brandStore;
    var queryFilter = productStore.queryFilter,
        total = productStore.total,
        view = productStore.view;
    var brands = brandStore.brands;


    return Object(preact_min["h"])(
        'div',
        null,
        Object(preact_min["h"])(
            'small',
            { 'class': 'text-muted font-weight-lighter float-right mr-2' },
            'Total: ',
            total,
            products_nav__ref
        ),
        Object(preact_min["h"])(
            'div',
            { 'class': 'btn-group mr-2', role: 'group' },
            Object(preact_min["h"])(
                'button',
                { id: 'btnGroupBrand', type: 'button', 'class': 'btn btn-sm btn-' + (queryFilter.brand ? 'success' : 'outline-secondary') + ' dropdown-toggle',
                    'data-toggle': 'dropdown', 'aria-haspopup': 'true', 'aria-expanded': 'false',
                    onClick: function onClick() {
                        return productStore.toggleView('brands');
                    }
                },
                'Brands: ',
                queryFilter.brand ? queryFilter.brand : 'All'
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'dropdown-menu ' + (view.brands ? 'show' : 'hide'), 'aria-labelledby': 'btnGroupBrand' },
                brands.map(function (brand) {
                    return Object(preact_min["h"])(
                        'div',
                        { 'class': 'dropdown-item ' + products_style_default.a.pointerCursor,
                            onClick: function onClick() {
                                categoryStore.toggleQueryfilter('brand', brand.brandno, { setValue: true, toggle: function toggle() {
                                        return categoryStore.toggleView('brands');
                                    } });
                                productStore.toggleQueryfilter('mainCat', '', { setValue: 1, skipUpdate: 1 });
                                productStore.toggleQueryfilter('intCat', '', { setValue: 1, skipUpdate: 1 });
                                productStore.toggleQueryfilter('subCat', '', { setValue: 1, skipUpdate: 1 });
                                productStore.toggleQueryfilter('brand', brand.brandno, { setValue: true, toggle: function toggle() {
                                        return productStore.toggleView('brands');
                                    } });
                            }
                        },
                        brand.name
                    );
                })
            )
        ),
        Object(preact_min["h"])(
            'div',
            { 'class': 'btn-group mr-2', role: 'group' },
            Object(preact_min["h"])(
                'button',
                { id: 'btnGroupTranslationsImproved', type: 'button', 'class': 'btn btn-sm btn-' + (queryFilter.translationsImproved ? 'success' : 'outline-secondary') + ' dropdown-toggle',
                    'data-toggle': 'dropdown', 'aria-haspopup': 'true', 'aria-expanded': 'false',
                    onClick: function onClick() {
                        return productStore.toggleView('translationsImproved');
                    }
                },
                'Improved translations: ',
                queryFilter.translationsImproved ? queryFilter.translationsImproved : 'None'
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'dropdown-menu ' + (view.translationsImproved ? 'show' : 'hide'), 'aria-labelledby': 'btnGroupTranslationsImproved' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'dropdown-item ' + products_style_default.a.pointerCursor,
                        onClick: function onClick() {
                            return productStore.toggleQueryfilter('translationsImproved', '', { setValue: true, toggle: function toggle() {
                                    return productStore.toggleView('translationsImproved');
                                } });
                        }
                    },
                    'Clear'
                ),
                ['de', 'en', 'fr', 'it', 'no'].map(function (el) {
                    return Object(preact_min["h"])(
                        'div',
                        { 'class': 'dropdown-item ' + products_style_default.a.pointerCursor,
                            onClick: function onClick() {
                                return productStore.toggleQueryfilter('translationsImproved', el, {
                                    setValue: true, toggle: function toggle() {
                                        return productStore.toggleView('translationsImproved');
                                    }
                                });
                            } },
                        el
                    );
                })
            )
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.showOnConsumerWeb),
                onClick: function onClick() {
                    return productStore.toggleQueryfilter('showOnConsumerWeb', util.cyclevalues(queryFilter.showOnConsumerWeb, [null, 1, 0]), { setValue: 1 });
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.showOnConsumerWeb ? 'on' : 'off') + ' mr-1' }),
            'CW'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.showonwebyesno),
                onClick: function onClick() {
                    return productStore.toggleQueryfilter('showonwebyesno', util.cyclevalues(queryFilter.showonwebyesno, [null, 1, 0]), { setValue: 1 });
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.showonwebyesno ? 'on' : 'off') + ' mr-1' }),
            'DW'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.isNew),
                onClick: function onClick() {
                    return productStore.toggleQueryfilter('isNew', util.cyclevalues(queryFilter.isNew, [null, 1, 0]), { setValue: 1 });
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.isNew ? 'on' : 'off') + ' mr-1' }),
            'New'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.preSale),
                onClick: function onClick() {
                    return productStore.toggleQueryfilter('preSale', util.cyclevalues(queryFilter.preSale, [null, 1, 0]), { setValue: 1 });
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.preSale ? 'on' : 'off') + ' mr-1' }),
            'PS'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.preSaleNew),
                onClick: function onClick() {
                    return productStore.toggleQueryfilter('preSaleNew', util.cyclevalues(queryFilter.preSaleNew, [null, 1, 0]), { setValue: 1 });
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.preSaleNew ? 'on' : 'off') + ' mr-1' }),
            'PS New'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.hasDescription),
                onClick: function onClick() {
                    return productStore.toggleQueryfilter('hasDescription', util.cyclevalues(queryFilter.hasDescription, [null, 1, 0]), { setValue: 1 });
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.hasDescription ? 'on' : 'off') + ' mr-1' }),
            'Has desc'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.hasFeatures),
                onClick: function onClick() {
                    return productStore.toggleQueryfilter('hasFeatures', util.cyclevalues(queryFilter.hasFeatures, [null, 1, 0]), { setValue: 1 });
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.hasFeatures ? 'on' : 'off') + ' mr-1' }),
            'Has feat'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.hasTech),
                onClick: function onClick() {
                    return productStore.toggleQueryfilter('hasTech', util.cyclevalues(queryFilter.hasTech, [null, 1, 0]), { setValue: 1 });
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.hasTech ? 'on' : 'off') + ' mr-1' }),
            'Has tech'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.hasCare),
                onClick: function onClick() {
                    return productStore.toggleQueryfilter('hasCare', util.cyclevalues(queryFilter.hasCare, [null, 1, 0]), { setValue: 1 });
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.hasCare ? 'on' : 'off') + ' mr-1' }),
            'Has care'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.hasHowtouse),
                onClick: function onClick() {
                    return productStore.toggleQueryfilter('hasHowtouse', util.cyclevalues(queryFilter.hasHowtouse, [null, 1, 0]), { setValue: 1 });
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.hasHowtouse ? 'on' : 'off') + ' mr-1' }),
            'Has howto'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + (queryFilter.ratings ? 'btn-success' : 'btn-outline-secondary'),
                onClick: function onClick() {
                    return productStore.toggleQueryfilter('ratings');
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.ratings ? 'on' : 'off') + ' mr-1' }),
            'Has ratings'
        ),
        Object(preact_min["h"])(
            'button',
            { 'class': 'mr-2 btn btn-sm ' + (queryFilter.showall ? 'btn-success' : 'btn-outline-secondary'),
                onClick: function onClick() {
                    return productStore.toggleQueryfilter('showall');
                }
            },
            Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.showall ? 'on' : 'off') + ' mr-1' }),
            'Show all'
        ),
        Object(preact_min["h"])(
            'span',
            { 'class': 'float-left form-row align-items-center mr-5' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'col-auto' },
                Object(preact_min["h"])('input', { type: 'text', 'class': 'form-control form-control-sm', id: 'inlineFormInputName', placeholder: 'Search for products...',
                    onInput: function onInput(e) {
                        return productStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true });
                    },
                    value: queryFilter.search
                })
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'col-auto' },
                Object(preact_min["h"])(
                    'button',
                    { type: 'button', 'class': 'btn btn-sm btn-primary', onClick: function onClick() {
                            return productStore.list();
                        } },
                    'Search'
                )
            )
        )
    );
}

/* harmony default export */ var products_nav = (nav_CategoryNav);
// CONCATENATED MODULE: ./components/products/list.js







var products_list__class, products_list__class3, products_list__class4, list__class5, list__temp2, products_list__initialiseProps;




// import VirtualList from 'preact-virtual-list';









var products_list_initialState = {
    height: 100,
    windowHeight: 0,
    loading: false,
    view: {
        brands: false,
        languages: false,
        products: false
    }
};

function DescriptionIcon(props) {
    return Object(preact_min["h"])('i', {
        className: 'mr-1 ' + props.icon + '\n                text-' + (props.value ? 'success' : 'secondary'),
        title: props.value ? props.text : 'No ' + props.text
    });
}

function getAvailabilityBadge(availability) {
    var avail = '' + availability;
    if (avail.match(/yes/i)) {
        return 'success';
    }
    if (avail.match(/^\d+\+?$/i)) {
        return 'success';
    }
    if (avail.match(/\d{2}\.\d{2}/)) {
        return 'warning';
    }
    return 'danger';
}

var reducer = function reducer(accumulator, current) {
    return accumulator + current[1];
};

var products_list__ref = Object(preact_min["h"])('br', null);

var products_list__ref2 = Object(preact_min["h"])('i', { 'class': 'fas fa-globe-europe' });

var products_list__ref3 = Object(preact_min["h"])('br', null);

var products_list__ref4 = Object(preact_min["h"])('br', null);

var products_list__ref5 = Object(preact_min["h"])('i', { 'class': 'fas fa-sign-in-alt ml-1' });

var products_list__ref6 = Object(preact_min["h"])('i', { 'class': 'fas fa-sign-out-alt ml-1' });

var list_ProductTableLine = Object(index_module["a" /* observer */])(products_list__class = function (_Component) {
    inherits_default()(ProductTableLine, _Component);

    function ProductTableLine() {
        var _temp, _this, _ret;

        classCallCheck_default()(this, ProductTableLine);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.imageServer = util.getImageServer(), _this.updateLineField = function (e) {
            // console.log('updateLineField:', e);
            var updateField = _this.props.updateField;
            var params = e.target.dataset.params;

            var inputParams = JSON.parse(params || {});
            var id = inputParams.id,
                field = inputParams.field;
            var value = e.target.value;

            updateField(id, field, value);
        }, _this.saveLineField = function (e) {
            // console.log('saveField:', e);
            var saveField = _this.props.saveField;
            var params = e.target.dataset.params;

            var inputParams = JSON.parse(params || {});
            var id = inputParams.id,
                field = inputParams.field,
                updatememory = inputParams.updatememory,
                value = inputParams.value;

            saveField(id, field, value, updatememory);
        }, _temp), possibleConstructorReturn_default()(_this, _ret);
    }

    ProductTableLine.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            product = _props.product,
            saved = _props.saved;

        return Object(preact_min["h"])(
            'tr',
            { 'class': '' + products_style_default.a.tableline },
            Object(preact_min["h"])(
                'td',
                null,
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'mb-1' },
                    product.articleno
                )
            ),
            Object(preact_min["h"])(
                'td',
                { 'class': 'text-center' },
                Object(preact_min["h"])(
                    'a',
                    { href: '/products/' + encodeURIComponent(product.articleno) + '/Basics' },
                    product.images.small && Object(preact_min["h"])('img', { 'class': 'rounded', src: product.images.small })
                ),
                Object(preact_min["h"])(
                    'div',
                    null,
                    product.imgs && Object.keys(product.imgs).filter(function (i) {
                        return i > 1;
                    }).map(function (imgKey) {
                        return Object(preact_min["h"])(
                            'span',
                            null,
                            Object(preact_min["h"])('img', {
                                'class': 'rounded mr-1',
                                src: _this2.imageServer + '/' + util.getImageSrc(product.imgs[imgKey], '80x80', imgKey),
                                style: 'height: 20px; max-width: 20px;'
                            })
                        );
                    })
                )
            ),
            Object(preact_min["h"])(
                'td',
                null,
                Object(preact_min["h"])(
                    'a',
                    { href: '/products/' + encodeURIComponent(product.articleno) + '/Basics' },
                    product.nameDisplay,
                    products_list__ref
                ),
                Object.keys(product.translations || {}).filter(function (e) {
                    return e.length === 2;
                }).map(function (lang) {
                    return Object(preact_min["h"])(
                        'small',
                        { className: 'ml-2 text-muted font-weight-lighter' },
                        products_list__ref2,
                        ' ',
                        lang,
                        Object.keys(product.translations[lang] || {}).map(function (field) {
                            return Object(preact_min["h"])(
                                'span',
                                null,
                                Object.keys(product.translations[lang][field].suggestions || {}).map(function (suggestion) {
                                    return Object(preact_min["h"])(
                                        'span',
                                        { 'class': 'text-danger ml-1' },
                                        field,
                                        ': ',
                                        suggestion
                                    );
                                })
                            );
                        })
                    );
                }),
                product.avg > 0 && Object(preact_min["h"])(
                    'div',
                    null,
                    Object(preact_min["h"])(
                        'small',
                        { className: 'ml-2 text-warning font-weight-lighter' },
                        [1, 2, 3, 4, 5].map(function (score) {
                            return Object(preact_min["h"])('i', { 'class': (product.avg >= score ? 'fas' : 'far') + ' fa-star' });
                        }),
                        ' (',
                        product.avgTot,
                        ')'
                    )
                ),
                Object(preact_min["h"])(
                    'div',
                    null,
                    Object(preact_min["h"])(
                        'small',
                        null,
                        product.introYear
                    )
                )
            ),
            Object(preact_min["h"])(
                'td',
                null,
                Object(preact_min["h"])(
                    'small',
                    { 'class': 'float-right' },
                    Object(preact_min["h"])(
                        'span',
                        {
                            className: 'mr-1 badge\n                                badge-' + (product.showonwebyesno === 1 ? 'success' : 'danger'),
                            title: 'DealerWeb' },
                        'DW'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        {
                            className: 'mr-1 badge\n                                badge-' + (product.showOnConsumerWeb === 1 ? 'success' : 'danger'),
                            title: 'ConsumerWeb' },
                        'CW'
                    ),
                    product.is_new ? Object(preact_min["h"])(
                        'span',
                        { className: 'mr-1 badge badge-primary' },
                        'New'
                    ) : '',
                    product.preSale ? Object(preact_min["h"])(
                        'span',
                        { className: 'mr-1 badge badge-secondary' },
                        'PS'
                    ) : '',
                    product.is_discontinued && Object(preact_min["h"])(
                        'span',
                        { className: 'mr-1 badge badge-warning' },
                        'Discontinued'
                    )
                ),
                Object(preact_min["h"])(
                    'a',
                    { href: '/products/' + encodeURIComponent(product.articleno) + '/Basics' },
                    product.name,
                    products_list__ref3
                ),
                Object(preact_min["h"])(
                    'span',
                    { 'class': 'float-right' },
                    Object(preact_min["h"])(
                        'small',
                        { className: 'text-muted' },
                        product.dealerCurrency
                    ),
                    '\xA0',
                    Object(preact_min["h"])(
                        'nobr',
                        null,
                        util.format(product.dealerPrice, 2, ',', ' ')
                    )
                ),
                Object(preact_min["h"])(
                    'small',
                    null,
                    Object(preact_min["h"])(
                        'span',
                        { className: 'text-primary' },
                        product.mainCategory
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { className: 'text-success' },
                        product.intermediateCategory ? ' / ' + product.intermediateCategory : ''
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { className: 'text-danger' },
                        product.subCategory ? ' / ' + product.subCategory : ''
                    ),
                    products_list__ref4,
                    Object(preact_min["h"])(
                        'span',
                        { 'class': 'float-right' },
                        'Retail price:',
                        Object(preact_min["h"])(
                            'small',
                            { className: 'text-muted ml-2' },
                            product.retailCurrency
                        ),
                        '\xA0',
                        Object(preact_min["h"])(
                            'nobr',
                            null,
                            util.format(product.retailPrice, 2, ',', ' ')
                        )
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { className: 'text-muted' },
                        Object(preact_min["h"])(DescriptionIcon, {
                            icon: 'fas fa-info-circle',
                            value: product.description,
                            text: 'Description'
                        }),
                        Object(preact_min["h"])(DescriptionIcon, {
                            icon: 'fas fa-tools',
                            value: product.features,
                            text: 'Features'
                        }),
                        Object(preact_min["h"])(DescriptionIcon, {
                            icon: 'fas fa-robot',
                            value: product.tech,
                            text: 'Tech'
                        }),
                        Object(preact_min["h"])(DescriptionIcon, {
                            icon: 'fas fa-stethoscope',
                            value: product.care,
                            text: 'Care'
                        }),
                        Object(preact_min["h"])(DescriptionIcon, {
                            icon: 'fas fa-people-carry',
                            value: product.howtouse,
                            text: 'How-to-use'
                        }),
                        Object(preact_min["h"])(DescriptionIcon, {
                            icon: 'fab fa-youtube',
                            value: product.youtubeEUR,
                            text: 'Youtube'
                        })
                    )
                )
            ),
            Object(preact_min["h"])(
                'td',
                { 'class': 'text-center' },
                Object(preact_min["h"])(
                    'span',
                    { className: 'mr-1 badge\n                        badge-' + getAvailabilityBadge(product.availability) },
                    product.availability
                )
            ),
            Object(preact_min["h"])(
                'td',
                { 'class': 'text-right' },
                product.unitsInStock,
                Object(preact_min["h"])(
                    'small',
                    null,
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'text-success' },
                        Array.isArray(product.supplierOrderLines) && Object(preact_min["h"])(
                            'span',
                            null,
                            product.supplierOrderLines.reduce(reducer, 0),
                            products_list__ref5
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'text-danger' },
                        Array.isArray(product.customerOrderLines) && Object(preact_min["h"])(
                            'span',
                            null,
                            product.customerOrderLines.reduce(reducer, 0),
                            products_list__ref6
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'td',
                { 'class': 'text-right' },
                Object(preact_min["h"])(input, {
                    id: product.id,
                    className: 'text-right form-control-sm',
                    isValid: saved['sort.' + product.id],
                    name: 'sort',
                    value: product.sort,
                    dataParams: JSON.stringify({
                        id: product.id,
                        field: 'sort'
                    }),
                    onInput: this.updateLineField,
                    hideHelp: 1
                })
            ),
            Object(preact_min["h"])(
                'td',
                { 'class': 'text-center' },
                Object(preact_min["h"])(
                    'span',
                    {
                        'class': 'mr-1 badge ' + products_style_default.a.pointerCursor + ' badge-' + (product.offline === 1 ? 'success' : 'danger')
                        // onClick={() => saveField(product.id, `offline`, product.offline === 1 ? 0 : 1, true)}
                        , 'data-params': JSON.stringify({
                            id: product.id,
                            field: 'offline',
                            value: product.offline === 1 ? 0 : 1,
                            updatememory: 1
                        }),
                        onClick: this.saveLineField
                    },
                    '\xA0',
                    Object(preact_min["h"])('i', { 'class': 'fas fa-trash' + (product.offline === 1 ? '-restore' : '') }),
                    ' ',
                    product.offline === 1 ? 'Restore' : 'Delete'
                )
            )
        );
    };

    return ProductTableLine;
}(preact_min["Component"])) || products_list__class;

var products_list__ref7 = Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle' });

var products_list__ref8 = Object(preact_min["h"])(
    'th',
    { style: 'width: 5%', 'class': 'text-center' },
    'Image'
);

var list_ProductTable = Object(index_module["a" /* observer */])(products_list__class3 = function (_Component2) {
    inherits_default()(ProductTable, _Component2);

    function ProductTable() {
        classCallCheck_default()(this, ProductTable);

        return possibleConstructorReturn_default()(this, _Component2.apply(this, arguments));
    }

    ProductTable.prototype.render = function render() {
        var _props2 = this.props,
            products = _props2.products,
            saved = _props2.saved,
            saveField = _props2.saveField,
            updateField = _props2.updateField,
            productStore = _props2.productStore;

        return Object(preact_min["h"])(
            'table',
            { 'class': products_style_default.a.table + ' table table-striped table-sm table-borderless' },
            Object(preact_min["h"])(
                'thead',
                null,
                productStore.sort !== productStore.defaultSort && Object(preact_min["h"])(
                    'tr',
                    null,
                    Object(preact_min["h"])(
                        'th',
                        { colspan: '8' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': products_style_default.a.pointerCursor + ' mr-2 badge badge-pill badge-secondary', onClick: function onClick() {
                                    return productStore.resetSort();
                                } },
                            products_list__ref7,
                            ' Reset sort'
                        )
                    )
                ),
                Object(preact_min["h"])(
                    'tr',
                    null,
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 5%' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': products_style_default.a.pointerCursor, onClick: function onClick() {
                                    return productStore.toggleSort('articleno', '-');
                                } },
                            'Article# ',
                            util.getSortIcon('articleno', productStore.sort)
                        )
                    ),
                    products_list__ref8,
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 20%' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': products_style_default.a.pointerCursor, onClick: function onClick() {
                                    return productStore.toggleSort('nameDisplay', '');
                                } },
                            'NameDisplay ',
                            util.getSortIcon('nameDisplay', productStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 50%' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': products_style_default.a.pointerCursor, onClick: function onClick() {
                                    return productStore.toggleSort('name', '');
                                } },
                            'Name ',
                            util.getSortIcon('name', productStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 5%', 'class': 'text-center' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': products_style_default.a.pointerCursor, onClick: function onClick() {
                                    return productStore.toggleSort('availability', '-');
                                } },
                            'Availability ',
                            util.getSortIcon('availability', productStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 5%', 'class': 'text-right' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': products_style_default.a.pointerCursor, onClick: function onClick() {
                                    return productStore.toggleSort('unitsInStock', '-');
                                } },
                            'In stock ',
                            util.getSortIcon('unitsInStock', productStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 5%', 'class': 'text-right' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': products_style_default.a.pointerCursor, onClick: function onClick() {
                                    return productStore.toggleSort('sort', '');
                                } },
                            'Sort ',
                            util.getSortIcon('sort', productStore.sort)
                        )
                    ),
                    Object(preact_min["h"])(
                        'th',
                        { style: 'width: 5%', 'class': 'text-center' },
                        Object(preact_min["h"])(
                            'span',
                            { 'class': products_style_default.a.pointerCursor, onClick: function onClick() {
                                    return productStore.toggleSort('offline', '-');
                                } },
                            'Online ',
                            util.getSortIcon('offline', productStore.sort)
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'tbody',
                null,
                products && products.map(function (product) {
                    return Object(preact_min["h"])(list_ProductTableLine, {
                        product: product,
                        saved: saved,
                        saveField: saveField,
                        updateField: updateField
                    });
                })
            )
        );
    };

    return ProductTable;
}(preact_min["Component"])) || products_list__class3;

var products_list__ref10 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var products_list__ref11 = Object(preact_min["h"])(
    'h1',
    null,
    Object(preact_min["h"])('i', { 'class': 'fas fa-search' }),
    ' Search results'
);

var products_list__ref12 = Object(preact_min["h"])('br', null);

var products_list__ref13 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var products_list__ref14 = Object(preact_min["h"])(
    'div',
    { 'class': 'row' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'col-12 text-center' },
        Object(preact_min["h"])(
            'div',
            { 'class': 'spinner-border text-success', role: 'status' },
            Object(preact_min["h"])(
                'span',
                { 'class': 'sr-only' },
                'Loading...'
            )
        )
    )
);

var products_list__ref15 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var list_ProductList = Object(index_module["a" /* observer */])(products_list__class4 = (list__temp2 = list__class5 = function (_Component3) {
    inherits_default()(ProductList, _Component3);

    function ProductList(props) {
        classCallCheck_default()(this, ProductList);

        var _this4 = possibleConstructorReturn_default()(this, _Component3.call(this, props));

        products_list__initialiseProps.call(_this4);

        _this4.state = extends_default()({}, products_list_initialState);
        _this4.updateTimer = {};

        var productStore = _this4.props.stores.productStore;

        productStore.load();
        _this4.subscriptions();
        return _this4;
    }

    ProductList.prototype.subscriptions = function subscriptions() {
        var _this5 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this5.setState({ height: height });
        });
    };

    ProductList.prototype.doUpdateField = function () {
        var _ref9 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(id, field, value) {
            var productStore;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            productStore = this.props.stores.productStore;
                            _context.next = 3;
                            return productStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref9.apply(this, arguments);
        }

        return doUpdateField;
    }();

    ProductList.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    ProductList.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    ProductList.prototype.render = function render() {
        var _state = this.state,
            loading = _state.loading,
            height = _state.height;
        var productStore = this.props.stores.productStore;
        var products = productStore.products,
            queryFilter = productStore.queryFilter,
            saved = productStore.saved;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(products_nav, this.props)
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-2 fixed-top overflow-auto',
                        style: 'margin-top: ' + (height + 60) + 'px; height: calc(100% - ' + (height + 60) + 'px);'
                    },
                    Object(preact_min["h"])(
                        'small',
                        null,
                        Object(preact_min["h"])(products_tree, this.props)
                    ),
                    products_list__ref10
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-10 offset-2' },
                    Object(preact_min["h"])(
                        'div',
                        null,
                        queryFilter.search && Object(preact_min["h"])(
                            'div',
                            { 'class': 'w-100 text-left mt-2 mb-5' },
                            products_list__ref11,
                            'Found ',
                            productStore.total || 0,
                            ' results in your search for "',
                            queryFilter.search,
                            '".',
                            products_list__ref12,
                            Object(preact_min["h"])(
                                'button',
                                { 'class': 'btn btn-sm btn-warning mt-2',
                                    onClick: function onClick() {
                                        return productStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true });
                                    }
                                },
                                products_list__ref13,
                                ' Reset search'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'table-responsive' },
                            Object(preact_min["h"])(list_ProductTable, {
                                products: products,
                                saved: saved,
                                saveField: this.saveField,
                                updateField: this.updateField,
                                productStore: productStore
                            })
                        )
                    )
                )
            ),
            loading && products_list__ref14,
            products_list__ref15
        );
    };

    return ProductList;
}(preact_min["Component"]), products_list__initialiseProps = function _initialiseProps() {
    var _this6 = this;

    this.handleScroll = function () {
        var loading = _this6.state.loading;
        var productStore = _this6.props.stores.productStore;
        var totalAppend = productStore.totalAppend,
            limit = productStore.limit;

        if (window.innerHeight + document.documentElement.scrollTop + 500 < document.documentElement.offsetHeight) return;
        if (loading) return;

        var offset = productStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(_this6.scrollLoader);
            _this6.scrollLoader = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                return regenerator_default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this6.setState({ loading: true });
                                productStore.updateOffset(offset);
                                _context2.next = 4;
                                return productStore.list(true);

                            case 4:
                                _this6.setState({ loading: false });

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this6);
            })), 500);
        }
    };

    this.updateField = function () {
        var _ref17 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(id, field, value) {
            var productStore, timerId;
            return regenerator_default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            productStore = _this6.props.stores.productStore;

                            productStore.updateField(id, field, value);

                            timerId = field + '-' + id;

                            clearTimeout(_this6.updateTimer[timerId]);
                            _this6.updateTimer[timerId] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                                return regenerator_default.a.wrap(function _callee3$(_context3) {
                                    while (1) {
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                _this6.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context3.stop();
                                        }
                                    }
                                }, _callee3, _this6);
                            })), 500);

                        case 5:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this6);
        }));

        return function (_x4, _x5, _x6) {
            return _ref17.apply(this, arguments);
        };
    }();

    this.saveField = function () {
        var _ref19 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(id, field, value, updatememory) {
            var productStore;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            productStore = _this6.props.stores.productStore;

                            productStore.saveField(id, field, value, updatememory);

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this6);
        }));

        return function (_x7, _x8, _x9, _x10) {
            return _ref19.apply(this, arguments);
        };
    }();
}, list__temp2)) || products_list__class4;

/* harmony default export */ var products_list = (list_ProductList);
// CONCATENATED MODULE: ./components/products/index.js




var products__class;









var products_initialState = {
    height: 100
};

var products_Product = Object(index_module["a" /* observer */])(products__class = function (_Component) {
    inherits_default()(Product, _Component);

    function Product(props) {
        classCallCheck_default()(this, Product);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = products_initialState;
        _this.subscriptions();
        return _this;
    }

    Product.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    Product.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(products_list, props)
                )
            )
        );
    };

    return Product;
}(preact_min["Component"])) || products__class;

/* harmony default export */ var components_products = (products_Product);
// CONCATENATED MODULE: ./components/products/edit.js







var products_edit__class, products_edit__class2, products_edit__temp, products_edit__initialiseProps;
















var products_edit_initialState = {
    height: 100
};

var products_edit_FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    articleno: { label: 'Articleno #', type: 'text', readonly: true, help: 'Field is imported from Visma: "ArticleNo" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    name: { label: 'Product name', type: 'text', readonly: true, help: 'Field is imported from Visma: "Name" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    nameDisplay: { label: 'Product webname', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrWebName" via new Visma SQL -> S3 -> Lambda -> API. File "consumerweb_products.csv"' },
    brand: { label: 'Brand', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrBRAND" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    vismaBrand: { label: 'Visma Brand', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrBRAND" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    brandno: { label: 'Brandno', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    itemCategory: { label: 'Item category', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrCategory" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    productGroup: { label: 'Product group', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrProductGroup" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    group: { label: 'Group', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    link: { label: 'Link to the dealerweb', type: 'text', readonly: true, help: 'Field is generated by the DealerWeb system.' },

    mainCategory: { label: 'Main category', type: 'text', readonly: true, aliasFor: 'maingroupname', help: 'Field is imported from Visma\'s maingroup table and related via: "MainGroupNo"' },
    intermediateCategory: { label: 'Intermediate category', type: 'text', readonly: true, aliasFor: 'intermediategroupname', help: 'Field is imported from Visma\'s intermediategroup table and related via: "IntermediateGroupNo"' },
    subCategory: { label: 'Sub category', type: 'text', readonly: true, aliasFor: 'subgroupname', help: 'Field is imported from Visma\'s subgroup table and related via: "SubGroupNo"' },

    maingroupname: { label: 'Maingroup name', type: 'text', readonly: true, help: 'Field is imported from Visma\'s maingroup table and related via: "MainGroupNo"' },
    maingroupno: { label: 'Maingroup #', type: 'text', readonly: true, help: 'Field is imported from Visma: "MainGroupNo" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    maingroupid: { label: 'Maingroup id', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    maingroupsort: { label: 'Maingroup sort', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },

    intermediategroupname: { label: 'Intermediategroup name', type: 'text', readonly: true, help: 'Field is imported from Visma\'s intermediategroup table and related via: "IntermediateGroupNo"' },
    intermediategroupno: { label: 'Intermediategroup #', type: 'text', readonly: true, help: 'Field is imported from Visma: "IntermediateGroupNo" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    intermediategroupid: { label: 'Intermediategroup id', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    intermediategroupsort: { label: 'Intermediategroup sort', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },

    subgroupname: { label: 'Subgroup name', type: 'text', readonly: true, help: 'Field is imported from Visma\'s subgroup table and related via: "SubGroupNo"' },
    subgroupno: { label: 'Subgroup #', type: 'text', readonly: true, help: 'Field is imported from Visma: "SubGroupNo" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    subgroupid: { label: 'Subgroup id', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    subgroupsort: { label: 'Subgroup sort', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },

    showonwebyesno: { label: 'Show on web', type: 'text', readonly: true, help: 'Field is imported from Visma: "ShowOnWebYesNo" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    showOnConsumerWeb: { label: 'Show on ConsumerWeb', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrConsumerWeb" via new Visma SQL -> S3 -> Lambda -> API. File "consumerweb_products.csv"' },
    is_new: { label: 'Is new', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrNewDW" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    isActive: { label: 'Is active', type: 'text', readonly: true, help: 'Field is imported from Visma: "InActiveYesNo" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },

    sort: { label: 'Sort', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    tradeItemNumber: { label: 'Trade item number', type: 'text', readonly: true, aliasFor: 'globalTradeItemNumber', help: 'Field is imported from Visma: "EANNo" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    color: { label: 'Color', type: 'text', readonly: true, help: 'Field is imported from Visma\'s color table and related via: "ZUsrFarge"' },
    size: { label: 'Size', type: 'text', readonly: true, help: 'Field is imported from Visma\'s size table and related via: "ZUsrStorrelse"' },
    weight: { label: 'Weight', type: 'text', readonly: true, help: 'Field is imported from Visma: "Weight" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },

    packingWeight: { label: 'Packing Weight', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrPackingWeight" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    volume: { label: 'Volume', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrVolume" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },

    length: { label: 'Length', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrLength" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    width: { label: 'Width', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrWidth" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    height: { label: 'Height', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrHeight" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },

    countryOfOrigin: { label: 'Country of origin', type: 'text', readonly: true, help: 'Field is imported from Visma: "CountryOfOriginNo" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    commodityCode: { label: 'Commodity code', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrCommodityCode" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    availability: { label: 'Availability', type: 'text', readonly: true, help: 'Field is calculated from "unitsInStock", "supplierOrderLines" and "customerOrderLines"' },
    introYear: { label: 'Intro Year', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrIntroYear" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    unitsInStock: { label: 'Units in stock', type: 'text', readonly: true, help: 'Field is imported from Visma: "unitsInStock" via new Visma SQL -> S3 -> Lambda -> API. File "unitinstock.csv"' },
    supplierOrderLines: { label: 'Supplier order lines', type: 'array', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "supplierorderline.csv"' },
    customerOrderLines: { label: 'Customer order lines', type: 'array', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "customerorderline.csv"' },

    priceNOK: { label: 'Price NOK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    priceSEK: { label: 'Price SEK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    priceDKK: { label: 'Price DKK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    priceGBP: { label: 'Price GBP', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    priceEUR: { label: 'Price EUR', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    priceCHF: { label: 'Price CHF', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    pricelist: { label: 'Pricelist', type: 'object', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "PriceList.xml"' },
    pricelistCombo: { label: 'Pricelist combo', type: 'text', readonly: true, help: 'Field is DealerWeb only. Can be update via DealerWeb admin/multiple update.' },

    imgs: { label: 'Images', type: 'images', readonly: false, help: 'Field is DealerWeb only.' },

    description: { label: 'Description', type: 'textarea', readonly: false, rows: 5, help: 'Field is DealerWeb only.' },
    features: { label: 'Features', type: 'textarea', readonly: false, rows: 5, help: 'Field is DealerWeb only.' },
    tech: { label: 'Tech', type: 'textarea', readonly: false, rows: 5, help: 'Field is DealerWeb only.' },
    care: { label: 'Care', type: 'textarea', readonly: false, rows: 5, help: 'Field is DealerWeb only.' },
    howtouse: { label: 'Howto use', type: 'textarea', readonly: false, rows: 5, help: 'Field is DealerWeb only.' },

    descriptionHtml: { label: 'Description Html', type: 'textarea', readonly: true, rows: 5, help: 'Field is DealerWeb only.' },
    featuresHtml: { label: 'Features Html', type: 'textarea', readonly: true, rows: 5, help: 'Field is DealerWeb only.' },
    techHtml: { label: 'Tech Html', type: 'textarea', readonly: true, rows: 5, help: 'Field is DealerWeb only.' },
    careHtml: { label: 'Care Html', type: 'textarea', readonly: true, rows: 5, help: 'Field is DealerWeb only.' },
    howtouseHtml: { label: 'Howto use Html', type: 'textarea', readonly: true, rows: 5, help: 'Field is DealerWeb only.' },

    youtubeNOK: { label: 'Youtube NOK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtubeSEK: { label: 'Youtube SEK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtubeDKK: { label: 'Youtube DKK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtubeGBP: { label: 'Youtube GBP', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtubeEUR: { label: 'Youtube EUR', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtubeCHF: { label: 'Youtube CHF', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtube2NOK: { label: 'Youtube 2 NOK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtube2SEK: { label: 'Youtube 2 SEK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtube2DKK: { label: 'Youtube 2 DKK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtube2GBP: { label: 'Youtube 2 GBP', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtube2EUR: { label: 'Youtube 2 EUR', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtube2CHF: { label: 'Youtube 2 CHF', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtube3NOK: { label: 'Youtube 3 NOK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtube3SEK: { label: 'Youtube 3 SEK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtube3DKK: { label: 'Youtube 3 DKK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtube3GBP: { label: 'Youtube 3 GBP', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtube3EUR: { label: 'Youtube 3 EUR', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    youtube3CHF: { label: 'Youtube 3 CHF', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },

    preSale: { label: 'PreSale', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrPSWeb" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    preSaleNew: { label: 'PreSaleNew', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrNewPS" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    preSalePopular: { label: 'PreSalePopular', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrFocus" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    preSaleDiscontinued: { label: 'PreSaleDiscontinued', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrPSDiscontinued" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    psPriceNOK: { label: 'PS Price NOK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    psPriceSEK: { label: 'PS Price SEK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    psPriceDKK: { label: 'PS Price DKK', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    psPriceGBP: { label: 'PS Price GBP', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    psPriceEUR: { label: 'PS Price EUR', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    psPriceCHF: { label: 'PS Price CHF', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },

    retailCurrency: { label: 'Retail currency', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    retailPrice: { label: 'Same as priceNOK', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    linkConsumerWeb: { label: 'Link to the consumerweb', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },

    dealerCurrency: { label: 'Dealer Currency from dealer pricelist', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "PriceList.xml" and mapped with dealer pricelistno.' },
    dealerPrice: { label: 'Dealer price dealer pricelist', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "PriceList.xml" and mapped with dealer pricelistno.' },
    dealerEurPrice: { label: 'Price from EUR pricelist 5', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "PriceList.xml".' },
    apiLinkToProductGroup: { label: 'API Link to product', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    apiLinkToProductMainCategory: { label: 'API Link to product group', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },

    colorId: { label: 'Color ID', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrFarge" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    sizeId: { label: 'Size ID', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrStorrelse" via new Visma SQL -> S3 -> Lambda -> API. File "artikkel.csv"' },
    option_1: { label: 'Option 1', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrOptionI" via new Visma SQL -> S3 -> Lambda -> API. File "consumerweb_products.csv"' },
    option_1_name: { label: 'Option 1 name', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrOptionNameI" via new Visma SQL -> S3 -> Lambda -> API. File "consumerweb_products.csv"' },
    option_2: { label: 'Option 2', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrOptionII" via new Visma SQL -> S3 -> Lambda -> API. File "consumerweb_products.csv"' },
    option_2_name: { label: 'Option 2 name', type: 'text', readonly: true, help: 'Field is imported from Visma: "ZUsrOptionNameII" via new Visma SQL -> S3 -> Lambda -> API. File "consumerweb_products.csv"' },

    warehouse: { label: 'Warehouse', type: 'text', readonly: true, help: 'Field is imported from Visma: "Location" via new Visma SQL -> S3 -> Lambda -> API. File "consumerweb_products.csv"' },

    translations: { label: 'Translations', type: 'object', readonly: false, help: 'Google translations of the texts.' },
    ratings: { label: 'Ratings', type: 'object', readonly: true, help: 'Dealer ratings of the products.' }
    // subgroupsort: { label: 'Link', type: 'text', readonly: true, help: '' },
};

var edit__ref7 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var edit_ProductEdit = Object(index_module["a" /* observer */])(products_edit__class = (products_edit__temp = products_edit__class2 = function (_Component) {
    inherits_default()(ProductEdit, _Component);

    function ProductEdit(props) {
        var _this2 = this;

        classCallCheck_default()(this, ProductEdit);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        products_edit__initialiseProps.call(_this);

        _this.state = extends_default()({}, products_edit_initialState);
        _this.updateTimer = {};
        var _this$props$stores = _this.props.stores,
            articleStore = _this$props$stores.articleStore,
            categoryStore = _this$props$stores.categoryStore,
            productStore = _this$props$stores.productStore;
        // categoryStore.load(props.categoryid);
        // categoryStore.tree();

        productStore.load(encodeURIComponent(props.productid));
        _this.subscriptions();

        _this.fields = [{
            tabname: 'Basics',
            icon: 'fas fa-user-edit',
            fields: ['id', 'articleno', 'name', 'nameDisplay', 'brand', 'itemCategory', 'productGroup', 'group', 'link'].map(function (f) {
                return util.makeField(f, products_edit_FIELDS);
            })
        }, {
            tabname: 'Category',
            icon: 'fas fa-folder-open',
            fields: ['vismaBrand', 'brandno', 'mainCategory', 'intermediateCategory', 'subCategory', 'maingroupname', 'maingroupno', 'maingroupsort', 'intermediategroupname', 'intermediategroupno', 'intermediategroupsort', 'subgroupname', 'subgroupno', 'subgroupsort'].map(function (f) {
                return util.makeField(f, products_edit_FIELDS);
            })
        }, {
            tabname: 'Status',
            icon: 'fas fa-traffic-light',
            fields: ['showonwebyesno', 'showOnConsumerWeb', 'is_new', 'isActive'].map(function (f) {
                return util.makeField(f, products_edit_FIELDS);
            })
        }, {
            tabname: 'Properties',
            icon: 'fas fa-cogs',
            fields: ['sort', 'tradeItemNumber', 'color', 'size', 'weight', 'packingWeight', 'volume', 'length', 'width', 'height', 'countryOfOrigin', 'commodityCode', 'availability', 'introYear', 'unitsInStock', 'supplierOrderLines', 'customerOrderLines'].map(function (f) {
                return util.makeField(f, products_edit_FIELDS);
            })
        }, {
            tabname: 'Price',
            icon: 'fas fa-money-bill-alt',
            fields: ['priceNOK', 'priceSEK', 'priceDKK', 'priceGBP', 'priceEUR', 'priceCHF', 'pricelist', 'pricelistCombo'].map(function (f) {
                return util.makeField(f, products_edit_FIELDS);
            })
        }, {
            tabname: 'Images',
            icon: 'fas fa-image',
            fields: [{
                name: 'imgs',
                label: 'Images',
                type: 'object',
                view: function view(val, opt) {
                    var opts = {
                        id: opt.id,
                        name: opt.name,
                        value: val,
                        updateField: opt.updateField,
                        handleAddImage: function handleAddImage(imageObject) {
                            var options = opt;
                            _this.addProductImage(options.id, imageObject, options.object);
                        },
                        handleDelImage: function handleDelImage(imageId) {
                            var options = opt;
                            _this.delProductImage(options.id, imageId, options.object);
                        },
                        object: opt.object
                    };
                    return Object(preact_min["h"])(form_images, opts);
                },
                readonly: false,
                help: 'Field is DealerWeb only.'
            }]
        }, {
            tabname: 'Files',
            icon: 'fas fa-image',
            fields: [{
                name: 'files',
                label: 'Files',
                type: 'object',
                view: function view(val, opt) {
                    var opts = {
                        id: opt.id,
                        name: opt.name,
                        value: val,
                        updateField: opt.updateField,
                        handleAddImage: function handleAddImage(imageObject) {
                            var options = opt;
                            _this.addProductImage(options.id, imageObject, options.object);
                        },
                        handleDelImage: function handleDelImage(imageId) {
                            var options = opt;
                            _this.delProductFile(options.id, imageId, options.object);
                        },
                        object: opt.object
                    };
                    return Object(preact_min["h"])(form_images, opts);
                },
                readonly: false,
                help: 'Field is DealerWeb only.'
            }]
        }, {
            tabname: 'Text',
            icon: 'fas fa-file-alt',
            fields: ['description', 'features', 'tech', 'care', 'howtouse', 'youtubeNOK', 'youtubeSEK', 'youtubeDKK', 'youtubeGBP', 'youtubeEUR', 'youtubeCHF', 'youtube2NOK', 'youtube2SEK', 'youtube2DKK', 'youtube2GBP', 'youtube2EUR', 'youtube2CHF', 'youtube3NOK', 'youtube3SEK', 'youtube3DKK', 'youtube3GBP', 'youtube3EUR', 'youtube3CHF'].map(function (f) {
                return util.makeField(f, products_edit_FIELDS);
            })
        }, {
            tabname: 'Translations',
            icon: 'fas fa-file-alt',
            fields: ['translations'].map(function (f) {
                return util.makeField(f, products_edit_FIELDS);
            })

        }, {
            tabname: 'Ratings',
            icon: 'fas fa-file-alt',
            fields: ['ratings'].map(function (f) {
                return util.makeField(f, products_edit_FIELDS);
            })

        }, {
            tabname: 'Related',
            icon: 'fas fa-paperclip',
            fields: [{
                name: 'children',
                label: 'Related combo articles (OUTFIT)',
                type: 'object',
                view: function view(val) {
                    var opts = {
                        name: 'children',
                        placeholder: 'Search for product...',
                        value: val,
                        valueDisplayMap: function valueDisplayMap(v) {
                            return Object(preact_min["h"])(
                                'span',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': 'font-weight-light' },
                                    v.articleno,
                                    ':'
                                ),
                                ' ',
                                v.name
                            );
                        },
                        autocompleteList: productStore.searchResults,
                        oninput: function oninput(e) {
                            clearTimeout(_this.searchTimer);
                            _this.searchTimer = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                return regenerator_default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                productStore.search(e.target.value, { searchFields: 'name,articleno', skipTextIndex: 1, showall: 1 });

                                            case 1:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this2);
                            })), 500);
                        },
                        addElement: function addElement(idx) {
                            productStore.addElement(idx, 'product', 'children');
                            productStore.resetSearch();
                        },
                        removeElement: function removeElement(id) {
                            productStore.removeElement(id, 'product', 'children');
                            productStore.resetSearch();
                        },
                        handleKeydown: function handleKeydown(e) {
                            if (e.key === 'ArrowDown') {
                                if (productStore.totalSearch === 0) {
                                    productStore.search(e.target.value, { searchFields: 'name,articleno', skipTextIndex: 1, showall: 1 });
                                }
                                productStore.incSearchSelectIdx();
                            } else if (e.key === 'ArrowUp') {
                                productStore.decSearchSelectIdx();
                            } else if (e.key === 'Enter') {
                                productStore.addElement(0, 'product', 'children');
                                productStore.resetSearch();
                            } else if (e.key === 'Escape') {
                                productStore.resetSearch();
                            }
                        },
                        currentIdx: productStore.searchSelectIdx,
                        currentId: productStore.searchSelectId,
                        total: productStore.totalSearch
                    };
                    return Object(preact_min["h"])(autocomplete, opts);
                },
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'categories',
                label: 'Related categories',
                type: 'object',
                view: function view(val) {
                    var opts = {
                        placeholder: 'Search for category...',
                        value: val,
                        valueDisplayMap: function valueDisplayMap(v) {
                            return Object(preact_min["h"])(
                                'span',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': 'font-weight-light' },
                                    v.groupno,
                                    ':'
                                ),
                                ' ',
                                v.name
                            );
                        },
                        autocompleteList: categoryStore.searchResults,
                        oninput: function oninput(e) {
                            clearTimeout(_this.searchTimer);
                            _this.searchTimer = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                    while (1) {
                                        switch (_context2.prev = _context2.next) {
                                            case 0:
                                                categoryStore.search(e.target.value, { searchFields: 'name', intSearchFields: 'groupno', skipTokenizer: 1 });

                                            case 1:
                                            case 'end':
                                                return _context2.stop();
                                        }
                                    }
                                }, _callee2, _this2);
                            })), 500);
                        },
                        addElement: function addElement(idx) {
                            productStore.addElement(categoryStore.getElement(idx), 'product', 'categories');
                            categoryStore.resetSearch();
                        },
                        removeElement: function removeElement(id) {
                            productStore.removeElement(id, 'product', 'categories');
                            categoryStore.resetSearch();
                        },
                        handleKeydown: function handleKeydown(e) {
                            if (e.key === 'ArrowDown') {
                                if (categoryStore.totalSearch === 0) {
                                    categoryStore.search(e.target.value, { searchFields: 'name', intSearchFields: 'groupno', skipTokenizer: 1 });
                                }
                                categoryStore.incSearchSelectIdx();
                            } else if (e.key === 'ArrowUp') {
                                categoryStore.decSearchSelectIdx();
                            } else if (e.key === 'Enter') {
                                productStore.addElement(categoryStore.getElement(), 'product', 'categories');
                                categoryStore.resetSearch();
                            } else if (e.key === 'Escape') {
                                categoryStore.resetSearch();
                            }
                        },
                        currentIdx: categoryStore.searchSelectIdx,
                        currentId: categoryStore.searchSelectId,
                        total: categoryStore.totalSearch
                    };
                    return Object(preact_min["h"])(autocomplete, opts);
                },
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'articles',
                label: 'Related articles',
                type: 'object',
                view: function view(val) {
                    var opts = {
                        placeholder: 'Search for article...',
                        value: val,
                        valueDisplayMap: function valueDisplayMap(v) {
                            return Object(preact_min["h"])(
                                'span',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': 'font-weight-light' },
                                    v.id,
                                    ':'
                                ),
                                ' ',
                                v.title
                            );
                        },
                        autocompleteList: articleStore.searchResults,
                        oninput: function oninput(e) {
                            clearTimeout(_this.searchTimer);
                            _this.searchTimer = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
                                return regenerator_default.a.wrap(function _callee3$(_context3) {
                                    while (1) {
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                articleStore.search(e.target.value, { searchFields: 'title' });

                                            case 1:
                                            case 'end':
                                                return _context3.stop();
                                        }
                                    }
                                }, _callee3, _this2);
                            })), 500);
                        },
                        addElement: function addElement(idx) {
                            productStore.addElement(articleStore.getElement(idx), 'product', 'articles');
                            articleStore.resetSearch();
                        },
                        removeElement: function removeElement(id) {
                            productStore.removeElement(id, 'product', 'articles');
                            articleStore.resetSearch();
                        },
                        handleKeydown: function handleKeydown(e) {
                            if (e.key === 'ArrowDown') {
                                if (articleStore.totalSearch === 0) {
                                    articleStore.search(e.target.value, { searchFields: 'title' });
                                }
                                articleStore.incSearchSelectIdx();
                            } else if (e.key === 'ArrowUp') {
                                articleStore.decSearchSelectIdx();
                            } else if (e.key === 'Enter') {
                                productStore.addElement(articleStore.getElement(), 'product', 'articles');
                                articleStore.resetSearch();
                            } else if (e.key === 'Escape') {
                                articleStore.resetSearch();
                            }
                        },
                        currentIdx: articleStore.searchSelectIdx,
                        currentId: articleStore.searchSelectId,
                        total: articleStore.totalSearch
                    };
                    return Object(preact_min["h"])(autocomplete, opts);
                },
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'articlesTech',
                label: 'Related tech articles',
                type: 'object',
                view: function view(val) {
                    var opts = {
                        name: 'relatedArticlesTech',
                        placeholder: 'Search for tech article...',
                        value: val,
                        valueDisplayMap: function valueDisplayMap(v) {
                            return Object(preact_min["h"])(
                                'span',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': 'font-weight-light' },
                                    v.id,
                                    ':'
                                ),
                                ' ',
                                v.title
                            );
                        },
                        autocompleteList: articleStore.searchResults,
                        oninput: function oninput(e) {
                            clearTimeout(_this.searchTimer);
                            _this.searchTimer = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                                return regenerator_default.a.wrap(function _callee4$(_context4) {
                                    while (1) {
                                        switch (_context4.prev = _context4.next) {
                                            case 0:
                                                articleStore.search(e.target.value, { searchFields: 'title' });

                                            case 1:
                                            case 'end':
                                                return _context4.stop();
                                        }
                                    }
                                }, _callee4, _this2);
                            })), 500);
                        },
                        addElement: function addElement(idx) {
                            productStore.addElement(articleStore.getElement(idx), 'product', 'articlesTech');
                            articleStore.resetSearch();
                        },
                        removeElement: function removeElement(id) {
                            productStore.removeElement(id, 'product', 'articlesTech');
                            articleStore.resetSearch();
                        },
                        handleKeydown: function handleKeydown(e) {
                            if (e.key === 'ArrowDown') {
                                if (articleStore.totalSearch === 0) {
                                    articleStore.search(e.target.value, { searchFields: 'title' });
                                }
                                articleStore.incSearchSelectIdx();
                            } else if (e.key === 'ArrowUp') {
                                articleStore.decSearchSelectIdx();
                            } else if (e.key === 'Enter') {
                                productStore.addElement(articleStore.getElement(), 'product', 'articlesTech');
                                articleStore.resetSearch();
                            } else if (e.key === 'Escape') {
                                articleStore.resetSearch();
                            }
                        },
                        currentIdx: articleStore.searchSelectIdx,
                        currentId: articleStore.searchSelectId,
                        total: articleStore.totalSearch
                    };
                    return Object(preact_min["h"])(autocomplete, opts);
                },
                readonly: false,
                help: 'Field is DealerWeb only.'
            }, {
                name: 'products',
                label: 'Related products',
                type: 'object',
                view: function view(val) {
                    var opts = {
                        name: 'relatedProducts',
                        placeholder: 'Search for product...',
                        value: val,
                        valueDisplayMap: function valueDisplayMap(v) {
                            return Object(preact_min["h"])(
                                'span',
                                null,
                                Object(preact_min["h"])(
                                    'span',
                                    { 'class': 'font-weight-light' },
                                    v.articleno,
                                    ':'
                                ),
                                ' ',
                                v.name
                            );
                        },
                        autocompleteList: productStore.searchResults,
                        oninput: function oninput(e) {
                            clearTimeout(_this.searchTimer);
                            _this.searchTimer = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
                                return regenerator_default.a.wrap(function _callee5$(_context5) {
                                    while (1) {
                                        switch (_context5.prev = _context5.next) {
                                            case 0:
                                                productStore.search(e.target.value, { searchFields: 'name,articleno', skipTextIndex: 1 });

                                            case 1:
                                            case 'end':
                                                return _context5.stop();
                                        }
                                    }
                                }, _callee5, _this2);
                            })), 500);
                        },
                        addElement: function addElement(idx) {
                            productStore.addElement(idx, 'product', 'products');
                            productStore.resetSearch();
                        },
                        removeElement: function removeElement(id) {
                            productStore.removeElement(id, 'product', 'products');
                            productStore.resetSearch();
                        },
                        handleKeydown: function handleKeydown(e) {
                            if (e.key === 'ArrowDown') {
                                if (productStore.totalSearch === 0) {
                                    productStore.search(e.target.value, { searchFields: 'name,articleno', skipTextIndex: 1 });
                                }
                                productStore.incSearchSelectIdx();
                            } else if (e.key === 'ArrowUp') {
                                productStore.decSearchSelectIdx();
                            } else if (e.key === 'Enter') {
                                productStore.addElement(0, 'product', 'products');
                                productStore.resetSearch();
                            } else if (e.key === 'Escape') {
                                productStore.resetSearch();
                            }
                        },
                        currentIdx: productStore.searchSelectIdx,
                        currentId: productStore.searchSelectId,
                        total: articleStore.totalSearch
                    };
                    return Object(preact_min["h"])(autocomplete, opts);
                },
                readonly: false,
                help: 'Field is DealerWeb only.'
            }]
        }, {
            tabname: 'Presale',
            icon: 'fas fa-clock',
            fields: ['preSale', 'preSaleNew', 'preSalePopular', 'preSaleDiscontinued', 'psPriceNOK', 'psPriceSEK', 'psPriceDKK', 'psPriceGBP', 'psPriceEUR', 'psPriceCHF'].map(function (f) {
                return util.makeField(f, products_edit_FIELDS);
            })
        }, {
            tabname: 'API',
            icon: 'fas fa-satellite-dish',
            fields: ['articleno', 'maingroupno', 'tradeItemNumber', 'name', 'brand', 'itemCategory', 'productGroup', 'commodityCode', 'mainCategory', 'intermediateCategory', 'subCategory', 'maingroupid', 'intermediategroupid', 'subgroupid', 'maingroupno', 'intermediategroupno', 'subgroupno', 'color', 'size', 'nameDisplay', 'availability', 'weight', 'packingWeight', 'volume', 'length', 'width', 'height', 'retailCurrency', 'retailPrice', 'introYear', 'description', 'features', 'tech', 'care', 'howtouse', 'images', 'priceNOK', 'priceSEK', 'priceDKK', 'priceGBP', 'priceEUR', 'priceCHF', 'youtubeNOK', 'youtubeSEK', 'youtubeDKK', 'youtubeGBP', 'youtubeEUR', 'youtubeCHF', 'link', 'linkConsumerWeb', 'imageRef', 'descriptionHtml', 'featuresHtml', 'techHtml', 'careHtml', 'howtouseHtml', 'dealerCurrency', 'dealerPrice', 'dealerEurPrice', 'apiLinkToProductGroup', 'apiLinkToProductMainCategory', 'imageRefPrefixes', 'sort', 'is_new', 'preSaleNew', 'preSaleDiscontinued', 'pricelistCombo', 'categories', 'articles', 'articlesTech', 'products', 'warehouse'].map(function (f) {
                return util.makeField(f, products_edit_FIELDS);
            })
        }, {
            tabname: 'Visma',
            icon: 'fas fa-heart',
            fields: ['articleno', 'name', 'maingroupno', 'intermediategroupno', 'subgroupno', 'tradeItemNumber', 'vismaBrand', 'colorId', 'sizeId', 'preSale', 'preSaleNew', 'is_new', 'preSalePopular', 'showonwebyesno', 'preSaleDiscontinued', 'isActive', 'countryOfOrigin', 'weight', 'packingWeight', 'volume', 'length', 'width', 'height', 'itemCategory', 'commodityCode', 'introYear', 'productGroup', 'nameDisplay', 'option_1', 'option_1_name', 'option_2', 'option_2_name', 'showOnConsumerWeb', 'pricelist', 'warehouse'].map(function (f) {
                return util.makeField(f, products_edit_FIELDS);
            })
        }];
        return _this;
    }

    ProductEdit.prototype.subscriptions = function subscriptions() {
        var _this3 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this3.setState({ height: height });
        });
    };

    ProductEdit.prototype.doUpdateField = function () {
        var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(id, field, value) {
            var object = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var productStore, updateAll, filter;
            return regenerator_default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            productStore = this.props.stores.productStore;
                            updateAll = productStore.updateAll;
                            // await productStore.saveField(id, field, value);

                            filter = {
                                id: id,
                                maingroupid: object.maingroupid,
                                intermediategroupid: object.intermediategroupid,
                                nameDisplay: object.nameDisplay
                            };

                            if (field === 'imgs') {
                                filter.colorId = object.colorId;
                            }

                            if (!(updateAll && filter.maingroupid && filter.intermediategroupid && filter.nameDisplay)) {
                                _context6.next = 9;
                                break;
                            }

                            _context6.next = 7;
                            return productStore.updateMany(filter, field, value);

                        case 7:
                            _context6.next = 11;
                            break;

                        case 9:
                            _context6.next = 11;
                            return productStore.saveField(id, field, value);

                        case 11:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref6.apply(this, arguments);
        }

        return doUpdateField;
    }();

    ProductEdit.prototype.render = function render(props) {
        var _this4 = this;

        var height = this.state.height;
        var productStore = this.props.stores.productStore;
        var product = productStore.product,
            saved = productStore.saved,
            updateAll = productStore.updateAll;


        var tabIdx = this.fields.findIndex(function (e) {
            return e.tabname === props.tabname;
        });
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(products_nav, this.props)
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-2 fixed-top overflow-auto',
                        style: 'margin-top: ' + (height + 60) + 'px; height: calc(100% - ' + (height + 60) + 'px);'
                    },
                    Object(preact_min["h"])(
                        'small',
                        null,
                        Object(preact_min["h"])(products_tree, this.props)
                    ),
                    edit__ref7
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-10 offset-2' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-flex flex-row bd-highlight mb-3 mt-4' },
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: '/products', 'class': 'mr-2 btn btn-sm btn-warning' },
                                Object(preact_min["h"])('i', { 'class': 'fas fa-arrow-left mr-1' }),
                                'Back'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'h4',
                                null,
                                'Edit: ',
                                product.articleno,
                                ': ',
                                product.name
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'flex-grow-1 text-right' },
                            Object(preact_min["h"])(
                                'button',
                                { 'class': 'btn btn-link',
                                    onClick: function onClick() {
                                        return productStore.toggleUpdateAll();
                                    }
                                },
                                Object(preact_min["h"])('i', { 'class': '' + (updateAll ? 'fas fa-toggle-on text-success' : 'fas fa-toggle-off text-muted') })
                            ),
                            Object(preact_min["h"])(
                                'small',
                                { 'class': 'text-' + (updateAll ? 'success' : 'muted') },
                                'Update all products with same nameDisplay and in the same cateogry.'
                            )
                        )
                    ),
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'nav nav-tabs mb-2' },
                        this.fields.map(function (tab) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'nav-item' },
                                Object(preact_min["h"])(
                                    'a',
                                    { 'class': 'nav-link ' + (props.tabname === tab.tabname ? 'active' : ''),
                                        href: '/products/' + encodeURIComponent(props.productid) + '/' + tab.tabname
                                    },
                                    Object(preact_min["h"])('i', { 'class': tab.icon + ' mr-2' }),
                                    tab.tabname
                                )
                            );
                        })
                    ),
                    this.fields[tabIdx].fields.map(function (field) {
                        return Object(preact_min["h"])(formField_FormRow, {
                            field: field,
                            object: product,
                            saved: saved,
                            updateField: _this4.updateField
                        });
                    })
                )
            )
        );
    };

    return ProductEdit;
}(preact_min["Component"]), products_edit__initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.updateField = function () {
        var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8(id, field, value, object) {
            var productStore;
            return regenerator_default.a.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            productStore = _this5.props.stores.productStore;

                            productStore.updateField(id, field, value);

                            clearTimeout(_this5.updateTimer[field]);
                            _this5.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7() {
                                return regenerator_default.a.wrap(function _callee7$(_context7) {
                                    while (1) {
                                        switch (_context7.prev = _context7.next) {
                                            case 0:
                                                _this5.doUpdateField(id, field, value, object);

                                            case 1:
                                            case 'end':
                                                return _context7.stop();
                                        }
                                    }
                                }, _callee7, _this5);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this5);
        }));

        return function (_x5, _x6, _x7, _x8) {
            return _ref8.apply(this, arguments);
        };
    }();

    this.addProductImage = function () {
        var _ref10 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9(id, imageObject, object) {
            var productStore;
            return regenerator_default.a.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            productStore = _this5.props.stores.productStore;

                            if (imageObject.mimetype.match(/^image/)) {
                                productStore.addImage(id, imageObject, object);
                            } else {
                                productStore.addImage(id, imageObject, object, 'files');
                            }

                        case 2:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this5);
        }));

        return function (_x9, _x10, _x11) {
            return _ref10.apply(this, arguments);
        };
    }();

    this.delProductImage = function () {
        var _ref11 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee10(id, imageId, object) {
            var productStore;
            return regenerator_default.a.wrap(function _callee10$(_context10) {
                while (1) {
                    switch (_context10.prev = _context10.next) {
                        case 0:
                            productStore = _this5.props.stores.productStore;

                            productStore.delImage(id, imageId, object);

                        case 2:
                        case 'end':
                            return _context10.stop();
                    }
                }
            }, _callee10, _this5);
        }));

        return function (_x12, _x13, _x14) {
            return _ref11.apply(this, arguments);
        };
    }();

    this.delProductFile = function () {
        var _ref12 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee11(id, imageId, object) {
            var productStore;
            return regenerator_default.a.wrap(function _callee11$(_context11) {
                while (1) {
                    switch (_context11.prev = _context11.next) {
                        case 0:
                            productStore = _this5.props.stores.productStore;

                            productStore.delImage(id, imageId, object, 'files');

                        case 2:
                        case 'end':
                            return _context11.stop();
                    }
                }
            }, _callee11, _this5);
        }));

        return function (_x15, _x16, _x17) {
            return _ref12.apply(this, arguments);
        };
    }();
}, products_edit__temp)) || products_edit__class;

/* harmony default export */ var products_edit = (edit_ProductEdit);
// EXTERNAL MODULE: ./components/productcombos/style.css
var productcombos_style = __webpack_require__("TvtV");
var productcombos_style_default = /*#__PURE__*/__webpack_require__.n(productcombos_style);

// CONCATENATED MODULE: ./components/productcombos/list.js







var productcombos_list__class, productcombos_list__class2, productcombos_list__temp, productcombos_list__initialiseProps;










var productcombos_list_initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        productcombos: false
    }
};

var productcombos_list__ref4 = Object(preact_min["h"])('br', null);

var productcombos_list__ref5 = Object(preact_min["h"])('i', { 'class': 'far fa-file mr-2' });

var productcombos_list__ref6 = Object(preact_min["h"])(
    'h1',
    null,
    Object(preact_min["h"])('i', { 'class': 'fas fa-search' }),
    ' Search results'
);

var productcombos_list__ref7 = Object(preact_min["h"])('br', null);

var productcombos_list__ref8 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var productcombos_list__ref9 = Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle' });

var productcombos_list__ref10 = Object(preact_min["h"])(
    'th',
    { style: 'width: 30%' },
    'Group A'
);

var productcombos_list__ref11 = Object(preact_min["h"])(
    'th',
    { style: 'width: 30%' },
    'Group B'
);

var productcombos_list__ref12 = Object(preact_min["h"])('i', { 'class': 'fas fa-edit' });

var productcombos_list__ref13 = Object(preact_min["h"])(
    'div',
    { 'class': 'row' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'col-12 text-center' },
        Object(preact_min["h"])(
            'div',
            { 'class': 'spinner-border text-success', role: 'status' },
            Object(preact_min["h"])(
                'span',
                { 'class': 'sr-only' },
                'Loading...'
            )
        )
    )
);

var productcombos_list__ref14 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var list_ProductComboList = Object(index_module["a" /* observer */])(productcombos_list__class = (productcombos_list__temp = productcombos_list__class2 = function (_Component) {
    inherits_default()(ProductComboList, _Component);

    function ProductComboList(props) {
        classCallCheck_default()(this, ProductComboList);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        productcombos_list__initialiseProps.call(_this);

        _this.state = extends_default()({}, productcombos_list_initialState);
        _this.updateTimer = {};

        var productComboStore = _this.props.stores.productComboStore;

        productComboStore.list();
        return _this;
    }

    ProductComboList.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    ProductComboList.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    ProductComboList.prototype.updateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(id, field, value) {
            var _this2 = this;

            var productComboStore;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            productComboStore = this.props.stores.productComboStore;

                            productComboStore.updateField(id, field, value);

                            clearTimeout(this.updateTimer[field]);
                            this.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                return regenerator_default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _this2.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this2);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function updateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return updateField;
    }();

    ProductComboList.prototype.doUpdateField = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var productComboStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            productComboStore = this.props.stores.productComboStore;
                            _context3.next = 3;
                            return productComboStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function doUpdateField(_x4, _x5, _x6) {
            return _ref3.apply(this, arguments);
        }

        return doUpdateField;
    }();

    ProductComboList.prototype.render = function render() {
        var _this3 = this;

        var loading = this.state.loading;
        var productComboStore = this.props.stores.productComboStore;
        var productCombos = productComboStore.productCombos,
            queryFilter = productComboStore.queryFilter,
            saved = productComboStore.saved;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'text-muted font-weight-lighter float-right mr-2 ml-4' },
                        'Total: ',
                        productComboStore.total,
                        productcombos_list__ref4
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'ml-2 float-right btn btn-sm btn-success',
                            onClick: this.createNewProductCombo
                        },
                        productcombos_list__ref5,
                        'New Product combo'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': 'float-left form-row align-items-center mr-5' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])('input', { type: 'text', 'class': 'form-control form-control-sm', id: 'inlineFormInputName', placeholder: 'Search for productcombos...',
                                onInput: function onInput(e) {
                                    return productComboStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true });
                                },
                                value: queryFilter.search
                            })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])(
                                'button',
                                { type: 'button', 'class': 'btn btn-sm btn-primary', onClick: function onClick() {
                                        return productComboStore.list();
                                    } },
                                'Search'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    queryFilter.search && Object(preact_min["h"])(
                        'div',
                        { 'class': 'w-100 text-left mt-2 mb-5' },
                        productcombos_list__ref6,
                        'Found ',
                        productComboStore.total || 0,
                        ' results in your search for "',
                        queryFilter.search,
                        '".',
                        productcombos_list__ref7,
                        Object(preact_min["h"])(
                            'button',
                            { 'class': 'btn btn-sm btn-warning mt-2',
                                onClick: function onClick() {
                                    return productComboStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true });
                                }
                            },
                            productcombos_list__ref8,
                            ' Reset search'
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'table-responsive' },
                        Object(preact_min["h"])(
                            'table',
                            { 'class': productcombos_style_default.a.table + ' table table-striped table-sm table-borderless' },
                            Object(preact_min["h"])(
                                'thead',
                                null,
                                productComboStore.sort !== productComboStore.defaultSort && Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { colspan: '8' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': productcombos_style_default.a.pointerCursor + ' mr-2 badge badge-pill badge-secondary', onClick: function onClick() {
                                                    return productComboStore.resetSort();
                                                } },
                                            productcombos_list__ref9,
                                            ' Reset sort'
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': productcombos_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return productComboStore.toggleSort('id', '');
                                                } },
                                            'Combo# ',
                                            util.getSortIcon('id', productComboStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': productcombos_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return productComboStore.toggleSort('name', '-');
                                                } },
                                            'Name ',
                                            util.getSortIcon('name', productComboStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': productcombos_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return productComboStore.toggleSort('sort', '');
                                                } },
                                            'sort ',
                                            util.getSortIcon('sort', productComboStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': productcombos_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return productComboStore.toggleSort('groupno', '-');
                                                } },
                                            'Groupno ',
                                            util.getSortIcon('groupno', productComboStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-center' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': productcombos_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return productComboStore.toggleSort('singleIsOk', '-');
                                                } },
                                            'singleIsOk ',
                                            util.getSortIcon('singleIsOk', productComboStore.sort)
                                        )
                                    ),
                                    productcombos_list__ref10,
                                    productcombos_list__ref11,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': productcombos_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return productComboStore.toggleSort('createdDate', '-');
                                                } },
                                            'Created ',
                                            util.getSortIcon('createdDate', productComboStore.sort)
                                        )
                                    )
                                )
                            ),
                            Object(preact_min["h"])(
                                'tbody',
                                null,
                                productCombos && productCombos.map(function (productcombo) {
                                    return Object(preact_min["h"])(
                                        'tr',
                                        { 'class': '' + productcombos_style_default.a.tableline },
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            productcombo.id
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(
                                                'a',
                                                { href: '/productcombos/' + productcombo.id + '/Basics' },
                                                productcombo.name
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(input, {
                                                id: productcombo.id,
                                                className: 'text-right form-control-sm',
                                                isValid: saved['sort.' + productcombo.id],
                                                name: 'sort',
                                                value: productcombo.sort,
                                                onInput: function onInput(e) {
                                                    return _this3.updateField(productcombo.id, 'sort', e.target.value);
                                                },
                                                hideHelp: 1
                                            })
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            productcombo.groupno
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-center' },
                                            Object(preact_min["h"])(
                                                'span',
                                                {
                                                    'class': 'mr-1 badge ' + productcombos_style_default.a.pointerCursor + ' badge-' + util.colorClass(productcombo.singleIsOk, 'yesno'),
                                                    onClick: function onClick() {
                                                        return productComboStore.saveField(productcombo.id, 'singleIsOk', util.cyclevalues(productcombo.singleIsOk, [0, 1]), true);
                                                    }
                                                },
                                                util.statusText(productcombo.singleIsOk, 'yesno')
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            productcombo.groupA && productcombo.groupA.join(', ')
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            productcombo.groupB && productcombo.groupB.join(', ')
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            productcombo.createdDate && util.ffeDateTime(productcombo.createdDate),
                                            productcombo.updatedDate && Object(preact_min["h"])(
                                                'div',
                                                null,
                                                Object(preact_min["h"])(
                                                    'small',
                                                    { 'class': 'text-muted' },
                                                    productcombos_list__ref12,
                                                    ' ',
                                                    util.ffeDateTime(productcombo.updatedDate)
                                                )
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    )
                )
            ),
            loading && productcombos_list__ref13,
            productcombos_list__ref14
        );
    };

    return ProductComboList;
}(preact_min["Component"]), productcombos_list__initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.handleScroll = function () {
        var loading = _this4.state.loading;
        var productComboStore = _this4.props.stores.productComboStore;
        var totalAppend = productComboStore.totalAppend,
            limit = productComboStore.limit;

        if (window.innerHeight + document.documentElement.scrollTop + 500 < document.documentElement.offsetHeight) return;
        if (loading) return;

        var offset = productComboStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(_this4.scrollLoader);
            _this4.scrollLoader = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this4.setState({ loading: true });
                                productComboStore.updateOffset(offset);
                                _context4.next = 4;
                                return productComboStore.list(true);

                            case 4:
                                _this4.setState({ loading: false });

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            })), 500);
        }
    };

    this.createNewProductCombo = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var productComboStore;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        productComboStore = _this4.props.stores.productComboStore;
                        _context5.next = 3;
                        return productComboStore.create({
                            name: 'Untitled'
                        });

                    case 3:
                        _context5.next = 5;
                        return productComboStore.list();

                    case 5:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this4);
    }));
}, productcombos_list__temp)) || productcombos_list__class;

/* harmony default export */ var productcombos_list = (list_ProductComboList);
// CONCATENATED MODULE: ./components/productcombos/index.js




var productcombos__class;









var productcombos_initialState = {
    height: 100
};

var productcombos_Brand = Object(index_module["a" /* observer */])(productcombos__class = function (_Component) {
    inherits_default()(Brand, _Component);

    function Brand(props) {
        classCallCheck_default()(this, Brand);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = productcombos_initialState;
        _this.subscriptions();
        return _this;
    }

    Brand.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    Brand.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(productcombos_list, props)
                )
            )
        );
    };

    return Brand;
}(preact_min["Component"])) || productcombos__class;

/* harmony default export */ var productcombos = (productcombos_Brand);
// CONCATENATED MODULE: ./components/productcombos/edit.js







var productcombos_edit__class, productcombos_edit__class2, productcombos_edit__temp, productcombos_edit__initialiseProps;










var productcombos_edit_initialState = {};

var productcombos_edit_FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    groupno: { label: 'ProductCombo #', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    sort: { label: 'Sort', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    name: { label: 'Name', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    groupA: { label: 'Group A', type: 'array', readonly: false, help: 'Field is DealerWeb only.' },
    groupB: { label: 'Group B', type: 'array', readonly: false, help: 'Field is DealerWeb only.' }
};

var edit_ProductComboEdit = Object(index_module["a" /* observer */])(productcombos_edit__class = (productcombos_edit__temp = productcombos_edit__class2 = function (_Component) {
    inherits_default()(ProductComboEdit, _Component);

    function ProductComboEdit(props) {
        classCallCheck_default()(this, ProductComboEdit);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        productcombos_edit__initialiseProps.call(_this);

        _this.state = extends_default()({}, productcombos_edit_initialState);
        _this.updateTimer = {};
        var productComboStore = _this.props.stores.productComboStore;

        productComboStore.load(props.id);

        _this.fields = [{
            tabname: 'Basics',
            icon: 'fas fa-user-edit',
            fields: ['id', 'groupno', 'sort', 'name', 'groupA', 'groupB'].map(function (f) {
                return util.makeField(f, productcombos_edit_FIELDS);
            })
        }];
        return _this;
    }

    ProductComboEdit.prototype.doUpdateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(id, field, value) {
            var productComboStore;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            productComboStore = this.props.stores.productComboStore;
                            _context.next = 3;
                            return productComboStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return doUpdateField;
    }();

    ProductComboEdit.prototype.render = function render(props) {
        var _this2 = this;

        var productComboStore = this.props.stores.productComboStore;
        var productCombo = productComboStore.productCombo,
            saved = productComboStore.saved;


        var tabIdx = this.fields.findIndex(function (e) {
            return e.tabname === props.tabname;
        });
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-flex flex-row bd-highlight mb-3' },
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: '/productcombos', 'class': 'mr-2 btn btn-sm btn-warning' },
                                Object(preact_min["h"])('i', { 'class': 'fas fa-arrow-left mr-1' }),
                                'Back'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'h4',
                                null,
                                'Edit: ',
                                productCombo.id,
                                ': ',
                                productCombo.name
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'nav nav-tabs mb-2' },
                        this.fields.map(function (tab) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'nav-item' },
                                Object(preact_min["h"])(
                                    'a',
                                    { 'class': 'nav-link ' + (props.tabname === tab.tabname ? 'active' : ''),
                                        href: '/productcombos/' + props.id + '/' + tab.tabname
                                    },
                                    Object(preact_min["h"])('i', { 'class': tab.icon + ' mr-2' }),
                                    tab.tabname
                                )
                            );
                        })
                    ),
                    this.fields[tabIdx].fields.map(function (field) {
                        return Object(preact_min["h"])(formField_FormRow, {
                            field: field,
                            object: productCombo,
                            saved: saved,
                            updateField: _this2.updateField
                        });
                    })
                )
            )
        );
    };

    return ProductComboEdit;
}(preact_min["Component"]), productcombos_edit__initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.updateField = function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value, type) {
            var productComboStore, val;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            productComboStore = _this3.props.stores.productComboStore;
                            val = type === 'array' ? value.replace(/[\n\t\r]/g, ',').split(',').map(function (e) {
                                return e.trim();
                            }) : value;

                            productComboStore.updateField(id, field, val);

                            clearTimeout(_this3.updateTimer[field]);
                            _this3.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                    while (1) {
                                        switch (_context2.prev = _context2.next) {
                                            case 0:
                                                _this3.doUpdateField(id, field, val);

                                            case 1:
                                            case 'end':
                                                return _context2.stop();
                                        }
                                    }
                                }, _callee2, _this3);
                            })), 500);

                        case 5:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x4, _x5, _x6, _x7) {
            return _ref2.apply(this, arguments);
        };
    }();
}, productcombos_edit__temp)) || productcombos_edit__class;

/* harmony default export */ var productcombos_edit = (edit_ProductComboEdit);
// EXTERNAL MODULE: ./components/tags/style.css
var tags_style = __webpack_require__("+hHD");
var tags_style_default = /*#__PURE__*/__webpack_require__.n(tags_style);

// CONCATENATED MODULE: ./components/tags/tree.js





var tags_tree__class, tags_tree__class2, tags_tree__class3, tags_tree__class4, tags_tree__temp, tags_tree__initialiseProps;








var tags_tree_initialState = {};

var tree__ref = Object(preact_min["h"])('i', { 'class': 'fas fa-filter ml-1' });

var tree__ref2 = Object(preact_min["h"])('i', { 'class': 'fas fa-bars ml-1' });

var tree__ref3 = Object(preact_min["h"])('i', { 'class': 'fas fa-thumbtack ml-1' });

var tree_TagLine = Object(index_module["a" /* observer */])(tags_tree__class = function (_Component) {
    inherits_default()(TagLine, _Component);

    function TagLine() {
        classCallCheck_default()(this, TagLine);

        return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }

    TagLine.prototype.render = function render() {
        var _props = this.props,
            tag = _props.tag,
            queryFilter = _props.queryFilter,
            onClickTag = _props.onClickTag,
            editTag = _props.editTag,
            parent = _props.parent,
            children = _props.children;

        var isSelected = queryFilter.parent === tag.id || parent === tag.id;

        return Object(preact_min["h"])(
            'div',
            { 'class': 'nav-item' },
            Object(preact_min["h"])(
                'div',
                { 'class': tags_style_default.a.pointerCursor + ' nav-link py-0 ' + (isSelected ? 'active' : '') },
                Object(preact_min["h"])(
                    'span',
                    { onClick: function onClick() {
                            return onClickTag(tag.id);
                        } },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'float-right' },
                        tag.filter ? tree__ref : '',
                        tag.menu ? tree__ref2 : '',
                        tag.pinned ? tree__ref3 : ''
                    ),
                    Object(preact_min["h"])(
                        'small',
                        null,
                        Object(preact_min["h"])('i', { 'class': 'fas fa-edit mr-1 text-' + (isSelected ? 'light' : 'primary') + ' primary font-weight-lighter',
                            'data-params': JSON.stringify({
                                id: tag.id
                            }),
                            onClick: editTag
                        })
                    ),
                    Object(preact_min["h"])('i', { 'class': 'fas fa-folder' + (isSelected ? '-open' : '') + ' mr-1' }),
                    tag.name,
                    tag.countChildren && Object(preact_min["h"])(
                        'span',
                        { 'class': 'font-weight-lighter ml-2' },
                        '(',
                        tag.countChildren,
                        ')'
                    )
                )
            ),
            isSelected && Object(preact_min["h"])(
                'div',
                { 'class': 'd-' + (isSelected ? 'block' : 'none') + ' nav flex-column mt-1 ml-4' },
                Object(preact_min["h"])(tree_TagList, {
                    tags: children,
                    queryFilter: queryFilter,
                    onClickTag: onClickTag,
                    editTag: editTag
                })
            )
        );
    };

    return TagLine;
}(preact_min["Component"])) || tags_tree__class;

var tree_TagList = Object(index_module["a" /* observer */])(tags_tree__class2 = function (_Component2) {
    inherits_default()(TagList, _Component2);

    function TagList() {
        classCallCheck_default()(this, TagList);

        return possibleConstructorReturn_default()(this, _Component2.apply(this, arguments));
    }

    TagList.prototype.render = function render() {
        var _props2 = this.props,
            tags = _props2.tags,
            queryFilter = _props2.queryFilter,
            onClickTag = _props2.onClickTag,
            editTag = _props2.editTag,
            parent = _props2.parent,
            children = _props2.children;

        return Object(preact_min["h"])(
            'div',
            null,
            tags.map(function (tag) {
                return Object(preact_min["h"])(tree_TagLine, {
                    tag: tag,
                    queryFilter: queryFilter,
                    onClickTag: onClickTag,
                    editTag: editTag,
                    children: children,
                    parent: parent
                });
            })
        );
    };

    return TagList;
}(preact_min["Component"])) || tags_tree__class2;

var tree__ref4 = Object(preact_min["h"])('br', null);

var tree_TagTree = Object(index_module["a" /* observer */])(tags_tree__class3 = (tags_tree__temp = tags_tree__class4 = function (_Component3) {
    inherits_default()(TagTree, _Component3);

    function TagTree(props) {
        classCallCheck_default()(this, TagTree);

        var _this3 = possibleConstructorReturn_default()(this, _Component3.call(this, props));

        tags_tree__initialiseProps.call(_this3);

        _this3.state = extends_default()({}, tags_tree_initialState);

        var tagStore = _this3.props.stores.tagStore;
        var queryFilter = tagStore.queryFilter;

        tagStore.load('', false, { dataKey: 'tagTree', query: { hasParent: 0 } });
        tagStore.load('', false, { dataKey: 'tagTreeBranchPinned', query: { pinned: 1 } });
        if (queryFilter.parent) {
            tagStore.load('', false, { dataKey: 'tagTreeBranch', query: { parent: queryFilter.parent, limit: 200 } });
        }
        return _this3;
    }

    TagTree.prototype.render = function render() {
        var _this4 = this;

        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var tagStore = props.stores.tagStore;
        var tagTree = tagStore.tagTree,
            tagTreeBranch = tagStore.tagTreeBranch,
            tagTreeBranchPinned = tagStore.tagTreeBranchPinned,
            tagTreeParent = tagStore.tagTreeParent,
            queryFilter = tagStore.queryFilter;

        var isSelected = !queryFilter.parent;

        return Object(preact_min["h"])(
            'div',
            { 'class': 'nav flex-column nav-pills' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'nav-item mb-4 pb-4', style: 'border-bottom: 1px solid;' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': tags_style_default.a.pointerCursor + ' nav-link py-0 ' + (isSelected ? 'active' : '') },
                    Object(preact_min["h"])(
                        'span',
                        { onClick: function onClick() {
                                return _this4.onClickTag(null, { open: true });
                            } },
                        'ALL TAGS'
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'mb-4 pb-4', style: 'border-bottom: 1px solid;' },
                'PINNED TAGS: ',
                tree__ref4,
                Object(preact_min["h"])(tree_TagList, {
                    className: 'font-weight-bold',
                    tags: tagTreeBranchPinned,
                    queryFilter: queryFilter,
                    onClickTag: this.onClickTag,
                    editTag: this.editTag
                })
            ),
            Object(preact_min["h"])(tree_TagList, {
                tags: tagTree,
                queryFilter: queryFilter,
                onClickTag: this.onClickTag,
                editTag: this.editTag,
                children: tagTreeBranch,
                parent: tagTreeParent
            })
        );
    };

    return TagTree;
}(preact_min["Component"]), tags_tree__initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.onClickTag = function (parentId) {
        var tagStore = _this5.props.stores.tagStore;
        // tagStore.toggleQueryfilter('mainCat', '', { setValue: 1, skipUpdate: 1 });

        tagStore.updateKeyValue('tagTreeBranch', []);
        tagStore.toggleQueryfilter('parent', parentId, { setValue: true });
        tagStore.load('', false, { dataKey: 'tagTreeBranch', query: { parent: parentId, limit: 200 } });
    };

    this.editTag = function (event) {
        event.stopPropagation();
        var params = event.target.dataset.params;

        var inputParams = JSON.parse(params || {});
        var id = inputParams.id;

        route('/tags/' + id + '/Basics', true);
    };
}, tags_tree__temp)) || tags_tree__class3;

/* harmony default export */ var tags_tree = (tree_TagTree);
// CONCATENATED MODULE: ./components/tags/list.js







var tags_list__class, tags_list__class2, tags_list__temp, tags_list__initialiseProps;













var tags_list_initialState = {
    height: 100,
    windowHeight: 0,
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false
    }
};

var tags_list__ref4 = Object(preact_min["h"])('br', null);

var tags_list__ref5 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var tags_list__ref6 = Object(preact_min["h"])(
    'h1',
    null,
    Object(preact_min["h"])('i', { 'class': 'fas fa-search' }),
    ' Search results'
);

var tags_list__ref7 = Object(preact_min["h"])('br', null);

var tags_list__ref8 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var tags_list__ref9 = Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle' });

var tags_list__ref10 = Object(preact_min["h"])(
    'td',
    { 'class': 'text-center', colspan: '9' },
    Object(preact_min["h"])(
        'h5',
        null,
        'No tags found'
    )
);

var tags_list__ref11 = Object(preact_min["h"])('i', { 'class': 'fas fa-edit' });

var tags_list__ref12 = Object(preact_min["h"])(
    'div',
    { 'class': 'row' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'col-12 text-center' },
        Object(preact_min["h"])(
            'div',
            { 'class': 'spinner-border text-success', role: 'status' },
            Object(preact_min["h"])(
                'span',
                { 'class': 'sr-only' },
                'Loading...'
            )
        )
    )
);

var tags_list__ref13 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var list_TagList = Object(index_module["a" /* observer */])(tags_list__class = (tags_list__temp = tags_list__class2 = function (_Component) {
    inherits_default()(TagList, _Component);

    function TagList(props) {
        classCallCheck_default()(this, TagList);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        tags_list__initialiseProps.call(_this);

        _this.state = extends_default()({}, tags_list_initialState);
        _this.updateTimer = {};

        var tagStore = _this.props.stores.tagStore;

        tagStore.list(false, { addData: ['tagListTree'] });
        _this.subscriptions();
        return _this;
    }

    TagList.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    TagList.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    TagList.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    TagList.prototype.updateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(id, field, value) {
            var _this3 = this;

            var tagStore;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            tagStore = this.props.stores.tagStore;

                            tagStore.updateField(id, field, value);

                            clearTimeout(this.updateTimer[field]);
                            this.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                return regenerator_default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _this3.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this3);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function updateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return updateField;
    }();

    TagList.prototype.doUpdateField = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var tagStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            tagStore = this.props.stores.tagStore;
                            _context3.next = 3;
                            return tagStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function doUpdateField(_x4, _x5, _x6) {
            return _ref3.apply(this, arguments);
        }

        return doUpdateField;
    }();

    TagList.prototype.render = function render() {
        var _this4 = this;

        var _state = this.state,
            loading = _state.loading,
            height = _state.height;
        var tagStore = this.props.stores.tagStore;
        var tags = tagStore.tags,
            queryFilter = tagStore.queryFilter,
            saved = tagStore.saved;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'text-muted font-weight-lighter float-right mr-2' },
                        'Total: ',
                        tagStore.total,
                        tags_list__ref4
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': 'float-left form-row align-items-center mr-5' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])('input', { type: 'text', 'class': 'form-control form-control-sm', id: 'inlineFormInputName', placeholder: 'Search for tags...',
                                onInput: function onInput(e) {
                                    return tagStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true });
                                },
                                value: queryFilter.search
                            })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])(
                                'button',
                                { type: 'button', 'class': 'btn btn-sm btn-primary', onClick: function onClick() {
                                        return tagStore.list();
                                    } },
                                'Search'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-2 fixed-top overflow-auto',
                        style: 'margin-top: ' + (height + 60) + 'px; height: calc(100% - ' + (height + 60) + 'px);'
                    },
                    Object(preact_min["h"])(
                        'small',
                        null,
                        Object(preact_min["h"])(tags_tree, this.props)
                    ),
                    tags_list__ref5
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-10 offset-2' },
                    queryFilter.search && Object(preact_min["h"])(
                        'div',
                        { 'class': 'w-100 text-left mt-2 mb-5' },
                        tags_list__ref6,
                        'Found ',
                        tagStore.total || 0,
                        ' results in your search for "',
                        queryFilter.search,
                        '".',
                        tags_list__ref7,
                        Object(preact_min["h"])(
                            'button',
                            { 'class': 'btn btn-sm btn-warning mt-2',
                                onClick: function onClick() {
                                    return tagStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true });
                                }
                            },
                            tags_list__ref8,
                            ' Reset search'
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'table-responsive' },
                        Object(preact_min["h"])(
                            'table',
                            { 'class': tags_style_default.a.table + ' table table-striped table-sm table-borderless' },
                            Object(preact_min["h"])(
                                'thead',
                                null,
                                tagStore.sort !== tagStore.defaultSort && Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { colspan: '8' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': tags_style_default.a.pointerCursor + ' mr-2 badge badge-pill badge-secondary', onClick: function onClick() {
                                                    return tagStore.resetSort();
                                                } },
                                            tags_list__ref9,
                                            ' Reset sort'
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': tags_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return tagStore.toggleSort('id', '-');
                                                } },
                                            'Tag# ',
                                            util.getSortIcon('id', tagStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': tags_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return tagStore.toggleSort('parent', '-');
                                                } },
                                            'Parent # ',
                                            util.getSortIcon('parent', tagStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 55%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': tags_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return tagStore.toggleSort('name', '');
                                                } },
                                            'Name ',
                                            util.getSortIcon('name', tagStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': tags_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return tagStore.toggleSort('sort', '');
                                                } },
                                            'Sort ',
                                            util.getSortIcon('sort', tagStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': tags_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return tagStore.toggleSort('alias', '');
                                                } },
                                            'Alias ',
                                            util.getSortIcon('alias', tagStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': tags_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return tagStore.toggleSort('filter', '-');
                                                } },
                                            'Filter ',
                                            util.getSortIcon('filter', tagStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-center' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': tags_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return tagStore.toggleSort('pinned', '-');
                                                } },
                                            'Pinned ',
                                            util.getSortIcon('pinned', tagStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-center' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': tags_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return tagStore.toggleSort('menu', '-');
                                                } },
                                            'Menu ',
                                            util.getSortIcon('menu', tagStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': tags_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return tagStore.toggleSort('create_date', '-');
                                                } },
                                            'Created ',
                                            util.getSortIcon('create_date', tagStore.sort)
                                        )
                                    )
                                )
                            ),
                            Object(preact_min["h"])(
                                'tbody',
                                null,
                                !tags.length && Object(preact_min["h"])(
                                    'tr',
                                    { 'class': '' + tags_style_default.a.tableline },
                                    tags_list__ref10
                                ),
                                tags && tags.map(function (tag) {
                                    return Object(preact_min["h"])(
                                        'tr',
                                        { 'class': '' + tags_style_default.a.tableline },
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            tag.id
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            Object(preact_min["h"])(
                                                'a',
                                                { href: '/tags/' + tag.parent + '/Basics' },
                                                tag.parent
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(
                                                'a',
                                                { href: '/tags/' + tag.id + '/Basics' },
                                                tag.name
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            Object(preact_min["h"])(input, {
                                                id: tag.id,
                                                className: 'text-right form-control-sm',
                                                isValid: saved['sort.' + tag.id],
                                                name: 'sort',
                                                value: tag.sort,
                                                onInput: function onInput(e) {
                                                    return _this4.updateField(tag.id, 'sort', e.target.value);
                                                },
                                                hideHelp: 1
                                            })
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            tag.alias
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-center' },
                                            Object(preact_min["h"])(
                                                'span',
                                                {
                                                    'class': 'mr-1 badge ' + tags_style_default.a.pointerCursor + ' badge-' + util.colorClass(tag.filter, 'yesno'),
                                                    onClick: function onClick() {
                                                        return tagStore.saveField(tag.id, 'filter', util.cyclevalues(tag.filter, [0, 1]), true);
                                                    }
                                                },
                                                util.statusText(tag.filter, 'yesno')
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-center' },
                                            Object(preact_min["h"])(
                                                'span',
                                                {
                                                    'class': 'mr-1 badge ' + tags_style_default.a.pointerCursor + ' badge-' + util.colorClass(tag.pinned, 'yesno'),
                                                    onClick: function onClick() {
                                                        return tagStore.saveField(tag.id, 'pinned', util.cyclevalues(tag.pinned, [0, 1]), true);
                                                    }
                                                },
                                                util.statusText(tag.pinned, 'yesno')
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-center' },
                                            Object(preact_min["h"])(
                                                'span',
                                                {
                                                    'class': 'mr-1 badge ' + tags_style_default.a.pointerCursor + ' badge-' + util.colorClass(tag.menu, 'yesno'),
                                                    onClick: function onClick() {
                                                        return tagStore.saveField(tag.id, 'menu', util.cyclevalues(tag.menu, [0, 1]), true);
                                                    }
                                                },
                                                util.statusText(tag.menu, 'yesno')
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            util.ffeDateTime(tag.create_date),
                                            tag.updated && Object(preact_min["h"])(
                                                'div',
                                                null,
                                                Object(preact_min["h"])(
                                                    'small',
                                                    { 'class': 'text-muted' },
                                                    tags_list__ref11,
                                                    ' ',
                                                    util.ffeDateTime(tag.updated)
                                                )
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    )
                )
            ),
            loading && tags_list__ref12,
            tags_list__ref13
        );
    };

    return TagList;
}(preact_min["Component"]), tags_list__initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.handleScroll = function () {
        var loading = _this5.state.loading;
        var tagStore = _this5.props.stores.tagStore;
        var totalAppend = tagStore.totalAppend,
            limit = tagStore.limit;

        if (window.innerHeight + document.documentElement.scrollTop + 500 < document.documentElement.offsetHeight) return;
        if (loading) return;

        var offset = tagStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(_this5.scrollLoader);
            _this5.scrollLoader = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this5.setState({ loading: true });
                                tagStore.updateOffset(offset);
                                _context4.next = 4;
                                return tagStore.list(true);

                            case 4:
                                _this5.setState({ loading: false });

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            })), 500);
        }
    };
}, tags_list__temp)) || tags_list__class;

/* harmony default export */ var tags_list = (list_TagList);
// CONCATENATED MODULE: ./components/tags/index.js




var tags__class;









var tags_initialState = {
    height: 100
};

var tags_Tag = Object(index_module["a" /* observer */])(tags__class = function (_Component) {
    inherits_default()(Tag, _Component);

    function Tag(props) {
        classCallCheck_default()(this, Tag);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = tags_initialState;
        _this.subscriptions();
        return _this;
    }

    Tag.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    Tag.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(tags_list, props)
                )
            )
        );
    };

    return Tag;
}(preact_min["Component"])) || tags__class;

/* harmony default export */ var components_tags = (tags_Tag);
// CONCATENATED MODULE: ./components/tags/edit.js







var tags_edit__class, tags_edit__class2, tags_edit__temp, tags_edit__initialiseProps;













var tags_edit_initialState = {
    height: 100,
    windowHeight: 0
};

var tags_edit_FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    parent: { label: 'Parent tag db #', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    name: { label: 'Tag name', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    alias: { label: 'Alias', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    filter: { label: 'Filter', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },
    sort: { label: 'Sort', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    menu: { label: 'Menu', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },
    pinned: { label: 'Pinned', type: 'radio', values: [{ key: 'Yes', val: 1 }, { key: 'No', val: 0 }], readonly: false, help: 'Field is DealerWeb only.' },
    field: { label: 'Fields', type: 'json', readonly: false, help: 'Field is DealerWeb only.' },
    create_date: { label: 'Created date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'Updated date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' }
};

var edit__ref2 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var edit_TagEdit = Object(index_module["a" /* observer */])(tags_edit__class = (tags_edit__temp = tags_edit__class2 = function (_Component) {
    inherits_default()(TagEdit, _Component);

    function TagEdit(props) {
        classCallCheck_default()(this, TagEdit);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        tags_edit__initialiseProps.call(_this);

        _this.state = extends_default()({}, tags_edit_initialState);
        _this.updateTimer = {};
        var tagStore = _this.props.stores.tagStore;

        tagStore.load(props.id);

        _this.fields = [{
            tabname: 'Basics',
            icon: 'fas fa-user-edit',
            fields: ['id', 'parent', 'name', 'sort', 'alias', 'filter', 'menu', 'pinned', 'field', 'create_date', 'updatedDate'].map(function (f) {
                return util.makeField(f, tags_edit_FIELDS);
            })
        }];
        _this.subscriptions();
        return _this;
    }

    TagEdit.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    TagEdit.prototype.doUpdateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(id, field, value) {
            var tagStore;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            tagStore = this.props.stores.tagStore;
                            _context.next = 3;
                            return tagStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return doUpdateField;
    }();

    TagEdit.prototype.render = function render(props) {
        var _this3 = this;

        var height = this.state.height;
        var tagStore = this.props.stores.tagStore;
        var tag = tagStore.tag,
            saved = tagStore.saved;


        var tabIdx = this.fields.findIndex(function (e) {
            return e.tabname === props.tabname;
        });
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-2 fixed-top overflow-auto',
                        style: 'margin-top: ' + (height + 60) + 'px; height: calc(100% - ' + (height + 60) + 'px);'
                    },
                    Object(preact_min["h"])(
                        'small',
                        null,
                        Object(preact_min["h"])(tags_tree, this.props)
                    ),
                    edit__ref2
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-10 offset-2' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-flex flex-row bd-highlight mb-3' },
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: '/tags', 'class': 'mr-2 btn btn-sm btn-warning' },
                                Object(preact_min["h"])('i', { 'class': 'fas fa-arrow-left mr-1' }),
                                'Back'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'h4',
                                null,
                                'Edit: ',
                                tag.id,
                                ': ',
                                tag.name
                            )
                        )
                    ),
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'nav nav-tabs mb-2' },
                        this.fields.map(function (tab) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'nav-item' },
                                Object(preact_min["h"])(
                                    'a',
                                    { 'class': 'nav-link ' + (props.tabname === tab.tabname ? 'active' : ''),
                                        href: '/tags/' + props.id + '/' + tab.tabname
                                    },
                                    Object(preact_min["h"])('i', { 'class': tab.icon + ' mr-2' }),
                                    tab.tabname
                                )
                            );
                        })
                    ),
                    this.fields[tabIdx].fields.map(function (field) {
                        return Object(preact_min["h"])(formField_FormRow, {
                            field: field,
                            object: tag,
                            saved: saved,
                            updateField: _this3.updateField
                        });
                    })
                )
            )
        );
    };

    return TagEdit;
}(preact_min["Component"]), tags_edit__initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.updateField = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var tagStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            tagStore = _this4.props.stores.tagStore;

                            tagStore.updateField(id, field, value);

                            clearTimeout(_this4.updateTimer[field]);
                            _this4.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                    while (1) {
                                        switch (_context2.prev = _context2.next) {
                                            case 0:
                                                _this4.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context2.stop();
                                        }
                                    }
                                }, _callee2, _this4);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this4);
        }));

        return function (_x4, _x5, _x6) {
            return _ref3.apply(this, arguments);
        };
    }();
}, tags_edit__temp)) || tags_edit__class;

/* harmony default export */ var tags_edit = (edit_TagEdit);
// EXTERNAL MODULE: ./components/articles/style.css
var articles_style = __webpack_require__("OQuE");
var articles_style_default = /*#__PURE__*/__webpack_require__.n(articles_style);

// CONCATENATED MODULE: ./components/articles/tree.js





var articles_tree__class, articles_tree__class2, articles_tree__class3, articles_tree__class4, articles_tree__temp, articles_tree__initialiseProps;








var articles_tree_initialState = {};

var articles_tree__ref = Object(preact_min["h"])('i', { 'class': 'fas fa-filter ml-1' });

var articles_tree__ref2 = Object(preact_min["h"])('i', { 'class': 'fas fa-bars ml-1' });

var articles_tree__ref3 = Object(preact_min["h"])('i', { 'class': 'fas fa-thumbtack ml-1' });

var articles_tree_TagLine = Object(index_module["a" /* observer */])(articles_tree__class = function (_Component) {
    inherits_default()(TagLine, _Component);

    function TagLine() {
        classCallCheck_default()(this, TagLine);

        return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
    }

    TagLine.prototype.render = function render() {
        var _props = this.props,
            tag = _props.tag,
            queryFilter = _props.queryFilter,
            onClickTag = _props.onClickTag,
            children = _props.children,
            parent = _props.parent,
            className = _props.className;

        var isSelected = queryFilter.tag === tag.id || parent === tag.id;
        return Object(preact_min["h"])(
            'div',
            { 'class': 'nav-item' },
            Object(preact_min["h"])(
                'div',
                { 'class': articles_style_default.a.pointerCursor + ' nav-link py-0 ' + (isSelected ? 'active' : '') + ' ' + className },
                Object(preact_min["h"])(
                    'span',
                    { onClick: function onClick() {
                            return onClickTag(tag.id, { open: !tag.parent });
                        } },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'float-right' },
                        tag.filter ? articles_tree__ref : '',
                        tag.menu ? articles_tree__ref2 : '',
                        tag.pinned ? articles_tree__ref3 : ''
                    ),
                    Object(preact_min["h"])('i', { 'class': 'fas fa-folder' + (isSelected ? '-open' : '') + ' mr-1' }),
                    tag.name,
                    tag.count && Object(preact_min["h"])(
                        'span',
                        { 'class': 'font-weight-lighter ml-2' },
                        '(',
                        tag.count,
                        ')'
                    )
                )
            ),
            isSelected && Object(preact_min["h"])(
                'div',
                { 'class': 'd-' + (isSelected ? 'block' : 'none') + ' nav flex-column mt-1 ml-4' },
                Object(preact_min["h"])(articles_tree_TagList, {
                    className: className,
                    tags: children,
                    queryFilter: queryFilter,
                    onClickTag: onClickTag,
                    parent: parent
                })
            )
        );
    };

    return TagLine;
}(preact_min["Component"])) || articles_tree__class;

var articles_tree_TagList = Object(index_module["a" /* observer */])(articles_tree__class2 = function (_Component2) {
    inherits_default()(TagList, _Component2);

    function TagList() {
        classCallCheck_default()(this, TagList);

        return possibleConstructorReturn_default()(this, _Component2.apply(this, arguments));
    }

    TagList.prototype.render = function render() {
        var _props2 = this.props,
            tags = _props2.tags,
            queryFilter = _props2.queryFilter,
            onClickTag = _props2.onClickTag,
            children = _props2.children,
            parent = _props2.parent,
            className = _props2.className;

        return Object(preact_min["h"])(
            'div',
            null,
            tags.map(function (tag) {
                return Object(preact_min["h"])(articles_tree_TagLine, {
                    className: className,
                    tag: tag,
                    queryFilter: queryFilter,
                    onClickTag: onClickTag,
                    children: children,
                    parent: parent
                });
            })
        );
    };

    return TagList;
}(preact_min["Component"])) || articles_tree__class2;

var articles_tree__ref4 = Object(preact_min["h"])('br', null);

var articles_tree_TagTree = Object(index_module["a" /* observer */])(articles_tree__class3 = (articles_tree__temp = articles_tree__class4 = function (_Component3) {
    inherits_default()(TagTree, _Component3);

    function TagTree(props) {
        classCallCheck_default()(this, TagTree);

        var _this3 = possibleConstructorReturn_default()(this, _Component3.call(this, props));

        articles_tree__initialiseProps.call(_this3);

        _this3.state = extends_default()({}, articles_tree_initialState);

        var tagStore = _this3.props.stores.tagStore;
        var tagTreeParent = tagStore.tagTreeParent;

        tagStore.load('', false, { dataKey: 'tagTree', query: { hasParent: 0 } });
        tagStore.load('', false, { dataKey: 'tagTreeBranchPinned', query: { pinned: 1 } });
        if (tagTreeParent) {
            tagStore.load('', false, { dataKey: 'tagTreeBranch', query: { parent: tagTreeParent, limit: 200 } });
        }
        return _this3;
    }

    TagTree.prototype.render = function render() {
        var _this4 = this;

        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var _props$stores = props.stores,
            tagStore = _props$stores.tagStore,
            articleStore = _props$stores.articleStore;
        var tagTree = tagStore.tagTree,
            tagTreeBranch = tagStore.tagTreeBranch,
            tagTreeBranchPinned = tagStore.tagTreeBranchPinned,
            tagTreeParent = tagStore.tagTreeParent;
        var queryFilter = articleStore.queryFilter;

        var isSelected = !queryFilter.tag;

        return Object(preact_min["h"])(
            'div',
            { 'class': 'nav flex-column nav-pills' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'nav-item mb-4 pb-4', style: 'border-bottom: 1px solid;' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': articles_style_default.a.pointerCursor + ' nav-link py-0 ' + (isSelected ? 'active' : '') },
                    Object(preact_min["h"])(
                        'span',
                        { onClick: function onClick() {
                                return _this4.onClickTag(null, { open: true });
                            } },
                        'ALL TAGS'
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'mb-4 pb-4', style: 'border-bottom: 1px solid;' },
                'PINNED TAGS: ',
                articles_tree__ref4,
                Object(preact_min["h"])(articles_tree_TagList, {
                    className: 'font-weight-bold',
                    tags: tagTreeBranchPinned,
                    queryFilter: queryFilter,
                    onClickTag: this.onClickTag
                })
            ),
            Object(preact_min["h"])(articles_tree_TagList, {
                tags: tagTree,
                queryFilter: queryFilter,
                onClickTag: this.onClickTag,
                children: tagTreeBranch,
                parent: tagTreeParent
            })
        );
    };

    return TagTree;
}(preact_min["Component"]), articles_tree__initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.onClickTag = function (id) {
        var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var articleStore = _this5.props.stores.articleStore;

        articleStore.toggleQueryfilter('tag', id, { setValue: true });
        if (opt.open) {
            var tagStore = _this5.props.stores.tagStore;

            tagStore.updateKeyValue('tagTreeBranch', []);
            tagStore.updateKeyValue('tagTreeParent', id, { save: true });
            tagStore.load('', false, { dataKey: 'tagTreeBranch', query: { parent: id, limit: 200 } });
        }
    };
}, articles_tree__temp)) || articles_tree__class3;

/* harmony default export */ var articles_tree = (articles_tree_TagTree);
// CONCATENATED MODULE: ./components/articles/list.js







var articles_list__class, articles_list__class2, articles_list__temp, articles_list__initialiseProps;













var articles_list_initialState = {
    height: 100,
    windowHeight: 0,
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false
    }
};

var articles_list__ref4 = Object(preact_min["h"])('br', null);

var articles_list__ref5 = Object(preact_min["h"])('i', { 'class': 'far fa-file mr-2' });

var articles_list__ref6 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var articles_list__ref7 = Object(preact_min["h"])(
    'h1',
    null,
    Object(preact_min["h"])('i', { 'class': 'fas fa-search' }),
    ' Search results'
);

var articles_list__ref8 = Object(preact_min["h"])('br', null);

var articles_list__ref9 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var articles_list__ref10 = Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle' });

var articles_list__ref11 = Object(preact_min["h"])(
    'th',
    { style: 'width: 5%', 'class': 'text-center' },
    'Image'
);

var articles_list__ref12 = Object(preact_min["h"])(
    'th',
    { style: 'width: 20%' },
    'Tag'
);

var articles_list__ref13 = Object(preact_min["h"])(
    'th',
    { style: 'width: 5%', 'class': 'text-right' },
    'Offline'
);

var articles_list__ref14 = Object(preact_min["h"])(
    'td',
    { 'class': 'text-center', colspan: '9' },
    Object(preact_min["h"])(
        'h5',
        null,
        'No articles found'
    ),
    'Try using the "Show all" button if you are missing some articles.'
);

var articles_list__ref15 = Object(preact_min["h"])('i', { 'class': 'fas fa-link mr-1' });

var articles_list__ref16 = Object(preact_min["h"])('i', { 'class': 'fab fa-youtube mr-1' });

var articles_list__ref17 = Object(preact_min["h"])('i', { 'class': 'fas fa-search mr-1' });

var list__ref18 = Object(preact_min["h"])('i', { 'class': 'fas fa-edit' });

var articles_list__ref19 = Object(preact_min["h"])(
    'div',
    { 'class': 'row' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'col-12 text-center' },
        Object(preact_min["h"])(
            'div',
            { 'class': 'spinner-border text-success', role: 'status' },
            Object(preact_min["h"])(
                'span',
                { 'class': 'sr-only' },
                'Loading...'
            )
        )
    )
);

var list__ref20 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var list_ArticleList = Object(index_module["a" /* observer */])(articles_list__class = (articles_list__temp = articles_list__class2 = function (_Component) {
    inherits_default()(ArticleList, _Component);

    function ArticleList(props) {
        classCallCheck_default()(this, ArticleList);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        articles_list__initialiseProps.call(_this);

        _this.state = extends_default()({}, articles_list_initialState);
        _this.updateTimer = {};

        var articleStore = _this.props.stores.articleStore;

        articleStore.toggleQueryfilter('status', 'all', { setValue: true });
        articleStore.list(false, { addData: ['tagList', 'tagIdRef'] });
        _this.subscriptions();
        return _this;
    }

    ArticleList.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    ArticleList.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    ArticleList.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    ArticleList.prototype.updateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(id, field, value) {
            var _this3 = this;

            var articleStore;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            articleStore = this.props.stores.articleStore;

                            articleStore.updateField(id, field, value);

                            clearTimeout(this.updateTimer[field]);
                            this.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                return regenerator_default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _this3.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this3);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function updateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return updateField;
    }();

    ArticleList.prototype.doUpdateField = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var articleStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            articleStore = this.props.stores.articleStore;
                            _context3.next = 3;
                            return articleStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function doUpdateField(_x4, _x5, _x6) {
            return _ref3.apply(this, arguments);
        }

        return doUpdateField;
    }();

    ArticleList.prototype.render = function render() {
        var _this4 = this;

        var _state = this.state,
            loading = _state.loading,
            height = _state.height;
        var articleStore = this.props.stores.articleStore;
        var imageServer = this.props.imageServer;
        var articles = articleStore.articles,
            queryFilter = articleStore.queryFilter,
            tagIdRef = articleStore.tagIdRef,
            saved = articleStore.saved;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'text-muted font-weight-lighter float-right ml-4' },
                        'Total: ',
                        articleStore.total,
                        articles_list__ref4
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'ml-2 float-right btn btn-sm btn-success',
                            onClick: this.createNewArticle
                        },
                        articles_list__ref5,
                        'New article'
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.status, 'article'),
                            onClick: function onClick() {
                                return articleStore.toggleQueryfilter('status', util.cyclevalues(queryFilter.status, ['all', 2, 1, 3]), { setValue: 1 });
                            }
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.status ? 'on' : 'off') + ' mr-1' }),
                        'Status'
                    ),
                    Object(preact_min["h"])(
                        'button',
                        { 'class': 'mr-2 btn btn-sm ' + util.buttonClass(queryFilter.showall),
                            onClick: function onClick() {
                                return articleStore.toggleQueryfilter('showall', util.cyclevalues(queryFilter.showall, [null, 1]), { setValue: 1 });
                            }
                        },
                        Object(preact_min["h"])('i', { 'class': 'fas fa-toggle-' + (queryFilter.showall ? 'on' : 'off') + ' mr-1' }),
                        'Show all'
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': 'float-left form-row align-items-center mr-5' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])('input', { type: 'text', 'class': 'form-control form-control-sm', id: 'inlineFormInputName', placeholder: 'Search for articles...',
                                onInput: function onInput(e) {
                                    return articleStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true });
                                },
                                value: queryFilter.search
                            })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])(
                                'button',
                                { type: 'button', 'class': 'btn btn-sm btn-primary', onClick: function onClick() {
                                        return articleStore.list();
                                    } },
                                'Search'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-2 fixed-top overflow-auto',
                        style: 'margin-top: ' + (height + 60) + 'px; height: calc(100% - ' + (height + 60) + 'px);'
                    },
                    Object(preact_min["h"])(
                        'small',
                        null,
                        Object(preact_min["h"])(articles_tree, this.props)
                    ),
                    articles_list__ref6
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-10 offset-2' },
                    queryFilter.search && Object(preact_min["h"])(
                        'div',
                        { 'class': 'w-100 text-left mt-2 mb-5' },
                        articles_list__ref7,
                        'Found ',
                        articleStore.total,
                        ' results in your search for "',
                        queryFilter.search,
                        '".',
                        articles_list__ref8,
                        Object(preact_min["h"])(
                            'button',
                            { 'class': 'btn btn-sm btn-warning mt-2',
                                onClick: function onClick() {
                                    return articleStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true });
                                }
                            },
                            articles_list__ref9,
                            ' Reset search'
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'table-responsive' },
                        Object(preact_min["h"])(
                            'table',
                            { 'class': articles_style_default.a.table + ' table table-striped table-sm table-borderless' },
                            Object(preact_min["h"])(
                                'thead',
                                null,
                                articleStore.sort !== articleStore.defaultSort && Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { colspan: '8' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': articles_style_default.a.pointerCursor + ' mr-2 badge badge-pill badge-secondary', onClick: function onClick() {
                                                    return articleStore.resetSort();
                                                } },
                                            articles_list__ref10,
                                            ' Reset sort'
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': articles_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return articleStore.toggleSort('id', '-');
                                                } },
                                            'Article# ',
                                            util.getSortIcon('id', articleStore.sort)
                                        )
                                    ),
                                    articles_list__ref11,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 35%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': articles_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return articleStore.toggleSort('title', '');
                                                } },
                                            'Title ',
                                            util.getSortIcon('title', articleStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': articles_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return articleStore.toggleSort('sort', '');
                                                } },
                                            'Sort ',
                                            util.getSortIcon('sort', articleStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-center' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': articles_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return articleStore.toggleSort('status', '-');
                                                } },
                                            'Status ',
                                            util.getSortIcon('status', articleStore.sort)
                                        )
                                    ),
                                    articles_list__ref12,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': articles_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return articleStore.toggleSort('author', '-');
                                                } },
                                            'Author ',
                                            util.getSortIcon('author', articleStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': articles_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return articleStore.toggleSort('create_date', '-');
                                                } },
                                            'Created ',
                                            util.getSortIcon('create_date', articleStore.sort)
                                        )
                                    ),
                                    articles_list__ref13
                                )
                            ),
                            Object(preact_min["h"])(
                                'tbody',
                                null,
                                !articles.length && Object(preact_min["h"])(
                                    'tr',
                                    { 'class': '' + articles_style_default.a.tableline },
                                    articles_list__ref14
                                ),
                                articles && articles.map(function (article) {
                                    return Object(preact_min["h"])(
                                        'tr',
                                        { 'class': '' + articles_style_default.a.tableline },
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            article.id
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-center' },
                                            util.asString(article, 'images', 'tiny') && Object(preact_min["h"])(
                                                'a',
                                                { href: '/articles/' + article.id + '/Basics' },
                                                Object(preact_min["h"])('img', { src: imageServer + '/' + util.asString(article, 'images', 'tiny'), 'class': 'rounded' })
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(
                                                'div',
                                                null,
                                                Object(preact_min["h"])(
                                                    'a',
                                                    { href: '/articles/' + article.id + '/Basics' },
                                                    article.title || '(No title)'
                                                )
                                            ),
                                            article.url && Object(preact_min["h"])(
                                                'div',
                                                null,
                                                Object(preact_min["h"])(
                                                    'small',
                                                    null,
                                                    articles_list__ref15,
                                                    ' ',
                                                    article.url
                                                )
                                            ),
                                            article.youtube && Object(preact_min["h"])(
                                                'div',
                                                null,
                                                Object(preact_min["h"])(
                                                    'small',
                                                    null,
                                                    articles_list__ref16,
                                                    ' ',
                                                    article.youtube
                                                )
                                            ),
                                            article.productsearch && Object(preact_min["h"])(
                                                'div',
                                                null,
                                                Object(preact_min["h"])(
                                                    'small',
                                                    null,
                                                    articles_list__ref17,
                                                    ' ',
                                                    article.productsearch
                                                )
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            Object(preact_min["h"])(input, {
                                                id: article.id,
                                                className: 'text-right form-control-sm',
                                                isValid: saved['sort.' + article.id],
                                                name: 'sort',
                                                value: article.sort,
                                                onInput: function onInput(e) {
                                                    return _this4.updateField(article.id, 'sort', e.target.value);
                                                },
                                                hideHelp: 1
                                            })
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-center' },
                                            Object(preact_min["h"])(
                                                'span',
                                                {
                                                    'class': 'mr-1 badge ' + articles_style_default.a.pointerCursor + ' badge-' + util.colorClass(article.status, 'article'),
                                                    onClick: function onClick() {
                                                        return articleStore.saveField(article.id, 'status', util.cyclevalues(article.status, [1, 2, 3]), true);
                                                    }
                                                },
                                                util.statusText(article.status, 'article')
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            util.asString(tagIdRef, article.tag, 'name') && Object(preact_min["h"])(
                                                'span',
                                                { 'class': 'mr-2 badge badge-primary' },
                                                util.asString(tagIdRef, article.tag, 'name')
                                            ),
                                            article.tags
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            article.author
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            Object(preact_min["h"])(
                                                'div',
                                                null,
                                                util.ffeDateTime(article.create_date)
                                            ),
                                            article.updated && Object(preact_min["h"])(
                                                'div',
                                                null,
                                                Object(preact_min["h"])(
                                                    'small',
                                                    { 'class': 'text-muted' },
                                                    list__ref18,
                                                    ' ',
                                                    util.ffeDateTime(article.updated)
                                                )
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            Object(preact_min["h"])(
                                                'span',
                                                {
                                                    'class': 'mr-1 badge ' + articles_style_default.a.pointerCursor + ' badge-' + (article.offline === 1 ? 'success' : 'danger'),
                                                    onClick: function onClick() {
                                                        return articleStore.saveField(article.id, 'offline', article.offline === 1 ? 0 : 1, true);
                                                    }
                                                },
                                                '\xA0',
                                                Object(preact_min["h"])('i', { 'class': 'fas fa-trash' + (article.offline === 1 ? '-restore' : '') }),
                                                ' ',
                                                article.offline === 1 ? 'Restore' : 'Delete'
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    )
                )
            ),
            loading && articles_list__ref19,
            list__ref20
        );
    };

    return ArticleList;
}(preact_min["Component"]), articles_list__initialiseProps = function _initialiseProps() {
    var _this5 = this;

    this.handleScroll = function () {
        var loading = _this5.state.loading;
        var articleStore = _this5.props.stores.articleStore;
        var totalAppend = articleStore.totalAppend,
            limit = articleStore.limit;

        if (window.innerHeight + document.documentElement.scrollTop + 500 < document.documentElement.offsetHeight) return;
        if (loading) return;

        var offset = articleStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(_this5.scrollLoader);
            _this5.scrollLoader = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this5.setState({ loading: true });
                                articleStore.updateOffset(offset);
                                _context4.next = 4;
                                return articleStore.list(true);

                            case 4:
                                _this5.setState({ loading: false });

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5);
            })), 500);
        }
    };

    this.createNewArticle = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var _props$stores, articleStore, dealerStore, realDealer;

        return regenerator_default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _props$stores = _this5.props.stores, articleStore = _props$stores.articleStore, dealerStore = _props$stores.dealerStore;
                        realDealer = dealerStore.realDealer;
                        _context5.next = 4;
                        return articleStore.create(extends_default()({}, articleStore.queryFilter, {
                            author: realDealer.email,
                            status: 1,
                            title: 'No title yet for this shiny new article...'
                        }));

                    case 4:
                        _context5.next = 6;
                        return articleStore.list(false, { addData: ['tagList', 'tagIdRef'] });

                    case 6:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this5);
    }));
}, articles_list__temp)) || articles_list__class;

/* harmony default export */ var articles_list = (list_ArticleList);
// CONCATENATED MODULE: ./components/articles/index.js




var articles__class;









var articles_initialState = {
    height: 100
};

var articles_Tag = Object(index_module["a" /* observer */])(articles__class = function (_Component) {
    inherits_default()(Tag, _Component);

    function Tag(props) {
        classCallCheck_default()(this, Tag);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = articles_initialState;
        _this.subscriptions();
        return _this;
    }

    Tag.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    Tag.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(articles_list, props)
                )
            )
        );
    };

    return Tag;
}(preact_min["Component"])) || articles__class;

/* harmony default export */ var components_articles = (articles_Tag);
// CONCATENATED MODULE: ./components/articles/edit.js







var articles_edit__class, articles_edit__class2, articles_edit__temp, articles_edit__initialiseProps;















var articles_edit_initialState = {
    height: 100,
    windowHeight: 0
};

var articles_edit_FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    author: { label: 'Author', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    sort: { label: 'Sort', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    status: { label: 'Status', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    tag: { label: 'Tag', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    title: { label: 'Title', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    url: { label: 'URL', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    urlTarget: { label: 'Open in new window', type: 'checkbox', readonly: false, help: 'Field is DealerWeb only.' },
    ingress: { label: 'Ingress', type: 'textarea', rows: 5, readonly: false, help: 'Field is DealerWeb only.' },
    body: { label: 'Body', type: 'textarea', rows: 15, readonly: false, help: 'Field is DealerWeb only.' },
    productsearch: { label: 'productsearch', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    introYear: { label: 'introYear', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    imgs: { label: 'Image preview', type: 'imageList', imagePrefix: 'article', readonly: false, help: 'Field is DealerWeb only.' },
    images: { label: 'Images', type: 'json', readonly: false, help: 'Field is DealerWeb only.' },
    version: { label: 'Document version', type: 'text', readonly: false, help: 'Field is DealerWeb only. Value should be 1, 2, 3, etc.' },
    publishDate: { label: 'Publish date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updated: { label: 'Updated date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    create_date: { label: 'Created date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' }
};

var articles_edit__ref2 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var edit__ref3 = Object(preact_min["h"])('i', { 'class': 'fas fa-share ml-2' });

var edit_ArticleEdit = Object(index_module["a" /* observer */])(articles_edit__class = (articles_edit__temp = articles_edit__class2 = function (_Component) {
    inherits_default()(ArticleEdit, _Component);

    function ArticleEdit(props) {
        classCallCheck_default()(this, ArticleEdit);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        articles_edit__initialiseProps.call(_this);

        _this.state = extends_default()({}, articles_edit_initialState, {
            previewServer: util.getPreviewServer(),
            jwtToken: util.getJwtToken()
        });
        _this.updateTimer = {};
        var articleStore = _this.props.stores.articleStore;

        articleStore.load(props.id);
        _this.fields = [{
            tabname: 'Basics',
            icon: 'fas fa-user-edit',
            fields: ['id', 'author', 'sort', 'status', 'version', 'tag', 'tags', 'title', 'url', 'urlTarget', 'ingress', 'body', 'productsearch', 'introYear', 'imgs', 'images', 'updated', 'create_date'].map(function (f) {
                return util.makeField(f, articles_edit_FIELDS);
            })
        }, {
            tabname: 'Images',
            icon: 'fas fa-image',
            fields: [{
                name: 'imgs',
                label: 'Images',
                type: 'object',
                view: function view(val, opt) {
                    var opts = {
                        id: opt.id,
                        name: opt.name,
                        value: val,
                        imagePrefix: 'article',
                        updateField: opt.updateField,
                        handleAddImage: function handleAddImage(imageObject) {
                            var options = opt;
                            _this.addArticleImage(options.id, imageObject);
                        },
                        handleDelImage: function handleDelImage(imageId) {
                            var options = opt;
                            _this.delArticleImage(options.id, imageId);
                        }
                    };
                    return Object(preact_min["h"])(form_images, opts);
                },
                readonly: false,
                help: 'Field is DealerWeb only.'
            }]
        }];
        _this.subscriptions();
        return _this;
    }

    ArticleEdit.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    // {
    //     "2":{
    //         "id":3191,
    //         "title":"Get Busy Tying - Loon Fly Tying Tools",
    //         "ingress":"With so many fly fishermen in lockdown across Europe it's time to get busy tying flies - time to prepare for better times... Check out the Loon fly tying tool assortment with plenty of news for 2020.",
    //         "create_date":"2020-04-14T07:04:50.144Z",
    //         "updated":"2020-04-14T09:12:28+02:00",
    //         "tag":10,
    //         "tags":[{"id":10,"name":"news"}],
    //         "status":2,
    //         "author":"rasmus@flyfisheurope.com",
    //         "imgs":{
    //             "1":{
    //                 "name":"Fly Tying Tools1.jpg",
    //                 "encoding":"7bit",
    //                 "mimetype":"image/jpeg",
    //                 "ext":".jpg",
    //                 "newFilename":"dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //                 "s3Link":"https://dealer.flyfisheurope.com/originaldealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //                 "s3ThumbLink":"https://dealer.flyfisheurope.com/80x80/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg"
    //             }
    //         },
    //         "url":"https://dealer.flyfisheurope.com/html/dealerweb-v2.html#/product/loon/Fly%20Tying%20Tools",
    //         "images":{
    //             "tiny":"80x80/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //             "small":"220x/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //             "medium":"400x/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //             "large":"1024x/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //             "xlarge":"1280x/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg",
    //             "xxlarge":"1600x/dealerweb-cms-d27d04a6-321d-4fb6-a082-0d5044d91fad.jpg"
    //         }
    //     }
    // }

    ArticleEdit.prototype.doUpdateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(id, field, value) {
            var articleStore;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            articleStore = this.props.stores.articleStore;
                            _context.next = 3;
                            return articleStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return doUpdateField;
    }();

    ArticleEdit.prototype.render = function render(props) {
        var _this3 = this;

        var _state = this.state,
            height = _state.height,
            previewServer = _state.previewServer,
            jwtToken = _state.jwtToken;
        var articleStore = this.props.stores.articleStore;
        var article = articleStore.article,
            saved = articleStore.saved;


        var tabIdx = this.fields.findIndex(function (e) {
            return e.tabname === props.tabname;
        });
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-2 fixed-top overflow-auto',
                        style: 'margin-top: ' + (height + 60) + 'px; height: calc(100% - ' + (height + 60) + 'px);'
                    },
                    Object(preact_min["h"])(
                        'small',
                        null,
                        Object(preact_min["h"])(articles_tree, this.props)
                    ),
                    articles_edit__ref2
                ),
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-10 offset-2' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-flex flex-row bd-highlight mb-3' },
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: '/articles', 'class': 'mr-2 btn btn-sm btn-warning' },
                                Object(preact_min["h"])('i', { 'class': 'fas fa-arrow-left mr-1' }),
                                'Back'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'flex-grow-1' },
                            Object(preact_min["h"])(
                                'h4',
                                null,
                                'Edit: ',
                                article.id,
                                ': ',
                                article.title
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: previewServer + '/flyfisheurope/' + article.tag + '/' + article.id + '?token=' + jwtToken,
                                    target: '_blank',
                                    'class': 'mr-2 btn btn-sm btn-primary float-right' },
                                'Preview',
                                edit__ref3
                            )
                        )
                    ),
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'nav nav-tabs mb-2' },
                        this.fields.map(function (tab) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'nav-item' },
                                Object(preact_min["h"])(
                                    'a',
                                    { 'class': 'nav-link ' + (props.tabname === tab.tabname ? 'active' : ''),
                                        href: '/articles/' + props.id + '/' + tab.tabname
                                    },
                                    Object(preact_min["h"])('i', { 'class': tab.icon + ' mr-2' }),
                                    tab.tabname
                                )
                            );
                        })
                    ),
                    this.fields[tabIdx].fields.map(function (field) {
                        return Object(preact_min["h"])(formField_FormRow, {
                            field: field,
                            object: article,
                            saved: saved,
                            updateField: _this3.updateField
                        });
                    })
                )
            )
        );
    };

    return ArticleEdit;
}(preact_min["Component"]), articles_edit__initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.updateField = function () {
        var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var articleStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            articleStore = _this4.props.stores.articleStore;

                            articleStore.updateField(id, field, value);

                            clearTimeout(_this4.updateTimer[field]);
                            _this4.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                    while (1) {
                                        switch (_context2.prev = _context2.next) {
                                            case 0:
                                                _this4.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context2.stop();
                                        }
                                    }
                                }, _callee2, _this4);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this4);
        }));

        return function (_x4, _x5, _x6) {
            return _ref4.apply(this, arguments);
        };
    }();

    this.addArticleImage = function () {
        var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(id, imageObject) {
            var articleStore;
            return regenerator_default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            articleStore = _this4.props.stores.articleStore;

                            articleStore.addImage(id, imageObject);

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }));

        return function (_x7, _x8) {
            return _ref6.apply(this, arguments);
        };
    }();

    this.delArticleImage = function () {
        var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(id, imageId) {
            var articleStore;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            articleStore = _this4.props.stores.articleStore;

                            articleStore.delImage(id, imageId);

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this4);
        }));

        return function (_x9, _x10) {
            return _ref7.apply(this, arguments);
        };
    }();
}, articles_edit__temp)) || articles_edit__class;

/* harmony default export */ var articles_edit = (edit_ArticleEdit);
// EXTERNAL MODULE: ./components/consumers/style.css
var consumers_style = __webpack_require__("h8Pt");
var consumers_style_default = /*#__PURE__*/__webpack_require__.n(consumers_style);

// CONCATENATED MODULE: ./components/consumers/list.js







var consumers_list__class, consumers_list__class2, consumers_list__temp, consumers_list__initialiseProps;










var consumers_list_initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false
    }
};

var consumers_list__ref4 = Object(preact_min["h"])('br', null);

var consumers_list__ref5 = Object(preact_min["h"])(
    'h1',
    null,
    Object(preact_min["h"])('i', { 'class': 'fas fa-search' }),
    ' Search results'
);

var consumers_list__ref6 = Object(preact_min["h"])('br', null);

var consumers_list__ref7 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var consumers_list__ref8 = Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle' });

var consumers_list__ref9 = Object(preact_min["h"])(
    'th',
    { style: 'width: 10%' },
    'Delete'
);

var consumers_list__ref10 = Object(preact_min["h"])(
    'div',
    { 'class': 'row' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'col-12 text-center' },
        Object(preact_min["h"])(
            'div',
            { 'class': 'spinner-border text-success', role: 'status' },
            Object(preact_min["h"])(
                'span',
                { 'class': 'sr-only' },
                'Loading...'
            )
        )
    )
);

var consumers_list__ref11 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var list_ConsumerList = Object(index_module["a" /* observer */])(consumers_list__class = (consumers_list__temp = consumers_list__class2 = function (_Component) {
    inherits_default()(ConsumerList, _Component);

    function ConsumerList(props) {
        classCallCheck_default()(this, ConsumerList);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        consumers_list__initialiseProps.call(_this);

        _this.state = extends_default()({}, consumers_list_initialState, {
            previewServer: util.getPreviewServer()
        });
        _this.updateTimer = {};

        var consumerStore = _this.props.stores.consumerStore;

        consumerStore.list();
        return _this;
    }

    ConsumerList.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    ConsumerList.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    ConsumerList.prototype.updateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(id, field, value) {
            var _this2 = this;

            var consumerStore;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            consumerStore = this.props.stores.consumerStore;

                            consumerStore.updateField(id, field, value);

                            clearTimeout(this.updateTimer[field]);
                            this.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                return regenerator_default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _this2.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this2);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function updateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return updateField;
    }();

    ConsumerList.prototype.doUpdateField = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var consumerStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            consumerStore = this.props.stores.consumerStore;
                            _context3.next = 3;
                            return consumerStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function doUpdateField(_x4, _x5, _x6) {
            return _ref3.apply(this, arguments);
        }

        return doUpdateField;
    }();

    ConsumerList.prototype.render = function render() {
        var _this3 = this;

        var _state = this.state,
            loading = _state.loading,
            previewServer = _state.previewServer;
        var consumerStore = this.props.stores.consumerStore;
        var consumers = consumerStore.consumers,
            queryFilter = consumerStore.queryFilter,
            saved = consumerStore.saved,
            deleted = consumerStore.deleted;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'text-muted font-weight-lighter float-right mr-2' },
                        'Total: ',
                        consumerStore.total,
                        consumers_list__ref4
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': 'float-left form-row align-items-center mr-5' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])('input', { type: 'text', 'class': 'form-control form-control-sm', id: 'inlineFormInputName', placeholder: 'Search for consumers...',
                                onInput: function onInput(e) {
                                    return consumerStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true });
                                },
                                value: queryFilter.search
                            })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])(
                                'button',
                                { type: 'button', 'class': 'btn btn-sm btn-primary', onClick: function onClick() {
                                        return consumerStore.list();
                                    } },
                                'Search'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    queryFilter.search && Object(preact_min["h"])(
                        'div',
                        { 'class': 'w-100 text-left mt-2 mb-5' },
                        consumers_list__ref5,
                        'Found ',
                        consumerStore.total || 0,
                        ' results in your search for "',
                        queryFilter.search,
                        '".',
                        consumers_list__ref6,
                        Object(preact_min["h"])(
                            'button',
                            { 'class': 'btn btn-sm btn-warning mt-2',
                                onClick: function onClick() {
                                    return consumerStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true });
                                }
                            },
                            consumers_list__ref7,
                            ' Reset search'
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'table-responsive' },
                        Object(preact_min["h"])(
                            'table',
                            { 'class': consumers_style_default.a.table + ' table table-striped table-sm table-borderless' },
                            Object(preact_min["h"])(
                                'thead',
                                null,
                                consumerStore.sort !== consumerStore.defaultSort && Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { colspan: '8' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': consumers_style_default.a.pointerCursor + ' mr-2 badge badge-pill badge-secondary', onClick: function onClick() {
                                                    return consumerStore.resetSort();
                                                } },
                                            consumers_list__ref8,
                                            ' Reset sort'
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 15%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': consumers_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return consumerStore.toggleSort('email', '-');
                                                } },
                                            'email ',
                                            util.getSortIcon('email', consumerStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': consumers_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return consumerStore.toggleSort('receive_info', '-');
                                                } },
                                            'receive_info ',
                                            util.getSortIcon('receive_info', consumerStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': consumers_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return consumerStore.toggleSort('fname', '');
                                                } },
                                            'fname ',
                                            util.getSortIcon('fname', consumerStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': consumers_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return consumerStore.toggleSort('lname', '');
                                                } },
                                            'lname ',
                                            util.getSortIcon('lname', consumerStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': consumers_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return consumerStore.toggleSort('address1', '');
                                                } },
                                            'address1 ',
                                            util.getSortIcon('address1', consumerStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': consumers_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return consumerStore.toggleSort('postalcode', '');
                                                } },
                                            'postalcode ',
                                            util.getSortIcon('postalcode', consumerStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': consumers_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return consumerStore.toggleSort('postalplace', '');
                                                } },
                                            'postalplace ',
                                            util.getSortIcon('postalplace', consumerStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': consumers_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return consumerStore.toggleSort('country_name', '');
                                                } },
                                            'country_name ',
                                            util.getSortIcon('country_name', consumerStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': consumers_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return consumerStore.toggleSort('rods', '');
                                                } },
                                            'rods ',
                                            util.getSortIcon('rods', consumerStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': consumers_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return consumerStore.toggleSort('updated', '');
                                                } },
                                            'updated ',
                                            util.getSortIcon('updated', consumerStore.sort)
                                        )
                                    ),
                                    consumers_list__ref9
                                )
                            ),
                            Object(preact_min["h"])(
                                'tbody',
                                null,
                                consumers && consumers.map(function (consumer) {
                                    return Object(preact_min["h"])(
                                        'tr',
                                        { 'class': consumers_style_default.a.tableline + ' ' + (deleted[consumer.id] ? 'text-muted' : ''), style: '' + (deleted[consumer.id] ? 'text-decoration: line-through;' : '') },
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            !deleted[consumer.id] ? Object(preact_min["h"])(
                                                'a',
                                                { href: '/consumers/' + consumer.id + '/Basics' },
                                                consumer.email
                                            ) : Object(preact_min["h"])(
                                                'span',
                                                null,
                                                consumer.email
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            consumer.receive_info
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            consumer.fname
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            consumer.lname
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            consumer.address1
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            consumer.postalcode
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            consumer.postalplace
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            consumer.country_name
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            consumer.rods && Object.keys(consumer.rods).map(function (serial) {
                                                return Object(preact_min["h"])(
                                                    'a',
                                                    { 'class': 'mr-2 float-left', href: '/rodregs/' + serial + '/Basics' },
                                                    serial
                                                );
                                            })
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            consumer.updated
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(
                                                'nobr',
                                                null,
                                                !deleted[consumer.id] && Object(preact_min["h"])(
                                                    'a',
                                                    { 'class': 'btn btn-sm btn-danger', 'data-id': consumer.id, onClick: _this3.delete },
                                                    Object(preact_min["h"])('i', { 'class': 'fas fa-trash' }),
                                                    ' Delete'
                                                )
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    )
                )
            ),
            loading && consumers_list__ref10,
            consumers_list__ref11
        );
    };

    return ConsumerList;
}(preact_min["Component"]), consumers_list__initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.handleScroll = function () {
        var loading = _this4.state.loading;
        var consumerStore = _this4.props.stores.consumerStore;
        var totalAppend = consumerStore.totalAppend,
            limit = consumerStore.limit;

        if (window.innerHeight + document.documentElement.scrollTop + 500 < document.documentElement.offsetHeight) return;
        if (loading) return;

        var offset = consumerStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(_this4.scrollLoader);
            _this4.scrollLoader = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this4.setState({ loading: true });
                                consumerStore.updateOffset(offset);
                                _context4.next = 4;
                                return consumerStore.list(true);

                            case 4:
                                _this4.setState({ loading: false });

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            })), 500);
        }
    };

    this.delete = function () {
        var _ref13 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(event) {
            var id, consumerStore;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            id = event.target.dataset.id;
                            consumerStore = _this4.props.stores.consumerStore;
                            _context5.next = 4;
                            return consumerStore.delete(id);

                        case 4:
                            consumerStore.markDeleted(id);

                        case 5:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this4);
        }));

        return function (_x7) {
            return _ref13.apply(this, arguments);
        };
    }();
}, consumers_list__temp)) || consumers_list__class;

/* harmony default export */ var consumers_list = (list_ConsumerList);
// CONCATENATED MODULE: ./components/consumers/index.js




var consumers__class;









var consumers_initialState = {
    height: 100
};

var consumers_Consumer = Object(index_module["a" /* observer */])(consumers__class = function (_Component) {
    inherits_default()(Consumer, _Component);

    function Consumer(props) {
        classCallCheck_default()(this, Consumer);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = consumers_initialState;
        _this.subscriptions();
        return _this;
    }

    Consumer.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    Consumer.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(consumers_list, props)
                )
            )
        );
    };

    return Consumer;
}(preact_min["Component"])) || consumers__class;

/* harmony default export */ var components_consumers = (consumers_Consumer);
// CONCATENATED MODULE: ./components/consumers/edit.js







var consumers_edit__class, consumers_edit__class2, consumers_edit__temp, consumers_edit__initialiseProps;














var consumers_edit_initialState = {
    height: 100,
    windowHeight: 0
};

var consumers_edit_FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    email: { label: 'Email', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    fname: { label: 'Firstname', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    lname: { label: 'Lastname', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    address1: { label: 'Address', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    postalcode: { label: 'Zip', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    postalplace: { label: 'City', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    country_name: { label: 'Country', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    receive_info: { label: 'Newsletter', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    rods: { label: 'Rods', type: 'object', readonly: true, help: 'Field is DealerWeb only.' },
    position: { label: 'Position', type: 'object', readonly: true, help: 'Field is DealerWeb only.' },

    updated: { label: 'Updated date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    create_date: { label: 'Created date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' }
};

var edit_ConsumerEdit = Object(index_module["a" /* observer */])(consumers_edit__class = (consumers_edit__temp = consumers_edit__class2 = function (_Component) {
    inherits_default()(ConsumerEdit, _Component);

    function ConsumerEdit(props) {
        classCallCheck_default()(this, ConsumerEdit);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        consumers_edit__initialiseProps.call(_this);

        _this.state = extends_default()({}, consumers_edit_initialState, {
            previewServer: util.getPreviewServer(),
            jwtToken: util.getJwtToken()
        });
        _this.updateTimer = {};
        var consumerStore = _this.props.stores.consumerStore;

        consumerStore.load(props.id);

        _this.fields = [{
            tabname: 'Basics',
            icon: 'fas fa-user-edit',
            fields: ['id', 'email', 'fname', 'lname', 'address1', 'postalcode', 'postalplace', 'country_name', 'receive_info', 'rods', 'position', 'updated', 'create_date'].map(function (f) {
                return util.makeField(f, consumers_edit_FIELDS);
            })
        }];
        _this.subscriptions();
        return _this;
    }

    ConsumerEdit.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    ConsumerEdit.prototype.doUpdateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(id, field, value) {
            var consumerStore;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            consumerStore = this.props.stores.consumerStore;
                            _context.next = 3;
                            return consumerStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return doUpdateField;
    }();

    ConsumerEdit.prototype.render = function render(props) {
        var _this3 = this;

        var _state = this.state,
            height = _state.height,
            previewServer = _state.previewServer,
            jwtToken = _state.jwtToken;
        var consumerStore = this.props.stores.consumerStore;
        var consumer = consumerStore.consumer,
            saved = consumerStore.saved;


        var tabIdx = this.fields.findIndex(function (e) {
            return e.tabname === props.tabname;
        });
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-flex flex-row bd-highlight mb-3' },
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: '/consumers', 'class': 'mr-2 btn btn-sm btn-warning' },
                                Object(preact_min["h"])('i', { 'class': 'fas fa-arrow-left mr-1' }),
                                'Back'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'flex-grow-1' },
                            Object(preact_min["h"])(
                                'h4',
                                null,
                                'Edit: ',
                                consumer.id,
                                ': ',
                                consumer.email
                            )
                        )
                    ),
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'nav nav-tabs mb-2' },
                        this.fields.map(function (tab) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'nav-item' },
                                Object(preact_min["h"])(
                                    'a',
                                    { 'class': 'nav-link ' + (props.tabname === tab.tabname ? 'active' : ''),
                                        href: '/consumers/' + props.id + '/' + tab.tabname
                                    },
                                    Object(preact_min["h"])('i', { 'class': tab.icon + ' mr-2' }),
                                    tab.tabname
                                )
                            );
                        })
                    ),
                    this.fields[tabIdx].fields.map(function (field) {
                        return Object(preact_min["h"])(formField_FormRow, {
                            field: field,
                            object: consumer,
                            saved: saved,
                            updateField: _this3.updateField
                        });
                    })
                )
            )
        );
    };

    return ConsumerEdit;
}(preact_min["Component"]), consumers_edit__initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.updateField = function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var consumerStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            consumerStore = _this4.props.stores.consumerStore;

                            consumerStore.updateField(id, field, value);

                            clearTimeout(_this4.updateTimer[field]);
                            _this4.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                    while (1) {
                                        switch (_context2.prev = _context2.next) {
                                            case 0:
                                                _this4.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context2.stop();
                                        }
                                    }
                                }, _callee2, _this4);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this4);
        }));

        return function (_x4, _x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();

    this.addArticleImage = function () {
        var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(id, imageObject) {
            var consumerStore;
            return regenerator_default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            consumerStore = _this4.props.stores.consumerStore;

                            consumerStore.addImage(id, imageObject);

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();

    this.delArticleImage = function () {
        var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(id, imageId) {
            var consumerStore;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            consumerStore = _this4.props.stores.consumerStore;

                            consumerStore.delImage(id, imageId);

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this4);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
}, consumers_edit__temp)) || consumers_edit__class;

/* harmony default export */ var consumers_edit = (edit_ConsumerEdit);
// EXTERNAL MODULE: ./components/rodregs/style.css
var rodregs_style = __webpack_require__("Hzzu");
var rodregs_style_default = /*#__PURE__*/__webpack_require__.n(rodregs_style);

// CONCATENATED MODULE: ./components/rodregs/list.js







var rodregs_list__class, rodregs_list__class2, rodregs_list__temp, rodregs_list__initialiseProps;










var rodregs_list_initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false
    }
};

var rodregs_list__ref4 = Object(preact_min["h"])('br', null);

var rodregs_list__ref5 = Object(preact_min["h"])(
    'h1',
    null,
    Object(preact_min["h"])('i', { 'class': 'fas fa-search' }),
    ' Search results'
);

var rodregs_list__ref6 = Object(preact_min["h"])('br', null);

var rodregs_list__ref7 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var rodregs_list__ref8 = Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle' });

var rodregs_list__ref9 = Object(preact_min["h"])(
    'th',
    { style: 'width: 5%' },
    'Delete'
);

var rodregs_list__ref10 = Object(preact_min["h"])('br', null);

var rodregs_list__ref11 = Object(preact_min["h"])('br', null);

var rodregs_list__ref12 = Object(preact_min["h"])('br', null);

var rodregs_list__ref13 = Object(preact_min["h"])('br', null);

var rodregs_list__ref14 = Object(preact_min["h"])('br', null);

var rodregs_list__ref15 = Object(preact_min["h"])('br', null);

var rodregs_list__ref16 = Object(preact_min["h"])(
    'div',
    { 'class': 'row' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'col-12 text-center' },
        Object(preact_min["h"])(
            'div',
            { 'class': 'spinner-border text-success', role: 'status' },
            Object(preact_min["h"])(
                'span',
                { 'class': 'sr-only' },
                'Loading...'
            )
        )
    )
);

var rodregs_list__ref17 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var list_RodregList = Object(index_module["a" /* observer */])(rodregs_list__class = (rodregs_list__temp = rodregs_list__class2 = function (_Component) {
    inherits_default()(RodregList, _Component);

    function RodregList(props) {
        classCallCheck_default()(this, RodregList);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        rodregs_list__initialiseProps.call(_this);

        _this.state = extends_default()({}, rodregs_list_initialState, {
            previewServer: util.getPreviewServer()
        });
        _this.updateTimer = {};

        var rodregStore = _this.props.stores.rodregStore;

        rodregStore.list();
        return _this;
    }

    RodregList.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    RodregList.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    RodregList.prototype.updateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(id, field, value) {
            var _this2 = this;

            var rodregStore;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            rodregStore = this.props.stores.rodregStore;

                            rodregStore.updateField(id, field, value);

                            clearTimeout(this.updateTimer[field]);
                            this.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                return regenerator_default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _this2.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this2);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function updateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return updateField;
    }();

    RodregList.prototype.doUpdateField = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var rodregStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            rodregStore = this.props.stores.rodregStore;
                            _context3.next = 3;
                            return rodregStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function doUpdateField(_x4, _x5, _x6) {
            return _ref3.apply(this, arguments);
        }

        return doUpdateField;
    }();

    RodregList.prototype.render = function render() {
        var _this3 = this;

        var _state = this.state,
            loading = _state.loading,
            previewServer = _state.previewServer;
        var rodregStore = this.props.stores.rodregStore;
        var rodregs = rodregStore.rodregs,
            queryFilter = rodregStore.queryFilter,
            saved = rodregStore.saved,
            deleted = rodregStore.deleted;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'text-muted font-weight-lighter float-right mr-2' },
                        'Total: ',
                        rodregStore.total,
                        rodregs_list__ref4
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': 'float-left form-row align-items-center mr-5' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])('input', { type: 'text', 'class': 'form-control form-control-sm', id: 'inlineFormInputName', placeholder: 'Search for rod registrations...',
                                onInput: function onInput(e) {
                                    return rodregStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true });
                                },
                                value: queryFilter.search
                            })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])(
                                'button',
                                { type: 'button', 'class': 'btn btn-sm btn-primary', onClick: function onClick() {
                                        return rodregStore.list();
                                    } },
                                'Search'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    queryFilter.search && Object(preact_min["h"])(
                        'div',
                        { 'class': 'w-100 text-left mt-2 mb-5' },
                        rodregs_list__ref5,
                        'Found ',
                        rodregStore.total || 0,
                        ' results in your search for "',
                        queryFilter.search,
                        '".',
                        rodregs_list__ref6,
                        Object(preact_min["h"])(
                            'button',
                            { 'class': 'btn btn-sm btn-warning mt-2',
                                onClick: function onClick() {
                                    return rodregStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true });
                                }
                            },
                            rodregs_list__ref7,
                            ' Reset search'
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'table-responsive' },
                        Object(preact_min["h"])(
                            'table',
                            { 'class': rodregs_style_default.a.table + ' table table-striped table-sm table-borderless' },
                            Object(preact_min["h"])(
                                'thead',
                                null,
                                rodregStore.sort !== rodregStore.defaultSort && Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { colspan: '8' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': rodregs_style_default.a.pointerCursor + ' mr-2 badge badge-pill badge-secondary', onClick: function onClick() {
                                                    return rodregStore.resetSort();
                                                } },
                                            rodregs_list__ref8,
                                            ' Reset sort'
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': rodregs_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return rodregStore.toggleSort('serial', '-');
                                                } },
                                            'serial ',
                                            util.getSortIcon('serial', rodregStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 20%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': rodregs_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return rodregStore.toggleSort('articleno', '-');
                                                } },
                                            'articleno ',
                                            util.getSortIcon('name', rodregStore.articleno)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 30%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': rodregs_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return rodregStore.toggleSort('dealerName', '-');
                                                } },
                                            'dealerName ',
                                            util.getSortIcon('dealerName', rodregStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 20%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': rodregs_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return rodregStore.toggleSort('userEmail', '');
                                                } },
                                            'userEmail ',
                                            util.getSortIcon('userEmail', rodregStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': rodregs_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return rodregStore.toggleSort('purchase_date', '');
                                                } },
                                            'purchase_date ',
                                            util.getSortIcon('purchase_date', rodregStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': rodregs_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return rodregStore.toggleSort('received_date', '');
                                                } },
                                            'received_date ',
                                            util.getSortIcon('received_date', rodregStore.sort)
                                        )
                                    ),
                                    rodregs_list__ref9
                                )
                            ),
                            Object(preact_min["h"])(
                                'tbody',
                                null,
                                rodregs && rodregs.map(function (rodreg) {
                                    return Object(preact_min["h"])(
                                        'tr',
                                        { 'class': rodregs_style_default.a.tableline + ' ' + (deleted[rodreg.serial] ? 'text-muted' : ''), style: '' + (deleted[rodreg.serial] ? 'text-decoration: line-through;' : '') },
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            !deleted[rodreg.serial] ? Object(preact_min["h"])(
                                                'a',
                                                { href: '/rodregs/' + rodreg.serial + '/Basics' },
                                                rodreg.serial
                                            ) : Object(preact_min["h"])(
                                                'span',
                                                null,
                                                rodreg.serial
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            rodreg.name,
                                            rodregs_list__ref10,
                                            Object(preact_min["h"])(
                                                'small',
                                                { 'class': 'text-muted' },
                                                rodreg.articleno,
                                                ':',
                                                rodreg.model,
                                                ', ',
                                                rodreg.length,
                                                ', ',
                                                rodreg.line
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            rodreg.dealerCustomerno,
                                            ': ',
                                            rodreg.dealerName,
                                            rodregs_list__ref11,
                                            rodreg.registeredByDealer && Object(preact_min["h"])(
                                                'small',
                                                { 'class': 'text-muted' },
                                                'Registered by:',
                                                rodregs_list__ref12,
                                                rodreg.registeredByDealer.customerno,
                                                ': ',
                                                rodreg.registeredByDealer.name,
                                                ', ',
                                                rodreg.registeredByDealer.email
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            rodreg.userEmail,
                                            ': ',
                                            rodreg.userFname,
                                            ' ',
                                            rodreg.userLname,
                                            rodregs_list__ref13,
                                            Object(preact_min["h"])(
                                                'small',
                                                { 'class': 'text-muted' },
                                                rodreg.userAddress1,
                                                rodregs_list__ref14,
                                                rodreg.userPostalcode,
                                                ' ',
                                                rodreg.userPostalplace,
                                                rodregs_list__ref15,
                                                rodreg.userCountry
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            rodreg.purchase_date && util.ffeDateTime(rodreg.purchase_date)
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            rodreg.received_date && util.ffeDateTime(rodreg.received_date)
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(
                                                'nobr',
                                                null,
                                                !deleted[rodreg.serial] && Object(preact_min["h"])(
                                                    'a',
                                                    { 'class': 'btn btn-sm btn-danger', 'data-serial': rodreg.serial, onClick: _this3.delete },
                                                    Object(preact_min["h"])('i', { 'class': 'fas fa-trash' }),
                                                    ' Delete'
                                                )
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    )
                )
            ),
            loading && rodregs_list__ref16,
            rodregs_list__ref17
        );
    };

    return RodregList;
}(preact_min["Component"]), rodregs_list__initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.handleScroll = function () {
        var loading = _this4.state.loading;
        var rodregStore = _this4.props.stores.rodregStore;
        var totalAppend = rodregStore.totalAppend,
            limit = rodregStore.limit;

        if (window.innerHeight + document.documentElement.scrollTop + 500 < document.documentElement.offsetHeight) return;
        if (loading) return;

        var offset = rodregStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(_this4.scrollLoader);
            _this4.scrollLoader = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this4.setState({ loading: true });
                                rodregStore.updateOffset(offset);
                                _context4.next = 4;
                                return rodregStore.list(true);

                            case 4:
                                _this4.setState({ loading: false });

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            })), 500);
        }
    };

    this.delete = function () {
        var _ref19 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(event) {
            var serial, rodregStore;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            serial = event.target.dataset.serial;
                            rodregStore = _this4.props.stores.rodregStore;
                            _context5.next = 4;
                            return rodregStore.delete(serial);

                        case 4:
                            rodregStore.markDeleted(serial);

                        case 5:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this4);
        }));

        return function (_x7) {
            return _ref19.apply(this, arguments);
        };
    }();
}, rodregs_list__temp)) || rodregs_list__class;

/* harmony default export */ var rodregs_list = (list_RodregList);
// CONCATENATED MODULE: ./components/rodregs/index.js




var rodregs__class;









var rodregs_initialState = {
    height: 100
};

var rodregs_Tag = Object(index_module["a" /* observer */])(rodregs__class = function (_Component) {
    inherits_default()(Tag, _Component);

    function Tag(props) {
        classCallCheck_default()(this, Tag);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = rodregs_initialState;
        _this.subscriptions();
        return _this;
    }

    Tag.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    Tag.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(rodregs_list, props)
                )
            )
        );
    };

    return Tag;
}(preact_min["Component"])) || rodregs__class;

/* harmony default export */ var components_rodregs = (rodregs_Tag);
// CONCATENATED MODULE: ./components/rodregs/edit.js







var rodregs_edit__class, rodregs_edit__class2, rodregs_edit__temp, rodregs_edit__initialiseProps;














var rodregs_edit_initialState = {
    height: 100,
    windowHeight: 0
};

var rodregs_edit_FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    serial: { label: 'serial', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    name: { label: 'name', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    model: { label: 'model', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    articleno: { label: 'articleno', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    length: { label: 'length', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    length_key: { label: 'length_key', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    line: { label: 'line', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    line_key: { label: 'line_key', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    purchase_date: { label: 'purchase_date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    received_date: { label: 'received_date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    dealerName: { label: 'dealerName', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    dealerCustomerno: { label: 'dealerCustomerno', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    userFname: { label: 'userFname', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    userLname: { label: 'userLname', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    userAddress1: { label: 'userAddress1', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    userPostalcode: { label: 'userPostalcode', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    userPostalplace: { label: 'userPostalplace', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    userCountry: { label: 'userCountry', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },

    registeredByDealer: { label: 'registeredByDealer', type: 'object', readonly: true, help: 'Field is DealerWeb only.' }
};

var rodregs_edit_ConsumerEdit = Object(index_module["a" /* observer */])(rodregs_edit__class = (rodregs_edit__temp = rodregs_edit__class2 = function (_Component) {
    inherits_default()(ConsumerEdit, _Component);

    function ConsumerEdit(props) {
        classCallCheck_default()(this, ConsumerEdit);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        rodregs_edit__initialiseProps.call(_this);

        _this.state = extends_default()({}, rodregs_edit_initialState, {
            previewServer: util.getPreviewServer(),
            jwtToken: util.getJwtToken()
        });
        _this.updateTimer = {};
        var rodregStore = _this.props.stores.rodregStore;

        rodregStore.load(props.serial);

        _this.fields = [{
            tabname: 'Basics',
            icon: 'fas fa-user-edit',
            fields: ['serial', 'name', 'model', 'articleno', 'length', 'length_key', 'line', 'line_key', 'purchase_date', 'received_date', 'dealerName', 'dealerCustomerno', 'userFname', 'userLname', 'userAddress1', 'userPostalcode', 'userPostalplace', 'userCountry', 'registeredByDealer'].map(function (f) {
                return util.makeField(f, rodregs_edit_FIELDS);
            })
        }];
        _this.subscriptions();
        return _this;
    }

    ConsumerEdit.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    ConsumerEdit.prototype.doUpdateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(id, field, value) {
            var rodregStore;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            rodregStore = this.props.stores.rodregStore;
                            _context.next = 3;
                            return rodregStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return doUpdateField;
    }();

    ConsumerEdit.prototype.render = function render(props) {
        var _this3 = this;

        var _state = this.state,
            height = _state.height,
            previewServer = _state.previewServer,
            jwtToken = _state.jwtToken;
        var rodregStore = this.props.stores.rodregStore;
        var rodreg = rodregStore.rodreg,
            saved = rodregStore.saved;


        var tabIdx = this.fields.findIndex(function (e) {
            return e.tabname === props.tabname;
        });
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-flex flex-row bd-highlight mb-3' },
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: '/rodregs', 'class': 'mr-2 btn btn-sm btn-warning' },
                                Object(preact_min["h"])('i', { 'class': 'fas fa-arrow-left mr-1' }),
                                'Back'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'flex-grow-1' },
                            Object(preact_min["h"])(
                                'h4',
                                null,
                                'Edit: ',
                                rodreg.serial,
                                ': ',
                                rodreg.name
                            )
                        )
                    ),
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'nav nav-tabs mb-2' },
                        this.fields.map(function (tab) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'nav-item' },
                                Object(preact_min["h"])(
                                    'a',
                                    { 'class': 'nav-link ' + (props.tabname === tab.tabname ? 'active' : ''),
                                        href: '/rodregs/' + props.serial + '/' + tab.tabname
                                    },
                                    Object(preact_min["h"])('i', { 'class': tab.icon + ' mr-2' }),
                                    tab.tabname
                                )
                            );
                        })
                    ),
                    this.fields[tabIdx].fields.map(function (field) {
                        return Object(preact_min["h"])(formField_FormRow, {
                            field: field,
                            object: rodreg,
                            saved: saved,
                            updateField: _this3.updateField
                        });
                    })
                )
            )
        );
    };

    return ConsumerEdit;
}(preact_min["Component"]), rodregs_edit__initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.updateField = function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var rodregStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            rodregStore = _this4.props.stores.rodregStore;

                            rodregStore.updateField(id, field, value);

                            clearTimeout(_this4.updateTimer[field]);
                            _this4.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                    while (1) {
                                        switch (_context2.prev = _context2.next) {
                                            case 0:
                                                _this4.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context2.stop();
                                        }
                                    }
                                }, _callee2, _this4);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this4);
        }));

        return function (_x4, _x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();

    this.addArticleImage = function () {
        var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(id, imageObject) {
            var rodregStore;
            return regenerator_default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            rodregStore = _this4.props.stores.rodregStore;

                            rodregStore.addImage(id, imageObject);

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();

    this.delArticleImage = function () {
        var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(id, imageId) {
            var rodregStore;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            rodregStore = _this4.props.stores.rodregStore;

                            rodregStore.delImage(id, imageId);

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this4);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
}, rodregs_edit__temp)) || rodregs_edit__class;

/* harmony default export */ var rodregs_edit = (rodregs_edit_ConsumerEdit);
// EXTERNAL MODULE: ./components/shipments/style.css
var shipments_style = __webpack_require__("/wXX");
var shipments_style_default = /*#__PURE__*/__webpack_require__.n(shipments_style);

// CONCATENATED MODULE: ./components/shipments/list.js







var shipments_list__class, shipments_list__class2, shipments_list__temp, shipments_list__initialiseProps;










var shipments_list_initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false
    }
};

var shipments_list__ref4 = Object(preact_min["h"])('br', null);

var shipments_list__ref5 = Object(preact_min["h"])(
    'h1',
    null,
    Object(preact_min["h"])('i', { 'class': 'fas fa-search' }),
    ' Search results'
);

var shipments_list__ref6 = Object(preact_min["h"])('br', null);

var shipments_list__ref7 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var shipments_list__ref8 = Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle' });

var shipments_list__ref9 = Object(preact_min["h"])('br', null);

var shipments_list__ref10 = Object(preact_min["h"])(
    'div',
    { 'class': 'row' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'col-12 text-center' },
        Object(preact_min["h"])(
            'div',
            { 'class': 'spinner-border text-success', role: 'status' },
            Object(preact_min["h"])(
                'span',
                { 'class': 'sr-only' },
                'Loading...'
            )
        )
    )
);

var shipments_list__ref11 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var list_ShipmentList = Object(index_module["a" /* observer */])(shipments_list__class = (shipments_list__temp = shipments_list__class2 = function (_Component) {
    inherits_default()(ShipmentList, _Component);

    function ShipmentList(props) {
        classCallCheck_default()(this, ShipmentList);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        shipments_list__initialiseProps.call(_this);

        _this.state = extends_default()({}, shipments_list_initialState, {
            previewServer: util.getPreviewServer()
        });
        _this.updateTimer = {};

        var shipmentStore = _this.props.stores.shipmentStore;

        shipmentStore.list();
        return _this;
    }

    ShipmentList.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    ShipmentList.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    ShipmentList.prototype.updateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(id, field, value) {
            var _this2 = this;

            var shipmentStore;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            shipmentStore = this.props.stores.shipmentStore;

                            shipmentStore.updateField(id, field, value);

                            clearTimeout(this.updateTimer[field]);
                            this.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                return regenerator_default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _this2.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this2);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function updateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return updateField;
    }();

    ShipmentList.prototype.doUpdateField = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var shipmentStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            shipmentStore = this.props.stores.shipmentStore;
                            _context3.next = 3;
                            return shipmentStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function doUpdateField(_x4, _x5, _x6) {
            return _ref3.apply(this, arguments);
        }

        return doUpdateField;
    }();

    ShipmentList.prototype.render = function render() {
        var _state = this.state,
            loading = _state.loading,
            previewServer = _state.previewServer;
        var shipmentStore = this.props.stores.shipmentStore;
        var shipments = shipmentStore.shipments,
            queryFilter = shipmentStore.queryFilter,
            saved = shipmentStore.saved;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'text-muted font-weight-lighter float-right mr-2' },
                        'Total: ',
                        shipmentStore.total,
                        shipments_list__ref4
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': 'float-left form-row align-items-center mr-5' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])('input', { type: 'text', 'class': 'form-control form-control-sm', id: 'inlineFormInputName', placeholder: 'Search for shipments...',
                                onInput: function onInput(e) {
                                    return shipmentStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true });
                                },
                                value: queryFilter.search
                            })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])(
                                'button',
                                { type: 'button', 'class': 'btn btn-sm btn-primary', onClick: function onClick() {
                                        return shipmentStore.list();
                                    } },
                                'Search'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    queryFilter.search && Object(preact_min["h"])(
                        'div',
                        { 'class': 'w-100 text-left mt-2 mb-5' },
                        shipments_list__ref5,
                        'Found ',
                        shipmentStore.total || 0,
                        ' results in your search for "',
                        queryFilter.search,
                        '".',
                        shipments_list__ref6,
                        Object(preact_min["h"])(
                            'button',
                            { 'class': 'btn btn-sm btn-warning mt-2',
                                onClick: function onClick() {
                                    return shipmentStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true });
                                }
                            },
                            shipments_list__ref7,
                            ' Reset search'
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'table-responsive' },
                        Object(preact_min["h"])(
                            'table',
                            { 'class': shipments_style_default.a.table + ' table table-striped table-sm table-borderless' },
                            Object(preact_min["h"])(
                                'thead',
                                null,
                                shipmentStore.sort !== shipmentStore.defaultSort && Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { colspan: '8' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': shipments_style_default.a.pointerCursor + ' mr-2 badge badge-pill badge-secondary', onClick: function onClick() {
                                                    return shipmentStore.resetSort();
                                                } },
                                            shipments_list__ref8,
                                            ' Reset sort'
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': shipments_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return shipmentStore.toggleSort('uniqueId', '-');
                                                } },
                                            'uniqueId ',
                                            util.getSortIcon('uniqueId', shipmentStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': shipments_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return shipmentStore.toggleSort('warehouseRef', '-');
                                                } },
                                            'warehouseRef ',
                                            util.getSortIcon('warehouseRef', shipmentStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': shipments_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return shipmentStore.toggleSort('customerno', '');
                                                } },
                                            'customerno ',
                                            util.getSortIcon('customerno', shipmentStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': shipments_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return shipmentStore.toggleSort('shipDate', '');
                                                } },
                                            'shipDate ',
                                            util.getSortIcon('shipDate', shipmentStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': shipments_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return shipmentStore.toggleSort('articleno', '');
                                                } },
                                            'articleno ',
                                            util.getSortIcon('articleno', shipmentStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': shipments_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return shipmentStore.toggleSort('serial', '');
                                                } },
                                            'serial ',
                                            util.getSortIcon('serial', shipmentStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': shipments_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return shipmentStore.toggleSort('orderno', '');
                                                } },
                                            'orderno ',
                                            util.getSortIcon('orderno', shipmentStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': shipments_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return shipmentStore.toggleSort('shipper', '');
                                                } },
                                            'shipper ',
                                            util.getSortIcon('shipper', shipmentStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': shipments_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return shipmentStore.toggleSort('shipperId', '');
                                                } },
                                            'shipperId ',
                                            util.getSortIcon('shipperId', shipmentStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': shipments_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return shipmentStore.toggleSort('weight', '');
                                                } },
                                            'weight ',
                                            util.getSortIcon('weight', shipmentStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': shipments_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return shipmentStore.toggleSort('createdDate', '');
                                                } },
                                            'createdDate ',
                                            util.getSortIcon('createdDate', shipmentStore.sort)
                                        )
                                    )
                                )
                            ),
                            Object(preact_min["h"])(
                                'tbody',
                                null,
                                shipments && shipments.map(function (shipment) {
                                    return Object(preact_min["h"])(
                                        'tr',
                                        { 'class': '' + shipments_style_default.a.tableline },
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'font-weight-light' },
                                            Object(preact_min["h"])(
                                                'a',
                                                { href: '/shipments/' + shipment.uniqueId + '/Basics' },
                                                shipment.uniqueId
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'font-weight-light' },
                                            Object(preact_min["h"])(
                                                'span',
                                                { 'class': 'text-muted' },
                                                shipment.warehouseId
                                            ),
                                            ' ',
                                            shipment.warehouseRef
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'font-weight-light' },
                                            shipment.customerno
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'font-weight-light' },
                                            shipment.shipDate
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'font-weight-light' },
                                            Object(preact_min["h"])(
                                                'span',
                                                { 'class': 'text-muted' },
                                                shipment.qty,
                                                ' x'
                                            ),
                                            ' ',
                                            shipment.articleno
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'font-weight-light' },
                                            shipment.serial
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'font-weight-light' },
                                            shipment.orderno
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'font-weight-light' },
                                            shipment.shipper
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'font-weight-light' },
                                            shipment.shipperId
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'font-weight-light' },
                                            shipment.weight
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'font-weight-light' },
                                            shipment.createdDate,
                                            shipments_list__ref9,
                                            Object(preact_min["h"])(
                                                'span',
                                                { 'class': 'text-muted' },
                                                shipment.updatedDate
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    )
                )
            ),
            loading && shipments_list__ref10,
            shipments_list__ref11
        );
    };

    return ShipmentList;
}(preact_min["Component"]), shipments_list__initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleScroll = function () {
        var loading = _this3.state.loading;
        var shipmentStore = _this3.props.stores.shipmentStore;
        var totalAppend = shipmentStore.totalAppend,
            limit = shipmentStore.limit;

        if (window.innerHeight + document.documentElement.scrollTop + 500 < document.documentElement.offsetHeight) return;
        if (loading) return;

        var offset = shipmentStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(_this3.scrollLoader);
            _this3.scrollLoader = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this3.setState({ loading: true });
                                shipmentStore.updateOffset(offset);
                                _context4.next = 4;
                                return shipmentStore.list(true);

                            case 4:
                                _this3.setState({ loading: false });

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this3);
            })), 500);
        }
    };
}, shipments_list__temp)) || shipments_list__class;

/* harmony default export */ var shipments_list = (list_ShipmentList);
// CONCATENATED MODULE: ./components/shipments/index.js




var shipments__class;









var shipments_initialState = {
    height: 100
};

var shipments_Shipment = Object(index_module["a" /* observer */])(shipments__class = function (_Component) {
    inherits_default()(Shipment, _Component);

    function Shipment(props) {
        classCallCheck_default()(this, Shipment);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = shipments_initialState;
        _this.subscriptions();
        return _this;
    }

    Shipment.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    Shipment.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(shipments_list, props)
                )
            )
        );
    };

    return Shipment;
}(preact_min["Component"])) || shipments__class;

/* harmony default export */ var components_shipments = (shipments_Shipment);
// CONCATENATED MODULE: ./components/shipments/edit.js







var shipments_edit__class, shipments_edit__class2, shipments_edit__temp, shipments_edit__initialiseProps;














var shipments_edit_initialState = {
    height: 100,
    windowHeight: 0
};

var shipments_edit_FIELDS = {
    warehouseId: { label: 'warehouseId', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    warehouseRef: { label: 'warehouseRef', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    customerno: { label: 'customerno', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    shipDate: { label: 'shipDate', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    articleno: { label: 'articleno', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    serial: { label: 'serial', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    qty: { label: 'qty', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    orderno: { label: 'orderno', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    shipper: { label: 'shipper', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    shipperId: { label: 'shipperId', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    weight: { label: 'weight', type: 'text', readonly: true, help: 'Field is imported from Visma: via new Visma SQL -> S3 -> Lambda -> API. File "SSD_*.csv"' },
    uniqueId: { label: 'uniqueId', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },

    createdDate: { label: 'createdDate', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'updatedDate', type: 'text', readonly: true, help: 'Field is DealerWeb only.' }
};

var shipments_edit_ConsumerEdit = Object(index_module["a" /* observer */])(shipments_edit__class = (shipments_edit__temp = shipments_edit__class2 = function (_Component) {
    inherits_default()(ConsumerEdit, _Component);

    function ConsumerEdit(props) {
        classCallCheck_default()(this, ConsumerEdit);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        shipments_edit__initialiseProps.call(_this);

        _this.state = extends_default()({}, shipments_edit_initialState, {
            previewServer: util.getPreviewServer(),
            jwtToken: util.getJwtToken()
        });
        _this.updateTimer = {};
        var shipmentStore = _this.props.stores.shipmentStore;

        shipmentStore.load(props.uniqueid);

        _this.fields = [{
            tabname: 'Basics',
            icon: 'fas fa-user-edit',
            fields: ['warehouseId', 'warehouseRef', 'customerno', 'shipDate', 'articleno', 'serial', 'qty', 'orderno', 'shipper', 'shipperId', 'weight', 'uniqueId', 'createdDate', 'updatedDate'].map(function (f) {
                return util.makeField(f, shipments_edit_FIELDS);
            })
        }];
        _this.subscriptions();
        return _this;
    }

    ConsumerEdit.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    ConsumerEdit.prototype.doUpdateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(id, field, value) {
            var shipmentStore;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            shipmentStore = this.props.stores.shipmentStore;
                            _context.next = 3;
                            return shipmentStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return doUpdateField;
    }();

    ConsumerEdit.prototype.render = function render(props) {
        var _this3 = this;

        var _state = this.state,
            height = _state.height,
            previewServer = _state.previewServer,
            jwtToken = _state.jwtToken;
        var shipmentStore = this.props.stores.shipmentStore;
        var shipment = shipmentStore.shipment,
            saved = shipmentStore.saved;


        var tabIdx = this.fields.findIndex(function (e) {
            return e.tabname === props.tabname;
        });
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-flex flex-row bd-highlight mb-3' },
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: '/shipments', 'class': 'mr-2 btn btn-sm btn-warning' },
                                Object(preact_min["h"])('i', { 'class': 'fas fa-arrow-left mr-1' }),
                                'Back'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'flex-grow-1' },
                            Object(preact_min["h"])(
                                'h4',
                                null,
                                'Edit: ',
                                shipment.customerno,
                                ': ',
                                shipment.articleno
                            )
                        )
                    ),
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'nav nav-tabs mb-2' },
                        this.fields.map(function (tab) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'nav-item' },
                                Object(preact_min["h"])(
                                    'a',
                                    { 'class': 'nav-link ' + (props.tabname === tab.tabname ? 'active' : ''),
                                        href: '/shipments/' + props.uniqueid + '/' + tab.tabname
                                    },
                                    Object(preact_min["h"])('i', { 'class': tab.icon + ' mr-2' }),
                                    tab.tabname
                                )
                            );
                        })
                    ),
                    this.fields[tabIdx].fields.map(function (field) {
                        return Object(preact_min["h"])(formField_FormRow, {
                            field: field,
                            object: shipment,
                            saved: saved,
                            updateField: _this3.updateField
                        });
                    })
                )
            )
        );
    };

    return ConsumerEdit;
}(preact_min["Component"]), shipments_edit__initialiseProps = function _initialiseProps() {
    var _this4 = this;

    this.updateField = function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var shipmentStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            shipmentStore = _this4.props.stores.shipmentStore;

                            shipmentStore.updateField(id, field, value);

                            clearTimeout(_this4.updateTimer[field]);
                            _this4.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                    while (1) {
                                        switch (_context2.prev = _context2.next) {
                                            case 0:
                                                _this4.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context2.stop();
                                        }
                                    }
                                }, _callee2, _this4);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this4);
        }));

        return function (_x4, _x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();

    this.addArticleImage = function () {
        var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(id, imageObject) {
            var shipmentStore;
            return regenerator_default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            shipmentStore = _this4.props.stores.shipmentStore;

                            shipmentStore.addImage(id, imageObject);

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }));

        return function (_x7, _x8) {
            return _ref4.apply(this, arguments);
        };
    }();

    this.delArticleImage = function () {
        var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(id, imageId) {
            var shipmentStore;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            shipmentStore = _this4.props.stores.shipmentStore;

                            shipmentStore.delImage(id, imageId);

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this4);
        }));

        return function (_x9, _x10) {
            return _ref5.apply(this, arguments);
        };
    }();
}, shipments_edit__temp)) || shipments_edit__class;

/* harmony default export */ var shipments_edit = (shipments_edit_ConsumerEdit);
// EXTERNAL MODULE: ./components/maillogs/style.css
var maillogs_style = __webpack_require__("9HBQ");
var maillogs_style_default = /*#__PURE__*/__webpack_require__.n(maillogs_style);

// CONCATENATED MODULE: ./components/maillogs/list.js







var maillogs_list__class, maillogs_list__class2, maillogs_list__temp, maillogs_list__initialiseProps;










var maillogs_list_initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false
    }
};

var maillogs_list__ref4 = Object(preact_min["h"])('br', null);

var maillogs_list__ref5 = Object(preact_min["h"])(
    'h1',
    null,
    Object(preact_min["h"])('i', { 'class': 'fas fa-search' }),
    ' Search results'
);

var maillogs_list__ref6 = Object(preact_min["h"])('br', null);

var maillogs_list__ref7 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var maillogs_list__ref8 = Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle' });

var maillogs_list__ref9 = Object(preact_min["h"])(
    'th',
    { style: 'width: 5%', 'class': 'text-right' },
    'Id#'
);

var maillogs_list__ref10 = Object(preact_min["h"])(
    'th',
    { style: 'width: 10%' },
    'From'
);

var maillogs_list__ref11 = Object(preact_min["h"])(
    'th',
    { style: 'width: 20%' },
    'To'
);

var maillogs_list__ref12 = Object(preact_min["h"])(
    'th',
    { style: 'width: 5%' },
    'Attachments'
);

var maillogs_list__ref13 = Object(preact_min["h"])(
    'th',
    { style: 'width: 10%' },
    'RelayService'
);

var maillogs_list__ref14 = Object(preact_min["h"])(
    'th',
    { style: 'width: 5%' },
    'Status'
);

var maillogs_list__ref15 = Object(preact_min["h"])(
    'div',
    { 'class': 'row' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'col-12 text-center' },
        Object(preact_min["h"])(
            'div',
            { 'class': 'spinner-border text-success', role: 'status' },
            Object(preact_min["h"])(
                'span',
                { 'class': 'sr-only' },
                'Loading...'
            )
        )
    )
);

var maillogs_list__ref16 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var list_MaillogList = Object(index_module["a" /* observer */])(maillogs_list__class = (maillogs_list__temp = maillogs_list__class2 = function (_Component) {
    inherits_default()(MaillogList, _Component);

    function MaillogList(props) {
        classCallCheck_default()(this, MaillogList);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        maillogs_list__initialiseProps.call(_this);

        _this.state = extends_default()({}, maillogs_list_initialState);
        _this.updateTimer = {};

        var maillogStore = _this.props.stores.maillogStore;

        maillogStore.list();
        return _this;
    }

    MaillogList.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    MaillogList.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    MaillogList.prototype.updateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(id, field, value) {
            var _this2 = this;

            var maillogStore;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            maillogStore = this.props.stores.maillogStore;

                            maillogStore.updateField(id, field, value);

                            clearTimeout(this.updateTimer[field]);
                            this.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                return regenerator_default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _this2.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this2);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function updateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return updateField;
    }();

    MaillogList.prototype.doUpdateField = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var maillogStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            maillogStore = this.props.stores.maillogStore;
                            _context3.next = 3;
                            return maillogStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function doUpdateField(_x4, _x5, _x6) {
            return _ref3.apply(this, arguments);
        }

        return doUpdateField;
    }();

    MaillogList.prototype.render = function render() {
        var loading = this.state.loading;
        var maillogStore = this.props.stores.maillogStore;
        var maillogs = maillogStore.maillogs,
            queryFilter = maillogStore.queryFilter,
            saved = maillogStore.saved;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'text-muted font-weight-lighter float-right mr-2' },
                        'Total: ',
                        maillogStore.total,
                        maillogs_list__ref4
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': 'float-left form-row align-items-center mr-5' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])('input', { type: 'text', 'class': 'form-control form-control-sm', id: 'inlineFormInputName', placeholder: 'Search for mail logs...',
                                onInput: function onInput(e) {
                                    return maillogStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true });
                                },
                                value: queryFilter.search
                            })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])(
                                'button',
                                { type: 'button', 'class': 'btn btn-sm btn-primary', onClick: function onClick() {
                                        return maillogStore.list();
                                    } },
                                'Search'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    queryFilter.search && Object(preact_min["h"])(
                        'div',
                        { 'class': 'w-100 text-left mt-2 mb-5' },
                        maillogs_list__ref5,
                        'Found ',
                        maillogStore.total || 0,
                        ' results in your search for "',
                        queryFilter.search,
                        '".',
                        maillogs_list__ref6,
                        Object(preact_min["h"])(
                            'button',
                            { 'class': 'btn btn-sm btn-warning mt-2',
                                onClick: function onClick() {
                                    return maillogStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true });
                                }
                            },
                            maillogs_list__ref7,
                            ' Reset search'
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'table-responsive' },
                        Object(preact_min["h"])(
                            'table',
                            { 'class': maillogs_style_default.a.table + ' table table-striped table-sm table-borderless' },
                            Object(preact_min["h"])(
                                'thead',
                                null,
                                maillogStore.sort !== maillogStore.defaultSort && Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { colspan: '8' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': maillogs_style_default.a.pointerCursor + ' mr-2 badge badge-pill badge-secondary', onClick: function onClick() {
                                                    return maillogStore.resetSort();
                                                } },
                                            maillogs_list__ref8,
                                            ' Reset sort'
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    maillogs_list__ref9,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': maillogs_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return maillogStore.toggleSort('createdDate', '');
                                                } },
                                            'Date ',
                                            util.getSortIcon('createdDate', maillogStore.sort)
                                        )
                                    ),
                                    maillogs_list__ref10,
                                    maillogs_list__ref11,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 35%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': maillogs_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return maillogStore.toggleSort('subject', '');
                                                } },
                                            'Subject ',
                                            util.getSortIcon('subject', maillogStore.sort)
                                        )
                                    ),
                                    maillogs_list__ref12,
                                    maillogs_list__ref13,
                                    maillogs_list__ref14
                                )
                            ),
                            Object(preact_min["h"])(
                                'tbody',
                                null,
                                maillogs && maillogs.map(function (maillog) {
                                    return Object(preact_min["h"])(
                                        'tr',
                                        { 'class': '' + maillogs_style_default.a.tableline },
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            maillog.id
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            util.ffeDateTime(maillog.createdDate)
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            maillog.from
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'font-weight-light' },
                                            maillog.to.map(function (r) {
                                                return Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': 'badge badge-pill badge-primary mr-2' },
                                                    r
                                                );
                                            }),
                                            maillog.cc.map(function (r) {
                                                return Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': 'badge badge-pill badge-info mr-2' },
                                                    r
                                                );
                                            }),
                                            maillog.bcc.map(function (r) {
                                                return Object(preact_min["h"])(
                                                    'span',
                                                    { 'class': 'badge badge-pill badge-secondary mr-2' },
                                                    r
                                                );
                                            })
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(
                                                'a',
                                                { href: '/maillogs/' + maillog.id + '/Basics' },
                                                maillog.subject
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(
                                                'small',
                                                null,
                                                Object(preact_min["h"])(
                                                    'code',
                                                    null,
                                                    JSON.stringify(maillog.attachments)
                                                )
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            maillog.relayService
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            maillog.response && Object(preact_min["h"])(
                                                'span',
                                                { 'class': 'badge badge-pill badge-' + (maillog.response[0].statusCode < 400 ? 'success' : 'danger') },
                                                maillog.response[0].statusCode
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    )
                )
            ),
            loading && maillogs_list__ref15,
            maillogs_list__ref16
        );
    };

    return MaillogList;
}(preact_min["Component"]), maillogs_list__initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleScroll = function () {
        var loading = _this3.state.loading;
        var maillogStore = _this3.props.stores.maillogStore;
        var totalAppend = maillogStore.totalAppend,
            limit = maillogStore.limit;

        if (window.innerHeight + document.documentElement.scrollTop + 500 < document.documentElement.offsetHeight) return;
        if (loading) return;

        var offset = maillogStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(_this3.scrollLoader);
            _this3.scrollLoader = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this3.setState({ loading: true });
                                maillogStore.updateOffset(offset);
                                _context4.next = 4;
                                return maillogStore.list(true);

                            case 4:
                                _this3.setState({ loading: false });

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this3);
            })), 500);
        }
    };
}, maillogs_list__temp)) || maillogs_list__class;

/* harmony default export */ var maillogs_list = (list_MaillogList);
// CONCATENATED MODULE: ./components/maillogs/index.js




var maillogs__class;









var maillogs_initialState = {
    height: 100
};

var maillogs_Tag = Object(index_module["a" /* observer */])(maillogs__class = function (_Component) {
    inherits_default()(Tag, _Component);

    function Tag(props) {
        classCallCheck_default()(this, Tag);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = maillogs_initialState;
        _this.subscriptions();
        return _this;
    }

    Tag.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    Tag.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(maillogs_list, props)
                )
            )
        );
    };

    return Tag;
}(preact_min["Component"])) || maillogs__class;

/* harmony default export */ var components_maillogs = (maillogs_Tag);
// CONCATENATED MODULE: ./components/maillogs/edit.js







var maillogs_edit__class, maillogs_edit__class2, maillogs_edit__temp, maillogs_edit__initialiseProps;










var maillogs_edit_initialState = {};

var maillogs_edit_FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    from: { label: 'from', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    to: { label: 'to', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    cc: { label: 'cc', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    bcc: { label: 'bcc', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    subject: { label: 'subject', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    body: { label: 'body', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    attachments: { label: 'attachments', type: 'json', readonly: true, help: 'Field is DealerWeb only.' },
    response: { label: 'response', type: 'json', readonly: true, help: 'Field is DealerWeb only.' },

    createdDate: { label: 'Created date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'Updated date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' }
};

var edit_MaillogEdit = Object(index_module["a" /* observer */])(maillogs_edit__class = (maillogs_edit__temp = maillogs_edit__class2 = function (_Component) {
    inherits_default()(MaillogEdit, _Component);

    function MaillogEdit(props) {
        classCallCheck_default()(this, MaillogEdit);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        maillogs_edit__initialiseProps.call(_this);

        _this.state = extends_default()({}, maillogs_edit_initialState);
        _this.updateTimer = {};
        var maillogStore = _this.props.stores.maillogStore;

        maillogStore.load(props.id);
        _this.fields = [{
            tabname: 'Basics',
            icon: 'fas fa-user-edit',
            fields: ['id', 'from', 'to', 'cc', 'bcc', 'subject', 'body', 'attachments', 'response', 'createdDate', 'updatedDate'].map(function (f) {
                return util.makeField(f, maillogs_edit_FIELDS);
            })
        }];
        return _this;
    }

    MaillogEdit.prototype.doUpdateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(id, field, value) {
            var maillogStore;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            maillogStore = this.props.stores.maillogStore;
                            _context.next = 3;
                            return maillogStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return doUpdateField;
    }();

    MaillogEdit.prototype.render = function render(props) {
        var _this2 = this;

        var maillogStore = this.props.stores.maillogStore;
        var maillog = maillogStore.maillog,
            saved = maillogStore.saved;


        var tabIdx = this.fields.findIndex(function (e) {
            return e.tabname === props.tabname;
        });
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-flex flex-row bd-highlight mb-3' },
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: '/maillogs', 'class': 'mr-2 btn btn-sm btn-warning' },
                                Object(preact_min["h"])('i', { 'class': 'fas fa-arrow-left mr-1' }),
                                'Back'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'h4',
                                null,
                                'Edit: ',
                                maillog.id,
                                ': ',
                                maillog.from,
                                ': ',
                                maillog.subject
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'nav nav-tabs mb-2' },
                        this.fields.map(function (tab) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'nav-item' },
                                Object(preact_min["h"])(
                                    'a',
                                    { 'class': 'nav-link ' + (props.tabname === tab.tabname ? 'active' : ''),
                                        href: '/maillogs/' + props.maillogid + '/' + tab.tabname
                                    },
                                    Object(preact_min["h"])('i', { 'class': tab.icon + ' mr-2' }),
                                    tab.tabname
                                )
                            );
                        })
                    ),
                    this.fields[tabIdx].fields.map(function (field) {
                        return Object(preact_min["h"])(formField_FormRow, {
                            field: field,
                            object: maillog,
                            saved: saved,
                            updateField: _this2.updateField
                        });
                    })
                )
            )
        );
    };

    return MaillogEdit;
}(preact_min["Component"]), maillogs_edit__initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.updateField = function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var maillogStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            maillogStore = _this3.props.stores.maillogStore;

                            maillogStore.updateField(id, field, value);

                            clearTimeout(_this3.updateTimer[field]);
                            _this3.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                    while (1) {
                                        switch (_context2.prev = _context2.next) {
                                            case 0:
                                                _this3.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context2.stop();
                                        }
                                    }
                                }, _callee2, _this3);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x4, _x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();
}, maillogs_edit__temp)) || maillogs_edit__class;

/* harmony default export */ var maillogs_edit = (edit_MaillogEdit);
// EXTERNAL MODULE: ./components/mailaddresses/style.css
var mailaddresses_style = __webpack_require__("en7x");
var mailaddresses_style_default = /*#__PURE__*/__webpack_require__.n(mailaddresses_style);

// CONCATENATED MODULE: ./components/mailaddresses/list.js







var mailaddresses_list__class, mailaddresses_list__class2, mailaddresses_list__temp, mailaddresses_list__initialiseProps;










var mailaddresses_list_initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false
    }
};

var mailaddresses_list__ref4 = Object(preact_min["h"])('br', null);

var mailaddresses_list__ref5 = Object(preact_min["h"])(
    'h1',
    null,
    Object(preact_min["h"])('i', { 'class': 'fas fa-search' }),
    ' Search results'
);

var mailaddresses_list__ref6 = Object(preact_min["h"])('br', null);

var mailaddresses_list__ref7 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var mailaddresses_list__ref8 = Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle' });

var mailaddresses_list__ref9 = Object(preact_min["h"])(
    'th',
    { style: 'width: 5%' },
    'Bounce qty'
);

var mailaddresses_list__ref10 = Object(preact_min["h"])(
    'th',
    { style: 'width: 5%' },
    'Complaint qty'
);

var mailaddresses_list__ref11 = Object(preact_min["h"])(
    'th',
    { style: 'width: 40%' },
    'Bounces'
);

var mailaddresses_list__ref12 = Object(preact_min["h"])(
    'th',
    { style: 'width: 20%' },
    'Complaints'
);

var mailaddresses_list__ref13 = Object(preact_min["h"])(
    'span',
    { 'class': 'text-muted' },
    'Date:'
);

var mailaddresses_list__ref14 = Object(preact_min["h"])(
    'span',
    { 'class': 'text-muted' },
    'Remote MTA IP:'
);

var mailaddresses_list__ref15 = Object(preact_min["h"])(
    'span',
    { 'class': 'text-muted' },
    'Reporting MTA:'
);

var mailaddresses_list__ref16 = Object(preact_min["h"])(
    'span',
    { 'class': 'text-muted' },
    'Action:'
);

var mailaddresses_list__ref17 = Object(preact_min["h"])(
    'span',
    { 'class': 'text-muted' },
    'Status:'
);

var mailaddresses_list__ref18 = Object(preact_min["h"])(
    'span',
    { 'class': 'text-muted' },
    'Code:'
);

var mailaddresses_list__ref19 = Object(preact_min["h"])(
    'div',
    { 'class': 'row' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'col-12 text-center' },
        Object(preact_min["h"])(
            'div',
            { 'class': 'spinner-border text-success', role: 'status' },
            Object(preact_min["h"])(
                'span',
                { 'class': 'sr-only' },
                'Loading...'
            )
        )
    )
);

var mailaddresses_list__ref20 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var list_MailAddressList = Object(index_module["a" /* observer */])(mailaddresses_list__class = (mailaddresses_list__temp = mailaddresses_list__class2 = function (_Component) {
    inherits_default()(MailAddressList, _Component);

    function MailAddressList(props) {
        classCallCheck_default()(this, MailAddressList);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        mailaddresses_list__initialiseProps.call(_this);

        _this.state = extends_default()({}, mailaddresses_list_initialState);
        _this.updateTimer = {};

        var mailaddressStore = _this.props.stores.mailaddressStore;

        mailaddressStore.list();
        return _this;
    }

    MailAddressList.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    MailAddressList.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    MailAddressList.prototype.updateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(id, field, value) {
            var _this2 = this;

            var mailaddressStore;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            mailaddressStore = this.props.stores.mailaddressStore;

                            mailaddressStore.updateField(id, field, value);

                            clearTimeout(this.updateTimer[field]);
                            this.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                return regenerator_default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _this2.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this2);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function updateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return updateField;
    }();

    MailAddressList.prototype.doUpdateField = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var mailaddressStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            mailaddressStore = this.props.stores.mailaddressStore;
                            _context3.next = 3;
                            return mailaddressStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function doUpdateField(_x4, _x5, _x6) {
            return _ref3.apply(this, arguments);
        }

        return doUpdateField;
    }();

    MailAddressList.prototype.render = function render() {
        var loading = this.state.loading;
        var mailaddressStore = this.props.stores.mailaddressStore;
        var mailaddresses = mailaddressStore.mailaddresses,
            queryFilter = mailaddressStore.queryFilter,
            saved = mailaddressStore.saved;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'text-muted font-weight-lighter float-right mr-2' },
                        'Total: ',
                        mailaddressStore.total,
                        mailaddresses_list__ref4
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': 'float-left form-row align-items-center mr-5' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])('input', { type: 'text', 'class': 'form-control form-control-sm', id: 'inlineFormInputName', placeholder: 'Search for mail addresses...',
                                onInput: function onInput(e) {
                                    return mailaddressStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true });
                                },
                                value: queryFilter.search
                            })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])(
                                'button',
                                { type: 'button', 'class': 'btn btn-sm btn-primary', onClick: function onClick() {
                                        return mailaddressStore.list();
                                    } },
                                'Search'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    queryFilter.search && Object(preact_min["h"])(
                        'div',
                        { 'class': 'w-100 text-left mt-2 mb-5' },
                        mailaddresses_list__ref5,
                        'Found ',
                        mailaddressStore.total || 0,
                        ' results in your search for "',
                        queryFilter.search,
                        '".',
                        mailaddresses_list__ref6,
                        Object(preact_min["h"])(
                            'button',
                            { 'class': 'btn btn-sm btn-warning mt-2',
                                onClick: function onClick() {
                                    return mailaddressStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true });
                                }
                            },
                            mailaddresses_list__ref7,
                            ' Reset search'
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'table-responsive' },
                        Object(preact_min["h"])(
                            'table',
                            { 'class': mailaddresses_style_default.a.table + ' table table-striped table-sm table-borderless' },
                            Object(preact_min["h"])(
                                'thead',
                                null,
                                mailaddressStore.sort !== mailaddressStore.defaultSort && Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { colspan: '8' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': mailaddresses_style_default.a.pointerCursor + ' mr-2 badge badge-pill badge-secondary', onClick: function onClick() {
                                                    return mailaddressStore.resetSort();
                                                } },
                                            mailaddresses_list__ref8,
                                            ' Reset sort'
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': mailaddresses_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return mailaddressStore.toggleSort('email', '-');
                                                } },
                                            'Email ',
                                            util.getSortIcon('email', mailaddressStore.sort)
                                        )
                                    ),
                                    mailaddresses_list__ref9,
                                    mailaddresses_list__ref10,
                                    mailaddresses_list__ref11,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': mailaddresses_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return mailaddressStore.toggleSort('lastBounceDate', '-');
                                                } },
                                            'Last bounce date ',
                                            util.getSortIcon('lastBounceDate', mailaddressStore.sort)
                                        )
                                    ),
                                    mailaddresses_list__ref12,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': mailaddresses_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return mailaddressStore.toggleSort('updatedDate', '-');
                                                } },
                                            'Updated ',
                                            util.getSortIcon('updatedDate', mailaddressStore.sort)
                                        )
                                    )
                                )
                            ),
                            Object(preact_min["h"])(
                                'tbody',
                                null,
                                mailaddresses && mailaddresses.map(function (mailaddress) {
                                    return Object(preact_min["h"])(
                                        'tr',
                                        { 'class': '' + mailaddresses_style_default.a.tableline },
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(
                                                'a',
                                                { href: '/mailaddresses/' + mailaddress.email + '/Basics' },
                                                mailaddress.email
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            mailaddress.bounceQty
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            mailaddress.complaintQty
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            mailaddress.bounces && mailaddress.bounces.map(function (bounce) {
                                                return Object(preact_min["h"])(
                                                    'div',
                                                    null,
                                                    bounce.bounceType,
                                                    Object(preact_min["h"])(
                                                        'small',
                                                        null,
                                                        Object(preact_min["h"])(
                                                            'div',
                                                            null,
                                                            mailaddresses_list__ref13,
                                                            ' ',
                                                            util.ffeDateTime(bounce.timestamp)
                                                        ),
                                                        Object(preact_min["h"])(
                                                            'div',
                                                            null,
                                                            mailaddresses_list__ref14,
                                                            ' ',
                                                            bounce.remoteMtaIp
                                                        ),
                                                        Object(preact_min["h"])(
                                                            'div',
                                                            null,
                                                            mailaddresses_list__ref15,
                                                            ' ',
                                                            bounce.reportingMTA
                                                        ),
                                                        Object(preact_min["h"])(
                                                            'div',
                                                            null,
                                                            bounce.bouncedRecipients.map(function (rcpt) {
                                                                return Object(preact_min["h"])(
                                                                    'div',
                                                                    { 'class': 'ml-4' },
                                                                    rcpt.emailAddress,
                                                                    ':',
                                                                    rcpt.action ? Object(preact_min["h"])(
                                                                        'div',
                                                                        { 'class': 'ml-4' },
                                                                        mailaddresses_list__ref16,
                                                                        ' ',
                                                                        rcpt.action
                                                                    ) : Object(preact_min["h"])(
                                                                        'small',
                                                                        null,
                                                                        Object(preact_min["h"])(
                                                                            'code',
                                                                            null,
                                                                            JSON.stringify(mailaddress.bounces)
                                                                        )
                                                                    ),
                                                                    rcpt.status && Object(preact_min["h"])(
                                                                        'div',
                                                                        { 'class': 'ml-4' },
                                                                        mailaddresses_list__ref17,
                                                                        ' ',
                                                                        rcpt.status
                                                                    ),
                                                                    rcpt.diagnosticCode && Object(preact_min["h"])(
                                                                        'div',
                                                                        { 'class': 'ml-4 text-primary' },
                                                                        mailaddresses_list__ref18,
                                                                        ' ',
                                                                        rcpt.diagnosticCode
                                                                    )
                                                                );
                                                            })
                                                        )
                                                    )
                                                );
                                            })
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            util.ffeDateTime(mailaddress.lastBounceDate)
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(
                                                'small',
                                                null,
                                                Object(preact_min["h"])(
                                                    'code',
                                                    null,
                                                    JSON.stringify(mailaddress.complaints)
                                                )
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            util.ffeDateTime(mailaddress.updatedDate)
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            Object(preact_min["h"])(
                                                'span',
                                                {
                                                    'class': 'mr-1 badge ' + mailaddresses_style_default.a.pointerCursor + ' badge-danger',
                                                    onClick: function onClick() {
                                                        return mailaddressStore.delete(mailaddress.email, 'email');
                                                    }
                                                },
                                                Object(preact_min["h"])('i', { 'class': 'fas fa-trash' }),
                                                ' Delete'
                                            )
                                        )
                                    );
                                })
                            )
                        )
                    )
                )
            ),
            loading && mailaddresses_list__ref19,
            mailaddresses_list__ref20
        );
    };

    return MailAddressList;
}(preact_min["Component"]), mailaddresses_list__initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleScroll = function () {
        var loading = _this3.state.loading;
        var mailaddressStore = _this3.props.stores.mailaddressStore;
        var totalAppend = mailaddressStore.totalAppend,
            limit = mailaddressStore.limit;

        if (window.innerHeight + document.documentElement.scrollTop + 500 < document.documentElement.offsetHeight) return;
        if (loading) return;

        var offset = mailaddressStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(_this3.scrollLoader);
            _this3.scrollLoader = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this3.setState({ loading: true });
                                mailaddressStore.updateOffset(offset);
                                _context4.next = 4;
                                return mailaddressStore.list(true);

                            case 4:
                                _this3.setState({ loading: false });

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this3);
            })), 500);
        }
    };
}, mailaddresses_list__temp)) || mailaddresses_list__class;

/* harmony default export */ var mailaddresses_list = (list_MailAddressList);
// CONCATENATED MODULE: ./components/mailaddresses/index.js




var mailaddresses__class;









var mailaddresses_initialState = {
    height: 100
};

var mailaddresses_Tag = Object(index_module["a" /* observer */])(mailaddresses__class = function (_Component) {
    inherits_default()(Tag, _Component);

    function Tag(props) {
        classCallCheck_default()(this, Tag);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = mailaddresses_initialState;
        _this.subscriptions();
        return _this;
    }

    Tag.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    Tag.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(mailaddresses_list, props)
                )
            )
        );
    };

    return Tag;
}(preact_min["Component"])) || mailaddresses__class;

/* harmony default export */ var components_mailaddresses = (mailaddresses_Tag);
// CONCATENATED MODULE: ./components/mailaddresses/edit.js







var mailaddresses_edit__class, mailaddresses_edit__class2, mailaddresses_edit__temp, mailaddresses_edit__initialiseProps;










var mailaddresses_edit_initialState = {};

var mailaddresses_edit_FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    email: { label: 'email', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    bounceQty: { label: 'bounceQty', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    bounces: { label: 'bounces', type: 'json', readonly: true, help: 'Field is DealerWeb only.' },
    complaintQty: { label: 'complaintQty', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    complaints: { label: 'complaints', type: 'json', readonly: true, help: 'Field is DealerWeb only.' },
    lastBounceDate: { label: 'lastBounceDate', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'updatedDate', type: 'text', readonly: true, help: 'Field is DealerWeb only.' }
};

var edit_MailaddressEdit = Object(index_module["a" /* observer */])(mailaddresses_edit__class = (mailaddresses_edit__temp = mailaddresses_edit__class2 = function (_Component) {
    inherits_default()(MailaddressEdit, _Component);

    function MailaddressEdit(props) {
        classCallCheck_default()(this, MailaddressEdit);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        mailaddresses_edit__initialiseProps.call(_this);

        _this.state = extends_default()({}, mailaddresses_edit_initialState);
        _this.updateTimer = {};
        var mailaddressStore = _this.props.stores.mailaddressStore;

        mailaddressStore.load(props.id);

        _this.fields = [{
            tabname: 'Basics',
            icon: 'fas fa-user-edit',
            fields: ['id', 'email', 'bounceQty', 'bounces', 'complaintQty', 'complaints', 'lastBounceDate', 'updatedDate'].map(function (f) {
                return util.makeField(f, mailaddresses_edit_FIELDS);
            })
        }];
        return _this;
    }

    MailaddressEdit.prototype.doUpdateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(id, field, value) {
            var mailaddressStore;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            mailaddressStore = this.props.stores.mailaddressStore;
                            _context.next = 3;
                            return mailaddressStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return doUpdateField;
    }();

    MailaddressEdit.prototype.render = function render(props) {
        var _this2 = this;

        var mailaddressStore = this.props.stores.mailaddressStore;
        var mailaddress = mailaddressStore.mailaddress,
            saved = mailaddressStore.saved;


        var tabIdx = this.fields.findIndex(function (e) {
            return e.tabname === props.tabname;
        });
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-flex flex-row bd-highlight mb-3' },
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: '/mailaddresses', 'class': 'mr-2 btn btn-sm btn-warning' },
                                Object(preact_min["h"])('i', { 'class': 'fas fa-arrow-left mr-1' }),
                                'Back'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'h4',
                                null,
                                'Edit: ',
                                mailaddress.email
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'nav nav-tabs mb-2' },
                        this.fields.map(function (tab) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'nav-item' },
                                Object(preact_min["h"])(
                                    'a',
                                    { 'class': 'nav-link ' + (props.tabname === tab.tabname ? 'active' : ''),
                                        href: '/mailaddresss/' + props.mailaddressid + '/' + tab.tabname
                                    },
                                    Object(preact_min["h"])('i', { 'class': tab.icon + ' mr-2' }),
                                    tab.tabname
                                )
                            );
                        })
                    ),
                    this.fields[tabIdx].fields.map(function (field) {
                        return Object(preact_min["h"])(formField_FormRow, {
                            field: field,
                            object: mailaddress,
                            saved: saved,
                            updateField: _this2.updateField
                        });
                    })
                )
            )
        );
    };

    return MailaddressEdit;
}(preact_min["Component"]), mailaddresses_edit__initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.updateField = function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var mailaddressStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            mailaddressStore = _this3.props.stores.mailaddressStore;

                            mailaddressStore.updateField(id, field, value);

                            clearTimeout(_this3.updateTimer[field]);
                            _this3.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                    while (1) {
                                        switch (_context2.prev = _context2.next) {
                                            case 0:
                                                _this3.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context2.stop();
                                        }
                                    }
                                }, _callee2, _this3);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x4, _x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();
}, mailaddresses_edit__temp)) || mailaddresses_edit__class;

/* harmony default export */ var mailaddresses_edit = (edit_MailaddressEdit);
// EXTERNAL MODULE: ./components/urls/style.css
var urls_style = __webpack_require__("3nwz");
var urls_style_default = /*#__PURE__*/__webpack_require__.n(urls_style);

// CONCATENATED MODULE: ./components/urls/list.js







var urls_list__class, urls_list__class2, urls_list__temp, urls_list__initialiseProps;










var urls_list_initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false
    }
};

var urls_list__ref4 = Object(preact_min["h"])('br', null);

var urls_list__ref5 = Object(preact_min["h"])(
    'h1',
    null,
    Object(preact_min["h"])('i', { 'class': 'fas fa-search' }),
    ' Search results'
);

var urls_list__ref6 = Object(preact_min["h"])('br', null);

var urls_list__ref7 = Object(preact_min["h"])('i', { 'class': 'fas fa-times' });

var urls_list__ref8 = Object(preact_min["h"])('i', { 'class': 'fas fa-times-circle' });

var urls_list__ref9 = Object(preact_min["h"])(
    'th',
    { style: 'width: 50%' },
    'Url'
);

var urls_list__ref10 = Object(preact_min["h"])('i', { 'class': 'fas fa-link' });

var urls_list__ref11 = Object(preact_min["h"])(
    'div',
    { 'class': 'row' },
    Object(preact_min["h"])(
        'div',
        { 'class': 'col-12 text-center' },
        Object(preact_min["h"])(
            'div',
            { 'class': 'spinner-border text-success', role: 'status' },
            Object(preact_min["h"])(
                'span',
                { 'class': 'sr-only' },
                'Loading...'
            )
        )
    )
);

var urls_list__ref12 = Object(preact_min["h"])(
    'div',
    { 'class': 'text-center mt-4 mb-2' },
    Object(preact_min["h"])(
        'small',
        { 'class': 'text-muted' },
        Object(preact_min["h"])('i', { 'class': 'fas fa-ellipsis-h' })
    )
);

var list_UrlList = Object(index_module["a" /* observer */])(urls_list__class = (urls_list__temp = urls_list__class2 = function (_Component) {
    inherits_default()(UrlList, _Component);

    function UrlList(props) {
        classCallCheck_default()(this, UrlList);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        urls_list__initialiseProps.call(_this);

        _this.state = extends_default()({}, urls_list_initialState, {
            previewServer: util.getPreviewServer()
        });
        _this.updateTimer = {};

        var urlStore = _this.props.stores.urlStore;

        urlStore.list();
        return _this;
    }

    UrlList.prototype.componentDidMount = function componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    };

    UrlList.prototype.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    };

    UrlList.prototype.updateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(id, field, value) {
            var _this2 = this;

            var urlStore;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            urlStore = this.props.stores.urlStore;

                            urlStore.updateField(id, field, value);

                            clearTimeout(this.updateTimer[field]);
                            this.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                                return regenerator_default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                _this2.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this2);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function updateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return updateField;
    }();

    UrlList.prototype.doUpdateField = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var urlStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            urlStore = this.props.stores.urlStore;
                            _context3.next = 3;
                            return urlStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function doUpdateField(_x4, _x5, _x6) {
            return _ref3.apply(this, arguments);
        }

        return doUpdateField;
    }();

    UrlList.prototype.render = function render() {
        var _state = this.state,
            loading = _state.loading,
            previewServer = _state.previewServer;
        var urlStore = this.props.stores.urlStore;
        var urls = urlStore.urls,
            queryFilter = urlStore.queryFilter,
            saved = urlStore.saved;


        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'small',
                        { 'class': 'text-muted font-weight-lighter float-right mr-2' },
                        'Total: ',
                        urlStore.total,
                        urls_list__ref4
                    ),
                    Object(preact_min["h"])(
                        'span',
                        { 'class': 'float-left form-row align-items-center mr-5' },
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])('input', { type: 'text', 'class': 'form-control form-control-sm', id: 'inlineFormInputName', placeholder: 'Search for urls...',
                                onInput: function onInput(e) {
                                    return urlStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true });
                                },
                                value: queryFilter.search
                            })
                        ),
                        Object(preact_min["h"])(
                            'div',
                            { 'class': 'col-auto' },
                            Object(preact_min["h"])(
                                'button',
                                { type: 'button', 'class': 'btn btn-sm btn-primary', onClick: function onClick() {
                                        return urlStore.list();
                                    } },
                                'Search'
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    queryFilter.search && Object(preact_min["h"])(
                        'div',
                        { 'class': 'w-100 text-left mt-2 mb-5' },
                        urls_list__ref5,
                        'Found ',
                        urlStore.total || 0,
                        ' results in your search for "',
                        queryFilter.search,
                        '".',
                        urls_list__ref6,
                        Object(preact_min["h"])(
                            'button',
                            { 'class': 'btn btn-sm btn-warning mt-2',
                                onClick: function onClick() {
                                    return urlStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true });
                                }
                            },
                            urls_list__ref7,
                            ' Reset search'
                        )
                    ),
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'table-responsive' },
                        Object(preact_min["h"])(
                            'table',
                            { 'class': urls_style_default.a.table + ' table table-striped table-sm table-borderless' },
                            Object(preact_min["h"])(
                                'thead',
                                null,
                                urlStore.sort !== urlStore.defaultSort && Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { colspan: '8' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': urls_style_default.a.pointerCursor + ' mr-2 badge badge-pill badge-secondary', onClick: function onClick() {
                                                    return urlStore.resetSort();
                                                } },
                                            urls_list__ref8,
                                            ' Reset sort'
                                        )
                                    )
                                ),
                                Object(preact_min["h"])(
                                    'tr',
                                    null,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 15%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': urls_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return urlStore.toggleSort('title', '-');
                                                } },
                                            'Title ',
                                            util.getSortIcon('title', urlStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': urls_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return urlStore.toggleSort('alias', '-');
                                                } },
                                            'Alias ',
                                            util.getSortIcon('alias', urlStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': urls_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return urlStore.toggleSort('source', '-');
                                                } },
                                            'Source ',
                                            util.getSortIcon('source', urlStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': urls_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return urlStore.toggleSort('tags', '');
                                                } },
                                            'Tags ',
                                            util.getSortIcon('tags', urlStore.sort)
                                        )
                                    ),
                                    urls_list__ref9,
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 5%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': urls_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return urlStore.toggleSort('clicks', '');
                                                } },
                                            'Clicks ',
                                            util.getSortIcon('clicks', urlStore.sort)
                                        )
                                    ),
                                    Object(preact_min["h"])(
                                        'th',
                                        { style: 'width: 10%', 'class': 'text-right' },
                                        Object(preact_min["h"])(
                                            'span',
                                            { 'class': urls_style_default.a.pointerCursor, onClick: function onClick() {
                                                    return urlStore.toggleSort('created', '');
                                                } },
                                            'Created ',
                                            util.getSortIcon('created', urlStore.sort)
                                        )
                                    )
                                )
                            ),
                            Object(preact_min["h"])(
                                'tbody',
                                null,
                                urls && urls.map(function (article) {
                                    return Object(preact_min["h"])(
                                        'tr',
                                        { 'class': '' + urls_style_default.a.tableline },
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(
                                                'a',
                                                { href: '/urls/' + article.id + '/Basics' },
                                                article.title
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            Object(preact_min["h"])(
                                                'nobr',
                                                null,
                                                Object(preact_min["h"])(
                                                    'a',
                                                    { target: '_blank', href: previewServer + '/go/' + article.alias },
                                                    urls_list__ref10,
                                                    ' ',
                                                    article.alias
                                                )
                                            )
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            article.source
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            article.tags
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            null,
                                            article.url
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            article.clicks
                                        ),
                                        Object(preact_min["h"])(
                                            'td',
                                            { 'class': 'text-right' },
                                            article.created && util.ffeDateTime(article.created)
                                        )
                                    );
                                })
                            )
                        )
                    )
                )
            ),
            loading && urls_list__ref11,
            urls_list__ref12
        );
    };

    return UrlList;
}(preact_min["Component"]), urls_list__initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleScroll = function () {
        var loading = _this3.state.loading;
        var urlStore = _this3.props.stores.urlStore;
        var totalAppend = urlStore.totalAppend,
            limit = urlStore.limit;

        if (window.innerHeight + document.documentElement.scrollTop + 500 < document.documentElement.offsetHeight) return;
        if (loading) return;

        var offset = urlStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(_this3.scrollLoader);
            _this3.scrollLoader = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
                return regenerator_default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this3.setState({ loading: true });
                                urlStore.updateOffset(offset);
                                _context4.next = 4;
                                return urlStore.list(true);

                            case 4:
                                _this3.setState({ loading: false });

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this3);
            })), 500);
        }
    };
}, urls_list__temp)) || urls_list__class;

/* harmony default export */ var urls_list = (list_UrlList);
// CONCATENATED MODULE: ./components/urls/index.js




var urls__class;









var urls_initialState = {
    height: 100
};

var urls_Tag = Object(index_module["a" /* observer */])(urls__class = function (_Component) {
    inherits_default()(Tag, _Component);

    function Tag(props) {
        classCallCheck_default()(this, Tag);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.state = urls_initialState;
        _this.subscriptions();
        return _this;
    }

    Tag.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LEFT_MENU_HEIGHT_UPDATED, function (height) {
            _this2.setState({ height: height });
        });
    };

    Tag.prototype.render = function render() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(urls_list, props)
                )
            )
        );
    };

    return Tag;
}(preact_min["Component"])) || urls__class;

/* harmony default export */ var components_urls = (urls_Tag);
// CONCATENATED MODULE: ./components/urls/edit.js







var urls_edit__class, urls_edit__class2, urls_edit__temp, urls_edit__initialiseProps;











var urls_edit_initialState = {};

var urls_edit_FIELDS = {
    id: { label: 'Db #', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    title: { label: 'title', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    alias: { label: 'alias', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    source: { label: 'source', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    tags: { label: 'tags', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    url: { label: 'url', type: 'text', readonly: false, help: 'Field is DealerWeb only.' },
    clicks: { label: 'clicks', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    created: { label: 'created', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updated: { label: 'updated', type: 'text', readonly: true, help: 'Field is DealerWeb only.' },
    updatedDate: { label: 'Updated date', type: 'text', readonly: true, help: 'Field is DealerWeb only.' }
};

var edit_UrlEdit = Object(index_module["a" /* observer */])(urls_edit__class = (urls_edit__temp = urls_edit__class2 = function (_Component) {
    inherits_default()(UrlEdit, _Component);

    function UrlEdit(props) {
        classCallCheck_default()(this, UrlEdit);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        urls_edit__initialiseProps.call(_this);

        _this.state = extends_default()({}, urls_edit_initialState);
        _this.updateTimer = {};
        var urlStore = _this.props.stores.urlStore;

        urlStore.load(props.id);

        _this.fields = [{
            tabname: 'Basics',
            icon: 'fas fa-user-edit',
            fields: ['id', 'title', 'alias', 'source', 'tags', 'url', 'clicks', 'created', 'updated', 'updatedDate'].map(function (f) {
                return util.makeField(f, urls_edit_FIELDS);
            })
        }];
        return _this;
    }

    UrlEdit.prototype.doUpdateField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(id, field, value) {
            var urlStore;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            urlStore = this.props.stores.urlStore;
                            _context.next = 3;
                            return urlStore.saveField(id, field, value);

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function doUpdateField(_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        }

        return doUpdateField;
    }();

    UrlEdit.prototype.render = function render(props) {
        var _this2 = this;

        var urlStore = this.props.stores.urlStore;
        var url = urlStore.url,
            saved = urlStore.saved;


        var tabIdx = this.fields.findIndex(function (e) {
            return e.tabname === props.tabname;
        });
        if (tabIdx < 0) {
            tabIdx = 0;
        }

        return Object(preact_min["h"])(
            'div',
            null,
            Object(preact_min["h"])(navigation_top, props),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'div',
                        { 'class': 'd-flex flex-row bd-highlight mb-3' },
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'a',
                                { href: '/urls', 'class': 'mr-2 btn btn-sm btn-warning' },
                                Object(preact_min["h"])('i', { 'class': 'fas fa-arrow-left mr-1' }),
                                'Back'
                            )
                        ),
                        Object(preact_min["h"])(
                            'div',
                            null,
                            Object(preact_min["h"])(
                                'h4',
                                null,
                                'Edit: ',
                                url.id,
                                ': ',
                                url.title
                            )
                        )
                    )
                )
            ),
            Object(preact_min["h"])(
                'div',
                { 'class': 'row' },
                Object(preact_min["h"])(
                    'div',
                    { 'class': 'col-12' },
                    Object(preact_min["h"])(
                        'ul',
                        { 'class': 'nav nav-tabs mb-2' },
                        this.fields.map(function (tab) {
                            return Object(preact_min["h"])(
                                'li',
                                { 'class': 'nav-item' },
                                Object(preact_min["h"])(
                                    'a',
                                    { 'class': 'nav-link ' + (props.tabname === tab.tabname ? 'active' : ''),
                                        href: '/urls/' + props.urlid + '/' + tab.tabname
                                    },
                                    Object(preact_min["h"])('i', { 'class': tab.icon + ' mr-2' }),
                                    tab.tabname
                                )
                            );
                        })
                    ),
                    this.fields[tabIdx].fields.map(function (field) {
                        return Object(preact_min["h"])(formField_FormRow, {
                            field: field,
                            object: url,
                            saved: saved,
                            updateField: _this2.updateField
                        });
                    })
                )
            )
        );
    };

    return UrlEdit;
}(preact_min["Component"]), urls_edit__initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.updateField = function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(id, field, value) {
            var urlStore;
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            urlStore = _this3.props.stores.urlStore;

                            urlStore.updateField(id, field, value);

                            clearTimeout(_this3.updateTimer[field]);
                            _this3.updateTimer[field] = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
                                return regenerator_default.a.wrap(function _callee2$(_context2) {
                                    while (1) {
                                        switch (_context2.prev = _context2.next) {
                                            case 0:
                                                _this3.doUpdateField(id, field, value);

                                            case 1:
                                            case 'end':
                                                return _context2.stop();
                                        }
                                    }
                                }, _callee2, _this3);
                            })), 500);

                        case 4:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x4, _x5, _x6) {
            return _ref2.apply(this, arguments);
        };
    }();
}, urls_edit__temp)) || urls_edit__class;

/* harmony default export */ var urls_edit = (edit_UrlEdit);
// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("jx4H");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ../node_modules/mobx/lib/mobx.module.js
var mobx_module = __webpack_require__("6uYi");

// CONCATENATED MODULE: ./stores/appstate.js



var _desc, _value, appstate__class, _descriptor, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var appstate_AppState = (appstate__class = function () {
    function AppState() {
        classCallCheck_default()(this, AppState);

        _initDefineProp(this, 'view', _descriptor, this);

        _initDefineProp(this, 'darkmode', _descriptor2, this);

        _initDefineProp(this, 'counter', _descriptor3, this);

        this.setView(util.getObject('view'));
    }

    AppState.prototype.setView = function setView(view) {
        this.view = view;
        util.setObject('view', view);
    };

    AppState.prototype.setViewKey = function setViewKey(key, value) {
        this.view[key] = value;
    };

    AppState.prototype.incCounter = function incCounter() {
        this.counter += 1;
        util.set('counter', this.counter);
    };

    AppState.prototype.decCounter = function decCounter() {
        this.counter -= 1;
        util.set('counter', this.counter);
    };

    AppState.prototype.toggleDarkmode = function toggleDarkmode() {
        this.darkmode = !this.darkmode;
        util.set('darkmode', this.darkmode);
        util.toggleDarkModeClasses(this.darkmode);
    };

    createClass_default()(AppState, [{
        key: 'counterTimes2',
        get: function get() {
            return this.counter * 2;
        }
    }]);

    return AppState;
}(), (_descriptor = _applyDecoratedDescriptor(appstate__class.prototype, 'view', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), _descriptor2 = _applyDecoratedDescriptor(appstate__class.prototype, 'darkmode', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return util.get('darkmode');
    }
}), _descriptor3 = _applyDecoratedDescriptor(appstate__class.prototype, 'counter', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return util.get('counter');
    }
}), _applyDecoratedDescriptor(appstate__class.prototype, 'setView', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(appstate__class.prototype, 'setView'), appstate__class.prototype), _applyDecoratedDescriptor(appstate__class.prototype, 'setViewKey', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(appstate__class.prototype, 'setViewKey'), appstate__class.prototype), _applyDecoratedDescriptor(appstate__class.prototype, 'incCounter', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(appstate__class.prototype, 'incCounter'), appstate__class.prototype), _applyDecoratedDescriptor(appstate__class.prototype, 'decCounter', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(appstate__class.prototype, 'decCounter'), appstate__class.prototype), _applyDecoratedDescriptor(appstate__class.prototype, 'counterTimes2', [mobx_module["e" /* computed */]], Object.getOwnPropertyDescriptor(appstate__class.prototype, 'counterTimes2'), appstate__class.prototype), _applyDecoratedDescriptor(appstate__class.prototype, 'toggleDarkmode', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(appstate__class.prototype, 'toggleDarkmode'), appstate__class.prototype)), appstate__class);


var store = new appstate_AppState();

Object(mobx_module["d" /* autorun */])(function () {
    // console.log(store.counter);
});

/* harmony default export */ var appstate = (store);
// CONCATENATED MODULE: ./stores/storeModel.js





var storeModel__desc, storeModel__value, storeModel__class, storeModel__descriptor, storeModel__descriptor2, storeModel__descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;

function storeModel__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function storeModel__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function storeModel__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var storeModel_StoreModel = (storeModel__class = function () {
    function StoreModel(name, opts) {
        classCallCheck_default()(this, StoreModel);

        storeModel__initDefineProp(this, 'queryFilter', storeModel__descriptor, this);

        storeModel__initDefineProp(this, 'sort', storeModel__descriptor2, this);

        storeModel__initDefineProp(this, 'defaultSort', storeModel__descriptor3, this);

        storeModel__initDefineProp(this, 'extendedView', _descriptor4, this);

        storeModel__initDefineProp(this, 'limit', _descriptor5, this);

        storeModel__initDefineProp(this, 'offset', _descriptor6, this);

        storeModel__initDefineProp(this, 'searchResults', _descriptor7, this);

        storeModel__initDefineProp(this, 'totalSearch', _descriptor8, this);

        storeModel__initDefineProp(this, 'searchSelectId', _descriptor9, this);

        storeModel__initDefineProp(this, 'searchSelectIdx', _descriptor10, this);

        storeModel__initDefineProp(this, 'total', _descriptor11, this);

        storeModel__initDefineProp(this, 'totalAppend', _descriptor12, this);

        storeModel__initDefineProp(this, 'saved', _descriptor13, this);

        storeModel__initDefineProp(this, 'view', _descriptor14, this);

        storeModel__initDefineProp(this, 'toggleQueryfilter', _descriptor15, this);

        this.name = name;
        this.namePlural = opts.namePlural;
        this.api = opts.api;
        this.opts = opts;
    }

    StoreModel.prototype.update = function update(items, append) {
        if (append) {
            this[this.namePlural] = this[this.namePlural].concat(items);
        } else {
            this[this.namePlural] = items;
        }
    };

    StoreModel.prototype.deleteElement = function deleteElement(val) {
        var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';

        var idx = this[this.namePlural].findIndex(function (e) {
            return e[field] === val;
        });
        if (idx >= 0) {
            this[this.namePlural] = this[this.namePlural].filter(function (e) {
                return e[field] !== val;
            });
        }
    };

    StoreModel.prototype.updateKeyValue = function updateKeyValue(key, value) {
        var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        this[key] = value;
        if (opt.save) {
            util.set('' + this.name + key, value);
        }
    };

    StoreModel.prototype.updateItem = function updateItem(item) {
        this[this.name] = item;
    };

    StoreModel.prototype.updateField = function updateField(id, field, value) {
        var findBy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'id';

        var idx = this[this.namePlural].findIndex(function (e) {
            return e[findBy] === id;
        });
        if (idx >= 0) {
            var obj = this[this.namePlural][idx];
            util.setNestedValue(obj, field, value);
        }
        // else {
        //     const obj = this[this.namePlural];
        //     util.setNestedValue(obj, field, value);
        // }
        if (this[this.name]) {
            util.setNestedValue(this[this.name], field, value);
        }
    };

    StoreModel.prototype.updateQueryFilter = function updateQueryFilter(queryFilter) {
        this.queryFilter = queryFilter;
        util.setObject(this.name + 'QueryFilter', this.queryFilter);
    };

    StoreModel.prototype.updateSort = function updateSort(sort) {
        this.sort = sort;
    };

    StoreModel.prototype.resetSort = function resetSort() {
        this.sort = this.defaultSort;
        this.load();
    };

    StoreModel.prototype.toggleSort = function toggleSort(sort) {
        var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        var hasSign = this.sort.match(/^-/);
        var oldSort = this.sort.replace(/^-/, '');
        if (oldSort === sort) {
            if (hasSign) {
                this.sort = sort;
            } else {
                this.sort = '-' + sort;
            }
        } else {
            this.sort = '' + initial + sort;
        }
        this.load();
    };

    StoreModel.prototype.updateOffset = function updateOffset(offset) {
        this.offset = offset;
    };

    StoreModel.prototype.updateTotal = function updateTotal(total) {
        this.total = total;
    };

    StoreModel.prototype.updateTotalAppend = function updateTotalAppend(total) {
        this.totalAppend = total;
    };

    StoreModel.prototype.updateSaved = function updateSaved(key, val) {
        if (val) {
            this.saved[key] = val;
        } else {
            delete this.saved[key];
        }
    };

    StoreModel.prototype.toggleView = function toggleView(element, value) {
        this.view[element] = value || !this.view[element];
    };

    StoreModel.prototype.resetQueryFilter = function resetQueryFilter() {
        this.updateQueryFilter({});
    };

    StoreModel.prototype.updateSearchSelectId = function updateSearchSelectId(id) {
        this.searchSelectId = id;
    };

    StoreModel.prototype.updateSearchSelectIdx = function updateSearchSelectIdx(idx) {
        this.searchSelectIdx = idx;
    };

    StoreModel.prototype.updateSearchResults = function updateSearchResults(items) {
        this.searchResults = items;
    };

    StoreModel.prototype.updateSearchTotal = function updateSearchTotal(total) {
        this.totalSearch = total;
    };

    StoreModel.prototype.incSearchSelectIdx = function incSearchSelectIdx() {
        this.searchSelectIdx += 1;
        if (this.searchSelectIdx >= this.totalSearch) {
            this.searchSelectIdx = this.totalSearch - 1;
        }
        var item = extends_default()({}, this.searchResults[this.searchSelectIdx]);
        this.updateSearchSelectId(item.id);
    };

    StoreModel.prototype.decSearchSelectIdx = function decSearchSelectIdx() {
        this.searchSelectIdx -= 1;
        if (this.searchSelectIdx < 0) {
            this.searchSelectIdx = 0;
        }
        var item = extends_default()({}, this.searchResults[this.searchSelectIdx]);
        this.updateSearchSelectId(item.id);
    };

    StoreModel.prototype.resetSearch = function resetSearch() {
        this.updateSearchResults([]);
        this.updateSearchTotal(0);
        this.updateSearchSelectId(0);
        this.searchSelectIdx = 0;
    };

    StoreModel.prototype.addElement = function addElement(idx, dataObj, field) {
        var element = {};
        if (typeof idx === 'object') {
            element = extends_default()({}, idx);
        } else {
            element = this.getElement(idx);
        }
        if (typeof this[dataObj][field] === 'undefined') {
            this[dataObj][field] = [];
        }
        var elIdx = this[dataObj][field].findIndex(function (e) {
            return parseInt(e.id, 10) === element.id;
        });
        if (elIdx < 0) {
            var _save;

            this[dataObj][field].push(element);
            this.save((_save = {}, _save[field] = this[dataObj][field], _save));
        }
    };

    StoreModel.prototype.getElement = function getElement(idx) {
        var index = idx || this.searchSelectIdx;
        return {
            id: this.searchResults[index].id,
            title: this.searchResults[index].title
        };
    };

    StoreModel.prototype.removeElement = function removeElement(id, dataObj, field) {
        var elId = parseInt(id, 10);
        var elIdx = this[dataObj][field].findIndex(function (e) {
            return parseInt(e.id, 10) === elId;
        });
        if (elIdx >= 0) {
            var _save2;

            this[dataObj][field] = this[dataObj][field].filter(function (e) {
                return parseInt(e.id, 10) != elId;
            });
            // this[dataObj][field].splice(elIdx, 1); // Not detected by observers.
            this.save((_save2 = {}, _save2[field] = this[dataObj][field], _save2));
        }
    };

    StoreModel.prototype.search = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(searchText) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var url, apiParams, response;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            url = util.getNestedValue(this, 'api.search.url');
                            apiParams = util.getNestedValue(this, 'api.search.params');
                            _context.next = 4;
                            return util.fetchApi(url, { publish: true }, extends_default()({
                                sort: this.sort,
                                limit: this.limit
                            }, apiParams, options, {
                                search: searchText
                            }));

                        case 4:
                            response = _context.sent;

                            if (response.data) {
                                this.updateSearchSelectId(util.asNumber(response, 'data', 0, 'id'));
                                this.updateSearchSelectIdx(0);
                                this.updateSearchResults(response.data);
                                this.updateSearchTotal(response.total);
                            }

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function search(_x5) {
            return _ref.apply(this, arguments);
        }

        return search;
    }();

    StoreModel.prototype.makeQuery = function makeQuery() {
        var query = Object(mobx_module["i" /* toJS */])(this.queryFilter);
        return query;
    };

    StoreModel.prototype.load = function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
            var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

            var _this = this;

            var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var url, qf, queryFilter, response;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (!append) {
                                this.updateOffset(0);
                            }
                            url = util.getNestedValue(this, 'api.load.url');
                            qf = opt.skipFilter ? {} : this.makeQuery();
                            queryFilter = id ? {} : extends_default()({}, qf);

                            if (opt.query) {
                                queryFilter = opt.query;
                            }
                            _context2.next = 7;
                            return util.fetchApi('' + url + id, { publish: true }, util.cleanObject(extends_default()({
                                extendedView: this.extendedView,
                                offset: this.offset,
                                limit: opt.limit || this.limit,
                                sort: opt.sort || this.sort
                            }, queryFilter)));

                        case 7:
                            response = _context2.sent;

                            if (response.status < 400) {
                                if (Array.isArray(opt.addData)) {
                                    opt.addData.forEach(function (el) {
                                        if (response[el]) {
                                            _this.updateKeyValue(el, response[el]);
                                        }
                                    });
                                }
                                if (id) {
                                    if (Array.isArray(response.data)) {
                                        this.updateItem(response.data[0]);
                                    } else {
                                        this.updateItem(response.data);
                                    }
                                } else if (opt.dataKey) {
                                    this.updateKeyValue(opt.dataKey, response.data);
                                } else {
                                    this.update(response.data, append);
                                    if (append) {
                                        this.updateTotalAppend(response.data.length);
                                    } else {
                                        this.updateTotal(response.total);
                                        window.scrollTo(0, 0);
                                    }
                                }
                                if (typeof this.parseElements === 'function') {
                                    this.parseElements();
                                }
                            }

                        case 9:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function load() {
            return _ref2.apply(this, arguments);
        }

        return load;
    }();

    StoreModel.prototype.list = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(append) {
            var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            return _context3.abrupt('return', this.load('', append, opt));

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function list(_x10) {
            return _ref3.apply(this, arguments);
        }

        return list;
    }();

    StoreModel.prototype.saveField = function () {
        var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(id, field, value, updateMemory) {
            var _util$fetchApi,
                _this2 = this;

            var url, response;
            return regenerator_default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            url = util.getNestedValue(this, 'api.save.url');

                            if (updateMemory) {
                                this.updateField(id, field, value);
                            }
                            this.updateSaved(field + '.' + id, true);
                            _context4.next = 5;
                            return util.fetchApi('' + url + id, {
                                publish: true,
                                method: 'PATCH'
                            }, (_util$fetchApi = {}, _util$fetchApi[field] = value, _util$fetchApi));

                        case 5:
                            response = _context4.sent;

                            if (response.status < 300) {
                                // Remove saved
                                setTimeout(function () {
                                    _this2.updateSaved(field + '.' + id);
                                }, 2000);
                            }

                        case 7:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function saveField(_x12, _x13, _x14, _x15) {
            return _ref4.apply(this, arguments);
        }

        return saveField;
    }();

    /**
     * Update many database entries in one operation.
     *
     * @param {object} filter - The query filter for this update.
     * @param {string} field - Field name.
     * @param {*} value - Field value.
     * @param {boolean} updateMemory - Setting to update memory or not.
     * @memberof StoreModel
     */


    StoreModel.prototype.updateMany = function () {
        var _ref5 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5(filter, field, value, updateMemory) {
            var _extends2,
                _this3 = this;

            var url, response;
            return regenerator_default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            url = util.getNestedValue(this, 'api.save.url');

                            if (updateMemory) {
                                this.updateField(filter.id, field, value);
                            }
                            this.updateSaved(field + '.' + filter.id, true);
                            _context5.next = 5;
                            return util.fetchApi('' + url + filter.id, {
                                publish: true,
                                method: 'PATCH'
                            }, extends_default()({}, filter, (_extends2 = {}, _extends2[field] = value, _extends2)));

                        case 5:
                            response = _context5.sent;

                            if (response.status < 300) {
                                // Remove saved
                                setTimeout(function () {
                                    _this3.updateSaved(field + '.' + filter.id);
                                }, 2000);
                            }

                        case 7:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function updateMany(_x16, _x17, _x18, _x19) {
            return _ref5.apply(this, arguments);
        }

        return updateMany;
    }();

    StoreModel.prototype.save = function () {
        var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee6(data) {
            var url;
            return regenerator_default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            url = util.getNestedValue(this, 'api.save.url');
                            _context6.next = 3;
                            return util.fetchApi('' + url + this[this.name].id, { publish: true, method: 'PATCH' }, extends_default()({}, data));

                        case 3:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function save(_x20) {
            return _ref6.apply(this, arguments);
        }

        return save;
    }();

    StoreModel.prototype.create = function () {
        var _ref7 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee7(data) {
            var url;
            return regenerator_default.a.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            url = util.getNestedValue(this, 'api.save.url');
                            _context7.next = 3;
                            return util.fetchApi('' + url, { publish: true, method: 'POST' }, extends_default()({}, data));

                        case 3:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        function create(_x21) {
            return _ref7.apply(this, arguments);
        }

        return create;
    }();

    StoreModel.prototype.delete = function () {
        var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee8(id) {
            var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
            var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var url;
            return regenerator_default.a.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            this.deleteElement(id, field);
                            url = util.getNestedValue(this, 'api.delete.url');
                            _context8.next = 4;
                            return util.fetchApi('' + url + id, { publish: true, method: 'DELETE' }, extends_default()({}, data));

                        case 4:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        function _delete(_x22) {
            return _ref8.apply(this, arguments);
        }

        return _delete;
    }();

    return StoreModel;
}(), (storeModel__descriptor = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'queryFilter', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return util.getObject(this.name + 'QueryFilter') || this.opts.queryFilter || {};
    }
}), storeModel__descriptor2 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'sort', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return this.opts.sort;
    }
}), storeModel__descriptor3 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'defaultSort', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return this.opts.sort;
    }
}), _descriptor4 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'extendedView', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return this.opts.extendedView;
    }
}), _descriptor5 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'limit', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return 50;
    }
}), _descriptor6 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'offset', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor7 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'searchResults', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), _descriptor8 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'totalSearch', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor9 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'searchSelectId', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor10 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'searchSelectIdx', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor11 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'total', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor12 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'totalAppend', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return 0;
    }
}), _descriptor13 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'saved', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), _descriptor14 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'view', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'update', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'update'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'deleteElement', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'deleteElement'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'updateKeyValue', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'updateKeyValue'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'updateItem', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'updateItem'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'updateField', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'updateField'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'updateQueryFilter', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'updateQueryFilter'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'updateSort', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'updateSort'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'resetSort', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'resetSort'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'toggleSort', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'toggleSort'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'updateOffset', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'updateOffset'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'updateTotal', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'updateTotal'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'updateTotalAppend', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'updateTotalAppend'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'updateSaved', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'updateSaved'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'toggleView', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'toggleView'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'resetQueryFilter', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'resetQueryFilter'), storeModel__class.prototype), _descriptor15 = storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'toggleQueryfilter', [mobx_module["c" /* action */]], {
    enumerable: true,
    initializer: function initializer() {
        var _this4 = this;

        return function (filter) {
            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var opt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var finalFilter = extends_default()({}, _this4.queryFilter);
            if (opt.setValue) {
                finalFilter[filter] = value;
            } else {
                finalFilter[filter] = finalFilter[filter] ? null : value;
            }
            if (!finalFilter[filter] && finalFilter[filter] !== 0) {
                delete finalFilter[filter];
            }
            _this4.updateQueryFilter(finalFilter);
            if (!opt.skipUpdate) {
                _this4.list();
                if (typeof _this4.tree === 'function') {
                    _this4.tree();
                }
            }
            if (opt.viewElement) {
                opt.toggleView(opt.viewElement);
            }
            if (opt.setTimer) {
                clearTimeout(_this4.searchTimer);
                _this4.searchTimer = setTimeout(asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee9() {
                    return regenerator_default.a.wrap(function _callee9$(_context9) {
                        while (1) {
                            switch (_context9.prev = _context9.next) {
                                case 0:
                                    _this4.list();
                                    if (typeof _this4.tree === 'function') {
                                        _this4.tree();
                                    }

                                case 2:
                                case 'end':
                                    return _context9.stop();
                            }
                        }
                    }, _callee9, _this4);
                })), 750);
            }
            if (typeof opt.toggle === 'function') {
                opt.toggle(value);
            }
            if (opt.route) {
                route(opt.route, true);
            }
        };
    }
}), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'updateSearchSelectId', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'updateSearchSelectId'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'updateSearchSelectIdx', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'updateSearchSelectIdx'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'updateSearchResults', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'updateSearchResults'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'updateSearchTotal', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'updateSearchTotal'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'incSearchSelectIdx', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'incSearchSelectIdx'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'decSearchSelectIdx', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'decSearchSelectIdx'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'resetSearch', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'resetSearch'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'addElement', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'addElement'), storeModel__class.prototype), storeModel__applyDecoratedDescriptor(storeModel__class.prototype, 'removeElement', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(storeModel__class.prototype, 'removeElement'), storeModel__class.prototype)), storeModel__class);


/* harmony default export */ var storeModel = (storeModel_StoreModel);
// CONCATENATED MODULE: ./stores/dealer.js







var dealer__desc, dealer__value, dealer__class, dealer__descriptor, dealer__descriptor2, dealer__descriptor3, dealer__descriptor4, dealer__descriptor5;

function dealer__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function dealer__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function dealer__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var countryLanguageMap = {
    NORWAY: 'no',
    ITALY: 'it',
    GERMANY: 'de',
    FRANCE: 'fr',
    default: 'en'
};

var dealer_DealerStore = (dealer__class = function (_StoreModel) {
    inherits_default()(DealerStore, _StoreModel);

    function DealerStore() {
        classCallCheck_default()(this, DealerStore);

        // const dealer = util.getObject('dealer');
        // this.updateRealdealer(dealer);
        var _this = possibleConstructorReturn_default()(this, _StoreModel.call(this, 'dealer', {
            namePlural: 'dealers',
            sort: 'customerno',
            api: {
                search: {
                    url: '/api/dealers/',
                    params: {}
                },
                load: {
                    url: '/api/dealers/',
                    params: {}
                },
                save: {
                    url: '/api/dealers/',
                    params: {}
                }
            }
        }));

        dealer__initDefineProp(_this, 'languages', dealer__descriptor, _this);

        dealer__initDefineProp(_this, 'dealer', dealer__descriptor2, _this);

        dealer__initDefineProp(_this, 'dealers', dealer__descriptor3, _this);

        dealer__initDefineProp(_this, 'realDealer', dealer__descriptor4, _this);

        dealer__initDefineProp(_this, 'countries', dealer__descriptor5, _this);

        return _this;
    }

    DealerStore.prototype.getElement = function getElement(idx) {
        var index = idx || this.searchSelectIdx;
        return {
            id: this.searchResults[index].id,
            name: this.searchResults[index].name,
            customerno: this.searchResults[index].customerno,
            email: this.searchResults[index].email
        };
    };

    DealerStore.prototype.updateItem = function updateItem(dealer) {
        this.dealer = dealer;
        if (!this.dealer.settings) {
            this.dealer.settings = {};
        }
        if (this.dealer.country) {
            this.dealer.countryCode = this.dealer.settings.language || countryLanguageMap[this.dealer.country];
        }
    };

    DealerStore.prototype.updateRealdealer = function updateRealdealer(dealer) {
        this.realDealer = dealer;
        if (!this.realDealer.settings) {
            this.realDealer.settings = {};
        }
        if (this.realDealer.country) {
            this.realDealer.countryCode = this.realDealer.settings.language || countryLanguageMap[this.realDealer.country];
        }
    };

    DealerStore.prototype.updateCountries = function updateCountries(countries) {
        this.countries = countries;
    };

    DealerStore.prototype.saveField = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(customerno, field, value, updateMemory) {
            var _util$fetchApi,
                _this2 = this;

            var response;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (updateMemory) {
                                this.updateField(customerno, field, value, 'customerno');
                            }
                            this.updateSaved(field + '.' + customerno, true);
                            _context.next = 4;
                            return util.fetchApi('/api/dealers/' + customerno, {
                                publish: true,
                                method: 'PATCH'
                            }, (_util$fetchApi = {}, _util$fetchApi[field] = value, _util$fetchApi));

                        case 4:
                            response = _context.sent;

                            if (response.status < 300) {
                                // Remove saved
                                setTimeout(function () {
                                    _this2.updateSaved(field + '.' + customerno);
                                }, 2000);
                            }

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function saveField(_x, _x2, _x3, _x4) {
            return _ref.apply(this, arguments);
        }

        return saveField;
    }();

    // async load(customerno) {
    //     const response = await util.fetchApi(`/api/dealers/${customerno}`, { publish: true });
    //     if (response.data) {
    //         this.updateItem(response.data);
    //     }
    // }

    DealerStore.prototype.loadRealdealer = function () {
        var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
            var response;
            return regenerator_default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return util.fetchApi('/api/dealers/info', { publish: true });

                        case 2:
                            response = _context2.sent;

                            if (response.data) {
                                this.updateRealdealer(response.data);
                                util.setObject('dealer', response.data);
                            }

                        case 4:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function loadRealdealer() {
            return _ref2.apply(this, arguments);
        }

        return loadRealdealer;
    }();

    // async list(append = false) {
    //     if (!append) {
    //         this.updateOffset(0);
    //     }
    //     const response = await util.fetchApi('/api/dealers/', { publish: true }, {
    //         offset: this.offset,
    //         limit: this.limit,
    //         sort: this.sort,
    //         ...this.queryFilter,
    //     });
    //     if (response.data) {
    //         this.update(response.data, append);
    //         if (append) {
    //             this.updateTotalAppend(response.total);
    //         } else {
    //             this.updateTotal(response.total);
    //             this.updateCountries(response.countries);
    //             window.scrollTo(0, 0);
    //         }
    //     }
    // }

    DealerStore.prototype.sendEmail = function () {
        var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(params) {
            return regenerator_default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return util.fetchApi('/api/email', { publish: true, method: 'POST' }, extends_default()({
                                from: 'web@flyfisheurope.com',
                                to: this.dealer.email
                            }, params));

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function sendEmail(_x5) {
            return _ref3.apply(this, arguments);
        }

        return sendEmail;
    }();

    DealerStore.prototype.save = function () {
        var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4(data) {
            return regenerator_default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return util.fetchApi('/api/dealers/' + this.dealer.customerno, { publish: true, method: 'PATCH' }, extends_default()({}, data));

                        case 2:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function save(_x6) {
            return _ref4.apply(this, arguments);
        }

        return save;
    }();

    return DealerStore;
}(storeModel), (dealer__descriptor = dealer__applyDecoratedDescriptor(dealer__class.prototype, 'languages', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return countryLanguageMap;
    }
}), dealer__descriptor2 = dealer__applyDecoratedDescriptor(dealer__class.prototype, 'dealer', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), dealer__descriptor3 = dealer__applyDecoratedDescriptor(dealer__class.prototype, 'dealers', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), dealer__descriptor4 = dealer__applyDecoratedDescriptor(dealer__class.prototype, 'realDealer', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), dealer__descriptor5 = dealer__applyDecoratedDescriptor(dealer__class.prototype, 'countries', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), dealer__applyDecoratedDescriptor(dealer__class.prototype, 'updateItem', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(dealer__class.prototype, 'updateItem'), dealer__class.prototype), dealer__applyDecoratedDescriptor(dealer__class.prototype, 'updateRealdealer', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(dealer__class.prototype, 'updateRealdealer'), dealer__class.prototype), dealer__applyDecoratedDescriptor(dealer__class.prototype, 'updateCountries', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(dealer__class.prototype, 'updateCountries'), dealer__class.prototype)), dealer__class);


var dealer_store = new dealer_DealerStore();
/* harmony default export */ var stores_dealer = (dealer_store);
// CONCATENATED MODULE: ./stores/brand.js




var brand__desc, brand__value, brand__class, brand__descriptor, brand__descriptor2;

function brand__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function brand__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function brand__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var brand_BrandStore = (brand__class = function (_StoreModel) {
    inherits_default()(BrandStore, _StoreModel);

    function BrandStore() {
        classCallCheck_default()(this, BrandStore);

        var _this = possibleConstructorReturn_default()(this, _StoreModel.call(this, 'brand', {
            namePlural: 'brands',
            sort: 'sort',
            api: {
                search: {
                    url: '/api/brands/',
                    params: {}
                },
                load: {
                    url: '/api/brands/',
                    params: {}
                },
                save: {
                    url: '/api/brands/',
                    params: {}
                }
            },
            extendedView: 1,
            queryFilter: {
                brand: 'simms'
            }
        }));

        brand__initDefineProp(_this, 'brand', brand__descriptor, _this);

        brand__initDefineProp(_this, 'brands', brand__descriptor2, _this);

        return _this;
    }

    BrandStore.prototype.getBrandName = function getBrandName(key) {
        var brand = this.brands.find(function (e) {
            if (e.brandno === key) {
                return true;
            }
            var brandnoEscaped = e.brandno.replace(/[^a-zA-Z]/g, '_');
            if (brandnoEscaped === key) {
                return true;
            }
            return false;
        });
        if (brand) {
            return brand.name;
        }
        return '';
    };

    return BrandStore;
}(storeModel), (brand__descriptor = brand__applyDecoratedDescriptor(brand__class.prototype, 'brand', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), brand__descriptor2 = brand__applyDecoratedDescriptor(brand__class.prototype, 'brands', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), brand__class);


var brand_store = new brand_BrandStore();
/* harmony default export */ var stores_brand = (brand_store);
// CONCATENATED MODULE: ./stores/category.js






var category__desc, category__value, category__class, category__descriptor, category__descriptor2, category__descriptor3, category__descriptor4;

function category__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function category__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function category__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var category_CategoryStore = (category__class = function (_StoreModel) {
    inherits_default()(CategoryStore, _StoreModel);

    function CategoryStore() {
        classCallCheck_default()(this, CategoryStore);

        var _this = possibleConstructorReturn_default()(this, _StoreModel.call(this, 'category', {
            namePlural: 'categories',
            sort: 'sort,groupno',
            api: {
                search: {
                    url: '/api/categories/',
                    params: {
                        extendedView: 1,
                        brand: 'all',
                        level: 'all',
                        limit: 15,
                        sort: 'sort,groupno'
                    }
                },
                load: {
                    url: '/api/categories/',
                    params: {}
                },
                save: {
                    url: '/api/categories/by-id/',
                    params: {}
                }
            },
            extendedView: 1,
            queryFilter: {
                brand: 'simms'
            }
        }));

        category__initDefineProp(_this, 'category', category__descriptor, _this);

        category__initDefineProp(_this, 'categories', category__descriptor2, _this);

        category__initDefineProp(_this, 'categoryTree', category__descriptor3, _this);

        category__initDefineProp(_this, 'categoryView', category__descriptor4, _this);

        return _this;
    }

    CategoryStore.prototype.getElement = function getElement(idx) {
        var index = idx || this.searchSelectIdx;
        return {
            id: this.searchResults[index].id,
            name: this.searchResults[index].name,
            groupno: this.searchResults[index].groupno
        };
    };

    CategoryStore.prototype.updateTree = function updateTree(categories) {
        this.categoryTree = categories;
    };

    CategoryStore.prototype.updateCategoryView = function updateCategoryView(categoryView, value) {
        if (typeof categoryView === 'string' || typeof categoryView === 'number') {
            this.categoryView[categoryView] = typeof value === 'undefined' ? !this.categoryView[categoryView] : value;
            if (!this.categoryView[categoryView]) {
                delete this.categoryView[categoryView];
            }
        } else {
            this.categoryView = categoryView;
        }
        util.setObject('categoryCategoryView', this.categoryView);
    };

    CategoryStore.prototype.tree = function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
            var response;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return util.fetchApi('/api/categories/', { publish: true }, {
                                extendedView: 1,
                                offset: this.offset,
                                limit: this.limit,
                                sort: this.sort,
                                tree: 1,
                                brand: this.queryFilter.brand,
                                status: this.queryFilter.status,
                                showall: this.queryFilter.showall
                            });

                        case 2:
                            response = _context.sent;

                            if (response.status < 300) {
                                this.updateTree(response.data);
                            }

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function tree() {
            return _ref.apply(this, arguments);
        }

        return tree;
    }();

    return CategoryStore;
}(storeModel), (category__descriptor = category__applyDecoratedDescriptor(category__class.prototype, 'category', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), category__descriptor2 = category__applyDecoratedDescriptor(category__class.prototype, 'categories', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), category__descriptor3 = category__applyDecoratedDescriptor(category__class.prototype, 'categoryTree', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), category__descriptor4 = category__applyDecoratedDescriptor(category__class.prototype, 'categoryView', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return util.getObject('categoryCategoryView') || {};
    }
}), category__applyDecoratedDescriptor(category__class.prototype, 'updateTree', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(category__class.prototype, 'updateTree'), category__class.prototype), category__applyDecoratedDescriptor(category__class.prototype, 'updateCategoryView', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(category__class.prototype, 'updateCategoryView'), category__class.prototype)), category__class);


var category_store = new category_CategoryStore();
/* harmony default export */ var stores_category = (category_store);
// CONCATENATED MODULE: ./stores/article.js





var article__desc, article__value, article__class, article__descriptor, article__descriptor2, article__descriptor3, article__descriptor4;

function article__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function article__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function article__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var article_ArticleStore = (article__class = function (_StoreModel) {
    inherits_default()(ArticleStore, _StoreModel);

    function ArticleStore() {
        classCallCheck_default()(this, ArticleStore);

        var _this = possibleConstructorReturn_default()(this, _StoreModel.call(this, 'article', {
            namePlural: 'articles',
            sort: 'sort,-publishDate,-create_date',
            api: {
                search: {
                    url: '/api/articles/',
                    params: {
                        extendedView: 1,
                        showall: 1,
                        limit: 15,
                        sort: 'id'
                    }
                },
                load: {
                    url: '/api/articles/',
                    params: {
                        showall: 1
                    }
                },
                save: {
                    url: '/api/articles/',
                    params: {}
                }
            }
        }));

        article__initDefineProp(_this, 'article', article__descriptor, _this);

        article__initDefineProp(_this, 'articles', article__descriptor2, _this);

        article__initDefineProp(_this, 'tagList', article__descriptor3, _this);

        article__initDefineProp(_this, 'tagIdRef', article__descriptor4, _this);

        return _this;
    }

    ArticleStore.prototype.makeQuery = function makeQuery() {
        var query = Object(mobx_module["i" /* toJS */])(this.queryFilter);
        if (query.search) {
            delete query.tag;
        }
        return query;
    };

    ArticleStore.prototype.addImage = function addImage(id, imageObject) {
        var article = this.article.id ? this.article : this.article.find(function (e) {
            return e.id === id;
        });
        if (typeof article === 'object') {
            var maxNum = 0;
            if (typeof article.imgs === 'object') {
                var imgKeys = Object.keys(article.imgs);
                for (var i = 0, l = imgKeys.length; i < l; i += 1) {
                    var key = parseInt(imgKeys[i], 10);
                    if (key > maxNum) {
                        maxNum = key;
                    }
                }
            } else {
                article.imgs = {};
            }
            var nextNum = maxNum + 1;
            var newImage = extends_default()({}, imageObject, {
                sort: nextNum
            });
            article.imgs[nextNum] = newImage;
            this.saveField(id, 'imgs', article.imgs, true);
        }
    };

    ArticleStore.prototype.delImage = function delImage(id, imageId) {
        var article = this.article.id ? this.article : this.article.find(function (e) {
            return e.id === id;
        });
        if (typeof article === 'object' && typeof article.imgs === 'object') {
            delete article.imgs[imageId];
            var imageArray = util.makeArrayOfObject(article.imgs);
            article.imgs = util.makeObjectOfArray(imageArray);
            this.saveField(id, 'imgs', article.imgs, true);
        }
    };

    return ArticleStore;
}(storeModel), (article__descriptor = article__applyDecoratedDescriptor(article__class.prototype, 'article', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), article__descriptor2 = article__applyDecoratedDescriptor(article__class.prototype, 'articles', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), article__descriptor3 = article__applyDecoratedDescriptor(article__class.prototype, 'tagList', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), article__descriptor4 = article__applyDecoratedDescriptor(article__class.prototype, 'tagIdRef', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), article__applyDecoratedDescriptor(article__class.prototype, 'addImage', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(article__class.prototype, 'addImage'), article__class.prototype), article__applyDecoratedDescriptor(article__class.prototype, 'delImage', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(article__class.prototype, 'delImage'), article__class.prototype)), article__class);


var article_store = new article_ArticleStore();
/* harmony default export */ var stores_article = (article_store);
// CONCATENATED MODULE: ./stores/product.js





var product__desc, product__value, product__class, product__descriptor, product__descriptor2, product__descriptor3;

function product__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function product__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function product__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var product_ProductStore = (product__class = function (_StoreModel) {
    inherits_default()(ProductStore, _StoreModel);

    function ProductStore() {
        classCallCheck_default()(this, ProductStore);

        var _this = possibleConstructorReturn_default()(this, _StoreModel.call(this, 'product', {
            namePlural: 'products',
            sort: 'maingroupsort,intermediategroupsort,subgroupsort,sort,articleno',
            api: {
                search: {
                    url: '/api/products/',
                    params: {
                        extendedView: 1,
                        limit: 15,
                        sort: 'id'
                    }
                },
                load: {
                    url: '/api/products/',
                    params: {}
                },
                save: {
                    url: '/api/products/',
                    params: {}
                }
            },
            extendedView: 1,
            queryFilter: {
                brand: 'simms'
            }
        }));

        product__initDefineProp(_this, 'product', product__descriptor, _this);

        product__initDefineProp(_this, 'products', product__descriptor2, _this);

        product__initDefineProp(_this, 'updateAll', product__descriptor3, _this);

        return _this;
    }

    ProductStore.prototype.toggleUpdateAll = function toggleUpdateAll() {
        this.updateAll = !this.updateAll;
    };

    ProductStore.prototype.makeQuery = function makeQuery() {
        var query = Object(mobx_module["i" /* toJS */])(this.queryFilter);
        if (query.search) {
            delete query.brand;
            delete query.mainCat;
            delete query.intCat;
            delete query.subCat;
        }
        return query;
    };

    ProductStore.prototype.parseElements = function parseElements() {
        var _this2 = this;

        this.products.forEach(function (product, idx) {
            var ratingKeys = Object.keys(product.ratings || {});
            var sum = ratingKeys.map(function (dealerNum) {
                return product.ratings[dealerNum].rating;
            }).reduce(function (a, b) {
                return a + b;
            }, 0);
            var avg = sum / ratingKeys.length || 0;
            _this2.products[idx].avg = avg;
            _this2.products[idx].avgTot = ratingKeys.length;
        });
    };

    ProductStore.prototype.getElement = function getElement(idx) {
        var index = idx || this.searchSelectIdx;
        return {
            id: this.searchResults[index].id,
            name: this.searchResults[index].name,
            articleno: this.searchResults[index].articleno
        };
    };

    ProductStore.prototype.addImage = function addImage(id, imageObject, object) {
        var keyName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'imgs';

        var prod = this.product.id ? this.product : this.products.find(function (e) {
            return e.id === id;
        });
        if (typeof prod === 'object') {
            var maxNum = 0;
            if (typeof prod[keyName] === 'object') {
                var imgKeys = Object.keys(prod[keyName]);
                for (var i = 0, l = imgKeys.length; i < l; i += 1) {
                    var key = parseInt(imgKeys[i], 10);
                    if (key > maxNum) {
                        maxNum = key;
                    }
                }
            } else {
                prod[keyName] = {};
            }
            var nextNum = maxNum + 1;
            var newImage = extends_default()({}, imageObject, {
                sort: nextNum
            });
            prod[keyName][nextNum] = newImage;
            var filter = {
                id: id,
                maingroupid: object.maingroupid,
                intermediategroupid: object.intermediategroupid,
                nameDisplay: object.nameDisplay,
                colorId: object.colorId
            };
            if (this.updateAll && filter.maingroupid && filter.intermediategroupid && filter.nameDisplay) {
                this.updateMany(filter, keyName, prod[keyName], true);
            } else {
                this.saveField(id, keyName, prod[keyName], true);
            }
        }
    };

    ProductStore.prototype.delImage = function delImage(id, imageId, object) {
        var keyName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'imgs';

        var prod = this.product.id ? this.product : this.product.find(function (e) {
            return e.id === id;
        });
        if (typeof prod === 'object' && typeof prod[keyName] === 'object') {
            delete prod[keyName][imageId];
            var imageArray = util.makeArrayOfObject(prod[keyName]);
            prod[keyName] = util.makeObjectOfArray(imageArray);
            var filter = {
                id: id,
                maingroupid: object.maingroupid,
                intermediategroupid: object.intermediategroupid,
                nameDisplay: object.nameDisplay,
                colorId: object.colorId
            };
            if (this.updateAll && filter.maingroupid && filter.intermediategroupid && filter.nameDisplay) {
                this.updateMany(filter, keyName, prod[keyName], true);
            } else {
                this.saveField(id, keyName, prod[keyName], true);
            }
        }
    };

    return ProductStore;
}(storeModel), (product__descriptor = product__applyDecoratedDescriptor(product__class.prototype, 'product', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), product__descriptor2 = product__applyDecoratedDescriptor(product__class.prototype, 'products', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), product__descriptor3 = product__applyDecoratedDescriptor(product__class.prototype, 'updateAll', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return true;
    }
}), product__applyDecoratedDescriptor(product__class.prototype, 'toggleUpdateAll', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(product__class.prototype, 'toggleUpdateAll'), product__class.prototype), product__applyDecoratedDescriptor(product__class.prototype, 'parseElements', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(product__class.prototype, 'parseElements'), product__class.prototype), product__applyDecoratedDescriptor(product__class.prototype, 'addImage', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(product__class.prototype, 'addImage'), product__class.prototype), product__applyDecoratedDescriptor(product__class.prototype, 'delImage', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(product__class.prototype, 'delImage'), product__class.prototype)), product__class);


var product_store = new product_ProductStore();
/* harmony default export */ var stores_product = (product_store);
// CONCATENATED MODULE: ./stores/productcombo.js




var productcombo__desc, productcombo__value, productcombo__class, productcombo__descriptor, productcombo__descriptor2;

function productcombo__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function productcombo__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function productcombo__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var productcombo_ProductComboStore = (productcombo__class = function (_StoreModel) {
    inherits_default()(ProductComboStore, _StoreModel);

    function ProductComboStore() {
        classCallCheck_default()(this, ProductComboStore);

        var _this = possibleConstructorReturn_default()(this, _StoreModel.call(this, 'productCombo', {
            namePlural: 'productCombos',
            sort: 'sort',
            api: {
                search: {
                    url: '/api/productcombo/',
                    params: {}
                },
                load: {
                    url: '/api/productcombo/',
                    params: {}
                },
                save: {
                    url: '/api/productcombo/',
                    params: {}
                }
            },
            queryFilter: {}
        }));

        productcombo__initDefineProp(_this, 'productCombo', productcombo__descriptor, _this);

        productcombo__initDefineProp(_this, 'productCombos', productcombo__descriptor2, _this);

        return _this;
    }

    return ProductComboStore;
}(storeModel), (productcombo__descriptor = productcombo__applyDecoratedDescriptor(productcombo__class.prototype, 'productCombo', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), productcombo__descriptor2 = productcombo__applyDecoratedDescriptor(productcombo__class.prototype, 'productCombos', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), productcombo__class);


var productcombo_store = new productcombo_ProductComboStore();
/* harmony default export */ var stores_productcombo = (productcombo_store);
// CONCATENATED MODULE: ./stores/tag.js




var tag__desc, tag__value, tag__class, tag__descriptor, tag__descriptor2, tag__descriptor3, tag__descriptor4, tag__descriptor5, tag__descriptor6, tag__descriptor7;

function tag__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function tag__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function tag__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var tag_TagStore = (tag__class = function (_StoreModel) {
    inherits_default()(TagStore, _StoreModel);

    function TagStore() {
        classCallCheck_default()(this, TagStore);

        var _this = possibleConstructorReturn_default()(this, _StoreModel.call(this, 'tag', {
            namePlural: 'tags',
            sort: '-pinned,name',
            api: {
                search: {
                    url: '/api/tags/',
                    params: {}
                },
                load: {
                    url: '/api/tags/',
                    params: {}
                },
                save: {
                    url: '/api/tags/',
                    params: {}
                }
            },
            extendedView: 1,
            queryFilter: {}
        }));

        tag__initDefineProp(_this, 'tag', tag__descriptor, _this);

        tag__initDefineProp(_this, 'tags', tag__descriptor2, _this);

        tag__initDefineProp(_this, 'tagTree', tag__descriptor3, _this);

        tag__initDefineProp(_this, 'tagTreeBranch', tag__descriptor4, _this);

        tag__initDefineProp(_this, 'tagTreeBranchPinned', tag__descriptor5, _this);

        tag__initDefineProp(_this, 'tagTreeParent', tag__descriptor6, _this);

        tag__initDefineProp(_this, 'tagListTree', tag__descriptor7, _this);

        return _this;
    }

    return TagStore;
}(storeModel), (tag__descriptor = tag__applyDecoratedDescriptor(tag__class.prototype, 'tag', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), tag__descriptor2 = tag__applyDecoratedDescriptor(tag__class.prototype, 'tags', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), tag__descriptor3 = tag__applyDecoratedDescriptor(tag__class.prototype, 'tagTree', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), tag__descriptor4 = tag__applyDecoratedDescriptor(tag__class.prototype, 'tagTreeBranch', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), tag__descriptor5 = tag__applyDecoratedDescriptor(tag__class.prototype, 'tagTreeBranchPinned', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), tag__descriptor6 = tag__applyDecoratedDescriptor(tag__class.prototype, 'tagTreeParent', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return util.get(this.name + 'tagTreeParent');
    }
}), tag__descriptor7 = tag__applyDecoratedDescriptor(tag__class.prototype, 'tagListTree', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), tag__class);


var tag_store = new tag_TagStore();
/* harmony default export */ var stores_tag = (tag_store);
// CONCATENATED MODULE: ./stores/maillog.js




var maillog__desc, maillog__value, maillog__class, maillog__descriptor, maillog__descriptor2;

function maillog__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function maillog__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function maillog__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var maillog_MaillogStore = (maillog__class = function (_StoreModel) {
    inherits_default()(MaillogStore, _StoreModel);

    function MaillogStore() {
        classCallCheck_default()(this, MaillogStore);

        var _this = possibleConstructorReturn_default()(this, _StoreModel.call(this, 'maillog', {
            namePlural: 'maillogs',
            sort: '-createdDate',
            api: {
                search: {
                    url: '/api/maillog/',
                    params: {}
                },
                load: {
                    url: '/api/maillog/',
                    params: {}
                },
                save: {
                    url: '/api/maillog/',
                    params: {}
                }
            },
            queryFilter: {}
        }));

        maillog__initDefineProp(_this, 'maillog', maillog__descriptor, _this);

        maillog__initDefineProp(_this, 'maillogs', maillog__descriptor2, _this);

        return _this;
    }

    return MaillogStore;
}(storeModel), (maillog__descriptor = maillog__applyDecoratedDescriptor(maillog__class.prototype, 'maillog', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), maillog__descriptor2 = maillog__applyDecoratedDescriptor(maillog__class.prototype, 'maillogs', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), maillog__class);


var maillog_store = new maillog_MaillogStore();
/* harmony default export */ var stores_maillog = (maillog_store);
// CONCATENATED MODULE: ./stores/mailaddress.js




var mailaddress__desc, mailaddress__value, mailaddress__class, mailaddress__descriptor, mailaddress__descriptor2;

function mailaddress__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function mailaddress__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function mailaddress__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var mailaddress_MailaddressStore = (mailaddress__class = function (_StoreModel) {
    inherits_default()(MailaddressStore, _StoreModel);

    function MailaddressStore() {
        classCallCheck_default()(this, MailaddressStore);

        var _this = possibleConstructorReturn_default()(this, _StoreModel.call(this, 'mailaddress', {
            namePlural: 'mailaddresses',
            sort: '-updatedDate',
            api: {
                search: {
                    url: '/api/mailaddress/',
                    params: {}
                },
                load: {
                    url: '/api/mailaddress/',
                    params: {}
                },
                save: {
                    url: '/api/mailaddress/',
                    params: {}
                },
                delete: {
                    url: '/api/mailaddress/',
                    params: {}
                }
            },
            queryFilter: {}
        }));

        mailaddress__initDefineProp(_this, 'mailaddress', mailaddress__descriptor, _this);

        mailaddress__initDefineProp(_this, 'mailaddresses', mailaddress__descriptor2, _this);

        return _this;
    }

    return MailaddressStore;
}(storeModel), (mailaddress__descriptor = mailaddress__applyDecoratedDescriptor(mailaddress__class.prototype, 'mailaddress', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), mailaddress__descriptor2 = mailaddress__applyDecoratedDescriptor(mailaddress__class.prototype, 'mailaddresses', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), mailaddress__class);


var mailaddress_store = new mailaddress_MailaddressStore();
/* harmony default export */ var stores_mailaddress = (mailaddress_store);
// CONCATENATED MODULE: ./stores/url.js




var url__desc, url__value, url__class, url__descriptor, url__descriptor2;

function url__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function url__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function url__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var url_UrlStore = (url__class = function (_StoreModel) {
    inherits_default()(UrlStore, _StoreModel);

    function UrlStore() {
        classCallCheck_default()(this, UrlStore);

        var _this = possibleConstructorReturn_default()(this, _StoreModel.call(this, 'url', {
            namePlural: 'urls',
            sort: 'clicks',
            api: {
                search: {
                    url: '/api/shorturls/',
                    params: {}
                },
                load: {
                    url: '/api/shorturls/',
                    params: {}
                },
                save: {
                    url: '/api/shorturls/',
                    params: {}
                }
            },
            queryFilter: {}
        }));

        url__initDefineProp(_this, 'url', url__descriptor, _this);

        url__initDefineProp(_this, 'urls', url__descriptor2, _this);

        return _this;
    }

    return UrlStore;
}(storeModel), (url__descriptor = url__applyDecoratedDescriptor(url__class.prototype, 'url', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), url__descriptor2 = url__applyDecoratedDescriptor(url__class.prototype, 'urls', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), url__class);


var url_store = new url_UrlStore();
/* harmony default export */ var stores_url = (url_store);
// CONCATENATED MODULE: ./stores/consumer.js




var consumer__desc, consumer__value, consumer__class, consumer__descriptor, consumer__descriptor2, consumer__descriptor3;

function consumer__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function consumer__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function consumer__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var consumer_ConsumerStore = (consumer__class = function (_StoreModel) {
    inherits_default()(ConsumerStore, _StoreModel);

    function ConsumerStore() {
        classCallCheck_default()(this, ConsumerStore);

        var _this = possibleConstructorReturn_default()(this, _StoreModel.call(this, 'consumer', {
            namePlural: 'consumers',
            sort: '-updatedDate',
            api: {
                search: {
                    url: '/api/consumers/',
                    params: {}
                },
                load: {
                    url: '/api/consumers/admin/',
                    params: {}
                },
                save: {
                    url: '/api/consumers/',
                    params: {}
                },
                delete: {
                    url: '/api/consumers/admin/',
                    params: {}
                }
            },
            queryFilter: {}
        }));

        consumer__initDefineProp(_this, 'consumer', consumer__descriptor, _this);

        consumer__initDefineProp(_this, 'consumeres', consumer__descriptor2, _this);

        consumer__initDefineProp(_this, 'deleted', consumer__descriptor3, _this);

        return _this;
    }

    ConsumerStore.prototype.markDeleted = function markDeleted(id) {
        this.deleted[id] = true;
    };

    return ConsumerStore;
}(storeModel), (consumer__descriptor = consumer__applyDecoratedDescriptor(consumer__class.prototype, 'consumer', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), consumer__descriptor2 = consumer__applyDecoratedDescriptor(consumer__class.prototype, 'consumeres', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), consumer__descriptor3 = consumer__applyDecoratedDescriptor(consumer__class.prototype, 'deleted', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), consumer__applyDecoratedDescriptor(consumer__class.prototype, 'markDeleted', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(consumer__class.prototype, 'markDeleted'), consumer__class.prototype)), consumer__class);


var consumer_store = new consumer_ConsumerStore();
/* harmony default export */ var stores_consumer = (consumer_store);
// CONCATENATED MODULE: ./stores/rodreg.js




var rodreg__desc, rodreg__value, rodreg__class, rodreg__descriptor, rodreg__descriptor2, rodreg__descriptor3;

function rodreg__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function rodreg__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function rodreg__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var rodreg_RodregStore = (rodreg__class = function (_StoreModel) {
    inherits_default()(RodregStore, _StoreModel);

    function RodregStore() {
        classCallCheck_default()(this, RodregStore);

        var _this = possibleConstructorReturn_default()(this, _StoreModel.call(this, 'rodreg', {
            namePlural: 'rodregs',
            sort: '-purchase_date',
            api: {
                search: {
                    url: '/api/rodregs/',
                    params: {}
                },
                load: {
                    url: '/api/rodregs/',
                    params: {}
                },
                save: {
                    url: '/api/rodregs/',
                    params: {}
                },
                delete: {
                    url: '/api/rodregs/',
                    params: {}
                }
            },
            queryFilter: {}
        }));

        rodreg__initDefineProp(_this, 'rodreg', rodreg__descriptor, _this);

        rodreg__initDefineProp(_this, 'rodregs', rodreg__descriptor2, _this);

        rodreg__initDefineProp(_this, 'deleted', rodreg__descriptor3, _this);

        return _this;
    }

    RodregStore.prototype.markDeleted = function markDeleted(id) {
        this.deleted[id] = true;
    };

    return RodregStore;
}(storeModel), (rodreg__descriptor = rodreg__applyDecoratedDescriptor(rodreg__class.prototype, 'rodreg', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), rodreg__descriptor2 = rodreg__applyDecoratedDescriptor(rodreg__class.prototype, 'rodregs', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
}), rodreg__descriptor3 = rodreg__applyDecoratedDescriptor(rodreg__class.prototype, 'deleted', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), rodreg__applyDecoratedDescriptor(rodreg__class.prototype, 'markDeleted', [mobx_module["c" /* action */]], Object.getOwnPropertyDescriptor(rodreg__class.prototype, 'markDeleted'), rodreg__class.prototype)), rodreg__class);


var rodreg_store = new rodreg_RodregStore();
/* harmony default export */ var stores_rodreg = (rodreg_store);
// CONCATENATED MODULE: ./stores/shipment.js




var shipment__desc, shipment__value, shipment__class, shipment__descriptor, shipment__descriptor2;

function shipment__initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;
    Object.defineProperty(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function shipment__applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function shipment__initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




Object(mobx_module["f" /* configure */])({ enforceActions: 'always' });

var shipment_ShipmentStore = (shipment__class = function (_StoreModel) {
    inherits_default()(ShipmentStore, _StoreModel);

    function ShipmentStore() {
        classCallCheck_default()(this, ShipmentStore);

        var _this = possibleConstructorReturn_default()(this, _StoreModel.call(this, 'shipment', {
            namePlural: 'shipments',
            sort: '-shipDate',
            api: {
                search: {
                    url: '/api/shipments/admin/',
                    params: {}
                },
                load: {
                    url: '/api/shipments/admin/',
                    params: {}
                },
                save: {
                    url: '/api/shipments/',
                    params: {}
                },
                delete: {
                    url: '/api/shipments/',
                    params: {}
                }
            },
            queryFilter: {}
        }));

        shipment__initDefineProp(_this, 'shipment', shipment__descriptor, _this);

        shipment__initDefineProp(_this, 'shipments', shipment__descriptor2, _this);

        return _this;
    }

    return ShipmentStore;
}(storeModel), (shipment__descriptor = shipment__applyDecoratedDescriptor(shipment__class.prototype, 'shipment', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return {};
    }
}), shipment__descriptor2 = shipment__applyDecoratedDescriptor(shipment__class.prototype, 'shipments', [mobx_module["h" /* observable */]], {
    enumerable: true,
    initializer: function initializer() {
        return [];
    }
})), shipment__class);


var shipment_store = new shipment_ShipmentStore();
/* harmony default export */ var stores_shipment = (shipment_store);
// CONCATENATED MODULE: ./components/main/index.js





var main__class;


















































// Content stores with observable values and attributes.















/*
    If this is a widget on a page with more widgets you should probably set this
    to false to prevent confusion.
*/
var USE_ROUTER = true;

var main_STATE = {
    CURRENT_NAV: 'currentNav'
};

var main_Main = Object(index_module["a" /* observer */])(main__class = function (_Component) {
    inherits_default()(Main, _Component);

    function Main(props) {
        classCallCheck_default()(this, Main);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.handleRoute = function (event) {
            var _this$setState;

            var currentNav = event.url.replace(/^\/([^/?]+).*/g, '$1');
            _this.setState((_this$setState = {}, _this$setState[main_STATE.CURRENT_NAV] = currentNav, _this$setState));
            if (decodeURIComponent(event.url) !== decodeURIComponent(event.previous)) {
                // console.log(`${decodeURIComponent(event.url)} !== ${decodeURIComponent(event.previous)}`);
                if (event.current.attributes.categoryid) {
                    stores_category.load(event.current.attributes.categoryid);
                }
                if (event.current.attributes.customerno) {
                    stores_dealer.load(event.current.attributes.customerno);
                }
            }
        };

        _this.stores = {
            appState: appstate,
            dealerStore: stores_dealer,
            brandStore: stores_brand,
            categoryStore: stores_category,
            articleStore: stores_article,
            productStore: stores_product,
            productComboStore: stores_productcombo,
            tagStore: stores_tag,
            maillogStore: stores_maillog,
            mailaddressStore: stores_mailaddress,
            urlStore: stores_url,
            consumerStore: stores_consumer,
            rodregStore: stores_rodreg,
            shipmentStore: stores_shipment
        };

        stores_dealer.loadRealdealer();

        var darkmode = appstate.darkmode;

        util.toggleDarkModeClasses(darkmode);
        return _this;
    }

    Main.prototype.getMainContent = function getMainContent() {
        if (USE_ROUTER) {
            return Object(preact_min["h"])(
                preact_router_es,
                { onChange: this.handleRoute, history: createHashHistory() },
                Object(preact_min["h"])(components_dealers, extends_default()({ stores: this.stores, path: '/dealers' }, this.props)),
                Object(preact_min["h"])(edit, extends_default()({ stores: this.stores, path: '/dealers/:customerno' }, this.props)),
                Object(preact_min["h"])(edit, extends_default()({ stores: this.stores, path: '/dealers/:customerno/:tabname' }, this.props)),
                Object(preact_min["h"])(components_brands, extends_default()({ stores: this.stores, path: '/brands' }, this.props)),
                Object(preact_min["h"])(brands_edit, extends_default()({ stores: this.stores, path: '/brands/:brandid' }, this.props)),
                Object(preact_min["h"])(brands_edit, extends_default()({ stores: this.stores, path: '/brands/:brandid/:tabname' }, this.props)),
                Object(preact_min["h"])(components_categories, extends_default()({ stores: this.stores, path: '/categories' }, this.props)),
                Object(preact_min["h"])(categories_edit, extends_default()({ stores: this.stores, path: '/categories/:categoryid' }, this.props)),
                Object(preact_min["h"])(categories_edit, extends_default()({ stores: this.stores, path: '/categories/:categoryid/:tabname' }, this.props)),
                Object(preact_min["h"])(components_products, extends_default()({ stores: this.stores, path: '/products' }, this.props)),
                Object(preact_min["h"])(products_edit, extends_default()({ stores: this.stores, path: '/products/:productid' }, this.props)),
                Object(preact_min["h"])(products_edit, extends_default()({ stores: this.stores, path: '/products/:productid/:tabname' }, this.props)),
                Object(preact_min["h"])(productcombos, extends_default()({ stores: this.stores, path: '/productcombos' }, this.props)),
                Object(preact_min["h"])(productcombos_edit, extends_default()({ stores: this.stores, path: '/productcombos/:id' }, this.props)),
                Object(preact_min["h"])(productcombos_edit, extends_default()({ stores: this.stores, path: '/productcombos/:id/:tabname' }, this.props)),
                Object(preact_min["h"])(components_tags, extends_default()({ stores: this.stores, path: '/tags' }, this.props)),
                Object(preact_min["h"])(tags_edit, extends_default()({ stores: this.stores, path: '/tags/:id' }, this.props)),
                Object(preact_min["h"])(tags_edit, extends_default()({ stores: this.stores, path: '/tags/:id/:tabname' }, this.props)),
                Object(preact_min["h"])(components_articles, extends_default()({ stores: this.stores, path: '/articles' }, this.props)),
                Object(preact_min["h"])(articles_edit, extends_default()({ stores: this.stores, path: '/articles/:id' }, this.props)),
                Object(preact_min["h"])(articles_edit, extends_default()({ stores: this.stores, path: '/articles/:id/:tabname' }, this.props)),
                Object(preact_min["h"])(components_consumers, extends_default()({ stores: this.stores, path: '/consumers' }, this.props)),
                Object(preact_min["h"])(consumers_edit, extends_default()({ stores: this.stores, path: '/consumers/:id' }, this.props)),
                Object(preact_min["h"])(consumers_edit, extends_default()({ stores: this.stores, path: '/consumers/:id/:tabname' }, this.props)),
                Object(preact_min["h"])(components_rodregs, extends_default()({ stores: this.stores, path: '/rodregs' }, this.props)),
                Object(preact_min["h"])(rodregs_edit, extends_default()({ stores: this.stores, path: '/rodregs/:serial' }, this.props)),
                Object(preact_min["h"])(rodregs_edit, extends_default()({ stores: this.stores, path: '/rodregs/:serial/:tabname' }, this.props)),
                Object(preact_min["h"])(components_shipments, extends_default()({ stores: this.stores, path: '/shipments' }, this.props)),
                Object(preact_min["h"])(shipments_edit, extends_default()({ stores: this.stores, path: '/shipments/:uniqueid' }, this.props)),
                Object(preact_min["h"])(shipments_edit, extends_default()({ stores: this.stores, path: '/shipments/:uniqueid/:tabname' }, this.props)),
                Object(preact_min["h"])(components_maillogs, extends_default()({ stores: this.stores, path: '/maillogs' }, this.props)),
                Object(preact_min["h"])(maillogs_edit, extends_default()({ stores: this.stores, path: '/maillogs/:id' }, this.props)),
                Object(preact_min["h"])(maillogs_edit, extends_default()({ stores: this.stores, path: '/maillogs/:id/:tabname' }, this.props)),
                Object(preact_min["h"])(components_mailaddresses, extends_default()({ stores: this.stores, path: '/mailaddresses' }, this.props)),
                Object(preact_min["h"])(mailaddresses_edit, extends_default()({ stores: this.stores, path: '/mailaddresses/:id' }, this.props)),
                Object(preact_min["h"])(mailaddresses_edit, extends_default()({ stores: this.stores, path: '/mailaddresses/:id/:tabname' }, this.props)),
                Object(preact_min["h"])(components_urls, extends_default()({ stores: this.stores, path: '/urls' }, this.props)),
                Object(preact_min["h"])(urls_edit, extends_default()({ stores: this.stores, path: '/urls/:id' }, this.props)),
                Object(preact_min["h"])(urls_edit, extends_default()({ stores: this.stores, path: '/urls/:id/:tabname' }, this.props)),
                Object(preact_min["h"])(frontpage, extends_default()({ stores: this.stores, 'default': true }, this.props))
            );
        }
        return Object(preact_min["h"])(frontpage, extends_default()({ stores: this.stores, 'default': true }, this.props));
    };

    Main.prototype.render = function render() {
        return Object(preact_min["h"])(
            'div',
            { 'class': 'container-fluid' },
            this.getMainContent()
        );
    };

    return Main;
}(preact_min["Component"])) || main__class;

/* harmony default export */ var main = (main_Main);
// CONCATENATED MODULE: ./components/start/index.js













var REQUIRE_LOGIN = true;

var start_STATE = {
    JWT_TOKEN: 'jwtToken'
};

var start_Start = function (_Component) {
    inherits_default()(Start, _Component);

    function Start(props) {
        var _this$setState;

        classCallCheck_default()(this, Start);

        var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

        _this.getContent = function () {
            if (REQUIRE_LOGIN && !_this.state[start_STATE.JWT_TOKEN]) {
                return Object(preact_min["h"])(login, _this.props);
            }
            return Object(preact_min["h"])(main, _this.props);
        };

        var apiServer = props.apiServer || window.location.protocol + '//' + window.location.host;
        var previewServer = props.previewServer || window.location.protocol + '//' + window.location.host;
        var imageServer = props.imageServer || window.location.protocol + '//' + window.location.host;
        util.setApiServer(apiServer);
        util.setPreviewServer(previewServer);
        util.setImageServer(imageServer);

        _this.setState((_this$setState = {}, _this$setState[start_STATE.JWT_TOKEN] = util.getJwtToken(), _this$setState));

        _this.subscriptions();
        return _this;
    }

    Start.prototype.subscriptions = function subscriptions() {
        var _this2 = this;

        lib_pubsub.subscribe(topics.LOG_OUT, function () {
            var _this2$setState;

            _this2.setState((_this2$setState = {}, _this2$setState[start_STATE.JWT_TOKEN] = undefined, _this2$setState));
            util.removeUserEmail();
            util.removeJwtToken();
        });

        lib_pubsub.subscribe(topics.JWT_TOKEN_CHANGED, function () {
            var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(token) {
                var _this2$setState2;

                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                util.setJwtToken(token);
                                _this2.setState((_this2$setState2 = {}, _this2$setState2[start_STATE.JWT_TOKEN] = token, _this2$setState2));

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }());
    };

    Start.prototype.render = function render() {
        return this.getContent();
    };

    return Start;
}(preact_min["Component"]);

/* harmony default export */ var start = (start_Start);
// CONCATENATED MODULE: ./index.js
// eslint-disable-next-line




__webpack_require__("m+Gh");

var hab = preact_habitat_es(start);

hab.render({
    selector: '[data-widget-host="ffe-cms-retake-habitat"]',
    clean: true
});

/***/ }),

/***/ "Jyrs":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".table-fixed__2E2BV tbody{height:calc(100vh - 200px);overflow-y:auto;width:100%}.table-fixed__2E2BV tbody,.table-fixed__2E2BV td,.table-fixed__2E2BV th,.table-fixed__2E2BV thead,.table-fixed__2E2BV tr{display:block}.table-fixed__2E2BV tr:after{content:\"\";display:block;visibility:hidden;clear:both}.table-fixed__2E2BV tbody td,.table-fixed__2E2BV thead>tr>th{float:left}.hoveronly__ufZev{display:none}.tableline__3SvOF:hover .hoveronly__ufZev{display:inline}.hoverelementonly__3sy7C,.tableline__3SvOF:hover .hoverhide__37mH2{display:none}.element__341gI:hover .hoverelementonly__3sy7C{display:inline}.element__341gI:hover .hoverelementhide__3hC0K{display:none}.badge-outline__1zhYT{font-weight:400;color:gray;border:1px solid gray;background-color:transparent}.pointerCursor__2u-y3{cursor:pointer;pointer-events:inherit}.code__3Wz5h{display:block;white-space:pre-wrap}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/tags/style.css"],"names":[],"mappings":"AAAA,0BACI,2BAA4B,AAC5B,gBAAiB,AACjB,UAAY,CACf,AACD,yHAKI,aAAe,CAClB,AACD,6BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,6DAEI,UAAY,CACf,AAED,kBACI,YAAc,CACjB,AACD,0CACI,cAAiB,CACpB,AAKD,mEACI,YAAc,CACjB,AACD,+CACI,cAAiB,CACpB,AACD,+CACI,YAAe,CAClB,AAED,sBACI,gBAAiB,AACjB,WAAe,AACf,sBAA0B,AAC1B,4BAA8B,CACjC,AAED,sBACI,eAAgB,AAChB,sBAAwB,CAC3B,AAED,aACI,cAAe,AACf,oBAAqB,CACtB","file":"style.css","sourcesContent":[".table-fixed tbody {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    width: 100%;\n}\n.table-fixed thead,\n.table-fixed tbody,\n.table-fixed tr,\n.table-fixed td,\n.table-fixed th {\n    display: block;\n}\n.table-fixed tr:after {\n    content: \"\";\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n.table-fixed tbody td,\n.table-fixed thead > tr > th {\n    float: left;\n}\n\n.hoveronly { \n    display: none;\n}\n.tableline:hover .hoveronly {\n    display : inline;\n}\n.tableline:hover .hoverhide {\n    display : none;\n}\n\n.hoverelementonly {\n    display: none;\n}\n.element:hover .hoverelementonly {\n    display : inline;\n}\n.element:hover .hoverelementhide {\n    display : none;\n}\n\n.badge-outline {\n    font-weight: 400;\n    color: #808080;\n    border: 1px solid #808080;\n    background-color: transparent;\n}\n\n.pointerCursor {\n    cursor: pointer;\n    pointer-events: inherit;\n}\n\n.code {\n    display: block;\n    white-space: pre-wrap   \n  }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table-fixed": "table-fixed__2E2BV",
	"hoveronly": "hoveronly__ufZev",
	"tableline": "tableline__3SvOF",
	"hoverhide": "hoverhide__37mH2",
	"hoverelementonly": "hoverelementonly__3sy7C",
	"element": "element__341gI",
	"hoverelementhide": "hoverelementhide__3hC0K",
	"badge-outline": "badge-outline__1zhYT",
	"pointerCursor": "pointerCursor__2u-y3",
	"code": "code__3Wz5h"
};

/***/ }),

/***/ "KD0L":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".table-fixed__29urN tbody{height:calc(100vh - 200px);overflow-y:auto;width:100%}.table-fixed__29urN tbody,.table-fixed__29urN td,.table-fixed__29urN th,.table-fixed__29urN thead,.table-fixed__29urN tr{display:block}.table-fixed__29urN tr:after{content:\"\";display:block;visibility:hidden;clear:both}.table-fixed__29urN tbody td,.table-fixed__29urN thead>tr>th{float:left}.hoveronly___Hjg7{display:none}.tableline__3ZIwZ:hover .hoveronly___Hjg7{display:inline}.hoverelementonly__3ydu9,.tableline__3ZIwZ:hover .hoverhide__1sFEU{display:none}.element__1Dao-:hover .hoverelementonly__3ydu9{display:inline}.element__1Dao-:hover .hoverelementhide__2kuEA{display:none}.badge-outline__3soR6{font-weight:400;color:gray;border:1px solid gray;background-color:transparent}.pointerCursor__3J64B{cursor:pointer;pointer-events:inherit}.code__2j8H9{display:block;white-space:pre-wrap}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/products/style.css"],"names":[],"mappings":"AAAA,0BACI,2BAA4B,AAC5B,gBAAiB,AACjB,UAAY,CACf,AACD,yHAKI,aAAe,CAClB,AACD,6BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,6DAEI,UAAY,CACf,AAED,kBACI,YAAc,CACjB,AACD,0CACI,cAAiB,CACpB,AAKD,mEACI,YAAc,CACjB,AACD,+CACI,cAAiB,CACpB,AACD,+CACI,YAAe,CAClB,AAED,sBACI,gBAAiB,AACjB,WAAe,AACf,sBAA0B,AAC1B,4BAA8B,CACjC,AAED,sBACI,eAAgB,AAChB,sBAAwB,CAC3B,AAED,aACI,cAAe,AACf,oBAAqB,CACtB","file":"style.css","sourcesContent":[".table-fixed tbody {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    width: 100%;\n}\n.table-fixed thead,\n.table-fixed tbody,\n.table-fixed tr,\n.table-fixed td,\n.table-fixed th {\n    display: block;\n}\n.table-fixed tr:after {\n    content: \"\";\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n.table-fixed tbody td,\n.table-fixed thead > tr > th {\n    float: left;\n}\n\n.hoveronly { \n    display: none;\n}\n.tableline:hover .hoveronly {\n    display : inline;\n}\n.tableline:hover .hoverhide {\n    display : none;\n}\n\n.hoverelementonly {\n    display: none;\n}\n.element:hover .hoverelementonly {\n    display : inline;\n}\n.element:hover .hoverelementhide {\n    display : none;\n}\n\n.badge-outline {\n    font-weight: 400;\n    color: #808080;\n    border: 1px solid #808080;\n    background-color: transparent;\n}\n\n.pointerCursor {\n    cursor: pointer;\n    pointer-events: inherit;\n}\n\n.code {\n    display: block;\n    white-space: pre-wrap   \n  }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table-fixed": "table-fixed__29urN",
	"hoveronly": "hoveronly___Hjg7",
	"tableline": "tableline__3ZIwZ",
	"hoverhide": "hoverhide__1sFEU",
	"hoverelementonly": "hoverelementonly__3ydu9",
	"element": "element__1Dao-",
	"hoverelementhide": "hoverelementhide__2kuEA",
	"badge-outline": "badge-outline__3soR6",
	"pointerCursor": "pointerCursor__3J64B",
	"code": "code__2j8H9"
};

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "KUik":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
    throw TypeError(name + ': incorrect invocation!');
  }return it;
};

/***/ }),

/***/ "KxjL":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),

/***/ "Ky5l":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Aa2f");
__webpack_require__("tuDi");
__webpack_require__("c6mp");
__webpack_require__("2mwf");
module.exports = __webpack_require__("zKeE").Symbol;

/***/ }),

/***/ "L3Vt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("9u1Q"), __esModule: true };

/***/ }),

/***/ "LNnS":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("Wyka");
var toLength = __webpack_require__("S7IM");
var toAbsoluteIndex = __webpack_require__("Zwq5");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),

/***/ "LRt8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".table-fixed__36xKA tbody{height:calc(100vh - 200px);overflow-y:auto;width:100%}.table-fixed__36xKA tbody,.table-fixed__36xKA td,.table-fixed__36xKA th,.table-fixed__36xKA thead,.table-fixed__36xKA tr{display:block}.table-fixed__36xKA tr:after{content:\"\";display:block;visibility:hidden;clear:both}.table-fixed__36xKA tbody td,.table-fixed__36xKA thead>tr>th{float:left}.hoveronly__GrST7{display:none}.tableline__2-E5r:hover .hoveronly__GrST7{display:inline}.hoverelementonly__1isOp,.tableline__2-E5r:hover .hoverhide__2p_Lj{display:none}.element__22JYA:hover .hoverelementonly__1isOp{display:inline}.element__22JYA:hover .hoverelementhide__n_Mgd{display:none}.badge-outline__2xjK2{font-weight:400;color:gray;border:1px solid gray;background-color:transparent}.pointerCursor__3aRtA{cursor:pointer;pointer-events:inherit}.code__1ZfxI{display:block;white-space:pre-wrap}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/urls/style.css"],"names":[],"mappings":"AAAA,0BACI,2BAA4B,AAC5B,gBAAiB,AACjB,UAAY,CACf,AACD,yHAKI,aAAe,CAClB,AACD,6BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,6DAEI,UAAY,CACf,AAED,kBACI,YAAc,CACjB,AACD,0CACI,cAAiB,CACpB,AAKD,mEACI,YAAc,CACjB,AACD,+CACI,cAAiB,CACpB,AACD,+CACI,YAAe,CAClB,AAED,sBACI,gBAAiB,AACjB,WAAe,AACf,sBAA0B,AAC1B,4BAA8B,CACjC,AAED,sBACI,eAAgB,AAChB,sBAAwB,CAC3B,AAED,aACI,cAAe,AACf,oBAAqB,CACtB","file":"style.css","sourcesContent":[".table-fixed tbody {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    width: 100%;\n}\n.table-fixed thead,\n.table-fixed tbody,\n.table-fixed tr,\n.table-fixed td,\n.table-fixed th {\n    display: block;\n}\n.table-fixed tr:after {\n    content: \"\";\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n.table-fixed tbody td,\n.table-fixed thead > tr > th {\n    float: left;\n}\n\n.hoveronly { \n    display: none;\n}\n.tableline:hover .hoveronly {\n    display : inline;\n}\n.tableline:hover .hoverhide {\n    display : none;\n}\n\n.hoverelementonly {\n    display: none;\n}\n.element:hover .hoverelementonly {\n    display : inline;\n}\n.element:hover .hoverelementhide {\n    display : none;\n}\n\n.badge-outline {\n    font-weight: 400;\n    color: #808080;\n    border: 1px solid #808080;\n    background-color: transparent;\n}\n\n.pointerCursor {\n    cursor: pointer;\n    pointer-events: inherit;\n}\n\n.code {\n    display: block;\n    white-space: pre-wrap   \n  }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table-fixed": "table-fixed__36xKA",
	"hoveronly": "hoveronly__GrST7",
	"tableline": "tableline__2-E5r",
	"hoverhide": "hoverhide__2p_Lj",
	"hoverelementonly": "hoverelementonly__1isOp",
	"element": "element__22JYA",
	"hoverelementhide": "hoverelementhide__n_Mgd",
	"badge-outline": "badge-outline__2xjK2",
	"pointerCursor": "pointerCursor__3aRtA",
	"code": "code__1ZfxI"
};

/***/ }),

/***/ "Lli7":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("Ug9I")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {/* empty */}

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () {
      return { done: safe = true };
    };
    arr[ITERATOR] = function () {
      return iter;
    };
    exec(arr);
  } catch (e) {/* empty */}
  return safe;
};

/***/ }),

/***/ "MpYs":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),

/***/ "NB7d":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("zKeE");
var global = __webpack_require__("i1Q6");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("1kq3") ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

/***/ }),

/***/ "Ni5N":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("B9Lq");
var hiddenKeys = __webpack_require__("KxjL").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),

/***/ "O6kh":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("akPY");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];else hide(target, key, src[key]);
  }return target;
};

/***/ }),

/***/ "OQuE":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("iX0g");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "OYXR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addToUnscopables = __webpack_require__("ID6i");
var step = __webpack_require__("xwD+");
var Iterators = __webpack_require__("dhak");
var toIObject = __webpack_require__("Wyka");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("uRfg")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0; // next index
  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),

/***/ "Ocr3":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),

/***/ "PZ+8":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("KD0L");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Q4GW":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".code__321kK{display:block;white-space:pre-wrap}.dragged__BFncR{border:2px dotted red}.over__38usk{border:2px dotted #0f0}.list__2XSrj{list-style-type:none}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/form/style.css"],"names":[],"mappings":"AAAA,aACI,cAAe,AACf,oBAAqB,CACxB,AAED,gBACI,qBAA2B,CAC9B,AAED,aACI,sBAA2B,CAC9B,AAED,aACI,oBAAsB,CACzB","file":"style.css","sourcesContent":[".code {\n    display: block;\n    white-space: pre-wrap   \n}\n\n.dragged {\n    border: 2px dotted #ff0000;\n}\n\n.over {\n    border: 2px dotted #00ff00;\n}\n\n.list {\n    list-style-type: none;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"code": "code__321kK",
	"dragged": "dragged__BFncR",
	"over": "over__38usk",
	"list": "list__2XSrj"
};

/***/ }),

/***/ "QAmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var index = typeof fetch == 'function' ? fetch.bind() : function (url, options) {
	options = options || {};
	return new Promise(function (resolve, reject) {
		var request = new XMLHttpRequest();

		request.open(options.method || 'get', url, true);

		for (var i in options.headers) {
			request.setRequestHeader(i, options.headers[i]);
		}

		request.withCredentials = options.credentials == 'include';

		request.onload = function () {
			resolve(response());
		};

		request.onerror = reject;

		request.send(options.body || null);

		function response() {
			var _keys = [],
			    all = [],
			    headers = {},
			    header;

			request.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (m, key, value) {
				_keys.push(key = key.toLowerCase());
				all.push([key, value]);
				header = headers[key];
				headers[key] = header ? header + "," + value : value;
			});

			return {
				ok: (request.status / 100 | 0) == 2, // 200-299
				status: request.status,
				statusText: request.statusText,
				url: request.responseURL,
				clone: response,
				text: function text() {
					return Promise.resolve(request.responseText);
				},
				json: function json() {
					return Promise.resolve(request.responseText).then(JSON.parse);
				},
				blob: function blob() {
					return Promise.resolve(new Blob([request.response]));
				},
				headers: {
					keys: function keys() {
						return _keys;
					},
					entries: function entries() {
						return all;
					},
					get: function get(n) {
						return headers[n.toLowerCase()];
					},
					has: function has(n) {
						return n.toLowerCase() in headers;
					}
				}
			};
		}
	});
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=unfetch.es.js.map

/***/ }),

/***/ "QVnC":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!function (global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  runtime.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function (arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));

    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function stop() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
}(
// In sloppy mode, unbound `this` refers to the global object, fallback to
// Function constructor if we're in global strict mode. That is sadly a form
// of indirect eval which violates Content Security Policy.
function () {
  return this;
}() || Function("return this")());

/***/ }),

/***/ "QYzI":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = function () {
  return this;
}() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("QVnC");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch (e) {
    g.regeneratorRuntime = undefined;
  }
}

/***/ }),

/***/ "R6c1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("6MLN") && !__webpack_require__("wLcK")(function () {
  return Object.defineProperty(__webpack_require__("9kxq")('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),

/***/ "Rg5Y":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2tzx");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "S7IM":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("MpYs");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),

/***/ "ShN9":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ "T4f3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("gc0D");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "TFt2":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("h0PC");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "TNJq":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("zotD");
var dPs = __webpack_require__("gjjs");
var enumBugKeys = __webpack_require__("KxjL");
var IE_PROTO = __webpack_require__("/wuY")('IE_PROTO');
var Empty = function Empty() {/* empty */};
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("9kxq")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("ebIA").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),

/***/ "TvtV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("oGUa");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "U72i":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),

/***/ "Ug9I":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("NB7d")('wks');
var uid = __webpack_require__("X6va");
var Symbol = __webpack_require__("i1Q6").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),

/***/ "VOrx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("GyB/");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ "VS7n":
/***/ (function(module, exports, __webpack_require__) {

module.exports = window.fetch || (window.fetch = __webpack_require__("QAmr").default || __webpack_require__("QAmr"));

/***/ }),

/***/ "VUtF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("sIoo");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "WHk1":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".table-fixed__3uHST tbody{height:calc(100vh - 200px);overflow-y:auto;width:100%}.table-fixed__3uHST tbody,.table-fixed__3uHST td,.table-fixed__3uHST th,.table-fixed__3uHST thead,.table-fixed__3uHST tr{display:block}.table-fixed__3uHST tr:after{content:\"\";display:block;visibility:hidden;clear:both}.table-fixed__3uHST tbody td,.table-fixed__3uHST thead>tr>th{float:left}.hoveronly__3Uruy{display:none}.tableline__16u6I:hover .hoveronly__3Uruy{display:inline}.hoverelementonly__3Gvg1,.tableline__16u6I:hover .hoverhide__19NUd{display:none}.element__22Q4m:hover .hoverelementonly__3Gvg1{display:inline}.element__22Q4m:hover .hoverelementhide__3OtLW{display:none}.badge-outline__3sK3f{font-weight:400;color:gray;border:1px solid gray;background-color:transparent}.pointerCursor__3j-0L{cursor:pointer;pointer-events:inherit}.code__RDQkW{display:block;white-space:pre-wrap}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/rodregs/style.css"],"names":[],"mappings":"AAAA,0BACI,2BAA4B,AAC5B,gBAAiB,AACjB,UAAY,CACf,AACD,yHAKI,aAAe,CAClB,AACD,6BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,6DAEI,UAAY,CACf,AAED,kBACI,YAAc,CACjB,AACD,0CACI,cAAiB,CACpB,AAKD,mEACI,YAAc,CACjB,AACD,+CACI,cAAiB,CACpB,AACD,+CACI,YAAe,CAClB,AAED,sBACI,gBAAiB,AACjB,WAAe,AACf,sBAA0B,AAC1B,4BAA8B,CACjC,AAED,sBACI,eAAgB,AAChB,sBAAwB,CAC3B,AAED,aACI,cAAe,AACf,oBAAqB,CACtB","file":"style.css","sourcesContent":[".table-fixed tbody {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    width: 100%;\n}\n.table-fixed thead,\n.table-fixed tbody,\n.table-fixed tr,\n.table-fixed td,\n.table-fixed th {\n    display: block;\n}\n.table-fixed tr:after {\n    content: \"\";\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n.table-fixed tbody td,\n.table-fixed thead > tr > th {\n    float: left;\n}\n\n.hoveronly { \n    display: none;\n}\n.tableline:hover .hoveronly {\n    display : inline;\n}\n.tableline:hover .hoverhide {\n    display : none;\n}\n\n.hoverelementonly {\n    display: none;\n}\n.element:hover .hoverelementonly {\n    display : inline;\n}\n.element:hover .hoverelementhide {\n    display : none;\n}\n\n.badge-outline {\n    font-weight: 400;\n    color: #808080;\n    border: 1px solid #808080;\n    background-color: transparent;\n}\n\n.pointerCursor {\n    cursor: pointer;\n    pointer-events: inherit;\n}\n\n.code {\n    display: block;\n    white-space: pre-wrap   \n  }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table-fixed": "table-fixed__3uHST",
	"hoveronly": "hoveronly__3Uruy",
	"tableline": "tableline__16u6I",
	"hoverhide": "hoverhide__19NUd",
	"hoverelementonly": "hoverelementonly__3Gvg1",
	"element": "element__22Q4m",
	"hoverelementhide": "hoverelementhide__3OtLW",
	"badge-outline": "badge-outline__3sK3f",
	"pointerCursor": "pointerCursor__3j-0L",
	"code": "code__RDQkW"
};

/***/ }),

/***/ "Wyka":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("E5Ce");
var defined = __webpack_require__("U72i");
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),

/***/ "X6va":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),

/***/ "YD0x":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("vSO4");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("uj5A") });

/***/ }),

/***/ "ZHvQ":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("ShN9");
var TAG = __webpack_require__("Ug9I")('toStringTag');
// ES3 wrong here
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),

/***/ "ZKjc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("Aq8W");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("yeEC");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("GyB/");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "ZaKr":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("BxvP");
var anObject = __webpack_require__("zotD");
var check = function check(O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = __webpack_require__("3zRh")(Function.call, __webpack_require__("sxPs").f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }
    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
};

/***/ }),

/***/ "Zwq5":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("MpYs");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),

/***/ "ZxII":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("Ug9I");

/***/ }),

/***/ "aIIw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("QYzI");

/***/ }),

/***/ "af0K":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("dhak");
var ITERATOR = __webpack_require__("Ug9I")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),

/***/ "akPY":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("Gfzd");
var createDesc = __webpack_require__("0WCH");
module.exports = __webpack_require__("6MLN") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),

/***/ "ayXv":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("ShN9");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),

/***/ "b1tA":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("vSO4");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("ZaKr").set });

/***/ }),

/***/ "b7Q2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__("TNJq");
var descriptor = __webpack_require__("0WCH");
var setToStringTag = __webpack_require__("11Ut");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("akPY")(IteratorPrototype, __webpack_require__("Ug9I")('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),

/***/ "b8fj":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "bvhO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function stringifyPrimitive(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function (obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function (k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function (v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);
  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map(xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

/***/ }),

/***/ "c2zY":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("i1Q6");
var core = __webpack_require__("zKeE");
var LIBRARY = __webpack_require__("1kq3");
var wksExt = __webpack_require__("ZxII");
var defineProperty = __webpack_require__("Gfzd").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

/***/ }),

/***/ "c6mp":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("c2zY")('asyncIterator');

/***/ }),

/***/ "cjsw":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("yOG5");
var $Object = __webpack_require__("zKeE").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};

/***/ }),

/***/ "dACh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "dXs8":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("b1tA");
module.exports = __webpack_require__("zKeE").Object.setPrototypeOf;

/***/ }),

/***/ "dhak":
/***/ (function(module, exports) {

module.exports = {};

/***/ }),

/***/ "e8vu":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("X6va")('meta');
var isObject = __webpack_require__("BxvP");
var has = __webpack_require__("yS17");
var setDesc = __webpack_require__("Gfzd").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("wLcK")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function setMeta(it) {
  setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {} // weak collections IDs
    } });
};
var fastKey = function fastKey(it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }return it[META].i;
};
var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),

/***/ "ebIA":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("i1Q6").document;
module.exports = document && document.documentElement;

/***/ }),

/***/ "en7x":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("hTKZ");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "g31e":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ "gc0D":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("vcHl"), __esModule: true };

/***/ }),

/***/ "gjjs":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("Gfzd");
var anObject = __webpack_require__("zotD");
var getKeys = __webpack_require__("knrM");

module.exports = __webpack_require__("6MLN") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),

/***/ "gojl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("akPY");

/***/ }),

/***/ "h0PC":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".table-fixed__2ZeDd tbody{height:calc(100vh - 200px);overflow-y:auto;width:100%}.table-fixed__2ZeDd tbody,.table-fixed__2ZeDd td,.table-fixed__2ZeDd th,.table-fixed__2ZeDd thead,.table-fixed__2ZeDd tr{display:block}.table-fixed__2ZeDd tr:after{content:\"\";display:block;visibility:hidden;clear:both}.table-fixed__2ZeDd tbody td,.table-fixed__2ZeDd thead>tr>th{float:left}.hoveronly__1JhjF{display:none}.tableline__3MTa0:hover .hoveronly__1JhjF{display:inline}.hoverelementonly__2_1Qs,.tableline__3MTa0:hover .hoverhide__2Kg0X{display:none}.element__32Uas:hover .hoverelementonly__2_1Qs{display:inline}.element__32Uas:hover .hoverelementhide__2xbaR{display:none}.badge-outline__3ZB_2{font-weight:400;color:gray;border:1px solid gray;background-color:transparent}.pointerCursor__1FedY{cursor:pointer;pointer-events:inherit}.code__30nMM{display:block;white-space:pre-wrap}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/dealers/style.css"],"names":[],"mappings":"AAAA,0BACI,2BAA4B,AAC5B,gBAAiB,AACjB,UAAY,CACf,AACD,yHAKI,aAAe,CAClB,AACD,6BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,6DAEI,UAAY,CACf,AAED,kBACI,YAAc,CACjB,AACD,0CACI,cAAiB,CACpB,AAKD,mEACI,YAAc,CACjB,AACD,+CACI,cAAiB,CACpB,AACD,+CACI,YAAe,CAClB,AAED,sBACI,gBAAiB,AACjB,WAAe,AACf,sBAA0B,AAC1B,4BAA8B,CACjC,AAED,sBACI,eAAgB,AAChB,sBAAwB,CAC3B,AAED,aACI,cAAe,AACf,oBAAqB,CACtB","file":"style.css","sourcesContent":[".table-fixed tbody {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    width: 100%;\n}\n.table-fixed thead,\n.table-fixed tbody,\n.table-fixed tr,\n.table-fixed td,\n.table-fixed th {\n    display: block;\n}\n.table-fixed tr:after {\n    content: \"\";\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n.table-fixed tbody td,\n.table-fixed thead > tr > th {\n    float: left;\n}\n\n.hoveronly { \n    display: none;\n}\n.tableline:hover .hoveronly {\n    display : inline;\n}\n.tableline:hover .hoverhide {\n    display : none;\n}\n\n.hoverelementonly {\n    display: none;\n}\n.element:hover .hoverelementonly {\n    display : inline;\n}\n.element:hover .hoverelementhide {\n    display : none;\n}\n\n.badge-outline {\n    font-weight: 400;\n    color: #808080;\n    border: 1px solid #808080;\n    background-color: transparent;\n}\n\n.pointerCursor {\n    cursor: pointer;\n    pointer-events: inherit;\n}\n\n.code {\n    display: block;\n    white-space: pre-wrap   \n  }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table-fixed": "table-fixed__2ZeDd",
	"hoveronly": "hoveronly__1JhjF",
	"tableline": "tableline__3MTa0",
	"hoverhide": "hoverhide__2Kg0X",
	"hoverelementonly": "hoverelementonly__2_1Qs",
	"element": "element__32Uas",
	"hoverelementhide": "hoverelementhide__2xbaR",
	"badge-outline": "badge-outline__3ZB_2",
	"pointerCursor": "pointerCursor__1FedY",
	"code": "code__30nMM"
};

/***/ }),

/***/ "h8Pt":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("xVj4");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "hEIm":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("zotD");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),

/***/ "hTKZ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".table-fixed__3O3mP tbody{height:calc(100vh - 200px);overflow-y:auto;width:100%}.table-fixed__3O3mP tbody,.table-fixed__3O3mP td,.table-fixed__3O3mP th,.table-fixed__3O3mP thead,.table-fixed__3O3mP tr{display:block}.table-fixed__3O3mP tr:after{content:\"\";display:block;visibility:hidden;clear:both}.table-fixed__3O3mP tbody td,.table-fixed__3O3mP thead>tr>th{float:left}.hoveronly__2N3nT{display:none}.tableline__2hEdu:hover .hoveronly__2N3nT{display:inline}.hoverelementonly__1YxZ8,.tableline__2hEdu:hover .hoverhide__28bjk{display:none}.element__3sreD:hover .hoverelementonly__1YxZ8{display:inline}.element__3sreD:hover .hoverelementhide__1ijLP{display:none}.badge-outline__37tC8{font-weight:400;color:gray;border:1px solid gray;background-color:transparent}.pointerCursor__2SqRB{cursor:pointer;pointer-events:inherit}.code__TChsL{display:block;white-space:pre-wrap}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/mailaddresses/style.css"],"names":[],"mappings":"AAAA,0BACI,2BAA4B,AAC5B,gBAAiB,AACjB,UAAY,CACf,AACD,yHAKI,aAAe,CAClB,AACD,6BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,6DAEI,UAAY,CACf,AAED,kBACI,YAAc,CACjB,AACD,0CACI,cAAiB,CACpB,AAKD,mEACI,YAAc,CACjB,AACD,+CACI,cAAiB,CACpB,AACD,+CACI,YAAe,CAClB,AAED,sBACI,gBAAiB,AACjB,WAAe,AACf,sBAA0B,AAC1B,4BAA8B,CACjC,AAED,sBACI,eAAgB,AAChB,sBAAwB,CAC3B,AAED,aACI,cAAe,AACf,oBAAqB,CACtB","file":"style.css","sourcesContent":[".table-fixed tbody {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    width: 100%;\n}\n.table-fixed thead,\n.table-fixed tbody,\n.table-fixed tr,\n.table-fixed td,\n.table-fixed th {\n    display: block;\n}\n.table-fixed tr:after {\n    content: \"\";\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n.table-fixed tbody td,\n.table-fixed thead > tr > th {\n    float: left;\n}\n\n.hoveronly { \n    display: none;\n}\n.tableline:hover .hoveronly {\n    display : inline;\n}\n.tableline:hover .hoverhide {\n    display : none;\n}\n\n.hoverelementonly {\n    display: none;\n}\n.element:hover .hoverelementonly {\n    display : inline;\n}\n.element:hover .hoverelementhide {\n    display : none;\n}\n\n.badge-outline {\n    font-weight: 400;\n    color: #808080;\n    border: 1px solid #808080;\n    background-color: transparent;\n}\n\n.pointerCursor {\n    cursor: pointer;\n    pointer-events: inherit;\n}\n\n.code {\n    display: block;\n    white-space: pre-wrap   \n  }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table-fixed": "table-fixed__3O3mP",
	"hoveronly": "hoveronly__2N3nT",
	"tableline": "tableline__2hEdu",
	"hoverhide": "hoverhide__28bjk",
	"hoverelementonly": "hoverelementonly__1YxZ8",
	"element": "element__3sreD",
	"hoverelementhide": "hoverelementhide__1ijLP",
	"badge-outline": "badge-outline__37tC8",
	"pointerCursor": "pointerCursor__2SqRB",
	"code": "code__TChsL"
};

/***/ }),

/***/ "htFH":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("vSO4");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("6MLN"), 'Object', { defineProperty: __webpack_require__("Gfzd").f });

/***/ }),

/***/ "i+u+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $at = __webpack_require__("lytE")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("uRfg")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

/***/ }),

/***/ "i1Q6":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),

/***/ "iX0g":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".table-fixed__2hJeW tbody{height:calc(100vh - 200px);overflow-y:auto;width:100%}.table-fixed__2hJeW tbody,.table-fixed__2hJeW td,.table-fixed__2hJeW th,.table-fixed__2hJeW thead,.table-fixed__2hJeW tr{display:block}.table-fixed__2hJeW tr:after{content:\"\";display:block;visibility:hidden;clear:both}.table-fixed__2hJeW tbody td,.table-fixed__2hJeW thead>tr>th{float:left}.hoveronly__1fxO0{display:none}.tableline__2LFiB:hover .hoveronly__1fxO0{display:inline}.hoverelementonly__3fZDO,.tableline__2LFiB:hover .hoverhide__21jJL{display:none}.element__2cavz:hover .hoverelementonly__3fZDO{display:inline}.element__2cavz:hover .hoverelementhide__3ZSjk{display:none}.badge-outline__3JwJl{font-weight:400;color:gray;border:1px solid gray;background-color:transparent}.pointerCursor__2mL1W{cursor:pointer;pointer-events:inherit}.code__19vyU{display:block;white-space:pre-wrap}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/articles/style.css"],"names":[],"mappings":"AAAA,0BACI,2BAA4B,AAC5B,gBAAiB,AACjB,UAAY,CACf,AACD,yHAKI,aAAe,CAClB,AACD,6BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,6DAEI,UAAY,CACf,AAED,kBACI,YAAc,CACjB,AACD,0CACI,cAAiB,CACpB,AAKD,mEACI,YAAc,CACjB,AACD,+CACI,cAAiB,CACpB,AACD,+CACI,YAAe,CAClB,AAED,sBACI,gBAAiB,AACjB,WAAe,AACf,sBAA0B,AAC1B,4BAA8B,CACjC,AAED,sBACI,eAAgB,AAChB,sBAAwB,CAC3B,AAED,aACI,cAAe,AACf,oBAAqB,CACtB","file":"style.css","sourcesContent":[".table-fixed tbody {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    width: 100%;\n}\n.table-fixed thead,\n.table-fixed tbody,\n.table-fixed tr,\n.table-fixed td,\n.table-fixed th {\n    display: block;\n}\n.table-fixed tr:after {\n    content: \"\";\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n.table-fixed tbody td,\n.table-fixed thead > tr > th {\n    float: left;\n}\n\n.hoveronly { \n    display: none;\n}\n.tableline:hover .hoveronly {\n    display : inline;\n}\n.tableline:hover .hoverhide {\n    display : none;\n}\n\n.hoverelementonly {\n    display: none;\n}\n.element:hover .hoverelementonly {\n    display : inline;\n}\n.element:hover .hoverelementhide {\n    display : none;\n}\n\n.badge-outline {\n    font-weight: 400;\n    color: #808080;\n    border: 1px solid #808080;\n    background-color: transparent;\n}\n\n.pointerCursor {\n    cursor: pointer;\n    pointer-events: inherit;\n}\n\n.code {\n    display: block;\n    white-space: pre-wrap   \n  }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table-fixed": "table-fixed__2hJeW",
	"hoveronly": "hoveronly__1fxO0",
	"tableline": "tableline__2LFiB",
	"hoverhide": "hoverhide__21jJL",
	"hoverelementonly": "hoverelementonly__3fZDO",
	"element": "element__2cavz",
	"hoverelementhide": "hoverelementhide__3ZSjk",
	"badge-outline": "badge-outline__3JwJl",
	"pointerCursor": "pointerCursor__2mL1W",
	"code": "code__19vyU"
};

/***/ }),

/***/ "ibPW":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("Ky5l"), __esModule: true };

/***/ }),

/***/ "jx4H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("FFZn");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "kX4D":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

/***/ }),

/***/ "kcQR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__("L3Vt");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ "knrM":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("B9Lq");
var enumBugKeys = __webpack_require__("KxjL");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),

/***/ "lcwS":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),

/***/ "lytE":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("MpYs");
var defined = __webpack_require__("U72i");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),

/***/ "m+Gh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

if (!global.Promise) global.Promise = __webpack_require__("BtxX");
if (!global.fetch) global.fetch = __webpack_require__("VS7n");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("b8fj")))

/***/ }),

/***/ "mKeQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return observer; });
/* unused harmony export Observer */
/* unused harmony export useStaticRendering */
/* unused harmony export connect */
/* unused harmony export inject */
/* unused harmony export Provider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__("6uYi");



function isStateless(component) {
    // `function() {}` has prototype, but `() => {}` doesn't
    // `() => {}` via Babel has prototype too.
    return !(component.prototype && component.prototype.render) && !__WEBPACK_IMPORTED_MODULE_0_preact__["Component"].isPrototypeOf(component);
}

function makeDisplayName(component) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$prefix = _ref.prefix,
        prefix = _ref$prefix === undefined ? '' : _ref$prefix,
        _ref$suffix = _ref.suffix,
        suffix = _ref$suffix === undefined ? '' : _ref$suffix;

    var displayName = component.displayName || component.name || component.constructor && component.constructor.name || '<component>';
    return prefix + displayName + suffix;
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
};

var createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }

    return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var inherits = function inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var isUsingStaticRendering = false;

var logger = console; // eslint-disable-line no-console

function useStaticRendering(useStaticRendering) {
    isUsingStaticRendering = useStaticRendering;
}

/**
 Workaround

 allowStateChanges from mobX must be patched so that props, state and args are passed to the render() function
 */

function allowStateChangesStart(allowStateChanges) {
    var prev = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["b" /* _getGlobalState */])().allowStateChanges;
    Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["b" /* _getGlobalState */])().allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["b" /* _getGlobalState */])().allowStateChanges = prev;
}

function allowStateChanges(allowStateChanges, func, props, state, context) {
    var prev = allowStateChangesStart(allowStateChanges);
    var res = void 0;
    try {
        res = func(props, state, context);
    } finally {
        allowStateChangesEnd(prev);
    }
    return res;
}

/**
 * Utilities
 */

function patch(target, funcName) {
    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var base = target[funcName];
    var mixinFunc = reactiveMixin[funcName];
    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
        mixinFunc.apply(this, arguments);
        base.apply(this, arguments);
    } : function () {
        base.apply(this, arguments);
        mixinFunc.apply(this, arguments);
    };

    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
    // ...but that breaks react-hot-loader, see #231...
    target[funcName] = f;
}

function isObjectShallowModified(prev, next) {
    if (null == prev || null == next || (typeof prev === 'undefined' ? 'undefined' : _typeof(prev)) !== 'object' || (typeof next === 'undefined' ? 'undefined' : _typeof(next)) !== 'object') {
        return prev !== next;
    }
    var keys = Object.keys(prev);
    if (keys.length !== Object.keys(next).length) {
        return true;
    }
    var key = void 0;
    for (var i = keys.length - 1; key = keys[i]; i--) {
        if (next[key] !== prev[key]) {
            return true;
        }
    }
    return false;
}

/**
 * ReactiveMixin
 */
var reactiveMixin = {
    componentWillMount: function componentWillMount() {
        var _this = this;

        if (isUsingStaticRendering === true) {
            return;
        }
        // Generate friendly name for debugging
        var initialName = makeDisplayName(this);

        /**
         * If props are shallowly modified, react will render anyway,
         * so atom.reportChanged() should not result in yet another re-render
         */
        var skipRender = false;
        /**
         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
         * so detect these changes
         */
        var isForcingUpdate = false;

        function makePropertyObservableReference(propName) {
            var valueHolder = this[propName];
            var atom = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["g" /* createAtom */])('reactive ' + propName);
            Object.defineProperty(this, propName, {
                configurable: true,
                enumerable: true,
                get: function get$$1() {
                    atom.reportObserved();
                    return valueHolder;
                },
                set: function set$$1(v) {
                    if (!isForcingUpdate && isObjectShallowModified(valueHolder, v)) {
                        valueHolder = v;
                        skipRender = true;
                        atom.reportChanged();
                        skipRender = false;
                    } else {
                        valueHolder = v;
                    }
                }
            });
        }

        // make this.props an observable reference, see #124
        makePropertyObservableReference.call(this, 'props');
        // make state an observable reference
        makePropertyObservableReference.call(this, 'state');

        // wire up reactive render
        var baseRender = this.render.bind(this);
        var reaction = null;
        var isRenderingPending = false;

        var initialRender = function initialRender() {
            reaction = new __WEBPACK_IMPORTED_MODULE_1_mobx__["a" /* Reaction */](initialName + '.render()', function () {
                if (!isRenderingPending) {
                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
                    // See #85 / Pull #44
                    isRenderingPending = true;
                    if (typeof _this.componentWillReact === 'function') {
                        _this.componentWillReact();
                    } // TODO: wrap in action?
                    if (_this.__$mobxIsUnmounted !== true) {
                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
                        // However, people also claim this migth happen during unit tests..
                        var hasError = true;
                        try {
                            isForcingUpdate = true;
                            if (!skipRender) {
                                __WEBPACK_IMPORTED_MODULE_0_preact__["Component"].prototype.forceUpdate.call(_this);
                            }
                            hasError = false;
                        } finally {
                            isForcingUpdate = false;
                            if (hasError) {
                                reaction.dispose();
                            }
                        }
                    }
                }
            });
            reaction.reactComponent = _this;
            reactiveRender.$mobx = reaction;
            _this.render = reactiveRender;
            return reactiveRender(_this.props, _this.state, _this.context);
        };

        var reactiveRender = function reactiveRender(props, state, context) {
            isRenderingPending = false;
            var exception = undefined;
            var rendering = undefined;
            reaction.track(function () {
                try {
                    rendering = allowStateChanges(false, baseRender, props, state, context);
                } catch (e) {
                    exception = e;
                }
            });
            if (exception) {
                throw exception;
            }
            return rendering;
        };

        this.render = initialRender;
    },

    componentWillUnmount: function componentWillUnmount() {
        if (isUsingStaticRendering === true) {
            return;
        }
        this.render.$mobx && this.render.$mobx.dispose();
        this.__$mobxIsUnmounted = true;
    },

    componentDidMount: function componentDidMount() {},

    componentDidUpdate: function componentDidUpdate() {},

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (isUsingStaticRendering) {
            logger.warn('[mobx-preact] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.');
        }
        // update on any state changes (as is the default)
        if (this.state !== nextState) {
            return true;
        }
        // update if props are shallowly not equal, inspired by PureRenderMixin
        // we could return just 'false' here, and avoid the `skipRender` checks etc
        // however, it is nicer if lifecycle events are triggered like usually,
        // so we return true here if props are shallowly modified.
        return isObjectShallowModified(this.props, nextProps);
    }
};

/**
 * Observer function / decorator
 */
function observer(componentClass) {
    if (arguments.length > 1) {
        logger.warn('Mobx observer: Using observer to inject stores is not supported. Use `@connect(["store1", "store2"]) ComponentClass instead or preferably, use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))``');
    }

    if (componentClass.isMobxInjector === true) {
        logger.warn('Mobx observer: You are trying to use \'observer\' on a component that already has \'inject\'. Please apply \'observer\' before applying \'inject\'');
    }

    // Stateless function component:
    if (isStateless(componentClass)) {
        var _class, _temp;

        return observer((_temp = _class = function (_Component) {
            inherits(_class, _Component);

            function _class() {
                classCallCheck(this, _class);
                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
            }

            createClass(_class, [{
                key: 'render',
                value: function render() {
                    return componentClass.call(this, this.props, this.context);
                }
            }]);
            return _class;
        }(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.displayName = makeDisplayName(componentClass), _temp));
    }

    if (!componentClass) {
        throw new Error('Please pass a valid component to \'observer\'');
    }

    var target = componentClass.prototype || componentClass;
    mixinLifecycleEvents(target);
    componentClass.isMobXReactObserver = true;
    return componentClass;
}

function mixinLifecycleEvents(target) {
    patch(target, 'componentWillMount', true);
    patch(target, 'componentDidMount');

    if (!target.shouldComponentUpdate) {
        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
    }
}

var Observer = observer(function (_ref) {
    var children = _ref.children;
    return children[0]();
});

Observer.displayName = 'Observer';

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
    return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var hoistNonReactStatics = createCommonjsModule(function (module, exports) {
    /**
     * Copyright 2015, Yahoo! Inc.
     * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
     */
    (function (global, factory) {
        module.exports = factory();
    })(commonjsGlobal, function () {

        var REACT_STATICS = {
            childContextTypes: true,
            contextTypes: true,
            defaultProps: true,
            displayName: true,
            getDefaultProps: true,
            getDerivedStateFromProps: true,
            mixins: true,
            propTypes: true,
            type: true
        };

        var KNOWN_STATICS = {
            name: true,
            length: true,
            prototype: true,
            caller: true,
            callee: true,
            arguments: true,
            arity: true
        };

        var defineProperty = Object.defineProperty;
        var getOwnPropertyNames = Object.getOwnPropertyNames;
        var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var getPrototypeOf = Object.getPrototypeOf;
        var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

        return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
            if (typeof sourceComponent !== 'string') {
                // don't hoist over string (html) components

                if (objectPrototype) {
                    var inheritedComponent = getPrototypeOf(sourceComponent);
                    if (inheritedComponent && inheritedComponent !== objectPrototype) {
                        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                    }
                }

                var keys = getOwnPropertyNames(sourceComponent);

                if (getOwnPropertySymbols) {
                    keys = keys.concat(getOwnPropertySymbols(sourceComponent));
                }

                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                        try {
                            // Avoid failures from read-only properties
                            defineProperty(targetComponent, key, descriptor);
                        } catch (e) {}
                    }
                }

                return targetComponent;
            }

            return targetComponent;
        };
    });
});

var proxiedInjectorProps = {
    isMobxInjector: {
        value: true,
        writable: true,
        configurable: true,
        enumerable: true
    }
};

/**
 * Store Injection
 */
function createStoreInjector(grabStoresFn, component, injectNames) {
    var _class, _temp;

    var prefix = 'inject-';
    var suffix = injectNames ? '-with-' + injectNames : '';
    var displayName = makeDisplayName(component, { prefix: prefix, suffix: suffix });

    var Injector = (_temp = _class = function (_Component) {
        inherits(Injector, _Component);

        function Injector() {
            classCallCheck(this, Injector);
            return possibleConstructorReturn(this, (Injector.__proto__ || Object.getPrototypeOf(Injector)).apply(this, arguments));
        }

        createClass(Injector, [{
            key: 'render',
            value: function render() {
                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
                // See this test: 'using a custom injector is not too reactive' in inject.js
                var newProps = {};
                for (var key in this.props) {
                    if (this.props.hasOwnProperty(key)) {
                        newProps[key] = this.props[key];
                    }
                }
                var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
                for (var _key in additionalProps) {
                    newProps[_key] = additionalProps[_key];
                }

                return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(component, newProps);
            }
        }]);
        return Injector;
    }(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]), _class.displayName = displayName, _temp);

    // Static fields from component should be visible on the generated Injector

    hoistNonReactStatics(Injector, component);

    Injector.wrappedComponent = component;
    Object.defineProperties(Injector, proxiedInjectorProps);

    return Injector;
}

function grabStoresByName(storeNames) {
    return function (baseStores, nextProps) {
        storeNames.forEach(function (storeName) {
            // prefer props over stores
            if (storeName in nextProps) {
                return;
            }
            if (!(storeName in baseStores)) {
                throw new Error('MobX injector: Store \'' + storeName + '\' is not available! Make sure it is provided by some Provider');
            }
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}

/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */
function inject() /* fn(stores, nextProps) or ...storeNames */{
    var grabStoresFn = void 0;
    if (typeof arguments[0] === 'function') {
        grabStoresFn = arguments[0];
        return function (componentClass) {
            var injected = createStoreInjector(grabStoresFn, componentClass);
            injected.isMobxInjector = false; // suppress warning
            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
            // see #111
            injected = observer(injected);
            injected.isMobxInjector = true; // restore warning
            return injected;
        };
    } else {
        var storeNames = [];
        for (var i = 0; i < arguments.length; i++) {
            storeNames[i] = arguments[i];
        }
        grabStoresFn = grabStoresByName(storeNames);
        return function (componentClass) {
            return createStoreInjector(grabStoresFn, componentClass, storeNames.join('-'));
        };
    }
}

function connect(arg1, arg2) {
    if (typeof arg1 === 'string') {
        throw new Error('Store names should be provided as array');
    }
    if (Array.isArray(arg1)) {
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return connect(arg1, componentClass);
            };
        } else {
            return inject.apply(null, arg1)(connect(arg2));
        }
    }
    return observer(arg1);
}

var specialReactKeys = { children: true, key: true, ref: true };

var logger$1 = console; // eslint-disable-line no-console

var Provider = function (_Component) {
    inherits(Provider, _Component);

    function Provider() {
        classCallCheck(this, Provider);
        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
    }

    createClass(Provider, [{
        key: 'render',
        value: function render(_ref) {
            var children = _ref.children;

            return children.length > 1 ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', null, ' ', children, ' ') : children[0];
        }
    }, {
        key: 'getChildContext',
        value: function getChildContext() {
            var stores = {};
            // inherit stores
            var baseStores = this.context.mobxStores;
            if (baseStores) {
                for (var key in baseStores) {
                    stores[key] = baseStores[key];
                }
            }
            // add own stores
            for (var _key in this.props) {
                if (!specialReactKeys[_key] && _key !== 'suppressChangedStoreWarning') {
                    stores[_key] = this.props[_key];
                }
            }

            return {
                mobxStores: stores
            };
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // Maybe this warning is too aggressive?
            if (Object.keys(nextProps).length !== Object.keys(this.props).length) {
                logger$1.warn('MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children');
            }
            if (!nextProps.suppressChangedStoreWarning) {
                for (var key in nextProps) {
                    if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) {
                        logger$1.warn('MobX Provider: Provided store \'' + key + '\' has changed. Please avoid replacing stores as the change might not propagate to all children');
                    }
                }
            }
        }
    }]);
    return Provider;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

if (!__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]) {
    throw new Error('mobx-preact requires Preact to be available');
}


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("b8fj")))

/***/ }),

/***/ "mbLO":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("U72i");
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),

/***/ "nFDa":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("i+u+");
__webpack_require__("COf8");
module.exports = __webpack_require__("ZxII").f('iterator');

/***/ }),

/***/ "o4G5":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
                  var un = that === undefined;
                  switch (args.length) {
                                    case 0:
                                                      return un ? fn() : fn.call(that);
                                    case 1:
                                                      return un ? fn(args[0]) : fn.call(that, args[0]);
                                    case 2:
                                                      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
                                    case 3:
                                                      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
                                    case 4:
                                                      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
                  }return fn.apply(that, args);
};

/***/ }),

/***/ "oGUa":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".table-fixed__1T-Zm tbody{height:calc(100vh - 200px);overflow-y:auto;width:100%}.table-fixed__1T-Zm tbody,.table-fixed__1T-Zm td,.table-fixed__1T-Zm th,.table-fixed__1T-Zm thead,.table-fixed__1T-Zm tr{display:block}.table-fixed__1T-Zm tr:after{content:\"\";display:block;visibility:hidden;clear:both}.table-fixed__1T-Zm tbody td,.table-fixed__1T-Zm thead>tr>th{float:left}.hoveronly__1k59Y{display:none}.tableline__30mGd:hover .hoveronly__1k59Y{display:inline}.hoverelementonly__3Tx0P,.tableline__30mGd:hover .hoverhide__2Hk1K{display:none}.element__3DvaZ:hover .hoverelementonly__3Tx0P{display:inline}.element__3DvaZ:hover .hoverelementhide__2Rgg0{display:none}.badge-outline__2pYVn{font-weight:400;color:gray;border:1px solid gray;background-color:transparent}.pointerCursor__2QAtb{cursor:pointer;pointer-events:inherit}.code__1AWeD{display:block;white-space:pre-wrap}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/productcombos/style.css"],"names":[],"mappings":"AAAA,0BACI,2BAA4B,AAC5B,gBAAiB,AACjB,UAAY,CACf,AACD,yHAKI,aAAe,CAClB,AACD,6BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,6DAEI,UAAY,CACf,AAED,kBACI,YAAc,CACjB,AACD,0CACI,cAAiB,CACpB,AAKD,mEACI,YAAc,CACjB,AACD,+CACI,cAAiB,CACpB,AACD,+CACI,YAAe,CAClB,AAED,sBACI,gBAAiB,AACjB,WAAe,AACf,sBAA0B,AAC1B,4BAA8B,CACjC,AAED,sBACI,eAAgB,AAChB,sBAAwB,CAC3B,AAED,aACI,cAAe,AACf,oBAAqB,CACtB","file":"style.css","sourcesContent":[".table-fixed tbody {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    width: 100%;\n}\n.table-fixed thead,\n.table-fixed tbody,\n.table-fixed tr,\n.table-fixed td,\n.table-fixed th {\n    display: block;\n}\n.table-fixed tr:after {\n    content: \"\";\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n.table-fixed tbody td,\n.table-fixed thead > tr > th {\n    float: left;\n}\n\n.hoveronly { \n    display: none;\n}\n.tableline:hover .hoveronly {\n    display : inline;\n}\n.tableline:hover .hoverhide {\n    display : none;\n}\n\n.hoverelementonly {\n    display: none;\n}\n.element:hover .hoverelementonly {\n    display : inline;\n}\n.element:hover .hoverelementhide {\n    display : none;\n}\n\n.badge-outline {\n    font-weight: 400;\n    color: #808080;\n    border: 1px solid #808080;\n    background-color: transparent;\n}\n\n.pointerCursor {\n    cursor: pointer;\n    pointer-events: inherit;\n}\n\n.code {\n    display: block;\n    white-space: pre-wrap   \n  }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table-fixed": "table-fixed__1T-Zm",
	"hoveronly": "hoveronly__1k59Y",
	"tableline": "tableline__30mGd",
	"hoverhide": "hoverhide__2Hk1K",
	"hoverelementonly": "hoverelementonly__3Tx0P",
	"element": "element__3DvaZ",
	"hoverelementhide": "hoverelementhide__2Rgg0",
	"badge-outline": "badge-outline__2pYVn",
	"pointerCursor": "pointerCursor__2QAtb",
	"code": "code__1AWeD"
};

/***/ }),

/***/ "ozpD":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("3zRh");
var call = __webpack_require__("hEIm");
var isArrayIter = __webpack_require__("af0K");
var anObject = __webpack_require__("zotD");
var toLength = __webpack_require__("S7IM");
var getIterFn = __webpack_require__("7AqT");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () {
    return iterable;
  } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "q7Kr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".table-fixed__1mdCx tbody{height:calc(100vh - 200px);overflow-y:auto;width:100%}.table-fixed__1mdCx tbody,.table-fixed__1mdCx td,.table-fixed__1mdCx th,.table-fixed__1mdCx thead,.table-fixed__1mdCx tr{display:block}.table-fixed__1mdCx tr:after{content:\"\";display:block;visibility:hidden;clear:both}.table-fixed__1mdCx tbody td,.table-fixed__1mdCx thead>tr>th{float:left}.hoveronly__260Fv{display:none}.tableline__Dwx4e:hover .hoveronly__260Fv{display:inline}.hoverelementonly__7LVDK,.tableline__Dwx4e:hover .hoverhide__2hR0h{display:none}.element__owA78:hover .hoverelementonly__7LVDK{display:inline}.element__owA78:hover .hoverelementhide__2QBUv{display:none}.badge-outline__peJU-{font-weight:400;color:gray;border:1px solid gray;background-color:transparent}.pointerCursor__273Bf{cursor:pointer;pointer-events:inherit}.code__25VWU{display:block;white-space:pre-wrap}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/shipments/style.css"],"names":[],"mappings":"AAAA,0BACI,2BAA4B,AAC5B,gBAAiB,AACjB,UAAY,CACf,AACD,yHAKI,aAAe,CAClB,AACD,6BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,6DAEI,UAAY,CACf,AAED,kBACI,YAAc,CACjB,AACD,0CACI,cAAiB,CACpB,AAKD,mEACI,YAAc,CACjB,AACD,+CACI,cAAiB,CACpB,AACD,+CACI,YAAe,CAClB,AAED,sBACI,gBAAiB,AACjB,WAAe,AACf,sBAA0B,AAC1B,4BAA8B,CACjC,AAED,sBACI,eAAgB,AAChB,sBAAwB,CAC3B,AAED,aACI,cAAe,AACf,oBAAqB,CACtB","file":"style.css","sourcesContent":[".table-fixed tbody {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    width: 100%;\n}\n.table-fixed thead,\n.table-fixed tbody,\n.table-fixed tr,\n.table-fixed td,\n.table-fixed th {\n    display: block;\n}\n.table-fixed tr:after {\n    content: \"\";\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n.table-fixed tbody td,\n.table-fixed thead > tr > th {\n    float: left;\n}\n\n.hoveronly { \n    display: none;\n}\n.tableline:hover .hoveronly {\n    display : inline;\n}\n.tableline:hover .hoverhide {\n    display : none;\n}\n\n.hoverelementonly {\n    display: none;\n}\n.element:hover .hoverelementonly {\n    display : inline;\n}\n.element:hover .hoverelementhide {\n    display : none;\n}\n\n.badge-outline {\n    font-weight: 400;\n    color: #808080;\n    border: 1px solid #808080;\n    background-color: transparent;\n}\n\n.pointerCursor {\n    cursor: pointer;\n    pointer-events: inherit;\n}\n\n.code {\n    display: block;\n    white-space: pre-wrap   \n  }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table-fixed": "table-fixed__1mdCx",
	"hoveronly": "hoveronly__260Fv",
	"tableline": "tableline__Dwx4e",
	"hoverhide": "hoverhide__2hR0h",
	"hoverelementonly": "hoverelementonly__7LVDK",
	"element": "element__owA78",
	"hoverelementhide": "hoverelementhide__2QBUv",
	"badge-outline": "badge-outline__peJU-",
	"pointerCursor": "pointerCursor__273Bf",
	"code": "code__25VWU"
};

/***/ }),

/***/ "rMkZ":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("Wyka");
var gOPN = __webpack_require__("Ni5N").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),

/***/ "sIoo":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".table-fixed__16A6_ tbody{height:calc(100vh - 200px);overflow-y:auto;width:100%}.table-fixed__16A6_ tbody,.table-fixed__16A6_ td,.table-fixed__16A6_ th,.table-fixed__16A6_ thead,.table-fixed__16A6_ tr{display:block}.table-fixed__16A6_ tr:after{content:\"\";display:block;visibility:hidden;clear:both}.table-fixed__16A6_ tbody td,.table-fixed__16A6_ thead>tr>th{float:left}.hoveronly__2OFNY{display:none}.tableline__3k9Yx:hover .hoveronly__2OFNY{display:inline}.hoverelementonly__2mRbs,.tableline__3k9Yx:hover .hoverhide__2IAxM{display:none}.element__1WxQb:hover .hoverelementonly__2mRbs{display:inline}.element__1WxQb:hover .hoverelementhide__3tfJx{display:none}.badge-outline__BCaOI{font-weight:400;color:gray;border:1px solid gray;background-color:transparent}.pointerCursor__1Zfq-{cursor:pointer;pointer-events:inherit}.code__3jQ9B{display:block;white-space:pre-wrap}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/categories/style.css"],"names":[],"mappings":"AAAA,0BACI,2BAA4B,AAC5B,gBAAiB,AACjB,UAAY,CACf,AACD,yHAKI,aAAe,CAClB,AACD,6BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,6DAEI,UAAY,CACf,AAED,kBACI,YAAc,CACjB,AACD,0CACI,cAAiB,CACpB,AAKD,mEACI,YAAc,CACjB,AACD,+CACI,cAAiB,CACpB,AACD,+CACI,YAAe,CAClB,AAED,sBACI,gBAAiB,AACjB,WAAe,AACf,sBAA0B,AAC1B,4BAA8B,CACjC,AAED,sBACI,eAAgB,AAChB,sBAAwB,CAC3B,AAED,aACI,cAAe,AACf,oBAAqB,CACtB","file":"style.css","sourcesContent":[".table-fixed tbody {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    width: 100%;\n}\n.table-fixed thead,\n.table-fixed tbody,\n.table-fixed tr,\n.table-fixed td,\n.table-fixed th {\n    display: block;\n}\n.table-fixed tr:after {\n    content: \"\";\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n.table-fixed tbody td,\n.table-fixed thead > tr > th {\n    float: left;\n}\n\n.hoveronly { \n    display: none;\n}\n.tableline:hover .hoveronly {\n    display : inline;\n}\n.tableline:hover .hoverhide {\n    display : none;\n}\n\n.hoverelementonly {\n    display: none;\n}\n.element:hover .hoverelementonly {\n    display : inline;\n}\n.element:hover .hoverelementhide {\n    display : none;\n}\n\n.badge-outline {\n    font-weight: 400;\n    color: #808080;\n    border: 1px solid #808080;\n    background-color: transparent;\n}\n\n.pointerCursor {\n    cursor: pointer;\n    pointer-events: inherit;\n}\n\n.code {\n    display: block;\n    white-space: pre-wrap   \n  }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table-fixed": "table-fixed__16A6_",
	"hoveronly": "hoveronly__2OFNY",
	"tableline": "tableline__3k9Yx",
	"hoverhide": "hoverhide__2IAxM",
	"hoverelementonly": "hoverelementonly__2mRbs",
	"element": "element__1WxQb",
	"hoverelementhide": "hoverelementhide__3tfJx",
	"badge-outline": "badge-outline__BCaOI",
	"pointerCursor": "pointerCursor__1Zfq-",
	"code": "code__3jQ9B"
};

/***/ }),

/***/ "sxPs":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("z7R8");
var createDesc = __webpack_require__("0WCH");
var toIObject = __webpack_require__("Wyka");
var toPrimitive = __webpack_require__("EKwp");
var has = __webpack_require__("yS17");
var IE8_DOM_DEFINE = __webpack_require__("R6c1");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("6MLN") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {/* empty */}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),

/***/ "tuDi":
/***/ (function(module, exports) {



/***/ }),

/***/ "uRfg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__("1kq3");
var $export = __webpack_require__("vSO4");
var redefine = __webpack_require__("gojl");
var hide = __webpack_require__("akPY");
var Iterators = __webpack_require__("dhak");
var $iterCreate = __webpack_require__("b7Q2");
var setToStringTag = __webpack_require__("11Ut");
var getPrototypeOf = __webpack_require__("HHE0");
var ITERATOR = __webpack_require__("Ug9I")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),

/***/ "uj5A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)

var DESCRIPTORS = __webpack_require__("6MLN");
var getKeys = __webpack_require__("knrM");
var gOPS = __webpack_require__("Ocr3");
var pIE = __webpack_require__("z7R8");
var toObject = __webpack_require__("mbLO");
var IObject = __webpack_require__("E5Ce");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("wLcK")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),

/***/ "uzcO":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("3zRh");
var invoke = __webpack_require__("o4G5");
var html = __webpack_require__("ebIA");
var cel = __webpack_require__("9kxq");
var global = __webpack_require__("i1Q6");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function run() {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function listener(event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("ShN9")(process) == 'process') {
    defer = function defer(id) {
      process.nextTick(ctx(run, id, 1));
    };
    // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function defer(id) {
      Dispatch.now(ctx(run, id, 1));
    };
    // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function defer(id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
    // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function defer(id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
    // Rest old browsers
  } else {
    defer = function defer(id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

/***/ }),

/***/ "vSO4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("i1Q6");
var core = __webpack_require__("zKeE");
var ctx = __webpack_require__("3zRh");
var hide = __webpack_require__("akPY");
var has = __webpack_require__("yS17");
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? function (C) {
      var F = function F(a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0:
              return new C();
            case 1:
              return new C(a);
            case 2:
              return new C(a, b);
          }return new C(a, b, c);
        }return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
      // make static versions for prototype methods
    }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),

/***/ "vcHl":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("YD0x");
module.exports = __webpack_require__("zKeE").Object.assign;

/***/ }),

/***/ "wLcK":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),

/***/ "xVj4":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(true);
// imports


// module
exports.push([module.i, ".table-fixed__2C4FP tbody{height:calc(100vh - 200px);overflow-y:auto;width:100%}.table-fixed__2C4FP tbody,.table-fixed__2C4FP td,.table-fixed__2C4FP th,.table-fixed__2C4FP thead,.table-fixed__2C4FP tr{display:block}.table-fixed__2C4FP tr:after{content:\"\";display:block;visibility:hidden;clear:both}.table-fixed__2C4FP tbody td,.table-fixed__2C4FP thead>tr>th{float:left}.hoveronly__3Dq4N{display:none}.tableline__2FS3N:hover .hoveronly__3Dq4N{display:inline}.hoverelementonly__2Qyb2,.tableline__2FS3N:hover .hoverhide__dVrsc{display:none}.element__2KDhw:hover .hoverelementonly__2Qyb2{display:inline}.element__2KDhw:hover .hoverelementhide__Dgl6k{display:none}.badge-outline__3bQ0n{font-weight:400;color:gray;border:1px solid gray;background-color:transparent}.pointerCursor__LjM_0{cursor:pointer;pointer-events:inherit}.code__29H8s{display:block;white-space:pre-wrap}", "", {"version":3,"sources":["/Users/sorenso/Projects/ffe-cms-retake/src/components/consumers/style.css"],"names":[],"mappings":"AAAA,0BACI,2BAA4B,AAC5B,gBAAiB,AACjB,UAAY,CACf,AACD,yHAKI,aAAe,CAClB,AACD,6BACI,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,UAAY,CACf,AACD,6DAEI,UAAY,CACf,AAED,kBACI,YAAc,CACjB,AACD,0CACI,cAAiB,CACpB,AAKD,mEACI,YAAc,CACjB,AACD,+CACI,cAAiB,CACpB,AACD,+CACI,YAAe,CAClB,AAED,sBACI,gBAAiB,AACjB,WAAe,AACf,sBAA0B,AAC1B,4BAA8B,CACjC,AAED,sBACI,eAAgB,AAChB,sBAAwB,CAC3B,AAED,aACI,cAAe,AACf,oBAAqB,CACtB","file":"style.css","sourcesContent":[".table-fixed tbody {\n    height: calc(100vh - 200px);\n    overflow-y: auto;\n    width: 100%;\n}\n.table-fixed thead,\n.table-fixed tbody,\n.table-fixed tr,\n.table-fixed td,\n.table-fixed th {\n    display: block;\n}\n.table-fixed tr:after {\n    content: \"\";\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n.table-fixed tbody td,\n.table-fixed thead > tr > th {\n    float: left;\n}\n\n.hoveronly { \n    display: none;\n}\n.tableline:hover .hoveronly {\n    display : inline;\n}\n.tableline:hover .hoverhide {\n    display : none;\n}\n\n.hoverelementonly {\n    display: none;\n}\n.element:hover .hoverelementonly {\n    display : inline;\n}\n.element:hover .hoverelementhide {\n    display : none;\n}\n\n.badge-outline {\n    font-weight: 400;\n    color: #808080;\n    border: 1px solid #808080;\n    background-color: transparent;\n}\n\n.pointerCursor {\n    cursor: pointer;\n    pointer-events: inherit;\n}\n\n.code {\n    display: block;\n    white-space: pre-wrap   \n  }"],"sourceRoot":""}]);

// exports
exports.locals = {
	"table-fixed": "table-fixed__2C4FP",
	"hoveronly": "hoveronly__3Dq4N",
	"tableline": "tableline__2FS3N",
	"hoverhide": "hoverhide__dVrsc",
	"hoverelementonly": "hoverelementonly__2Qyb2",
	"element": "element__2KDhw",
	"hoverelementhide": "hoverelementhide__Dgl6k",
	"badge-outline": "badge-outline__3bQ0n",
	"pointerCursor": "pointerCursor__LjM_0",
	"code": "code__29H8s"
};

/***/ }),

/***/ "xwD+":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};

/***/ }),

/***/ "yOG5":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("vSO4");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("TNJq") });

/***/ }),

/***/ "yS17":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),

/***/ "ycyv":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("knrM");
var gOPS = __webpack_require__("Ocr3");
var pIE = __webpack_require__("z7R8");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }return result;
};

/***/ }),

/***/ "yeEC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("cjsw"), __esModule: true };

/***/ }),

/***/ "z7R8":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),

/***/ "zCAL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ "zKeE":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),

/***/ "zaru":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally


var $export = __webpack_require__("vSO4");
var core = __webpack_require__("zKeE");
var global = __webpack_require__("i1Q6");
var speciesConstructor = __webpack_require__("B1ls");
var promiseResolve = __webpack_require__("5Czc");

$export($export.P + $export.R, 'Promise', { 'finally': function _finally(onFinally) {
    var C = speciesConstructor(this, core.Promise || global.Promise);
    var isFunction = typeof onFinally == 'function';
    return this.then(isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  } });

/***/ }),

/***/ "zotD":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("BxvP");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// bundle.js